"use strict";
export const validate = validate10;
export default validate10;
const schema27 = {
  title: "Root Fields",
  type: "object",
  properties: {
    name: { type: "string", minLength: 1 },
    description: { type: ["string", "null"] },
    hiddenFromPublicByDefault: { type: "boolean" },
    successMessage: { type: ["string", "null"] },
    preamble: { type: ["string", "null"] },
    postamble: { type: ["string", "null"] },
    notificationEmails: { type: ["string", "null"] },
    category: { type: "string", minLength: 1 },
    canCreateRolesAndGroupIds: {
      type: "array",
      items: { type: "string" },
      minItems: 1,
    },
    modules: {
      type: "array",
      items: {
        type: "string",
        enum: [
          "preliminary_damage_assessment",
          "substantial_damage_estimate",
          "substantial_improvement_substantial_damage",
          "ec_submission",
          "milestone_inspection",
          "mailings",
        ],
      },
    },
    attachments: {
      type: "array",
      minItems: 1,
      items: {
        type: "object",
        discriminator: { propertyName: "type" },
        oneOf: [
          {
            type: "object",
            properties: {
              type: { type: "string", enum: ["customMapGeometry"] },
              tags: { type: "array", items: { type: "string", minLength: 1 } },
              customMapIds: {
                type: "array",
                items: { type: "string", minLength: 1 },
                minItems: 1,
              },
            },
            required: ["type", "customMapIds"],
            additionalProperties: false,
          },
          {
            type: "object",
            properties: { type: { type: "string", enum: ["property"] } },
            required: ["type"],
            additionalProperties: false,
          },
        ],
      },
    },
    inputs: {
      $id: "InputArray",
      type: "array",
      items: {
        type: "object",
        discriminator: { propertyName: "inputType" },
        oneOf: [
          {
            title: "Document Upload",
            type: "object",
            properties: {
              inputType: { type: "string", enum: ["DocumentUploader"] },
              name: { type: "string" },
              title: { type: "string", minLength: 1 },
              tooltipText: { type: "string" },
              required: { type: "boolean" },
              accountDocumentType: { type: "string", minLength: 1 },
              documentTypeAbbreviation: { type: "string", minLength: 1 },
              documentTypeName: { type: "string" },
              emptyFilesMessage: { type: "string" },
              fileQuantityDescription: { type: "string", minLength: 1 },
              fileSizeDescription: { type: "string", minLength: 1 },
              fileTypeDescription: { type: "string", minLength: 1 },
              columnHeaderOverride: { type: "string" },
              helperText: { type: "string" },
              viewOnCreate: { type: "array", items: { type: "string" } },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
              maxItems: { type: "integer", minimum: 1 },
              minItems: { type: "integer" },
            },
            required: [
              "inputType",
              "name",
              "required",
              "maxItems",
              "title",
              "fileTypeDescription",
              "fileQuantityDescription",
              "fileSizeDescription",
              "accountDocumentType",
              "documentTypeName",
              "documentTypeAbbreviation",
            ],
            allOf: [
              {
                if: { properties: { required: { const: true } } },
                then: {
                  required: ["minItems"],
                  properties: { minItems: { type: "number", minimum: 1 } },
                },
              },
            ],
            additionalProperties: false,
          },
          {
            title: "Tags",
            type: "object",
            properties: {
              inputType: { type: "string", enum: ["Tags"] },
              name: { type: "string" },
              type: { type: "string", enum: ["string", "number"] },
              title: { type: "string", minLength: 1 },
              required: { type: "boolean" },
              description: { type: "string" },
              tooltipText: { type: "string" },
              columnHeaderOverride: { type: "string" },
              viewOnCreate: { type: "array", items: { type: "string" } },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
              minItems: { type: "integer" },
              enum: {
                type: "array",
                items: { type: "string", minLength: 1 },
                minItems: 1,
              },
              defaultValue: { type: "array", items: { type: "string" } },
            },
            required: [
              "inputType",
              "name",
              "type",
              "title",
              "required",
              "minItems",
              "enum",
            ],
            additionalProperties: false,
          },
          {
            title: "Select",
            type: "object",
            properties: {
              name: { type: "string" },
              required: { type: "boolean" },
              useAsTag: { type: "boolean" },
              type: { type: "string", enum: ["string"] },
              inputType: { type: "string", enum: ["select"] },
              placeholder: { type: "string" },
              tooltipText: { type: "string" },
              title: { type: "string", minLength: 1 },
              enum: {
                type: "array",
                items: {
                  oneOf: [
                    {
                      title: "Select Option String",
                      type: "string",
                      minLength: 1,
                    },
                    {
                      title: "Select Option Label/Value Pair",
                      type: "object",
                      properties: {
                        label: { type: "string", minLength: 1 },
                        value: { type: "string", minLength: 1 },
                        display: {
                          type: ["string", "null"],
                          enum: [
                            "default",
                            "neutral",
                            "warning",
                            "critical",
                            "neutralInverted",
                          ],
                        },
                      },
                      required: ["label", "value"],
                    },
                  ],
                },
                minItems: 1,
              },
              defaultValuePath: {
                type: "string",
                enum: [
                  "property.sisd.adjustmentRatio",
                  "property.sisd.defaultExclude",
                  "property.improvementValue",
                  "property.sisd.costType",
                  "property.latitude",
                  "property.longitude",
                  "parcel.mailingAddress1",
                  "parcel.mailingAddress2",
                  "parcel.mailingAddress",
                  "parcel.parcelId",
                  "parcel.improvementValue",
                  "parcel.block",
                  "parcel.lot",
                  "parcel.ownerName",
                  "user.firstName",
                  "user.lastName",
                  "user.fullName",
                  "units.feet",
                  "units.inches",
                  "units.hours",
                  "units.minutes",
                  "units.days",
                  "boolean.true",
                  "boolean.false",
                  "date.today",
                ],
              },
              defaultValue: { type: "string" },
              columnHeaderOverride: { type: "string" },
              disabled: { type: "boolean" },
              helperText: { type: "string" },
              viewOnCreate: { type: "array", items: { type: "string" } },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
            },
            required: [
              "name",
              "required",
              "type",
              "inputType",
              "placeholder",
              "title",
              "enum",
            ],
            additionalProperties: false,
          },
          {
            title: "Date",
            type: "object",
            properties: {
              name: { type: "string" },
              required: { type: "boolean" },
              inputType: { type: "string", enum: ["date"] },
              type: { type: "string", enum: ["string"] },
              defaultToToday: { type: "boolean" },
              title: { type: "string", minLength: 1 },
              placeholder: { type: "string" },
              tooltipText: { type: "string" },
              columnHeaderOverride: { type: "string" },
              disabled: { type: "boolean" },
              helperText: { type: "string" },
              viewOnCreate: { type: "array", items: { type: "string" } },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
              formula: {
                type: "object",
                properties: {
                  name: { type: "string" },
                  applies: {
                    type: ["object", "boolean"],
                    additionalProperties: true,
                  },
                  logic: { type: "object", additionalProperties: true },
                },
                required: ["name", "applies", "logic"],
                additionalProperties: false,
              },
            },
            required: [
              "name",
              "required",
              "inputType",
              "type",
              "defaultToToday",
              "title",
            ],
            additionalProperties: false,
          },
          {
            title: "Damage Degree",
            type: "object",
            properties: {
              name: { type: "string" },
              required: { type: "boolean" },
              inputType: { type: "string", enum: ["DamageDegree"] },
              type: { type: "string" },
              placeholder: { type: "string" },
              tooltipText: { type: "string" },
              title: { type: "string", minLength: 1 },
              columnHeaderOverride: { type: "string" },
              disabled: { type: "boolean" },
              viewOnCreate: { type: "array", items: { type: "string" } },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
            },
            required: [
              "name",
              "required",
              "inputType",
              "type",
              "placeholder",
              "title",
            ],
            additionalProperties: false,
          },
          {
            title: "Text",
            type: "object",
            properties: {
              name: { type: "string" },
              required: { type: "boolean" },
              inputType: { type: "string", enum: ["text"] },
              type: { type: "string", enum: ["string"] },
              placeholder: { type: "string" },
              tooltipText: { type: "string" },
              title: { type: "string", minLength: 1 },
              defaultValuePath: {
                type: "string",
                enum: [
                  "property.sisd.adjustmentRatio",
                  "property.sisd.defaultExclude",
                  "property.improvementValue",
                  "property.sisd.costType",
                  "property.latitude",
                  "property.longitude",
                  "parcel.mailingAddress1",
                  "parcel.mailingAddress2",
                  "parcel.mailingAddress",
                  "parcel.parcelId",
                  "parcel.improvementValue",
                  "parcel.block",
                  "parcel.lot",
                  "parcel.ownerName",
                  "user.firstName",
                  "user.lastName",
                  "user.fullName",
                  "units.feet",
                  "units.inches",
                  "units.hours",
                  "units.minutes",
                  "units.days",
                  "boolean.true",
                  "boolean.false",
                  "date.today",
                ],
              },
              defaultValue: { type: "string" },
              labelSize: { type: "string", enum: ["small", "medium"] },
              columnHeaderOverride: { type: "string" },
              disabled: { type: "boolean" },
              helperText: { type: "string" },
              viewOnCreate: { type: "array", items: { type: "string" } },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
              uniqueIdentifier: { type: "string" },
              formula: {
                type: "object",
                properties: {
                  name: { type: "string" },
                  applies: {
                    type: ["object", "boolean"],
                    additionalProperties: true,
                  },
                  logic: { type: "object", additionalProperties: true },
                },
                required: ["name", "applies", "logic"],
                additionalProperties: false,
              },
            },
            required: [
              "name",
              "required",
              "inputType",
              "type",
              "placeholder",
              "title",
            ],
            additionalProperties: false,
          },
          {
            title: "Text Area",
            type: "object",
            properties: {
              name: { type: "string" },
              required: { type: "boolean" },
              inputType: { type: "string", enum: ["textarea"] },
              type: { type: "string", enum: ["string"] },
              placeholder: { type: "string" },
              tooltipText: { type: "string" },
              title: { type: "string", minLength: 1 },
              defaultValuePath: {
                type: "string",
                enum: [
                  "property.sisd.adjustmentRatio",
                  "property.sisd.defaultExclude",
                  "property.improvementValue",
                  "property.sisd.costType",
                  "property.latitude",
                  "property.longitude",
                  "parcel.mailingAddress1",
                  "parcel.mailingAddress2",
                  "parcel.mailingAddress",
                  "parcel.parcelId",
                  "parcel.improvementValue",
                  "parcel.block",
                  "parcel.lot",
                  "parcel.ownerName",
                  "user.firstName",
                  "user.lastName",
                  "user.fullName",
                  "units.feet",
                  "units.inches",
                  "units.hours",
                  "units.minutes",
                  "units.days",
                  "boolean.true",
                  "boolean.false",
                  "date.today",
                ],
              },
              defaultValue: { type: "string" },
              generativeAIPrompt: { type: "string" },
              useGenerativeAI: { type: "boolean" },
              columnHeaderOverride: { type: "string" },
              disabled: { type: "boolean" },
              helperText: { type: "string" },
              viewOnCreate: { type: "array", items: { type: "string" } },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
              formula: {
                type: "object",
                properties: {
                  name: { type: "string" },
                  applies: {
                    type: ["object", "boolean"],
                    additionalProperties: true,
                  },
                  logic: { type: "object", additionalProperties: true },
                },
                required: ["name", "applies", "logic"],
                additionalProperties: false,
              },
            },
            allOf: [
              {
                if: { properties: { required: { const: true } } },
                then: { properties: { useGenerativeAI: { enum: [false] } } },
              },
              {
                if: { properties: { useGenerativeAI: { const: true } } },
                then: {
                  properties: {
                    generativeAIPrompt: { type: "string", minLength: 1 },
                  },
                },
              },
            ],
            required: [
              "name",
              "required",
              "inputType",
              "type",
              "placeholder",
              "title",
            ],
            additionalProperties: false,
          },
          {
            title: "Number",
            type: "object",
            properties: {
              inputType: { type: "string", enum: ["number"] },
              type: { type: "string", enum: ["number"] },
              name: { type: "string" },
              placeholder: { type: "string" },
              tooltipText: { type: "string" },
              required: { type: "boolean" },
              title: { type: "string", minLength: 1 },
              step: { type: "number" },
              minimum: {
                type: "number",
                exclusiveMaximum: { $data: "1/maximum" },
              },
              maximum: {
                type: "number",
                exclusiveMinimum: { $data: "1/minimum" },
              },
              prefix: { type: "string" },
              postfix: { type: "string" },
              defaultValuePath: {
                type: "string",
                enum: [
                  "property.sisd.adjustmentRatio",
                  "property.sisd.defaultExclude",
                  "property.improvementValue",
                  "property.sisd.costType",
                  "property.latitude",
                  "property.longitude",
                  "parcel.mailingAddress1",
                  "parcel.mailingAddress2",
                  "parcel.mailingAddress",
                  "parcel.parcelId",
                  "parcel.improvementValue",
                  "parcel.block",
                  "parcel.lot",
                  "parcel.ownerName",
                  "user.firstName",
                  "user.lastName",
                  "user.fullName",
                  "units.feet",
                  "units.inches",
                  "units.hours",
                  "units.minutes",
                  "units.days",
                  "boolean.true",
                  "boolean.false",
                  "date.today",
                ],
              },
              defaultValue: {
                type: "number",
                minimum: { $data: "1/minimum" },
                maximum: { $data: "1/maximum" },
              },
              labelSize: { type: "string", enum: ["small", "medium"] },
              columnHeaderOverride: { type: "string" },
              disabled: { type: "boolean" },
              helperText: { type: "string" },
              viewOnCreate: { type: "array", items: { type: "string" } },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
              formula: {
                type: "object",
                properties: {
                  name: { type: "string" },
                  applies: {
                    type: ["object", "boolean"],
                    additionalProperties: true,
                  },
                  logic: { type: "object", additionalProperties: true },
                },
                required: ["name", "applies", "logic"],
                additionalProperties: false,
              },
              prefixPostfix: {
                type: "object",
                properties: {
                  label: { type: "string", minLength: 1 },
                  value: { type: "string", minLength: 1 },
                },
              },
            },
            required: ["inputType", "type", "name", "required", "title"],
            additionalProperties: false,
          },
          {
            title: "Boolean",
            type: "object",
            properties: {
              name: { type: "string" },
              required: { type: "boolean" },
              type: { type: "string", enum: ["boolean"] },
              inputType: { type: "string", enum: ["checkbox"] },
              tooltipText: { type: "string" },
              title: { type: "string" },
              checkboxText: { type: "string", minLength: 1 },
              columnHeaderOverride: { type: "string" },
              defaultValuePath: {
                type: "string",
                enum: [
                  "property.sisd.adjustmentRatio",
                  "property.sisd.defaultExclude",
                  "property.improvementValue",
                  "property.sisd.costType",
                  "property.latitude",
                  "property.longitude",
                  "parcel.mailingAddress1",
                  "parcel.mailingAddress2",
                  "parcel.mailingAddress",
                  "parcel.parcelId",
                  "parcel.improvementValue",
                  "parcel.block",
                  "parcel.lot",
                  "parcel.ownerName",
                  "user.firstName",
                  "user.lastName",
                  "user.fullName",
                  "units.feet",
                  "units.inches",
                  "units.hours",
                  "units.minutes",
                  "units.days",
                  "boolean.true",
                  "boolean.false",
                  "date.today",
                ],
              },
              disabled: { type: "boolean" },
              viewOnCreate: { type: "array", items: { type: "string" } },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
              formula: {
                type: "object",
                properties: {
                  name: { type: "string" },
                  applies: {
                    type: ["object", "boolean"],
                    additionalProperties: true,
                  },
                  logic: { type: "object", additionalProperties: true },
                },
                required: ["name", "applies", "logic"],
                additionalProperties: false,
              },
            },
            required: [
              "name",
              "required",
              "type",
              "title",
              "inputType",
              "checkboxText",
            ],
            additionalProperties: false,
          },
          {
            title: "Number with units",
            type: "object",
            properties: {
              inputType: { type: "string", enum: ["NumberWithUnits"] },
              name: { type: "string" },
              required: { type: "boolean" },
              title: { type: "string", minLength: 1 },
              minimum: {
                type: "number",
                exclusiveMaximum: { $data: "1/maximum" },
              },
              maximum: {
                type: "number",
                exclusiveMinimum: { $data: "1/minimum" },
              },
              tooltipText: { type: "string" },
              defaultValuePath: {
                type: "string",
                enum: [
                  "property.sisd.adjustmentRatio",
                  "property.sisd.defaultExclude",
                  "property.improvementValue",
                  "property.sisd.costType",
                  "property.latitude",
                  "property.longitude",
                  "parcel.mailingAddress1",
                  "parcel.mailingAddress2",
                  "parcel.mailingAddress",
                  "parcel.parcelId",
                  "parcel.improvementValue",
                  "parcel.block",
                  "parcel.lot",
                  "parcel.ownerName",
                  "user.firstName",
                  "user.lastName",
                  "user.fullName",
                  "units.feet",
                  "units.inches",
                  "units.hours",
                  "units.minutes",
                  "units.days",
                  "boolean.true",
                  "boolean.false",
                  "date.today",
                ],
              },
              defaultValue: {
                type: "number",
                minimum: { $data: "1/minimum" },
                maximum: { $data: "1/maximum" },
              },
              unitsDefaultValuePath: {
                type: "string",
                enum: [
                  "property.sisd.adjustmentRatio",
                  "property.sisd.defaultExclude",
                  "property.improvementValue",
                  "property.sisd.costType",
                  "property.latitude",
                  "property.longitude",
                  "parcel.mailingAddress1",
                  "parcel.mailingAddress2",
                  "parcel.mailingAddress",
                  "parcel.parcelId",
                  "parcel.improvementValue",
                  "parcel.block",
                  "parcel.lot",
                  "parcel.ownerName",
                  "user.firstName",
                  "user.lastName",
                  "user.fullName",
                  "units.feet",
                  "units.inches",
                  "units.hours",
                  "units.minutes",
                  "units.days",
                  "boolean.true",
                  "boolean.false",
                  "date.today",
                ],
              },
              unitsDefaultValue: { type: "string" },
              enum: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    label: { type: "string", minLength: 1 },
                    value: { type: "string", minLength: 1 },
                  },
                  required: ["label", "value"],
                },
                minItems: 1,
              },
              columnHeaderOverride: { type: "string" },
              disabled: { type: "boolean" },
              helperText: { type: "string" },
              viewOnCreate: { type: "array", items: { type: "string" } },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
            },
            required: ["inputType", "name", "enum", "title", "required"],
            additionalProperties: false,
          },
          {
            title: "Property Market Value",
            type: "object",
            properties: {
              inputType: { type: "string", enum: ["PropertyMarketValue"] },
              name: { type: "string" },
              required: { type: "boolean" },
              title: { type: "string", minLength: 1 },
              columnHeaderOverride: { type: "string" },
              tooltipText: { type: "string" },
              description: { type: "string" },
              viewOnCreate: { type: "array", items: { type: "string" } },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
              formula: {
                type: "object",
                properties: {
                  name: { type: "string" },
                  applies: {
                    type: ["object", "boolean"],
                    additionalProperties: true,
                  },
                  logic: { type: "object", additionalProperties: true },
                },
                required: ["name", "applies", "logic"],
                additionalProperties: false,
              },
              enum: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "squareFootageEstimate",
                    "automatedAssessedValue",
                    "otherValueEstimate",
                  ],
                  minLength: 1,
                },
              },
              overrides: {
                type: "object",
                properties: {
                  overrides: {
                    type: "object",
                    properties: {
                      squareFootageEstimate: {
                        type: "object",
                        properties: {
                          description: {
                            type: "string",
                            description:
                              "*FEMA preferred — Calculated by applying a value per square foot of the building.",
                          },
                          adjustmentRatio: {
                            type: "object",
                            properties: { title: { type: "string" } },
                          },
                        },
                      },
                    },
                  },
                  viewOnCreate: { type: "array", items: { type: "string" } },
                  viewOnRetrieve: {
                    type: "array",
                    items: {
                      type: "string",
                      enum: [
                        "manager",
                        "member",
                        "creator",
                        "view_only",
                        "admin",
                        "guest",
                        "publicUser",
                      ],
                    },
                    minItems: 1,
                  },
                  canUpdate: { type: "array", items: { type: "string" } },
                },
              },
            },
            required: ["inputType", "name", "title", "required"],
            additionalProperties: false,
          },
          {
            title: "Field Group",
            type: "object",
            properties: {
              inputType: { type: "string", enum: ["group"] },
              name: { type: "string" },
              title: { type: "string", minLength: 1 },
              description: { type: "string" },
              properties: {
                $ref: "InputArray",
                type: "array",
                items: { type: "object" },
                minItems: 1,
              },
              required: { type: "boolean" },
              columns: { type: "integer" },
              heading: { type: "string", enum: ["h1", "h2"] },
            },
            required: ["inputType", "title", "properties"],
            additionalProperties: false,
          },
          {
            title: "User",
            type: "object",
            properties: {
              inputType: { type: "string", enum: ["User"] },
              name: { type: "string" },
              title: { type: "string", minLength: 1 },
              required: { type: "boolean" },
              placeholder: { type: "string" },
              type: { type: "string" },
              tooltipText: { type: "string" },
              description: { type: "string" },
              disabled: { type: "boolean" },
              helperText: { type: "string" },
              viewOnCreate: { type: "array", items: { type: "string" } },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
              userGroupSelection: { type: "array" },
              columnHeaderOverride: { type: "string" },
            },
            required: ["inputType", "name", "required", "title"],
            additionalProperties: false,
          },
          {
            title: "Multi-select",
            type: "object",
            properties: {
              inputType: { type: "string", enum: ["multiSelect"] },
              name: { type: "string" },
              type: { type: "string", enum: ["string", "number"] },
              title: { type: "string", minLength: 1 },
              required: { type: "boolean" },
              placeholder: { type: "string" },
              description: { type: "string" },
              tooltipText: { type: "string" },
              columnHeaderOverride: { type: "string" },
              helperText: { type: "string" },
              viewOnCreate: { type: "array", items: { type: "string" } },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
              useAsTag: { type: "boolean" },
              enum: {
                type: "array",
                items: {
                  oneOf: [
                    {
                      title: "Select Option String",
                      type: "string",
                      minLength: 1,
                    },
                    {
                      title: "Select Option Label/Value Pair",
                      type: "object",
                      properties: {
                        label: { type: "string", minLength: 1 },
                        value: { type: "string", minLength: 1 },
                        display: {
                          type: ["string", "null"],
                          enum: [
                            "default",
                            "neutral",
                            "warning",
                            "critical",
                            "neutralInverted",
                          ],
                        },
                      },
                      required: ["label", "value"],
                    },
                  ],
                },
                minItems: 1,
              },
              defaultValue: { type: "array", items: { type: "string" } },
            },
            required: [
              "inputType",
              "name",
              "type",
              "title",
              "required",
              "enum",
            ],
            additionalProperties: false,
          },
          {
            title: "Unique ID",
            type: "object",
            properties: {
              name: { type: "string" },
              required: { type: "boolean" },
              inputType: { type: "string", enum: ["UniqueId"] },
              type: { type: "string", enum: ["string"] },
              placeholder: { type: "string" },
              tooltipText: { type: "string" },
              title: { type: "string", minLength: 1 },
              labelSize: { type: "string", enum: ["small", "medium"] },
              columnHeaderOverride: { type: "string" },
              disabled: { type: "boolean" },
              helperText: { type: "string" },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
              viewOnCreate: { type: "array", items: { type: "string" } },
              prefix: { type: "string" },
              numberType: { type: "string", enum: ["ascending", "random"] },
            },
            required: [
              "name",
              "required",
              "inputType",
              "type",
              "placeholder",
              "title",
            ],
            additionalProperties: false,
          },
        ],
      },
      minItems: 1,
    },
  },
  required: [
    "name",
    "category",
    "canCreateRolesAndGroupIds",
    "inputs",
    "attachments",
  ],
  additionalProperties: false,
};
const func2 = Object.prototype.hasOwnProperty;
const func3 = require("ajv/dist/runtime/ucs2length").default;
const schema28 = {
  $id: "InputArray",
  type: "array",
  items: {
    type: "object",
    discriminator: { propertyName: "inputType" },
    oneOf: [
      {
        title: "Document Upload",
        type: "object",
        properties: {
          inputType: { type: "string", enum: ["DocumentUploader"] },
          name: { type: "string" },
          title: { type: "string", minLength: 1 },
          tooltipText: { type: "string" },
          required: { type: "boolean" },
          accountDocumentType: { type: "string", minLength: 1 },
          documentTypeAbbreviation: { type: "string", minLength: 1 },
          documentTypeName: { type: "string" },
          emptyFilesMessage: { type: "string" },
          fileQuantityDescription: { type: "string", minLength: 1 },
          fileSizeDescription: { type: "string", minLength: 1 },
          fileTypeDescription: { type: "string", minLength: 1 },
          columnHeaderOverride: { type: "string" },
          helperText: { type: "string" },
          viewOnCreate: { type: "array", items: { type: "string" } },
          viewOnRetrieve: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "manager",
                "member",
                "creator",
                "view_only",
                "admin",
                "guest",
                "publicUser",
              ],
            },
            minItems: 1,
          },
          canUpdate: { type: "array", items: { type: "string" } },
          maxItems: { type: "integer", minimum: 1 },
          minItems: { type: "integer" },
        },
        required: [
          "inputType",
          "name",
          "required",
          "maxItems",
          "title",
          "fileTypeDescription",
          "fileQuantityDescription",
          "fileSizeDescription",
          "accountDocumentType",
          "documentTypeName",
          "documentTypeAbbreviation",
        ],
        allOf: [
          {
            if: { properties: { required: { const: true } } },
            then: {
              required: ["minItems"],
              properties: { minItems: { type: "number", minimum: 1 } },
            },
          },
        ],
        additionalProperties: false,
      },
      {
        title: "Tags",
        type: "object",
        properties: {
          inputType: { type: "string", enum: ["Tags"] },
          name: { type: "string" },
          type: { type: "string", enum: ["string", "number"] },
          title: { type: "string", minLength: 1 },
          required: { type: "boolean" },
          description: { type: "string" },
          tooltipText: { type: "string" },
          columnHeaderOverride: { type: "string" },
          viewOnCreate: { type: "array", items: { type: "string" } },
          viewOnRetrieve: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "manager",
                "member",
                "creator",
                "view_only",
                "admin",
                "guest",
                "publicUser",
              ],
            },
            minItems: 1,
          },
          canUpdate: { type: "array", items: { type: "string" } },
          minItems: { type: "integer" },
          enum: {
            type: "array",
            items: { type: "string", minLength: 1 },
            minItems: 1,
          },
          defaultValue: { type: "array", items: { type: "string" } },
        },
        required: [
          "inputType",
          "name",
          "type",
          "title",
          "required",
          "minItems",
          "enum",
        ],
        additionalProperties: false,
      },
      {
        title: "Select",
        type: "object",
        properties: {
          name: { type: "string" },
          required: { type: "boolean" },
          useAsTag: { type: "boolean" },
          type: { type: "string", enum: ["string"] },
          inputType: { type: "string", enum: ["select"] },
          placeholder: { type: "string" },
          tooltipText: { type: "string" },
          title: { type: "string", minLength: 1 },
          enum: {
            type: "array",
            items: {
              oneOf: [
                { title: "Select Option String", type: "string", minLength: 1 },
                {
                  title: "Select Option Label/Value Pair",
                  type: "object",
                  properties: {
                    label: { type: "string", minLength: 1 },
                    value: { type: "string", minLength: 1 },
                    display: {
                      type: ["string", "null"],
                      enum: [
                        "default",
                        "neutral",
                        "warning",
                        "critical",
                        "neutralInverted",
                      ],
                    },
                  },
                  required: ["label", "value"],
                },
              ],
            },
            minItems: 1,
          },
          defaultValuePath: {
            type: "string",
            enum: [
              "property.sisd.adjustmentRatio",
              "property.sisd.defaultExclude",
              "property.improvementValue",
              "property.sisd.costType",
              "property.latitude",
              "property.longitude",
              "parcel.mailingAddress1",
              "parcel.mailingAddress2",
              "parcel.mailingAddress",
              "parcel.parcelId",
              "parcel.improvementValue",
              "parcel.block",
              "parcel.lot",
              "parcel.ownerName",
              "user.firstName",
              "user.lastName",
              "user.fullName",
              "units.feet",
              "units.inches",
              "units.hours",
              "units.minutes",
              "units.days",
              "boolean.true",
              "boolean.false",
              "date.today",
            ],
          },
          defaultValue: { type: "string" },
          columnHeaderOverride: { type: "string" },
          disabled: { type: "boolean" },
          helperText: { type: "string" },
          viewOnCreate: { type: "array", items: { type: "string" } },
          viewOnRetrieve: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "manager",
                "member",
                "creator",
                "view_only",
                "admin",
                "guest",
                "publicUser",
              ],
            },
            minItems: 1,
          },
          canUpdate: { type: "array", items: { type: "string" } },
        },
        required: [
          "name",
          "required",
          "type",
          "inputType",
          "placeholder",
          "title",
          "enum",
        ],
        additionalProperties: false,
      },
      {
        title: "Date",
        type: "object",
        properties: {
          name: { type: "string" },
          required: { type: "boolean" },
          inputType: { type: "string", enum: ["date"] },
          type: { type: "string", enum: ["string"] },
          defaultToToday: { type: "boolean" },
          title: { type: "string", minLength: 1 },
          placeholder: { type: "string" },
          tooltipText: { type: "string" },
          columnHeaderOverride: { type: "string" },
          disabled: { type: "boolean" },
          helperText: { type: "string" },
          viewOnCreate: { type: "array", items: { type: "string" } },
          viewOnRetrieve: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "manager",
                "member",
                "creator",
                "view_only",
                "admin",
                "guest",
                "publicUser",
              ],
            },
            minItems: 1,
          },
          canUpdate: { type: "array", items: { type: "string" } },
          formula: {
            type: "object",
            properties: {
              name: { type: "string" },
              applies: {
                type: ["object", "boolean"],
                additionalProperties: true,
              },
              logic: { type: "object", additionalProperties: true },
            },
            required: ["name", "applies", "logic"],
            additionalProperties: false,
          },
        },
        required: [
          "name",
          "required",
          "inputType",
          "type",
          "defaultToToday",
          "title",
        ],
        additionalProperties: false,
      },
      {
        title: "Damage Degree",
        type: "object",
        properties: {
          name: { type: "string" },
          required: { type: "boolean" },
          inputType: { type: "string", enum: ["DamageDegree"] },
          type: { type: "string" },
          placeholder: { type: "string" },
          tooltipText: { type: "string" },
          title: { type: "string", minLength: 1 },
          columnHeaderOverride: { type: "string" },
          disabled: { type: "boolean" },
          viewOnCreate: { type: "array", items: { type: "string" } },
          viewOnRetrieve: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "manager",
                "member",
                "creator",
                "view_only",
                "admin",
                "guest",
                "publicUser",
              ],
            },
            minItems: 1,
          },
          canUpdate: { type: "array", items: { type: "string" } },
        },
        required: [
          "name",
          "required",
          "inputType",
          "type",
          "placeholder",
          "title",
        ],
        additionalProperties: false,
      },
      {
        title: "Text",
        type: "object",
        properties: {
          name: { type: "string" },
          required: { type: "boolean" },
          inputType: { type: "string", enum: ["text"] },
          type: { type: "string", enum: ["string"] },
          placeholder: { type: "string" },
          tooltipText: { type: "string" },
          title: { type: "string", minLength: 1 },
          defaultValuePath: {
            type: "string",
            enum: [
              "property.sisd.adjustmentRatio",
              "property.sisd.defaultExclude",
              "property.improvementValue",
              "property.sisd.costType",
              "property.latitude",
              "property.longitude",
              "parcel.mailingAddress1",
              "parcel.mailingAddress2",
              "parcel.mailingAddress",
              "parcel.parcelId",
              "parcel.improvementValue",
              "parcel.block",
              "parcel.lot",
              "parcel.ownerName",
              "user.firstName",
              "user.lastName",
              "user.fullName",
              "units.feet",
              "units.inches",
              "units.hours",
              "units.minutes",
              "units.days",
              "boolean.true",
              "boolean.false",
              "date.today",
            ],
          },
          defaultValue: { type: "string" },
          labelSize: { type: "string", enum: ["small", "medium"] },
          columnHeaderOverride: { type: "string" },
          disabled: { type: "boolean" },
          helperText: { type: "string" },
          viewOnCreate: { type: "array", items: { type: "string" } },
          viewOnRetrieve: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "manager",
                "member",
                "creator",
                "view_only",
                "admin",
                "guest",
                "publicUser",
              ],
            },
            minItems: 1,
          },
          canUpdate: { type: "array", items: { type: "string" } },
          uniqueIdentifier: { type: "string" },
          formula: {
            type: "object",
            properties: {
              name: { type: "string" },
              applies: {
                type: ["object", "boolean"],
                additionalProperties: true,
              },
              logic: { type: "object", additionalProperties: true },
            },
            required: ["name", "applies", "logic"],
            additionalProperties: false,
          },
        },
        required: [
          "name",
          "required",
          "inputType",
          "type",
          "placeholder",
          "title",
        ],
        additionalProperties: false,
      },
      {
        title: "Text Area",
        type: "object",
        properties: {
          name: { type: "string" },
          required: { type: "boolean" },
          inputType: { type: "string", enum: ["textarea"] },
          type: { type: "string", enum: ["string"] },
          placeholder: { type: "string" },
          tooltipText: { type: "string" },
          title: { type: "string", minLength: 1 },
          defaultValuePath: {
            type: "string",
            enum: [
              "property.sisd.adjustmentRatio",
              "property.sisd.defaultExclude",
              "property.improvementValue",
              "property.sisd.costType",
              "property.latitude",
              "property.longitude",
              "parcel.mailingAddress1",
              "parcel.mailingAddress2",
              "parcel.mailingAddress",
              "parcel.parcelId",
              "parcel.improvementValue",
              "parcel.block",
              "parcel.lot",
              "parcel.ownerName",
              "user.firstName",
              "user.lastName",
              "user.fullName",
              "units.feet",
              "units.inches",
              "units.hours",
              "units.minutes",
              "units.days",
              "boolean.true",
              "boolean.false",
              "date.today",
            ],
          },
          defaultValue: { type: "string" },
          generativeAIPrompt: { type: "string" },
          useGenerativeAI: { type: "boolean" },
          columnHeaderOverride: { type: "string" },
          disabled: { type: "boolean" },
          helperText: { type: "string" },
          viewOnCreate: { type: "array", items: { type: "string" } },
          viewOnRetrieve: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "manager",
                "member",
                "creator",
                "view_only",
                "admin",
                "guest",
                "publicUser",
              ],
            },
            minItems: 1,
          },
          canUpdate: { type: "array", items: { type: "string" } },
          formula: {
            type: "object",
            properties: {
              name: { type: "string" },
              applies: {
                type: ["object", "boolean"],
                additionalProperties: true,
              },
              logic: { type: "object", additionalProperties: true },
            },
            required: ["name", "applies", "logic"],
            additionalProperties: false,
          },
        },
        allOf: [
          {
            if: { properties: { required: { const: true } } },
            then: { properties: { useGenerativeAI: { enum: [false] } } },
          },
          {
            if: { properties: { useGenerativeAI: { const: true } } },
            then: {
              properties: {
                generativeAIPrompt: { type: "string", minLength: 1 },
              },
            },
          },
        ],
        required: [
          "name",
          "required",
          "inputType",
          "type",
          "placeholder",
          "title",
        ],
        additionalProperties: false,
      },
      {
        title: "Number",
        type: "object",
        properties: {
          inputType: { type: "string", enum: ["number"] },
          type: { type: "string", enum: ["number"] },
          name: { type: "string" },
          placeholder: { type: "string" },
          tooltipText: { type: "string" },
          required: { type: "boolean" },
          title: { type: "string", minLength: 1 },
          step: { type: "number" },
          minimum: { type: "number", exclusiveMaximum: { $data: "1/maximum" } },
          maximum: { type: "number", exclusiveMinimum: { $data: "1/minimum" } },
          prefix: { type: "string" },
          postfix: { type: "string" },
          defaultValuePath: {
            type: "string",
            enum: [
              "property.sisd.adjustmentRatio",
              "property.sisd.defaultExclude",
              "property.improvementValue",
              "property.sisd.costType",
              "property.latitude",
              "property.longitude",
              "parcel.mailingAddress1",
              "parcel.mailingAddress2",
              "parcel.mailingAddress",
              "parcel.parcelId",
              "parcel.improvementValue",
              "parcel.block",
              "parcel.lot",
              "parcel.ownerName",
              "user.firstName",
              "user.lastName",
              "user.fullName",
              "units.feet",
              "units.inches",
              "units.hours",
              "units.minutes",
              "units.days",
              "boolean.true",
              "boolean.false",
              "date.today",
            ],
          },
          defaultValue: {
            type: "number",
            minimum: { $data: "1/minimum" },
            maximum: { $data: "1/maximum" },
          },
          labelSize: { type: "string", enum: ["small", "medium"] },
          columnHeaderOverride: { type: "string" },
          disabled: { type: "boolean" },
          helperText: { type: "string" },
          viewOnCreate: { type: "array", items: { type: "string" } },
          viewOnRetrieve: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "manager",
                "member",
                "creator",
                "view_only",
                "admin",
                "guest",
                "publicUser",
              ],
            },
            minItems: 1,
          },
          canUpdate: { type: "array", items: { type: "string" } },
          formula: {
            type: "object",
            properties: {
              name: { type: "string" },
              applies: {
                type: ["object", "boolean"],
                additionalProperties: true,
              },
              logic: { type: "object", additionalProperties: true },
            },
            required: ["name", "applies", "logic"],
            additionalProperties: false,
          },
          prefixPostfix: {
            type: "object",
            properties: {
              label: { type: "string", minLength: 1 },
              value: { type: "string", minLength: 1 },
            },
          },
        },
        required: ["inputType", "type", "name", "required", "title"],
        additionalProperties: false,
      },
      {
        title: "Boolean",
        type: "object",
        properties: {
          name: { type: "string" },
          required: { type: "boolean" },
          type: { type: "string", enum: ["boolean"] },
          inputType: { type: "string", enum: ["checkbox"] },
          tooltipText: { type: "string" },
          title: { type: "string" },
          checkboxText: { type: "string", minLength: 1 },
          columnHeaderOverride: { type: "string" },
          defaultValuePath: {
            type: "string",
            enum: [
              "property.sisd.adjustmentRatio",
              "property.sisd.defaultExclude",
              "property.improvementValue",
              "property.sisd.costType",
              "property.latitude",
              "property.longitude",
              "parcel.mailingAddress1",
              "parcel.mailingAddress2",
              "parcel.mailingAddress",
              "parcel.parcelId",
              "parcel.improvementValue",
              "parcel.block",
              "parcel.lot",
              "parcel.ownerName",
              "user.firstName",
              "user.lastName",
              "user.fullName",
              "units.feet",
              "units.inches",
              "units.hours",
              "units.minutes",
              "units.days",
              "boolean.true",
              "boolean.false",
              "date.today",
            ],
          },
          disabled: { type: "boolean" },
          viewOnCreate: { type: "array", items: { type: "string" } },
          viewOnRetrieve: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "manager",
                "member",
                "creator",
                "view_only",
                "admin",
                "guest",
                "publicUser",
              ],
            },
            minItems: 1,
          },
          canUpdate: { type: "array", items: { type: "string" } },
          formula: {
            type: "object",
            properties: {
              name: { type: "string" },
              applies: {
                type: ["object", "boolean"],
                additionalProperties: true,
              },
              logic: { type: "object", additionalProperties: true },
            },
            required: ["name", "applies", "logic"],
            additionalProperties: false,
          },
        },
        required: [
          "name",
          "required",
          "type",
          "title",
          "inputType",
          "checkboxText",
        ],
        additionalProperties: false,
      },
      {
        title: "Number with units",
        type: "object",
        properties: {
          inputType: { type: "string", enum: ["NumberWithUnits"] },
          name: { type: "string" },
          required: { type: "boolean" },
          title: { type: "string", minLength: 1 },
          minimum: { type: "number", exclusiveMaximum: { $data: "1/maximum" } },
          maximum: { type: "number", exclusiveMinimum: { $data: "1/minimum" } },
          tooltipText: { type: "string" },
          defaultValuePath: {
            type: "string",
            enum: [
              "property.sisd.adjustmentRatio",
              "property.sisd.defaultExclude",
              "property.improvementValue",
              "property.sisd.costType",
              "property.latitude",
              "property.longitude",
              "parcel.mailingAddress1",
              "parcel.mailingAddress2",
              "parcel.mailingAddress",
              "parcel.parcelId",
              "parcel.improvementValue",
              "parcel.block",
              "parcel.lot",
              "parcel.ownerName",
              "user.firstName",
              "user.lastName",
              "user.fullName",
              "units.feet",
              "units.inches",
              "units.hours",
              "units.minutes",
              "units.days",
              "boolean.true",
              "boolean.false",
              "date.today",
            ],
          },
          defaultValue: {
            type: "number",
            minimum: { $data: "1/minimum" },
            maximum: { $data: "1/maximum" },
          },
          unitsDefaultValuePath: {
            type: "string",
            enum: [
              "property.sisd.adjustmentRatio",
              "property.sisd.defaultExclude",
              "property.improvementValue",
              "property.sisd.costType",
              "property.latitude",
              "property.longitude",
              "parcel.mailingAddress1",
              "parcel.mailingAddress2",
              "parcel.mailingAddress",
              "parcel.parcelId",
              "parcel.improvementValue",
              "parcel.block",
              "parcel.lot",
              "parcel.ownerName",
              "user.firstName",
              "user.lastName",
              "user.fullName",
              "units.feet",
              "units.inches",
              "units.hours",
              "units.minutes",
              "units.days",
              "boolean.true",
              "boolean.false",
              "date.today",
            ],
          },
          unitsDefaultValue: { type: "string" },
          enum: {
            type: "array",
            items: {
              type: "object",
              properties: {
                label: { type: "string", minLength: 1 },
                value: { type: "string", minLength: 1 },
              },
              required: ["label", "value"],
            },
            minItems: 1,
          },
          columnHeaderOverride: { type: "string" },
          disabled: { type: "boolean" },
          helperText: { type: "string" },
          viewOnCreate: { type: "array", items: { type: "string" } },
          viewOnRetrieve: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "manager",
                "member",
                "creator",
                "view_only",
                "admin",
                "guest",
                "publicUser",
              ],
            },
            minItems: 1,
          },
          canUpdate: { type: "array", items: { type: "string" } },
        },
        required: ["inputType", "name", "enum", "title", "required"],
        additionalProperties: false,
      },
      {
        title: "Property Market Value",
        type: "object",
        properties: {
          inputType: { type: "string", enum: ["PropertyMarketValue"] },
          name: { type: "string" },
          required: { type: "boolean" },
          title: { type: "string", minLength: 1 },
          columnHeaderOverride: { type: "string" },
          tooltipText: { type: "string" },
          description: { type: "string" },
          viewOnCreate: { type: "array", items: { type: "string" } },
          viewOnRetrieve: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "manager",
                "member",
                "creator",
                "view_only",
                "admin",
                "guest",
                "publicUser",
              ],
            },
            minItems: 1,
          },
          canUpdate: { type: "array", items: { type: "string" } },
          formula: {
            type: "object",
            properties: {
              name: { type: "string" },
              applies: {
                type: ["object", "boolean"],
                additionalProperties: true,
              },
              logic: { type: "object", additionalProperties: true },
            },
            required: ["name", "applies", "logic"],
            additionalProperties: false,
          },
          enum: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "squareFootageEstimate",
                "automatedAssessedValue",
                "otherValueEstimate",
              ],
              minLength: 1,
            },
          },
          overrides: {
            type: "object",
            properties: {
              overrides: {
                type: "object",
                properties: {
                  squareFootageEstimate: {
                    type: "object",
                    properties: {
                      description: {
                        type: "string",
                        description:
                          "*FEMA preferred — Calculated by applying a value per square foot of the building.",
                      },
                      adjustmentRatio: {
                        type: "object",
                        properties: { title: { type: "string" } },
                      },
                    },
                  },
                },
              },
              viewOnCreate: { type: "array", items: { type: "string" } },
              viewOnRetrieve: {
                type: "array",
                items: {
                  type: "string",
                  enum: [
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "admin",
                    "guest",
                    "publicUser",
                  ],
                },
                minItems: 1,
              },
              canUpdate: { type: "array", items: { type: "string" } },
            },
          },
        },
        required: ["inputType", "name", "title", "required"],
        additionalProperties: false,
      },
      {
        title: "Field Group",
        type: "object",
        properties: {
          inputType: { type: "string", enum: ["group"] },
          name: { type: "string" },
          title: { type: "string", minLength: 1 },
          description: { type: "string" },
          properties: {
            $ref: "InputArray",
            type: "array",
            items: { type: "object" },
            minItems: 1,
          },
          required: { type: "boolean" },
          columns: { type: "integer" },
          heading: { type: "string", enum: ["h1", "h2"] },
        },
        required: ["inputType", "title", "properties"],
        additionalProperties: false,
      },
      {
        title: "User",
        type: "object",
        properties: {
          inputType: { type: "string", enum: ["User"] },
          name: { type: "string" },
          title: { type: "string", minLength: 1 },
          required: { type: "boolean" },
          placeholder: { type: "string" },
          type: { type: "string" },
          tooltipText: { type: "string" },
          description: { type: "string" },
          disabled: { type: "boolean" },
          helperText: { type: "string" },
          viewOnCreate: { type: "array", items: { type: "string" } },
          viewOnRetrieve: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "manager",
                "member",
                "creator",
                "view_only",
                "admin",
                "guest",
                "publicUser",
              ],
            },
            minItems: 1,
          },
          canUpdate: { type: "array", items: { type: "string" } },
          userGroupSelection: { type: "array" },
          columnHeaderOverride: { type: "string" },
        },
        required: ["inputType", "name", "required", "title"],
        additionalProperties: false,
      },
      {
        title: "Multi-select",
        type: "object",
        properties: {
          inputType: { type: "string", enum: ["multiSelect"] },
          name: { type: "string" },
          type: { type: "string", enum: ["string", "number"] },
          title: { type: "string", minLength: 1 },
          required: { type: "boolean" },
          placeholder: { type: "string" },
          description: { type: "string" },
          tooltipText: { type: "string" },
          columnHeaderOverride: { type: "string" },
          helperText: { type: "string" },
          viewOnCreate: { type: "array", items: { type: "string" } },
          viewOnRetrieve: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "manager",
                "member",
                "creator",
                "view_only",
                "admin",
                "guest",
                "publicUser",
              ],
            },
            minItems: 1,
          },
          canUpdate: { type: "array", items: { type: "string" } },
          useAsTag: { type: "boolean" },
          enum: {
            type: "array",
            items: {
              oneOf: [
                { title: "Select Option String", type: "string", minLength: 1 },
                {
                  title: "Select Option Label/Value Pair",
                  type: "object",
                  properties: {
                    label: { type: "string", minLength: 1 },
                    value: { type: "string", minLength: 1 },
                    display: {
                      type: ["string", "null"],
                      enum: [
                        "default",
                        "neutral",
                        "warning",
                        "critical",
                        "neutralInverted",
                      ],
                    },
                  },
                  required: ["label", "value"],
                },
              ],
            },
            minItems: 1,
          },
          defaultValue: { type: "array", items: { type: "string" } },
        },
        required: ["inputType", "name", "type", "title", "required", "enum"],
        additionalProperties: false,
      },
      {
        title: "Unique ID",
        type: "object",
        properties: {
          name: { type: "string" },
          required: { type: "boolean" },
          inputType: { type: "string", enum: ["UniqueId"] },
          type: { type: "string", enum: ["string"] },
          placeholder: { type: "string" },
          tooltipText: { type: "string" },
          title: { type: "string", minLength: 1 },
          labelSize: { type: "string", enum: ["small", "medium"] },
          columnHeaderOverride: { type: "string" },
          disabled: { type: "boolean" },
          helperText: { type: "string" },
          viewOnRetrieve: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "manager",
                "member",
                "creator",
                "view_only",
                "admin",
                "guest",
                "publicUser",
              ],
            },
            minItems: 1,
          },
          canUpdate: { type: "array", items: { type: "string" } },
          viewOnCreate: { type: "array", items: { type: "string" } },
          prefix: { type: "string" },
          numberType: { type: "string", enum: ["ascending", "random"] },
        },
        required: [
          "name",
          "required",
          "inputType",
          "type",
          "placeholder",
          "title",
        ],
        additionalProperties: false,
      },
    ],
  },
  minItems: 1,
};
const wrapper0 = { validate: validate11 };
function validate11(
  data,
  { instancePath = "", parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="InputArray" */ let vErrors = null;
  let errors = 0;
  if (Array.isArray(data)) {
    if (data.length < 1) {
      const err0 = {
        instancePath,
        schemaPath: "#/minItems",
        keyword: "minItems",
        params: { limit: 1 },
        message: "must NOT have fewer than 1 items",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    const len0 = data.length;
    for (let i0 = 0; i0 < len0; i0++) {
      let data0 = data[i0];
      if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
        const tag0 = data0.inputType;
        if (typeof tag0 == "string") {
          if (tag0 === "DocumentUploader") {
            const _errs7 = errors;
            let valid5 = true;
            const _errs8 = errors;
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.required !== undefined) {
                if (true !== data0.required) {
                  const err1 = {};
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
              }
            }
            var _valid0 = _errs8 === errors;
            errors = _errs7;
            if (vErrors !== null) {
              if (_errs7) {
                vErrors.length = _errs7;
              } else {
                vErrors = null;
              }
            }
            if (_valid0) {
              const _errs10 = errors;
              if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
                if (data0.minItems === undefined) {
                  const err2 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/0/allOf/0/then/required",
                    keyword: "required",
                    params: { missingProperty: "minItems" },
                    message: "must have required property '" + "minItems" + "'",
                  };
                  if (vErrors === null) {
                    vErrors = [err2];
                  } else {
                    vErrors.push(err2);
                  }
                  errors++;
                }
                if (data0.minItems !== undefined) {
                  let data2 = data0.minItems;
                  if (typeof data2 == "number" && isFinite(data2)) {
                    if (data2 < 1 || isNaN(data2)) {
                      const err3 = {
                        instancePath: instancePath + "/" + i0 + "/minItems",
                        schemaPath:
                          "#/items/oneOf/0/allOf/0/then/properties/minItems/minimum",
                        keyword: "minimum",
                        params: { comparison: ">=", limit: 1 },
                        message: "must be >= 1",
                      };
                      if (vErrors === null) {
                        vErrors = [err3];
                      } else {
                        vErrors.push(err3);
                      }
                      errors++;
                    }
                  } else {
                    const err4 = {
                      instancePath: instancePath + "/" + i0 + "/minItems",
                      schemaPath:
                        "#/items/oneOf/0/allOf/0/then/properties/minItems/type",
                      keyword: "type",
                      params: { type: "number" },
                      message: "must be number",
                    };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                }
              }
              var _valid0 = _errs10 === errors;
              valid5 = _valid0;
            }
            if (!valid5) {
              const err5 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/0/allOf/0/if",
                keyword: "if",
                params: { failingKeyword: "then" },
                message: 'must match "then" schema',
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.inputType === undefined) {
                const err6 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/0/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
              if (data0.name === undefined) {
                const err7 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/0/required",
                  keyword: "required",
                  params: { missingProperty: "name" },
                  message: "must have required property '" + "name" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
              if (data0.required === undefined) {
                const err8 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/0/required",
                  keyword: "required",
                  params: { missingProperty: "required" },
                  message: "must have required property '" + "required" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
              if (data0.maxItems === undefined) {
                const err9 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/0/required",
                  keyword: "required",
                  params: { missingProperty: "maxItems" },
                  message: "must have required property '" + "maxItems" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err10 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/0/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
              if (data0.fileTypeDescription === undefined) {
                const err11 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/0/required",
                  keyword: "required",
                  params: { missingProperty: "fileTypeDescription" },
                  message:
                    "must have required property '" +
                    "fileTypeDescription" +
                    "'",
                };
                if (vErrors === null) {
                  vErrors = [err11];
                } else {
                  vErrors.push(err11);
                }
                errors++;
              }
              if (data0.fileQuantityDescription === undefined) {
                const err12 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/0/required",
                  keyword: "required",
                  params: { missingProperty: "fileQuantityDescription" },
                  message:
                    "must have required property '" +
                    "fileQuantityDescription" +
                    "'",
                };
                if (vErrors === null) {
                  vErrors = [err12];
                } else {
                  vErrors.push(err12);
                }
                errors++;
              }
              if (data0.fileSizeDescription === undefined) {
                const err13 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/0/required",
                  keyword: "required",
                  params: { missingProperty: "fileSizeDescription" },
                  message:
                    "must have required property '" +
                    "fileSizeDescription" +
                    "'",
                };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
              if (data0.accountDocumentType === undefined) {
                const err14 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/0/required",
                  keyword: "required",
                  params: { missingProperty: "accountDocumentType" },
                  message:
                    "must have required property '" +
                    "accountDocumentType" +
                    "'",
                };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
              if (data0.documentTypeName === undefined) {
                const err15 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/0/required",
                  keyword: "required",
                  params: { missingProperty: "documentTypeName" },
                  message:
                    "must have required property '" + "documentTypeName" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
              }
              if (data0.documentTypeAbbreviation === undefined) {
                const err16 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/0/required",
                  keyword: "required",
                  params: { missingProperty: "documentTypeAbbreviation" },
                  message:
                    "must have required property '" +
                    "documentTypeAbbreviation" +
                    "'",
                };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
              for (const key0 in data0) {
                if (!func2.call(schema28.items.oneOf[0].properties, key0)) {
                  const err17 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/0/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key0 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err17];
                  } else {
                    vErrors.push(err17);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data3 = data0.inputType;
                if (typeof data3 !== "string") {
                  const err18 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/0/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err18];
                  } else {
                    vErrors.push(err18);
                  }
                  errors++;
                }
                if (!(data3 === "DocumentUploader")) {
                  const err19 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/0/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[0].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err19];
                  } else {
                    vErrors.push(err19);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err20 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/0/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err20];
                  } else {
                    vErrors.push(err20);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                let data5 = data0.title;
                if (typeof data5 === "string") {
                  if (func3(data5) < 1) {
                    const err21 = {
                      instancePath: instancePath + "/" + i0 + "/title",
                      schemaPath: "#/items/oneOf/0/properties/title/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err21];
                    } else {
                      vErrors.push(err21);
                    }
                    errors++;
                  }
                } else {
                  const err22 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/0/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err22];
                  } else {
                    vErrors.push(err22);
                  }
                  errors++;
                }
              }
              if (data0.tooltipText !== undefined) {
                if (typeof data0.tooltipText !== "string") {
                  const err23 = {
                    instancePath: instancePath + "/" + i0 + "/tooltipText",
                    schemaPath: "#/items/oneOf/0/properties/tooltipText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err23];
                  } else {
                    vErrors.push(err23);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err24 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/0/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err24];
                  } else {
                    vErrors.push(err24);
                  }
                  errors++;
                }
              }
              if (data0.accountDocumentType !== undefined) {
                let data8 = data0.accountDocumentType;
                if (typeof data8 === "string") {
                  if (func3(data8) < 1) {
                    const err25 = {
                      instancePath:
                        instancePath + "/" + i0 + "/accountDocumentType",
                      schemaPath:
                        "#/items/oneOf/0/properties/accountDocumentType/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err25];
                    } else {
                      vErrors.push(err25);
                    }
                    errors++;
                  }
                } else {
                  const err26 = {
                    instancePath:
                      instancePath + "/" + i0 + "/accountDocumentType",
                    schemaPath:
                      "#/items/oneOf/0/properties/accountDocumentType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err26];
                  } else {
                    vErrors.push(err26);
                  }
                  errors++;
                }
              }
              if (data0.documentTypeAbbreviation !== undefined) {
                let data9 = data0.documentTypeAbbreviation;
                if (typeof data9 === "string") {
                  if (func3(data9) < 1) {
                    const err27 = {
                      instancePath:
                        instancePath + "/" + i0 + "/documentTypeAbbreviation",
                      schemaPath:
                        "#/items/oneOf/0/properties/documentTypeAbbreviation/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err27];
                    } else {
                      vErrors.push(err27);
                    }
                    errors++;
                  }
                } else {
                  const err28 = {
                    instancePath:
                      instancePath + "/" + i0 + "/documentTypeAbbreviation",
                    schemaPath:
                      "#/items/oneOf/0/properties/documentTypeAbbreviation/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err28];
                  } else {
                    vErrors.push(err28);
                  }
                  errors++;
                }
              }
              if (data0.documentTypeName !== undefined) {
                if (typeof data0.documentTypeName !== "string") {
                  const err29 = {
                    instancePath: instancePath + "/" + i0 + "/documentTypeName",
                    schemaPath:
                      "#/items/oneOf/0/properties/documentTypeName/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err29];
                  } else {
                    vErrors.push(err29);
                  }
                  errors++;
                }
              }
              if (data0.emptyFilesMessage !== undefined) {
                if (typeof data0.emptyFilesMessage !== "string") {
                  const err30 = {
                    instancePath:
                      instancePath + "/" + i0 + "/emptyFilesMessage",
                    schemaPath:
                      "#/items/oneOf/0/properties/emptyFilesMessage/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err30];
                  } else {
                    vErrors.push(err30);
                  }
                  errors++;
                }
              }
              if (data0.fileQuantityDescription !== undefined) {
                let data12 = data0.fileQuantityDescription;
                if (typeof data12 === "string") {
                  if (func3(data12) < 1) {
                    const err31 = {
                      instancePath:
                        instancePath + "/" + i0 + "/fileQuantityDescription",
                      schemaPath:
                        "#/items/oneOf/0/properties/fileQuantityDescription/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err31];
                    } else {
                      vErrors.push(err31);
                    }
                    errors++;
                  }
                } else {
                  const err32 = {
                    instancePath:
                      instancePath + "/" + i0 + "/fileQuantityDescription",
                    schemaPath:
                      "#/items/oneOf/0/properties/fileQuantityDescription/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err32];
                  } else {
                    vErrors.push(err32);
                  }
                  errors++;
                }
              }
              if (data0.fileSizeDescription !== undefined) {
                let data13 = data0.fileSizeDescription;
                if (typeof data13 === "string") {
                  if (func3(data13) < 1) {
                    const err33 = {
                      instancePath:
                        instancePath + "/" + i0 + "/fileSizeDescription",
                      schemaPath:
                        "#/items/oneOf/0/properties/fileSizeDescription/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err33];
                    } else {
                      vErrors.push(err33);
                    }
                    errors++;
                  }
                } else {
                  const err34 = {
                    instancePath:
                      instancePath + "/" + i0 + "/fileSizeDescription",
                    schemaPath:
                      "#/items/oneOf/0/properties/fileSizeDescription/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err34];
                  } else {
                    vErrors.push(err34);
                  }
                  errors++;
                }
              }
              if (data0.fileTypeDescription !== undefined) {
                let data14 = data0.fileTypeDescription;
                if (typeof data14 === "string") {
                  if (func3(data14) < 1) {
                    const err35 = {
                      instancePath:
                        instancePath + "/" + i0 + "/fileTypeDescription",
                      schemaPath:
                        "#/items/oneOf/0/properties/fileTypeDescription/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err35];
                    } else {
                      vErrors.push(err35);
                    }
                    errors++;
                  }
                } else {
                  const err36 = {
                    instancePath:
                      instancePath + "/" + i0 + "/fileTypeDescription",
                    schemaPath:
                      "#/items/oneOf/0/properties/fileTypeDescription/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err36];
                  } else {
                    vErrors.push(err36);
                  }
                  errors++;
                }
              }
              if (data0.columnHeaderOverride !== undefined) {
                if (typeof data0.columnHeaderOverride !== "string") {
                  const err37 = {
                    instancePath:
                      instancePath + "/" + i0 + "/columnHeaderOverride",
                    schemaPath:
                      "#/items/oneOf/0/properties/columnHeaderOverride/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err37];
                  } else {
                    vErrors.push(err37);
                  }
                  errors++;
                }
              }
              if (data0.helperText !== undefined) {
                if (typeof data0.helperText !== "string") {
                  const err38 = {
                    instancePath: instancePath + "/" + i0 + "/helperText",
                    schemaPath: "#/items/oneOf/0/properties/helperText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err38];
                  } else {
                    vErrors.push(err38);
                  }
                  errors++;
                }
              }
              if (data0.viewOnCreate !== undefined) {
                let data17 = data0.viewOnCreate;
                if (Array.isArray(data17)) {
                  const len1 = data17.length;
                  for (let i1 = 0; i1 < len1; i1++) {
                    if (typeof data17[i1] !== "string") {
                      const err39 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnCreate/" + i1,
                        schemaPath:
                          "#/items/oneOf/0/properties/viewOnCreate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err39];
                      } else {
                        vErrors.push(err39);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err40 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnCreate",
                    schemaPath: "#/items/oneOf/0/properties/viewOnCreate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err40];
                  } else {
                    vErrors.push(err40);
                  }
                  errors++;
                }
              }
              if (data0.viewOnRetrieve !== undefined) {
                let data19 = data0.viewOnRetrieve;
                if (Array.isArray(data19)) {
                  if (data19.length < 1) {
                    const err41 = {
                      instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                      schemaPath:
                        "#/items/oneOf/0/properties/viewOnRetrieve/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err41];
                    } else {
                      vErrors.push(err41);
                    }
                    errors++;
                  }
                  const len2 = data19.length;
                  for (let i2 = 0; i2 < len2; i2++) {
                    let data20 = data19[i2];
                    if (typeof data20 !== "string") {
                      const err42 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i2,
                        schemaPath:
                          "#/items/oneOf/0/properties/viewOnRetrieve/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err42];
                      } else {
                        vErrors.push(err42);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data20 === "manager" ||
                        data20 === "member" ||
                        data20 === "creator" ||
                        data20 === "view_only" ||
                        data20 === "admin" ||
                        data20 === "guest" ||
                        data20 === "publicUser"
                      )
                    ) {
                      const err43 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i2,
                        schemaPath:
                          "#/items/oneOf/0/properties/viewOnRetrieve/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[0].properties.viewOnRetrieve
                              .items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err43];
                      } else {
                        vErrors.push(err43);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err44 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                    schemaPath:
                      "#/items/oneOf/0/properties/viewOnRetrieve/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err44];
                  } else {
                    vErrors.push(err44);
                  }
                  errors++;
                }
              }
              if (data0.canUpdate !== undefined) {
                let data21 = data0.canUpdate;
                if (Array.isArray(data21)) {
                  const len3 = data21.length;
                  for (let i3 = 0; i3 < len3; i3++) {
                    if (typeof data21[i3] !== "string") {
                      const err45 = {
                        instancePath:
                          instancePath + "/" + i0 + "/canUpdate/" + i3,
                        schemaPath:
                          "#/items/oneOf/0/properties/canUpdate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err45];
                      } else {
                        vErrors.push(err45);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err46 = {
                    instancePath: instancePath + "/" + i0 + "/canUpdate",
                    schemaPath: "#/items/oneOf/0/properties/canUpdate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err46];
                  } else {
                    vErrors.push(err46);
                  }
                  errors++;
                }
              }
              if (data0.maxItems !== undefined) {
                let data23 = data0.maxItems;
                if (
                  !(
                    typeof data23 == "number" &&
                    !(data23 % 1) &&
                    !isNaN(data23) &&
                    isFinite(data23)
                  )
                ) {
                  const err47 = {
                    instancePath: instancePath + "/" + i0 + "/maxItems",
                    schemaPath: "#/items/oneOf/0/properties/maxItems/type",
                    keyword: "type",
                    params: { type: "integer" },
                    message: "must be integer",
                  };
                  if (vErrors === null) {
                    vErrors = [err47];
                  } else {
                    vErrors.push(err47);
                  }
                  errors++;
                }
                if (typeof data23 == "number" && isFinite(data23)) {
                  if (data23 < 1 || isNaN(data23)) {
                    const err48 = {
                      instancePath: instancePath + "/" + i0 + "/maxItems",
                      schemaPath: "#/items/oneOf/0/properties/maxItems/minimum",
                      keyword: "minimum",
                      params: { comparison: ">=", limit: 1 },
                      message: "must be >= 1",
                    };
                    if (vErrors === null) {
                      vErrors = [err48];
                    } else {
                      vErrors.push(err48);
                    }
                    errors++;
                  }
                }
              }
              if (data0.minItems !== undefined) {
                let data24 = data0.minItems;
                if (
                  !(
                    typeof data24 == "number" &&
                    !(data24 % 1) &&
                    !isNaN(data24) &&
                    isFinite(data24)
                  )
                ) {
                  const err49 = {
                    instancePath: instancePath + "/" + i0 + "/minItems",
                    schemaPath: "#/items/oneOf/0/properties/minItems/type",
                    keyword: "type",
                    params: { type: "integer" },
                    message: "must be integer",
                  };
                  if (vErrors === null) {
                    vErrors = [err49];
                  } else {
                    vErrors.push(err49);
                  }
                  errors++;
                }
              }
            } else {
              const err50 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/0/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err50];
              } else {
                vErrors.push(err50);
              }
              errors++;
            }
          } else if (tag0 === "Tags") {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.inputType === undefined) {
                const err51 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/1/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err51];
                } else {
                  vErrors.push(err51);
                }
                errors++;
              }
              if (data0.name === undefined) {
                const err52 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/1/required",
                  keyword: "required",
                  params: { missingProperty: "name" },
                  message: "must have required property '" + "name" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err52];
                } else {
                  vErrors.push(err52);
                }
                errors++;
              }
              if (data0.type === undefined) {
                const err53 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/1/required",
                  keyword: "required",
                  params: { missingProperty: "type" },
                  message: "must have required property '" + "type" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err53];
                } else {
                  vErrors.push(err53);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err54 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/1/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err54];
                } else {
                  vErrors.push(err54);
                }
                errors++;
              }
              if (data0.required === undefined) {
                const err55 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/1/required",
                  keyword: "required",
                  params: { missingProperty: "required" },
                  message: "must have required property '" + "required" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err55];
                } else {
                  vErrors.push(err55);
                }
                errors++;
              }
              if (data0.minItems === undefined) {
                const err56 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/1/required",
                  keyword: "required",
                  params: { missingProperty: "minItems" },
                  message: "must have required property '" + "minItems" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err56];
                } else {
                  vErrors.push(err56);
                }
                errors++;
              }
              if (data0.enum === undefined) {
                const err57 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/1/required",
                  keyword: "required",
                  params: { missingProperty: "enum" },
                  message: "must have required property '" + "enum" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err57];
                } else {
                  vErrors.push(err57);
                }
                errors++;
              }
              for (const key1 in data0) {
                if (!func2.call(schema28.items.oneOf[1].properties, key1)) {
                  const err58 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/1/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key1 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err58];
                  } else {
                    vErrors.push(err58);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data25 = data0.inputType;
                if (typeof data25 !== "string") {
                  const err59 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/1/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err59];
                  } else {
                    vErrors.push(err59);
                  }
                  errors++;
                }
                if (!(data25 === "Tags")) {
                  const err60 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/1/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[1].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err60];
                  } else {
                    vErrors.push(err60);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err61 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/1/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err61];
                  } else {
                    vErrors.push(err61);
                  }
                  errors++;
                }
              }
              if (data0.type !== undefined) {
                let data27 = data0.type;
                if (typeof data27 !== "string") {
                  const err62 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/1/properties/type/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err62];
                  } else {
                    vErrors.push(err62);
                  }
                  errors++;
                }
                if (!(data27 === "string" || data27 === "number")) {
                  const err63 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/1/properties/type/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[1].properties.type.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err63];
                  } else {
                    vErrors.push(err63);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                let data28 = data0.title;
                if (typeof data28 === "string") {
                  if (func3(data28) < 1) {
                    const err64 = {
                      instancePath: instancePath + "/" + i0 + "/title",
                      schemaPath: "#/items/oneOf/1/properties/title/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err64];
                    } else {
                      vErrors.push(err64);
                    }
                    errors++;
                  }
                } else {
                  const err65 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/1/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err65];
                  } else {
                    vErrors.push(err65);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err66 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/1/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err66];
                  } else {
                    vErrors.push(err66);
                  }
                  errors++;
                }
              }
              if (data0.description !== undefined) {
                if (typeof data0.description !== "string") {
                  const err67 = {
                    instancePath: instancePath + "/" + i0 + "/description",
                    schemaPath: "#/items/oneOf/1/properties/description/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err67];
                  } else {
                    vErrors.push(err67);
                  }
                  errors++;
                }
              }
              if (data0.tooltipText !== undefined) {
                if (typeof data0.tooltipText !== "string") {
                  const err68 = {
                    instancePath: instancePath + "/" + i0 + "/tooltipText",
                    schemaPath: "#/items/oneOf/1/properties/tooltipText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err68];
                  } else {
                    vErrors.push(err68);
                  }
                  errors++;
                }
              }
              if (data0.columnHeaderOverride !== undefined) {
                if (typeof data0.columnHeaderOverride !== "string") {
                  const err69 = {
                    instancePath:
                      instancePath + "/" + i0 + "/columnHeaderOverride",
                    schemaPath:
                      "#/items/oneOf/1/properties/columnHeaderOverride/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err69];
                  } else {
                    vErrors.push(err69);
                  }
                  errors++;
                }
              }
              if (data0.viewOnCreate !== undefined) {
                let data33 = data0.viewOnCreate;
                if (Array.isArray(data33)) {
                  const len4 = data33.length;
                  for (let i4 = 0; i4 < len4; i4++) {
                    if (typeof data33[i4] !== "string") {
                      const err70 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnCreate/" + i4,
                        schemaPath:
                          "#/items/oneOf/1/properties/viewOnCreate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err70];
                      } else {
                        vErrors.push(err70);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err71 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnCreate",
                    schemaPath: "#/items/oneOf/1/properties/viewOnCreate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err71];
                  } else {
                    vErrors.push(err71);
                  }
                  errors++;
                }
              }
              if (data0.viewOnRetrieve !== undefined) {
                let data35 = data0.viewOnRetrieve;
                if (Array.isArray(data35)) {
                  if (data35.length < 1) {
                    const err72 = {
                      instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                      schemaPath:
                        "#/items/oneOf/1/properties/viewOnRetrieve/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err72];
                    } else {
                      vErrors.push(err72);
                    }
                    errors++;
                  }
                  const len5 = data35.length;
                  for (let i5 = 0; i5 < len5; i5++) {
                    let data36 = data35[i5];
                    if (typeof data36 !== "string") {
                      const err73 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i5,
                        schemaPath:
                          "#/items/oneOf/1/properties/viewOnRetrieve/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err73];
                      } else {
                        vErrors.push(err73);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data36 === "manager" ||
                        data36 === "member" ||
                        data36 === "creator" ||
                        data36 === "view_only" ||
                        data36 === "admin" ||
                        data36 === "guest" ||
                        data36 === "publicUser"
                      )
                    ) {
                      const err74 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i5,
                        schemaPath:
                          "#/items/oneOf/1/properties/viewOnRetrieve/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[1].properties.viewOnRetrieve
                              .items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err74];
                      } else {
                        vErrors.push(err74);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err75 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                    schemaPath:
                      "#/items/oneOf/1/properties/viewOnRetrieve/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err75];
                  } else {
                    vErrors.push(err75);
                  }
                  errors++;
                }
              }
              if (data0.canUpdate !== undefined) {
                let data37 = data0.canUpdate;
                if (Array.isArray(data37)) {
                  const len6 = data37.length;
                  for (let i6 = 0; i6 < len6; i6++) {
                    if (typeof data37[i6] !== "string") {
                      const err76 = {
                        instancePath:
                          instancePath + "/" + i0 + "/canUpdate/" + i6,
                        schemaPath:
                          "#/items/oneOf/1/properties/canUpdate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err76];
                      } else {
                        vErrors.push(err76);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err77 = {
                    instancePath: instancePath + "/" + i0 + "/canUpdate",
                    schemaPath: "#/items/oneOf/1/properties/canUpdate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err77];
                  } else {
                    vErrors.push(err77);
                  }
                  errors++;
                }
              }
              if (data0.minItems !== undefined) {
                let data39 = data0.minItems;
                if (
                  !(
                    typeof data39 == "number" &&
                    !(data39 % 1) &&
                    !isNaN(data39) &&
                    isFinite(data39)
                  )
                ) {
                  const err78 = {
                    instancePath: instancePath + "/" + i0 + "/minItems",
                    schemaPath: "#/items/oneOf/1/properties/minItems/type",
                    keyword: "type",
                    params: { type: "integer" },
                    message: "must be integer",
                  };
                  if (vErrors === null) {
                    vErrors = [err78];
                  } else {
                    vErrors.push(err78);
                  }
                  errors++;
                }
              }
              if (data0.enum !== undefined) {
                let data40 = data0.enum;
                if (Array.isArray(data40)) {
                  if (data40.length < 1) {
                    const err79 = {
                      instancePath: instancePath + "/" + i0 + "/enum",
                      schemaPath: "#/items/oneOf/1/properties/enum/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err79];
                    } else {
                      vErrors.push(err79);
                    }
                    errors++;
                  }
                  const len7 = data40.length;
                  for (let i7 = 0; i7 < len7; i7++) {
                    let data41 = data40[i7];
                    if (typeof data41 === "string") {
                      if (func3(data41) < 1) {
                        const err80 = {
                          instancePath: instancePath + "/" + i0 + "/enum/" + i7,
                          schemaPath:
                            "#/items/oneOf/1/properties/enum/items/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err80];
                        } else {
                          vErrors.push(err80);
                        }
                        errors++;
                      }
                    } else {
                      const err81 = {
                        instancePath: instancePath + "/" + i0 + "/enum/" + i7,
                        schemaPath:
                          "#/items/oneOf/1/properties/enum/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err81];
                      } else {
                        vErrors.push(err81);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err82 = {
                    instancePath: instancePath + "/" + i0 + "/enum",
                    schemaPath: "#/items/oneOf/1/properties/enum/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err82];
                  } else {
                    vErrors.push(err82);
                  }
                  errors++;
                }
              }
              if (data0.defaultValue !== undefined) {
                let data42 = data0.defaultValue;
                if (Array.isArray(data42)) {
                  const len8 = data42.length;
                  for (let i8 = 0; i8 < len8; i8++) {
                    if (typeof data42[i8] !== "string") {
                      const err83 = {
                        instancePath:
                          instancePath + "/" + i0 + "/defaultValue/" + i8,
                        schemaPath:
                          "#/items/oneOf/1/properties/defaultValue/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err83];
                      } else {
                        vErrors.push(err83);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err84 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValue",
                    schemaPath: "#/items/oneOf/1/properties/defaultValue/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err84];
                  } else {
                    vErrors.push(err84);
                  }
                  errors++;
                }
              }
            } else {
              const err85 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/1/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err85];
              } else {
                vErrors.push(err85);
              }
              errors++;
            }
          } else if (tag0 === "select") {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.name === undefined) {
                const err86 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/2/required",
                  keyword: "required",
                  params: { missingProperty: "name" },
                  message: "must have required property '" + "name" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err86];
                } else {
                  vErrors.push(err86);
                }
                errors++;
              }
              if (data0.required === undefined) {
                const err87 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/2/required",
                  keyword: "required",
                  params: { missingProperty: "required" },
                  message: "must have required property '" + "required" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err87];
                } else {
                  vErrors.push(err87);
                }
                errors++;
              }
              if (data0.type === undefined) {
                const err88 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/2/required",
                  keyword: "required",
                  params: { missingProperty: "type" },
                  message: "must have required property '" + "type" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err88];
                } else {
                  vErrors.push(err88);
                }
                errors++;
              }
              if (data0.inputType === undefined) {
                const err89 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/2/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err89];
                } else {
                  vErrors.push(err89);
                }
                errors++;
              }
              if (data0.placeholder === undefined) {
                const err90 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/2/required",
                  keyword: "required",
                  params: { missingProperty: "placeholder" },
                  message:
                    "must have required property '" + "placeholder" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err90];
                } else {
                  vErrors.push(err90);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err91 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/2/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err91];
                } else {
                  vErrors.push(err91);
                }
                errors++;
              }
              if (data0.enum === undefined) {
                const err92 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/2/required",
                  keyword: "required",
                  params: { missingProperty: "enum" },
                  message: "must have required property '" + "enum" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err92];
                } else {
                  vErrors.push(err92);
                }
                errors++;
              }
              for (const key2 in data0) {
                if (!func2.call(schema28.items.oneOf[2].properties, key2)) {
                  const err93 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/2/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key2 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err93];
                  } else {
                    vErrors.push(err93);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err94 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/2/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err94];
                  } else {
                    vErrors.push(err94);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err95 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/2/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err95];
                  } else {
                    vErrors.push(err95);
                  }
                  errors++;
                }
              }
              if (data0.useAsTag !== undefined) {
                if (typeof data0.useAsTag !== "boolean") {
                  const err96 = {
                    instancePath: instancePath + "/" + i0 + "/useAsTag",
                    schemaPath: "#/items/oneOf/2/properties/useAsTag/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err96];
                  } else {
                    vErrors.push(err96);
                  }
                  errors++;
                }
              }
              if (data0.type !== undefined) {
                let data47 = data0.type;
                if (typeof data47 !== "string") {
                  const err97 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/2/properties/type/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err97];
                  } else {
                    vErrors.push(err97);
                  }
                  errors++;
                }
                if (!(data47 === "string")) {
                  const err98 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/2/properties/type/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[2].properties.type.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err98];
                  } else {
                    vErrors.push(err98);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data48 = data0.inputType;
                if (typeof data48 !== "string") {
                  const err99 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/2/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err99];
                  } else {
                    vErrors.push(err99);
                  }
                  errors++;
                }
                if (!(data48 === "select")) {
                  const err100 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/2/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[2].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err100];
                  } else {
                    vErrors.push(err100);
                  }
                  errors++;
                }
              }
              if (data0.placeholder !== undefined) {
                if (typeof data0.placeholder !== "string") {
                  const err101 = {
                    instancePath: instancePath + "/" + i0 + "/placeholder",
                    schemaPath: "#/items/oneOf/2/properties/placeholder/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err101];
                  } else {
                    vErrors.push(err101);
                  }
                  errors++;
                }
              }
              if (data0.tooltipText !== undefined) {
                if (typeof data0.tooltipText !== "string") {
                  const err102 = {
                    instancePath: instancePath + "/" + i0 + "/tooltipText",
                    schemaPath: "#/items/oneOf/2/properties/tooltipText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err102];
                  } else {
                    vErrors.push(err102);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                let data51 = data0.title;
                if (typeof data51 === "string") {
                  if (func3(data51) < 1) {
                    const err103 = {
                      instancePath: instancePath + "/" + i0 + "/title",
                      schemaPath: "#/items/oneOf/2/properties/title/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err103];
                    } else {
                      vErrors.push(err103);
                    }
                    errors++;
                  }
                } else {
                  const err104 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/2/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err104];
                  } else {
                    vErrors.push(err104);
                  }
                  errors++;
                }
              }
              if (data0.enum !== undefined) {
                let data52 = data0.enum;
                if (Array.isArray(data52)) {
                  if (data52.length < 1) {
                    const err105 = {
                      instancePath: instancePath + "/" + i0 + "/enum",
                      schemaPath: "#/items/oneOf/2/properties/enum/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err105];
                    } else {
                      vErrors.push(err105);
                    }
                    errors++;
                  }
                  const len9 = data52.length;
                  for (let i9 = 0; i9 < len9; i9++) {
                    let data53 = data52[i9];
                    const _errs121 = errors;
                    let valid31 = false;
                    let passing0 = null;
                    const _errs122 = errors;
                    if (typeof data53 === "string") {
                      if (func3(data53) < 1) {
                        const err106 = {
                          instancePath: instancePath + "/" + i0 + "/enum/" + i9,
                          schemaPath:
                            "#/items/oneOf/2/properties/enum/items/oneOf/0/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err106];
                        } else {
                          vErrors.push(err106);
                        }
                        errors++;
                      }
                    } else {
                      const err107 = {
                        instancePath: instancePath + "/" + i0 + "/enum/" + i9,
                        schemaPath:
                          "#/items/oneOf/2/properties/enum/items/oneOf/0/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err107];
                      } else {
                        vErrors.push(err107);
                      }
                      errors++;
                    }
                    var _valid1 = _errs122 === errors;
                    if (_valid1) {
                      valid31 = true;
                      passing0 = 0;
                    }
                    const _errs124 = errors;
                    if (
                      data53 &&
                      typeof data53 == "object" &&
                      !Array.isArray(data53)
                    ) {
                      if (data53.label === undefined) {
                        const err108 = {
                          instancePath: instancePath + "/" + i0 + "/enum/" + i9,
                          schemaPath:
                            "#/items/oneOf/2/properties/enum/items/oneOf/1/required",
                          keyword: "required",
                          params: { missingProperty: "label" },
                          message:
                            "must have required property '" + "label" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err108];
                        } else {
                          vErrors.push(err108);
                        }
                        errors++;
                      }
                      if (data53.value === undefined) {
                        const err109 = {
                          instancePath: instancePath + "/" + i0 + "/enum/" + i9,
                          schemaPath:
                            "#/items/oneOf/2/properties/enum/items/oneOf/1/required",
                          keyword: "required",
                          params: { missingProperty: "value" },
                          message:
                            "must have required property '" + "value" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err109];
                        } else {
                          vErrors.push(err109);
                        }
                        errors++;
                      }
                      if (data53.label !== undefined) {
                        let data54 = data53.label;
                        if (typeof data54 === "string") {
                          if (func3(data54) < 1) {
                            const err110 = {
                              instancePath:
                                instancePath +
                                "/" +
                                i0 +
                                "/enum/" +
                                i9 +
                                "/label",
                              schemaPath:
                                "#/items/oneOf/2/properties/enum/items/oneOf/1/properties/label/minLength",
                              keyword: "minLength",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 characters",
                            };
                            if (vErrors === null) {
                              vErrors = [err110];
                            } else {
                              vErrors.push(err110);
                            }
                            errors++;
                          }
                        } else {
                          const err111 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/enum/" +
                              i9 +
                              "/label",
                            schemaPath:
                              "#/items/oneOf/2/properties/enum/items/oneOf/1/properties/label/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err111];
                          } else {
                            vErrors.push(err111);
                          }
                          errors++;
                        }
                      }
                      if (data53.value !== undefined) {
                        let data55 = data53.value;
                        if (typeof data55 === "string") {
                          if (func3(data55) < 1) {
                            const err112 = {
                              instancePath:
                                instancePath +
                                "/" +
                                i0 +
                                "/enum/" +
                                i9 +
                                "/value",
                              schemaPath:
                                "#/items/oneOf/2/properties/enum/items/oneOf/1/properties/value/minLength",
                              keyword: "minLength",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 characters",
                            };
                            if (vErrors === null) {
                              vErrors = [err112];
                            } else {
                              vErrors.push(err112);
                            }
                            errors++;
                          }
                        } else {
                          const err113 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/enum/" +
                              i9 +
                              "/value",
                            schemaPath:
                              "#/items/oneOf/2/properties/enum/items/oneOf/1/properties/value/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err113];
                          } else {
                            vErrors.push(err113);
                          }
                          errors++;
                        }
                      }
                      if (data53.display !== undefined) {
                        let data56 = data53.display;
                        if (typeof data56 !== "string" && data56 !== null) {
                          const err114 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/enum/" +
                              i9 +
                              "/display",
                            schemaPath:
                              "#/items/oneOf/2/properties/enum/items/oneOf/1/properties/display/type",
                            keyword: "type",
                            params: {
                              type: schema28.items.oneOf[2].properties.enum
                                .items.oneOf[1].properties.display.type,
                            },
                            message: "must be string,null",
                          };
                          if (vErrors === null) {
                            vErrors = [err114];
                          } else {
                            vErrors.push(err114);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data56 === "default" ||
                            data56 === "neutral" ||
                            data56 === "warning" ||
                            data56 === "critical" ||
                            data56 === "neutralInverted"
                          )
                        ) {
                          const err115 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/enum/" +
                              i9 +
                              "/display",
                            schemaPath:
                              "#/items/oneOf/2/properties/enum/items/oneOf/1/properties/display/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema28.items.oneOf[2].properties.enum.items
                                  .oneOf[1].properties.display.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err115];
                          } else {
                            vErrors.push(err115);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err116 = {
                        instancePath: instancePath + "/" + i0 + "/enum/" + i9,
                        schemaPath:
                          "#/items/oneOf/2/properties/enum/items/oneOf/1/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err116];
                      } else {
                        vErrors.push(err116);
                      }
                      errors++;
                    }
                    var _valid1 = _errs124 === errors;
                    if (_valid1 && valid31) {
                      valid31 = false;
                      passing0 = [passing0, 1];
                    } else {
                      if (_valid1) {
                        valid31 = true;
                        passing0 = 1;
                      }
                    }
                    if (!valid31) {
                      const err117 = {
                        instancePath: instancePath + "/" + i0 + "/enum/" + i9,
                        schemaPath:
                          "#/items/oneOf/2/properties/enum/items/oneOf",
                        keyword: "oneOf",
                        params: { passingSchemas: passing0 },
                        message: "must match exactly one schema in oneOf",
                      };
                      if (vErrors === null) {
                        vErrors = [err117];
                      } else {
                        vErrors.push(err117);
                      }
                      errors++;
                    } else {
                      errors = _errs121;
                      if (vErrors !== null) {
                        if (_errs121) {
                          vErrors.length = _errs121;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                  }
                } else {
                  const err118 = {
                    instancePath: instancePath + "/" + i0 + "/enum",
                    schemaPath: "#/items/oneOf/2/properties/enum/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err118];
                  } else {
                    vErrors.push(err118);
                  }
                  errors++;
                }
              }
              if (data0.defaultValuePath !== undefined) {
                let data57 = data0.defaultValuePath;
                if (typeof data57 !== "string") {
                  const err119 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValuePath",
                    schemaPath:
                      "#/items/oneOf/2/properties/defaultValuePath/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err119];
                  } else {
                    vErrors.push(err119);
                  }
                  errors++;
                }
                if (
                  !(
                    data57 === "property.sisd.adjustmentRatio" ||
                    data57 === "property.sisd.defaultExclude" ||
                    data57 === "property.improvementValue" ||
                    data57 === "property.sisd.costType" ||
                    data57 === "property.latitude" ||
                    data57 === "property.longitude" ||
                    data57 === "parcel.mailingAddress1" ||
                    data57 === "parcel.mailingAddress2" ||
                    data57 === "parcel.mailingAddress" ||
                    data57 === "parcel.parcelId" ||
                    data57 === "parcel.improvementValue" ||
                    data57 === "parcel.block" ||
                    data57 === "parcel.lot" ||
                    data57 === "parcel.ownerName" ||
                    data57 === "user.firstName" ||
                    data57 === "user.lastName" ||
                    data57 === "user.fullName" ||
                    data57 === "units.feet" ||
                    data57 === "units.inches" ||
                    data57 === "units.hours" ||
                    data57 === "units.minutes" ||
                    data57 === "units.days" ||
                    data57 === "boolean.true" ||
                    data57 === "boolean.false" ||
                    data57 === "date.today"
                  )
                ) {
                  const err120 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValuePath",
                    schemaPath:
                      "#/items/oneOf/2/properties/defaultValuePath/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[2].properties.defaultValuePath
                          .enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err120];
                  } else {
                    vErrors.push(err120);
                  }
                  errors++;
                }
              }
              if (data0.defaultValue !== undefined) {
                if (typeof data0.defaultValue !== "string") {
                  const err121 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValue",
                    schemaPath: "#/items/oneOf/2/properties/defaultValue/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err121];
                  } else {
                    vErrors.push(err121);
                  }
                  errors++;
                }
              }
              if (data0.columnHeaderOverride !== undefined) {
                if (typeof data0.columnHeaderOverride !== "string") {
                  const err122 = {
                    instancePath:
                      instancePath + "/" + i0 + "/columnHeaderOverride",
                    schemaPath:
                      "#/items/oneOf/2/properties/columnHeaderOverride/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err122];
                  } else {
                    vErrors.push(err122);
                  }
                  errors++;
                }
              }
              if (data0.disabled !== undefined) {
                if (typeof data0.disabled !== "boolean") {
                  const err123 = {
                    instancePath: instancePath + "/" + i0 + "/disabled",
                    schemaPath: "#/items/oneOf/2/properties/disabled/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err123];
                  } else {
                    vErrors.push(err123);
                  }
                  errors++;
                }
              }
              if (data0.helperText !== undefined) {
                if (typeof data0.helperText !== "string") {
                  const err124 = {
                    instancePath: instancePath + "/" + i0 + "/helperText",
                    schemaPath: "#/items/oneOf/2/properties/helperText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err124];
                  } else {
                    vErrors.push(err124);
                  }
                  errors++;
                }
              }
              if (data0.viewOnCreate !== undefined) {
                let data62 = data0.viewOnCreate;
                if (Array.isArray(data62)) {
                  const len10 = data62.length;
                  for (let i10 = 0; i10 < len10; i10++) {
                    if (typeof data62[i10] !== "string") {
                      const err125 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnCreate/" + i10,
                        schemaPath:
                          "#/items/oneOf/2/properties/viewOnCreate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err125];
                      } else {
                        vErrors.push(err125);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err126 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnCreate",
                    schemaPath: "#/items/oneOf/2/properties/viewOnCreate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err126];
                  } else {
                    vErrors.push(err126);
                  }
                  errors++;
                }
              }
              if (data0.viewOnRetrieve !== undefined) {
                let data64 = data0.viewOnRetrieve;
                if (Array.isArray(data64)) {
                  if (data64.length < 1) {
                    const err127 = {
                      instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                      schemaPath:
                        "#/items/oneOf/2/properties/viewOnRetrieve/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err127];
                    } else {
                      vErrors.push(err127);
                    }
                    errors++;
                  }
                  const len11 = data64.length;
                  for (let i11 = 0; i11 < len11; i11++) {
                    let data65 = data64[i11];
                    if (typeof data65 !== "string") {
                      const err128 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i11,
                        schemaPath:
                          "#/items/oneOf/2/properties/viewOnRetrieve/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err128];
                      } else {
                        vErrors.push(err128);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data65 === "manager" ||
                        data65 === "member" ||
                        data65 === "creator" ||
                        data65 === "view_only" ||
                        data65 === "admin" ||
                        data65 === "guest" ||
                        data65 === "publicUser"
                      )
                    ) {
                      const err129 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i11,
                        schemaPath:
                          "#/items/oneOf/2/properties/viewOnRetrieve/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[2].properties.viewOnRetrieve
                              .items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err129];
                      } else {
                        vErrors.push(err129);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err130 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                    schemaPath:
                      "#/items/oneOf/2/properties/viewOnRetrieve/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err130];
                  } else {
                    vErrors.push(err130);
                  }
                  errors++;
                }
              }
              if (data0.canUpdate !== undefined) {
                let data66 = data0.canUpdate;
                if (Array.isArray(data66)) {
                  const len12 = data66.length;
                  for (let i12 = 0; i12 < len12; i12++) {
                    if (typeof data66[i12] !== "string") {
                      const err131 = {
                        instancePath:
                          instancePath + "/" + i0 + "/canUpdate/" + i12,
                        schemaPath:
                          "#/items/oneOf/2/properties/canUpdate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err131];
                      } else {
                        vErrors.push(err131);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err132 = {
                    instancePath: instancePath + "/" + i0 + "/canUpdate",
                    schemaPath: "#/items/oneOf/2/properties/canUpdate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err132];
                  } else {
                    vErrors.push(err132);
                  }
                  errors++;
                }
              }
            } else {
              const err133 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/2/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err133];
              } else {
                vErrors.push(err133);
              }
              errors++;
            }
          } else if (tag0 === "date") {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.name === undefined) {
                const err134 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/3/required",
                  keyword: "required",
                  params: { missingProperty: "name" },
                  message: "must have required property '" + "name" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err134];
                } else {
                  vErrors.push(err134);
                }
                errors++;
              }
              if (data0.required === undefined) {
                const err135 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/3/required",
                  keyword: "required",
                  params: { missingProperty: "required" },
                  message: "must have required property '" + "required" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err135];
                } else {
                  vErrors.push(err135);
                }
                errors++;
              }
              if (data0.inputType === undefined) {
                const err136 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/3/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err136];
                } else {
                  vErrors.push(err136);
                }
                errors++;
              }
              if (data0.type === undefined) {
                const err137 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/3/required",
                  keyword: "required",
                  params: { missingProperty: "type" },
                  message: "must have required property '" + "type" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err137];
                } else {
                  vErrors.push(err137);
                }
                errors++;
              }
              if (data0.defaultToToday === undefined) {
                const err138 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/3/required",
                  keyword: "required",
                  params: { missingProperty: "defaultToToday" },
                  message:
                    "must have required property '" + "defaultToToday" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err138];
                } else {
                  vErrors.push(err138);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err139 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/3/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err139];
                } else {
                  vErrors.push(err139);
                }
                errors++;
              }
              for (const key3 in data0) {
                if (!func2.call(schema28.items.oneOf[3].properties, key3)) {
                  const err140 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/3/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key3 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err140];
                  } else {
                    vErrors.push(err140);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err141 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/3/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err141];
                  } else {
                    vErrors.push(err141);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err142 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/3/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err142];
                  } else {
                    vErrors.push(err142);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data70 = data0.inputType;
                if (typeof data70 !== "string") {
                  const err143 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/3/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err143];
                  } else {
                    vErrors.push(err143);
                  }
                  errors++;
                }
                if (!(data70 === "date")) {
                  const err144 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/3/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[3].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err144];
                  } else {
                    vErrors.push(err144);
                  }
                  errors++;
                }
              }
              if (data0.type !== undefined) {
                let data71 = data0.type;
                if (typeof data71 !== "string") {
                  const err145 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/3/properties/type/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err145];
                  } else {
                    vErrors.push(err145);
                  }
                  errors++;
                }
                if (!(data71 === "string")) {
                  const err146 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/3/properties/type/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[3].properties.type.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err146];
                  } else {
                    vErrors.push(err146);
                  }
                  errors++;
                }
              }
              if (data0.defaultToToday !== undefined) {
                if (typeof data0.defaultToToday !== "boolean") {
                  const err147 = {
                    instancePath: instancePath + "/" + i0 + "/defaultToToday",
                    schemaPath:
                      "#/items/oneOf/3/properties/defaultToToday/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err147];
                  } else {
                    vErrors.push(err147);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                let data73 = data0.title;
                if (typeof data73 === "string") {
                  if (func3(data73) < 1) {
                    const err148 = {
                      instancePath: instancePath + "/" + i0 + "/title",
                      schemaPath: "#/items/oneOf/3/properties/title/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err148];
                    } else {
                      vErrors.push(err148);
                    }
                    errors++;
                  }
                } else {
                  const err149 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/3/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err149];
                  } else {
                    vErrors.push(err149);
                  }
                  errors++;
                }
              }
              if (data0.placeholder !== undefined) {
                if (typeof data0.placeholder !== "string") {
                  const err150 = {
                    instancePath: instancePath + "/" + i0 + "/placeholder",
                    schemaPath: "#/items/oneOf/3/properties/placeholder/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err150];
                  } else {
                    vErrors.push(err150);
                  }
                  errors++;
                }
              }
              if (data0.tooltipText !== undefined) {
                if (typeof data0.tooltipText !== "string") {
                  const err151 = {
                    instancePath: instancePath + "/" + i0 + "/tooltipText",
                    schemaPath: "#/items/oneOf/3/properties/tooltipText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err151];
                  } else {
                    vErrors.push(err151);
                  }
                  errors++;
                }
              }
              if (data0.columnHeaderOverride !== undefined) {
                if (typeof data0.columnHeaderOverride !== "string") {
                  const err152 = {
                    instancePath:
                      instancePath + "/" + i0 + "/columnHeaderOverride",
                    schemaPath:
                      "#/items/oneOf/3/properties/columnHeaderOverride/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err152];
                  } else {
                    vErrors.push(err152);
                  }
                  errors++;
                }
              }
              if (data0.disabled !== undefined) {
                if (typeof data0.disabled !== "boolean") {
                  const err153 = {
                    instancePath: instancePath + "/" + i0 + "/disabled",
                    schemaPath: "#/items/oneOf/3/properties/disabled/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err153];
                  } else {
                    vErrors.push(err153);
                  }
                  errors++;
                }
              }
              if (data0.helperText !== undefined) {
                if (typeof data0.helperText !== "string") {
                  const err154 = {
                    instancePath: instancePath + "/" + i0 + "/helperText",
                    schemaPath: "#/items/oneOf/3/properties/helperText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err154];
                  } else {
                    vErrors.push(err154);
                  }
                  errors++;
                }
              }
              if (data0.viewOnCreate !== undefined) {
                let data79 = data0.viewOnCreate;
                if (Array.isArray(data79)) {
                  const len13 = data79.length;
                  for (let i13 = 0; i13 < len13; i13++) {
                    if (typeof data79[i13] !== "string") {
                      const err155 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnCreate/" + i13,
                        schemaPath:
                          "#/items/oneOf/3/properties/viewOnCreate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err155];
                      } else {
                        vErrors.push(err155);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err156 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnCreate",
                    schemaPath: "#/items/oneOf/3/properties/viewOnCreate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err156];
                  } else {
                    vErrors.push(err156);
                  }
                  errors++;
                }
              }
              if (data0.viewOnRetrieve !== undefined) {
                let data81 = data0.viewOnRetrieve;
                if (Array.isArray(data81)) {
                  if (data81.length < 1) {
                    const err157 = {
                      instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                      schemaPath:
                        "#/items/oneOf/3/properties/viewOnRetrieve/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err157];
                    } else {
                      vErrors.push(err157);
                    }
                    errors++;
                  }
                  const len14 = data81.length;
                  for (let i14 = 0; i14 < len14; i14++) {
                    let data82 = data81[i14];
                    if (typeof data82 !== "string") {
                      const err158 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i14,
                        schemaPath:
                          "#/items/oneOf/3/properties/viewOnRetrieve/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err158];
                      } else {
                        vErrors.push(err158);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data82 === "manager" ||
                        data82 === "member" ||
                        data82 === "creator" ||
                        data82 === "view_only" ||
                        data82 === "admin" ||
                        data82 === "guest" ||
                        data82 === "publicUser"
                      )
                    ) {
                      const err159 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i14,
                        schemaPath:
                          "#/items/oneOf/3/properties/viewOnRetrieve/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[3].properties.viewOnRetrieve
                              .items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err159];
                      } else {
                        vErrors.push(err159);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err160 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                    schemaPath:
                      "#/items/oneOf/3/properties/viewOnRetrieve/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err160];
                  } else {
                    vErrors.push(err160);
                  }
                  errors++;
                }
              }
              if (data0.canUpdate !== undefined) {
                let data83 = data0.canUpdate;
                if (Array.isArray(data83)) {
                  const len15 = data83.length;
                  for (let i15 = 0; i15 < len15; i15++) {
                    if (typeof data83[i15] !== "string") {
                      const err161 = {
                        instancePath:
                          instancePath + "/" + i0 + "/canUpdate/" + i15,
                        schemaPath:
                          "#/items/oneOf/3/properties/canUpdate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err161];
                      } else {
                        vErrors.push(err161);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err162 = {
                    instancePath: instancePath + "/" + i0 + "/canUpdate",
                    schemaPath: "#/items/oneOf/3/properties/canUpdate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err162];
                  } else {
                    vErrors.push(err162);
                  }
                  errors++;
                }
              }
              if (data0.formula !== undefined) {
                let data85 = data0.formula;
                if (
                  data85 &&
                  typeof data85 == "object" &&
                  !Array.isArray(data85)
                ) {
                  if (data85.name === undefined) {
                    const err163 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/3/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err163];
                    } else {
                      vErrors.push(err163);
                    }
                    errors++;
                  }
                  if (data85.applies === undefined) {
                    const err164 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/3/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "applies" },
                      message:
                        "must have required property '" + "applies" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err164];
                    } else {
                      vErrors.push(err164);
                    }
                    errors++;
                  }
                  if (data85.logic === undefined) {
                    const err165 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/3/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "logic" },
                      message: "must have required property '" + "logic" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err165];
                    } else {
                      vErrors.push(err165);
                    }
                    errors++;
                  }
                  for (const key4 in data85) {
                    if (
                      !(
                        key4 === "name" ||
                        key4 === "applies" ||
                        key4 === "logic"
                      )
                    ) {
                      const err166 = {
                        instancePath: instancePath + "/" + i0 + "/formula",
                        schemaPath:
                          "#/items/oneOf/3/properties/formula/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key4 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err166];
                      } else {
                        vErrors.push(err166);
                      }
                      errors++;
                    }
                  }
                  if (data85.name !== undefined) {
                    if (typeof data85.name !== "string") {
                      const err167 = {
                        instancePath: instancePath + "/" + i0 + "/formula/name",
                        schemaPath:
                          "#/items/oneOf/3/properties/formula/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err167];
                      } else {
                        vErrors.push(err167);
                      }
                      errors++;
                    }
                  }
                  if (data85.applies !== undefined) {
                    let data87 = data85.applies;
                    if (
                      !(
                        data87 &&
                        typeof data87 == "object" &&
                        !Array.isArray(data87)
                      ) &&
                      typeof data87 !== "boolean"
                    ) {
                      const err168 = {
                        instancePath:
                          instancePath + "/" + i0 + "/formula/applies",
                        schemaPath:
                          "#/items/oneOf/3/properties/formula/properties/applies/type",
                        keyword: "type",
                        params: {
                          type: schema28.items.oneOf[3].properties.formula
                            .properties.applies.type,
                        },
                        message: "must be object,boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err168];
                      } else {
                        vErrors.push(err168);
                      }
                      errors++;
                    }
                  }
                  if (data85.logic !== undefined) {
                    let data88 = data85.logic;
                    if (
                      data88 &&
                      typeof data88 == "object" &&
                      !Array.isArray(data88)
                    ) {
                    } else {
                      const err169 = {
                        instancePath:
                          instancePath + "/" + i0 + "/formula/logic",
                        schemaPath:
                          "#/items/oneOf/3/properties/formula/properties/logic/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err169];
                      } else {
                        vErrors.push(err169);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err170 = {
                    instancePath: instancePath + "/" + i0 + "/formula",
                    schemaPath: "#/items/oneOf/3/properties/formula/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err170];
                  } else {
                    vErrors.push(err170);
                  }
                  errors++;
                }
              }
            } else {
              const err171 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/3/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err171];
              } else {
                vErrors.push(err171);
              }
              errors++;
            }
          } else if (tag0 === "DamageDegree") {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.name === undefined) {
                const err172 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/4/required",
                  keyword: "required",
                  params: { missingProperty: "name" },
                  message: "must have required property '" + "name" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err172];
                } else {
                  vErrors.push(err172);
                }
                errors++;
              }
              if (data0.required === undefined) {
                const err173 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/4/required",
                  keyword: "required",
                  params: { missingProperty: "required" },
                  message: "must have required property '" + "required" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err173];
                } else {
                  vErrors.push(err173);
                }
                errors++;
              }
              if (data0.inputType === undefined) {
                const err174 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/4/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err174];
                } else {
                  vErrors.push(err174);
                }
                errors++;
              }
              if (data0.type === undefined) {
                const err175 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/4/required",
                  keyword: "required",
                  params: { missingProperty: "type" },
                  message: "must have required property '" + "type" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err175];
                } else {
                  vErrors.push(err175);
                }
                errors++;
              }
              if (data0.placeholder === undefined) {
                const err176 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/4/required",
                  keyword: "required",
                  params: { missingProperty: "placeholder" },
                  message:
                    "must have required property '" + "placeholder" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err176];
                } else {
                  vErrors.push(err176);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err177 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/4/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err177];
                } else {
                  vErrors.push(err177);
                }
                errors++;
              }
              for (const key5 in data0) {
                if (!func2.call(schema28.items.oneOf[4].properties, key5)) {
                  const err178 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/4/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key5 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err178];
                  } else {
                    vErrors.push(err178);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err179 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/4/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err179];
                  } else {
                    vErrors.push(err179);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err180 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/4/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err180];
                  } else {
                    vErrors.push(err180);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data91 = data0.inputType;
                if (typeof data91 !== "string") {
                  const err181 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/4/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err181];
                  } else {
                    vErrors.push(err181);
                  }
                  errors++;
                }
                if (!(data91 === "DamageDegree")) {
                  const err182 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/4/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[4].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err182];
                  } else {
                    vErrors.push(err182);
                  }
                  errors++;
                }
              }
              if (data0.type !== undefined) {
                if (typeof data0.type !== "string") {
                  const err183 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/4/properties/type/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err183];
                  } else {
                    vErrors.push(err183);
                  }
                  errors++;
                }
              }
              if (data0.placeholder !== undefined) {
                if (typeof data0.placeholder !== "string") {
                  const err184 = {
                    instancePath: instancePath + "/" + i0 + "/placeholder",
                    schemaPath: "#/items/oneOf/4/properties/placeholder/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err184];
                  } else {
                    vErrors.push(err184);
                  }
                  errors++;
                }
              }
              if (data0.tooltipText !== undefined) {
                if (typeof data0.tooltipText !== "string") {
                  const err185 = {
                    instancePath: instancePath + "/" + i0 + "/tooltipText",
                    schemaPath: "#/items/oneOf/4/properties/tooltipText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err185];
                  } else {
                    vErrors.push(err185);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                let data95 = data0.title;
                if (typeof data95 === "string") {
                  if (func3(data95) < 1) {
                    const err186 = {
                      instancePath: instancePath + "/" + i0 + "/title",
                      schemaPath: "#/items/oneOf/4/properties/title/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err186];
                    } else {
                      vErrors.push(err186);
                    }
                    errors++;
                  }
                } else {
                  const err187 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/4/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err187];
                  } else {
                    vErrors.push(err187);
                  }
                  errors++;
                }
              }
              if (data0.columnHeaderOverride !== undefined) {
                if (typeof data0.columnHeaderOverride !== "string") {
                  const err188 = {
                    instancePath:
                      instancePath + "/" + i0 + "/columnHeaderOverride",
                    schemaPath:
                      "#/items/oneOf/4/properties/columnHeaderOverride/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err188];
                  } else {
                    vErrors.push(err188);
                  }
                  errors++;
                }
              }
              if (data0.disabled !== undefined) {
                if (typeof data0.disabled !== "boolean") {
                  const err189 = {
                    instancePath: instancePath + "/" + i0 + "/disabled",
                    schemaPath: "#/items/oneOf/4/properties/disabled/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err189];
                  } else {
                    vErrors.push(err189);
                  }
                  errors++;
                }
              }
              if (data0.viewOnCreate !== undefined) {
                let data98 = data0.viewOnCreate;
                if (Array.isArray(data98)) {
                  const len16 = data98.length;
                  for (let i16 = 0; i16 < len16; i16++) {
                    if (typeof data98[i16] !== "string") {
                      const err190 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnCreate/" + i16,
                        schemaPath:
                          "#/items/oneOf/4/properties/viewOnCreate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err190];
                      } else {
                        vErrors.push(err190);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err191 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnCreate",
                    schemaPath: "#/items/oneOf/4/properties/viewOnCreate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err191];
                  } else {
                    vErrors.push(err191);
                  }
                  errors++;
                }
              }
              if (data0.viewOnRetrieve !== undefined) {
                let data100 = data0.viewOnRetrieve;
                if (Array.isArray(data100)) {
                  if (data100.length < 1) {
                    const err192 = {
                      instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                      schemaPath:
                        "#/items/oneOf/4/properties/viewOnRetrieve/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err192];
                    } else {
                      vErrors.push(err192);
                    }
                    errors++;
                  }
                  const len17 = data100.length;
                  for (let i17 = 0; i17 < len17; i17++) {
                    let data101 = data100[i17];
                    if (typeof data101 !== "string") {
                      const err193 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i17,
                        schemaPath:
                          "#/items/oneOf/4/properties/viewOnRetrieve/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err193];
                      } else {
                        vErrors.push(err193);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data101 === "manager" ||
                        data101 === "member" ||
                        data101 === "creator" ||
                        data101 === "view_only" ||
                        data101 === "admin" ||
                        data101 === "guest" ||
                        data101 === "publicUser"
                      )
                    ) {
                      const err194 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i17,
                        schemaPath:
                          "#/items/oneOf/4/properties/viewOnRetrieve/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[4].properties.viewOnRetrieve
                              .items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err194];
                      } else {
                        vErrors.push(err194);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err195 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                    schemaPath:
                      "#/items/oneOf/4/properties/viewOnRetrieve/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err195];
                  } else {
                    vErrors.push(err195);
                  }
                  errors++;
                }
              }
              if (data0.canUpdate !== undefined) {
                let data102 = data0.canUpdate;
                if (Array.isArray(data102)) {
                  const len18 = data102.length;
                  for (let i18 = 0; i18 < len18; i18++) {
                    if (typeof data102[i18] !== "string") {
                      const err196 = {
                        instancePath:
                          instancePath + "/" + i0 + "/canUpdate/" + i18,
                        schemaPath:
                          "#/items/oneOf/4/properties/canUpdate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err196];
                      } else {
                        vErrors.push(err196);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err197 = {
                    instancePath: instancePath + "/" + i0 + "/canUpdate",
                    schemaPath: "#/items/oneOf/4/properties/canUpdate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err197];
                  } else {
                    vErrors.push(err197);
                  }
                  errors++;
                }
              }
            } else {
              const err198 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/4/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err198];
              } else {
                vErrors.push(err198);
              }
              errors++;
            }
          } else if (tag0 === "text") {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.name === undefined) {
                const err199 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/5/required",
                  keyword: "required",
                  params: { missingProperty: "name" },
                  message: "must have required property '" + "name" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err199];
                } else {
                  vErrors.push(err199);
                }
                errors++;
              }
              if (data0.required === undefined) {
                const err200 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/5/required",
                  keyword: "required",
                  params: { missingProperty: "required" },
                  message: "must have required property '" + "required" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err200];
                } else {
                  vErrors.push(err200);
                }
                errors++;
              }
              if (data0.inputType === undefined) {
                const err201 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/5/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err201];
                } else {
                  vErrors.push(err201);
                }
                errors++;
              }
              if (data0.type === undefined) {
                const err202 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/5/required",
                  keyword: "required",
                  params: { missingProperty: "type" },
                  message: "must have required property '" + "type" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err202];
                } else {
                  vErrors.push(err202);
                }
                errors++;
              }
              if (data0.placeholder === undefined) {
                const err203 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/5/required",
                  keyword: "required",
                  params: { missingProperty: "placeholder" },
                  message:
                    "must have required property '" + "placeholder" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err203];
                } else {
                  vErrors.push(err203);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err204 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/5/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err204];
                } else {
                  vErrors.push(err204);
                }
                errors++;
              }
              for (const key6 in data0) {
                if (!func2.call(schema28.items.oneOf[5].properties, key6)) {
                  const err205 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/5/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key6 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err205];
                  } else {
                    vErrors.push(err205);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err206 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/5/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err206];
                  } else {
                    vErrors.push(err206);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err207 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/5/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err207];
                  } else {
                    vErrors.push(err207);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data106 = data0.inputType;
                if (typeof data106 !== "string") {
                  const err208 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/5/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err208];
                  } else {
                    vErrors.push(err208);
                  }
                  errors++;
                }
                if (!(data106 === "text")) {
                  const err209 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/5/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[5].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err209];
                  } else {
                    vErrors.push(err209);
                  }
                  errors++;
                }
              }
              if (data0.type !== undefined) {
                let data107 = data0.type;
                if (typeof data107 !== "string") {
                  const err210 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/5/properties/type/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err210];
                  } else {
                    vErrors.push(err210);
                  }
                  errors++;
                }
                if (!(data107 === "string")) {
                  const err211 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/5/properties/type/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[5].properties.type.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err211];
                  } else {
                    vErrors.push(err211);
                  }
                  errors++;
                }
              }
              if (data0.placeholder !== undefined) {
                if (typeof data0.placeholder !== "string") {
                  const err212 = {
                    instancePath: instancePath + "/" + i0 + "/placeholder",
                    schemaPath: "#/items/oneOf/5/properties/placeholder/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err212];
                  } else {
                    vErrors.push(err212);
                  }
                  errors++;
                }
              }
              if (data0.tooltipText !== undefined) {
                if (typeof data0.tooltipText !== "string") {
                  const err213 = {
                    instancePath: instancePath + "/" + i0 + "/tooltipText",
                    schemaPath: "#/items/oneOf/5/properties/tooltipText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err213];
                  } else {
                    vErrors.push(err213);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                let data110 = data0.title;
                if (typeof data110 === "string") {
                  if (func3(data110) < 1) {
                    const err214 = {
                      instancePath: instancePath + "/" + i0 + "/title",
                      schemaPath: "#/items/oneOf/5/properties/title/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err214];
                    } else {
                      vErrors.push(err214);
                    }
                    errors++;
                  }
                } else {
                  const err215 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/5/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err215];
                  } else {
                    vErrors.push(err215);
                  }
                  errors++;
                }
              }
              if (data0.defaultValuePath !== undefined) {
                let data111 = data0.defaultValuePath;
                if (typeof data111 !== "string") {
                  const err216 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValuePath",
                    schemaPath:
                      "#/items/oneOf/5/properties/defaultValuePath/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err216];
                  } else {
                    vErrors.push(err216);
                  }
                  errors++;
                }
                if (
                  !(
                    data111 === "property.sisd.adjustmentRatio" ||
                    data111 === "property.sisd.defaultExclude" ||
                    data111 === "property.improvementValue" ||
                    data111 === "property.sisd.costType" ||
                    data111 === "property.latitude" ||
                    data111 === "property.longitude" ||
                    data111 === "parcel.mailingAddress1" ||
                    data111 === "parcel.mailingAddress2" ||
                    data111 === "parcel.mailingAddress" ||
                    data111 === "parcel.parcelId" ||
                    data111 === "parcel.improvementValue" ||
                    data111 === "parcel.block" ||
                    data111 === "parcel.lot" ||
                    data111 === "parcel.ownerName" ||
                    data111 === "user.firstName" ||
                    data111 === "user.lastName" ||
                    data111 === "user.fullName" ||
                    data111 === "units.feet" ||
                    data111 === "units.inches" ||
                    data111 === "units.hours" ||
                    data111 === "units.minutes" ||
                    data111 === "units.days" ||
                    data111 === "boolean.true" ||
                    data111 === "boolean.false" ||
                    data111 === "date.today"
                  )
                ) {
                  const err217 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValuePath",
                    schemaPath:
                      "#/items/oneOf/5/properties/defaultValuePath/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[5].properties.defaultValuePath
                          .enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err217];
                  } else {
                    vErrors.push(err217);
                  }
                  errors++;
                }
              }
              if (data0.defaultValue !== undefined) {
                if (typeof data0.defaultValue !== "string") {
                  const err218 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValue",
                    schemaPath: "#/items/oneOf/5/properties/defaultValue/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err218];
                  } else {
                    vErrors.push(err218);
                  }
                  errors++;
                }
              }
              if (data0.labelSize !== undefined) {
                let data113 = data0.labelSize;
                if (typeof data113 !== "string") {
                  const err219 = {
                    instancePath: instancePath + "/" + i0 + "/labelSize",
                    schemaPath: "#/items/oneOf/5/properties/labelSize/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err219];
                  } else {
                    vErrors.push(err219);
                  }
                  errors++;
                }
                if (!(data113 === "small" || data113 === "medium")) {
                  const err220 = {
                    instancePath: instancePath + "/" + i0 + "/labelSize",
                    schemaPath: "#/items/oneOf/5/properties/labelSize/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[5].properties.labelSize.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err220];
                  } else {
                    vErrors.push(err220);
                  }
                  errors++;
                }
              }
              if (data0.columnHeaderOverride !== undefined) {
                if (typeof data0.columnHeaderOverride !== "string") {
                  const err221 = {
                    instancePath:
                      instancePath + "/" + i0 + "/columnHeaderOverride",
                    schemaPath:
                      "#/items/oneOf/5/properties/columnHeaderOverride/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err221];
                  } else {
                    vErrors.push(err221);
                  }
                  errors++;
                }
              }
              if (data0.disabled !== undefined) {
                if (typeof data0.disabled !== "boolean") {
                  const err222 = {
                    instancePath: instancePath + "/" + i0 + "/disabled",
                    schemaPath: "#/items/oneOf/5/properties/disabled/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err222];
                  } else {
                    vErrors.push(err222);
                  }
                  errors++;
                }
              }
              if (data0.helperText !== undefined) {
                if (typeof data0.helperText !== "string") {
                  const err223 = {
                    instancePath: instancePath + "/" + i0 + "/helperText",
                    schemaPath: "#/items/oneOf/5/properties/helperText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err223];
                  } else {
                    vErrors.push(err223);
                  }
                  errors++;
                }
              }
              if (data0.viewOnCreate !== undefined) {
                let data117 = data0.viewOnCreate;
                if (Array.isArray(data117)) {
                  const len19 = data117.length;
                  for (let i19 = 0; i19 < len19; i19++) {
                    if (typeof data117[i19] !== "string") {
                      const err224 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnCreate/" + i19,
                        schemaPath:
                          "#/items/oneOf/5/properties/viewOnCreate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err224];
                      } else {
                        vErrors.push(err224);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err225 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnCreate",
                    schemaPath: "#/items/oneOf/5/properties/viewOnCreate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err225];
                  } else {
                    vErrors.push(err225);
                  }
                  errors++;
                }
              }
              if (data0.viewOnRetrieve !== undefined) {
                let data119 = data0.viewOnRetrieve;
                if (Array.isArray(data119)) {
                  if (data119.length < 1) {
                    const err226 = {
                      instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                      schemaPath:
                        "#/items/oneOf/5/properties/viewOnRetrieve/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err226];
                    } else {
                      vErrors.push(err226);
                    }
                    errors++;
                  }
                  const len20 = data119.length;
                  for (let i20 = 0; i20 < len20; i20++) {
                    let data120 = data119[i20];
                    if (typeof data120 !== "string") {
                      const err227 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i20,
                        schemaPath:
                          "#/items/oneOf/5/properties/viewOnRetrieve/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err227];
                      } else {
                        vErrors.push(err227);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data120 === "manager" ||
                        data120 === "member" ||
                        data120 === "creator" ||
                        data120 === "view_only" ||
                        data120 === "admin" ||
                        data120 === "guest" ||
                        data120 === "publicUser"
                      )
                    ) {
                      const err228 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i20,
                        schemaPath:
                          "#/items/oneOf/5/properties/viewOnRetrieve/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[5].properties.viewOnRetrieve
                              .items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err228];
                      } else {
                        vErrors.push(err228);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err229 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                    schemaPath:
                      "#/items/oneOf/5/properties/viewOnRetrieve/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err229];
                  } else {
                    vErrors.push(err229);
                  }
                  errors++;
                }
              }
              if (data0.canUpdate !== undefined) {
                let data121 = data0.canUpdate;
                if (Array.isArray(data121)) {
                  const len21 = data121.length;
                  for (let i21 = 0; i21 < len21; i21++) {
                    if (typeof data121[i21] !== "string") {
                      const err230 = {
                        instancePath:
                          instancePath + "/" + i0 + "/canUpdate/" + i21,
                        schemaPath:
                          "#/items/oneOf/5/properties/canUpdate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err230];
                      } else {
                        vErrors.push(err230);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err231 = {
                    instancePath: instancePath + "/" + i0 + "/canUpdate",
                    schemaPath: "#/items/oneOf/5/properties/canUpdate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err231];
                  } else {
                    vErrors.push(err231);
                  }
                  errors++;
                }
              }
              if (data0.uniqueIdentifier !== undefined) {
                if (typeof data0.uniqueIdentifier !== "string") {
                  const err232 = {
                    instancePath: instancePath + "/" + i0 + "/uniqueIdentifier",
                    schemaPath:
                      "#/items/oneOf/5/properties/uniqueIdentifier/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err232];
                  } else {
                    vErrors.push(err232);
                  }
                  errors++;
                }
              }
              if (data0.formula !== undefined) {
                let data124 = data0.formula;
                if (
                  data124 &&
                  typeof data124 == "object" &&
                  !Array.isArray(data124)
                ) {
                  if (data124.name === undefined) {
                    const err233 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/5/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err233];
                    } else {
                      vErrors.push(err233);
                    }
                    errors++;
                  }
                  if (data124.applies === undefined) {
                    const err234 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/5/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "applies" },
                      message:
                        "must have required property '" + "applies" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err234];
                    } else {
                      vErrors.push(err234);
                    }
                    errors++;
                  }
                  if (data124.logic === undefined) {
                    const err235 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/5/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "logic" },
                      message: "must have required property '" + "logic" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err235];
                    } else {
                      vErrors.push(err235);
                    }
                    errors++;
                  }
                  for (const key7 in data124) {
                    if (
                      !(
                        key7 === "name" ||
                        key7 === "applies" ||
                        key7 === "logic"
                      )
                    ) {
                      const err236 = {
                        instancePath: instancePath + "/" + i0 + "/formula",
                        schemaPath:
                          "#/items/oneOf/5/properties/formula/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key7 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err236];
                      } else {
                        vErrors.push(err236);
                      }
                      errors++;
                    }
                  }
                  if (data124.name !== undefined) {
                    if (typeof data124.name !== "string") {
                      const err237 = {
                        instancePath: instancePath + "/" + i0 + "/formula/name",
                        schemaPath:
                          "#/items/oneOf/5/properties/formula/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err237];
                      } else {
                        vErrors.push(err237);
                      }
                      errors++;
                    }
                  }
                  if (data124.applies !== undefined) {
                    let data126 = data124.applies;
                    if (
                      !(
                        data126 &&
                        typeof data126 == "object" &&
                        !Array.isArray(data126)
                      ) &&
                      typeof data126 !== "boolean"
                    ) {
                      const err238 = {
                        instancePath:
                          instancePath + "/" + i0 + "/formula/applies",
                        schemaPath:
                          "#/items/oneOf/5/properties/formula/properties/applies/type",
                        keyword: "type",
                        params: {
                          type: schema28.items.oneOf[5].properties.formula
                            .properties.applies.type,
                        },
                        message: "must be object,boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err238];
                      } else {
                        vErrors.push(err238);
                      }
                      errors++;
                    }
                  }
                  if (data124.logic !== undefined) {
                    let data127 = data124.logic;
                    if (
                      data127 &&
                      typeof data127 == "object" &&
                      !Array.isArray(data127)
                    ) {
                    } else {
                      const err239 = {
                        instancePath:
                          instancePath + "/" + i0 + "/formula/logic",
                        schemaPath:
                          "#/items/oneOf/5/properties/formula/properties/logic/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err239];
                      } else {
                        vErrors.push(err239);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err240 = {
                    instancePath: instancePath + "/" + i0 + "/formula",
                    schemaPath: "#/items/oneOf/5/properties/formula/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err240];
                  } else {
                    vErrors.push(err240);
                  }
                  errors++;
                }
              }
            } else {
              const err241 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/5/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err241];
              } else {
                vErrors.push(err241);
              }
              errors++;
            }
          } else if (tag0 === "textarea") {
            const _errs292 = errors;
            let valid67 = true;
            const _errs293 = errors;
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.required !== undefined) {
                if (true !== data0.required) {
                  const err242 = {};
                  if (vErrors === null) {
                    vErrors = [err242];
                  } else {
                    vErrors.push(err242);
                  }
                  errors++;
                }
              }
            }
            var _valid2 = _errs293 === errors;
            errors = _errs292;
            if (vErrors !== null) {
              if (_errs292) {
                vErrors.length = _errs292;
              } else {
                vErrors = null;
              }
            }
            if (_valid2) {
              const _errs295 = errors;
              if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
                if (data0.useGenerativeAI !== undefined) {
                  if (!(data0.useGenerativeAI === false)) {
                    const err243 = {
                      instancePath:
                        instancePath + "/" + i0 + "/useGenerativeAI",
                      schemaPath:
                        "#/items/oneOf/6/allOf/0/then/properties/useGenerativeAI/enum",
                      keyword: "enum",
                      params: {
                        allowedValues:
                          schema28.items.oneOf[6].allOf[0].then.properties
                            .useGenerativeAI.enum,
                      },
                      message: "must be equal to one of the allowed values",
                    };
                    if (vErrors === null) {
                      vErrors = [err243];
                    } else {
                      vErrors.push(err243);
                    }
                    errors++;
                  }
                }
              }
              var _valid2 = _errs295 === errors;
              valid67 = _valid2;
            }
            if (!valid67) {
              const err244 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/6/allOf/0/if",
                keyword: "if",
                params: { failingKeyword: "then" },
                message: 'must match "then" schema',
              };
              if (vErrors === null) {
                vErrors = [err244];
              } else {
                vErrors.push(err244);
              }
              errors++;
            }
            const _errs298 = errors;
            let valid70 = true;
            const _errs299 = errors;
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.useGenerativeAI !== undefined) {
                if (true !== data0.useGenerativeAI) {
                  const err245 = {};
                  if (vErrors === null) {
                    vErrors = [err245];
                  } else {
                    vErrors.push(err245);
                  }
                  errors++;
                }
              }
            }
            var _valid3 = _errs299 === errors;
            errors = _errs298;
            if (vErrors !== null) {
              if (_errs298) {
                vErrors.length = _errs298;
              } else {
                vErrors = null;
              }
            }
            if (_valid3) {
              const _errs301 = errors;
              if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
                if (data0.generativeAIPrompt !== undefined) {
                  let data131 = data0.generativeAIPrompt;
                  if (typeof data131 === "string") {
                    if (func3(data131) < 1) {
                      const err246 = {
                        instancePath:
                          instancePath + "/" + i0 + "/generativeAIPrompt",
                        schemaPath:
                          "#/items/oneOf/6/allOf/1/then/properties/generativeAIPrompt/minLength",
                        keyword: "minLength",
                        params: { limit: 1 },
                        message: "must NOT have fewer than 1 characters",
                      };
                      if (vErrors === null) {
                        vErrors = [err246];
                      } else {
                        vErrors.push(err246);
                      }
                      errors++;
                    }
                  } else {
                    const err247 = {
                      instancePath:
                        instancePath + "/" + i0 + "/generativeAIPrompt",
                      schemaPath:
                        "#/items/oneOf/6/allOf/1/then/properties/generativeAIPrompt/type",
                      keyword: "type",
                      params: { type: "string" },
                      message: "must be string",
                    };
                    if (vErrors === null) {
                      vErrors = [err247];
                    } else {
                      vErrors.push(err247);
                    }
                    errors++;
                  }
                }
              }
              var _valid3 = _errs301 === errors;
              valid70 = _valid3;
            }
            if (!valid70) {
              const err248 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/6/allOf/1/if",
                keyword: "if",
                params: { failingKeyword: "then" },
                message: 'must match "then" schema',
              };
              if (vErrors === null) {
                vErrors = [err248];
              } else {
                vErrors.push(err248);
              }
              errors++;
            }
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.name === undefined) {
                const err249 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/6/required",
                  keyword: "required",
                  params: { missingProperty: "name" },
                  message: "must have required property '" + "name" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err249];
                } else {
                  vErrors.push(err249);
                }
                errors++;
              }
              if (data0.required === undefined) {
                const err250 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/6/required",
                  keyword: "required",
                  params: { missingProperty: "required" },
                  message: "must have required property '" + "required" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err250];
                } else {
                  vErrors.push(err250);
                }
                errors++;
              }
              if (data0.inputType === undefined) {
                const err251 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/6/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err251];
                } else {
                  vErrors.push(err251);
                }
                errors++;
              }
              if (data0.type === undefined) {
                const err252 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/6/required",
                  keyword: "required",
                  params: { missingProperty: "type" },
                  message: "must have required property '" + "type" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err252];
                } else {
                  vErrors.push(err252);
                }
                errors++;
              }
              if (data0.placeholder === undefined) {
                const err253 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/6/required",
                  keyword: "required",
                  params: { missingProperty: "placeholder" },
                  message:
                    "must have required property '" + "placeholder" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err253];
                } else {
                  vErrors.push(err253);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err254 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/6/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err254];
                } else {
                  vErrors.push(err254);
                }
                errors++;
              }
              for (const key8 in data0) {
                if (!func2.call(schema28.items.oneOf[6].properties, key8)) {
                  const err255 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/6/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key8 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err255];
                  } else {
                    vErrors.push(err255);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err256 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/6/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err256];
                  } else {
                    vErrors.push(err256);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err257 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/6/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err257];
                  } else {
                    vErrors.push(err257);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data134 = data0.inputType;
                if (typeof data134 !== "string") {
                  const err258 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/6/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err258];
                  } else {
                    vErrors.push(err258);
                  }
                  errors++;
                }
                if (!(data134 === "textarea")) {
                  const err259 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/6/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[6].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err259];
                  } else {
                    vErrors.push(err259);
                  }
                  errors++;
                }
              }
              if (data0.type !== undefined) {
                let data135 = data0.type;
                if (typeof data135 !== "string") {
                  const err260 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/6/properties/type/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err260];
                  } else {
                    vErrors.push(err260);
                  }
                  errors++;
                }
                if (!(data135 === "string")) {
                  const err261 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/6/properties/type/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[6].properties.type.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err261];
                  } else {
                    vErrors.push(err261);
                  }
                  errors++;
                }
              }
              if (data0.placeholder !== undefined) {
                if (typeof data0.placeholder !== "string") {
                  const err262 = {
                    instancePath: instancePath + "/" + i0 + "/placeholder",
                    schemaPath: "#/items/oneOf/6/properties/placeholder/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err262];
                  } else {
                    vErrors.push(err262);
                  }
                  errors++;
                }
              }
              if (data0.tooltipText !== undefined) {
                if (typeof data0.tooltipText !== "string") {
                  const err263 = {
                    instancePath: instancePath + "/" + i0 + "/tooltipText",
                    schemaPath: "#/items/oneOf/6/properties/tooltipText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err263];
                  } else {
                    vErrors.push(err263);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                let data138 = data0.title;
                if (typeof data138 === "string") {
                  if (func3(data138) < 1) {
                    const err264 = {
                      instancePath: instancePath + "/" + i0 + "/title",
                      schemaPath: "#/items/oneOf/6/properties/title/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err264];
                    } else {
                      vErrors.push(err264);
                    }
                    errors++;
                  }
                } else {
                  const err265 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/6/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err265];
                  } else {
                    vErrors.push(err265);
                  }
                  errors++;
                }
              }
              if (data0.defaultValuePath !== undefined) {
                let data139 = data0.defaultValuePath;
                if (typeof data139 !== "string") {
                  const err266 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValuePath",
                    schemaPath:
                      "#/items/oneOf/6/properties/defaultValuePath/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err266];
                  } else {
                    vErrors.push(err266);
                  }
                  errors++;
                }
                if (
                  !(
                    data139 === "property.sisd.adjustmentRatio" ||
                    data139 === "property.sisd.defaultExclude" ||
                    data139 === "property.improvementValue" ||
                    data139 === "property.sisd.costType" ||
                    data139 === "property.latitude" ||
                    data139 === "property.longitude" ||
                    data139 === "parcel.mailingAddress1" ||
                    data139 === "parcel.mailingAddress2" ||
                    data139 === "parcel.mailingAddress" ||
                    data139 === "parcel.parcelId" ||
                    data139 === "parcel.improvementValue" ||
                    data139 === "parcel.block" ||
                    data139 === "parcel.lot" ||
                    data139 === "parcel.ownerName" ||
                    data139 === "user.firstName" ||
                    data139 === "user.lastName" ||
                    data139 === "user.fullName" ||
                    data139 === "units.feet" ||
                    data139 === "units.inches" ||
                    data139 === "units.hours" ||
                    data139 === "units.minutes" ||
                    data139 === "units.days" ||
                    data139 === "boolean.true" ||
                    data139 === "boolean.false" ||
                    data139 === "date.today"
                  )
                ) {
                  const err267 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValuePath",
                    schemaPath:
                      "#/items/oneOf/6/properties/defaultValuePath/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[6].properties.defaultValuePath
                          .enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err267];
                  } else {
                    vErrors.push(err267);
                  }
                  errors++;
                }
              }
              if (data0.defaultValue !== undefined) {
                if (typeof data0.defaultValue !== "string") {
                  const err268 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValue",
                    schemaPath: "#/items/oneOf/6/properties/defaultValue/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err268];
                  } else {
                    vErrors.push(err268);
                  }
                  errors++;
                }
              }
              if (data0.generativeAIPrompt !== undefined) {
                if (typeof data0.generativeAIPrompt !== "string") {
                  const err269 = {
                    instancePath:
                      instancePath + "/" + i0 + "/generativeAIPrompt",
                    schemaPath:
                      "#/items/oneOf/6/properties/generativeAIPrompt/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err269];
                  } else {
                    vErrors.push(err269);
                  }
                  errors++;
                }
              }
              if (data0.useGenerativeAI !== undefined) {
                if (typeof data0.useGenerativeAI !== "boolean") {
                  const err270 = {
                    instancePath: instancePath + "/" + i0 + "/useGenerativeAI",
                    schemaPath:
                      "#/items/oneOf/6/properties/useGenerativeAI/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err270];
                  } else {
                    vErrors.push(err270);
                  }
                  errors++;
                }
              }
              if (data0.columnHeaderOverride !== undefined) {
                if (typeof data0.columnHeaderOverride !== "string") {
                  const err271 = {
                    instancePath:
                      instancePath + "/" + i0 + "/columnHeaderOverride",
                    schemaPath:
                      "#/items/oneOf/6/properties/columnHeaderOverride/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err271];
                  } else {
                    vErrors.push(err271);
                  }
                  errors++;
                }
              }
              if (data0.disabled !== undefined) {
                if (typeof data0.disabled !== "boolean") {
                  const err272 = {
                    instancePath: instancePath + "/" + i0 + "/disabled",
                    schemaPath: "#/items/oneOf/6/properties/disabled/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err272];
                  } else {
                    vErrors.push(err272);
                  }
                  errors++;
                }
              }
              if (data0.helperText !== undefined) {
                if (typeof data0.helperText !== "string") {
                  const err273 = {
                    instancePath: instancePath + "/" + i0 + "/helperText",
                    schemaPath: "#/items/oneOf/6/properties/helperText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err273];
                  } else {
                    vErrors.push(err273);
                  }
                  errors++;
                }
              }
              if (data0.viewOnCreate !== undefined) {
                let data146 = data0.viewOnCreate;
                if (Array.isArray(data146)) {
                  const len22 = data146.length;
                  for (let i22 = 0; i22 < len22; i22++) {
                    if (typeof data146[i22] !== "string") {
                      const err274 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnCreate/" + i22,
                        schemaPath:
                          "#/items/oneOf/6/properties/viewOnCreate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err274];
                      } else {
                        vErrors.push(err274);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err275 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnCreate",
                    schemaPath: "#/items/oneOf/6/properties/viewOnCreate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err275];
                  } else {
                    vErrors.push(err275);
                  }
                  errors++;
                }
              }
              if (data0.viewOnRetrieve !== undefined) {
                let data148 = data0.viewOnRetrieve;
                if (Array.isArray(data148)) {
                  if (data148.length < 1) {
                    const err276 = {
                      instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                      schemaPath:
                        "#/items/oneOf/6/properties/viewOnRetrieve/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err276];
                    } else {
                      vErrors.push(err276);
                    }
                    errors++;
                  }
                  const len23 = data148.length;
                  for (let i23 = 0; i23 < len23; i23++) {
                    let data149 = data148[i23];
                    if (typeof data149 !== "string") {
                      const err277 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i23,
                        schemaPath:
                          "#/items/oneOf/6/properties/viewOnRetrieve/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err277];
                      } else {
                        vErrors.push(err277);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data149 === "manager" ||
                        data149 === "member" ||
                        data149 === "creator" ||
                        data149 === "view_only" ||
                        data149 === "admin" ||
                        data149 === "guest" ||
                        data149 === "publicUser"
                      )
                    ) {
                      const err278 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i23,
                        schemaPath:
                          "#/items/oneOf/6/properties/viewOnRetrieve/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[6].properties.viewOnRetrieve
                              .items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err278];
                      } else {
                        vErrors.push(err278);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err279 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                    schemaPath:
                      "#/items/oneOf/6/properties/viewOnRetrieve/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err279];
                  } else {
                    vErrors.push(err279);
                  }
                  errors++;
                }
              }
              if (data0.canUpdate !== undefined) {
                let data150 = data0.canUpdate;
                if (Array.isArray(data150)) {
                  const len24 = data150.length;
                  for (let i24 = 0; i24 < len24; i24++) {
                    if (typeof data150[i24] !== "string") {
                      const err280 = {
                        instancePath:
                          instancePath + "/" + i0 + "/canUpdate/" + i24,
                        schemaPath:
                          "#/items/oneOf/6/properties/canUpdate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err280];
                      } else {
                        vErrors.push(err280);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err281 = {
                    instancePath: instancePath + "/" + i0 + "/canUpdate",
                    schemaPath: "#/items/oneOf/6/properties/canUpdate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err281];
                  } else {
                    vErrors.push(err281);
                  }
                  errors++;
                }
              }
              if (data0.formula !== undefined) {
                let data152 = data0.formula;
                if (
                  data152 &&
                  typeof data152 == "object" &&
                  !Array.isArray(data152)
                ) {
                  if (data152.name === undefined) {
                    const err282 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/6/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err282];
                    } else {
                      vErrors.push(err282);
                    }
                    errors++;
                  }
                  if (data152.applies === undefined) {
                    const err283 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/6/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "applies" },
                      message:
                        "must have required property '" + "applies" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err283];
                    } else {
                      vErrors.push(err283);
                    }
                    errors++;
                  }
                  if (data152.logic === undefined) {
                    const err284 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/6/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "logic" },
                      message: "must have required property '" + "logic" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err284];
                    } else {
                      vErrors.push(err284);
                    }
                    errors++;
                  }
                  for (const key9 in data152) {
                    if (
                      !(
                        key9 === "name" ||
                        key9 === "applies" ||
                        key9 === "logic"
                      )
                    ) {
                      const err285 = {
                        instancePath: instancePath + "/" + i0 + "/formula",
                        schemaPath:
                          "#/items/oneOf/6/properties/formula/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key9 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err285];
                      } else {
                        vErrors.push(err285);
                      }
                      errors++;
                    }
                  }
                  if (data152.name !== undefined) {
                    if (typeof data152.name !== "string") {
                      const err286 = {
                        instancePath: instancePath + "/" + i0 + "/formula/name",
                        schemaPath:
                          "#/items/oneOf/6/properties/formula/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err286];
                      } else {
                        vErrors.push(err286);
                      }
                      errors++;
                    }
                  }
                  if (data152.applies !== undefined) {
                    let data154 = data152.applies;
                    if (
                      !(
                        data154 &&
                        typeof data154 == "object" &&
                        !Array.isArray(data154)
                      ) &&
                      typeof data154 !== "boolean"
                    ) {
                      const err287 = {
                        instancePath:
                          instancePath + "/" + i0 + "/formula/applies",
                        schemaPath:
                          "#/items/oneOf/6/properties/formula/properties/applies/type",
                        keyword: "type",
                        params: {
                          type: schema28.items.oneOf[6].properties.formula
                            .properties.applies.type,
                        },
                        message: "must be object,boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err287];
                      } else {
                        vErrors.push(err287);
                      }
                      errors++;
                    }
                  }
                  if (data152.logic !== undefined) {
                    let data155 = data152.logic;
                    if (
                      data155 &&
                      typeof data155 == "object" &&
                      !Array.isArray(data155)
                    ) {
                    } else {
                      const err288 = {
                        instancePath:
                          instancePath + "/" + i0 + "/formula/logic",
                        schemaPath:
                          "#/items/oneOf/6/properties/formula/properties/logic/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err288];
                      } else {
                        vErrors.push(err288);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err289 = {
                    instancePath: instancePath + "/" + i0 + "/formula",
                    schemaPath: "#/items/oneOf/6/properties/formula/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err289];
                  } else {
                    vErrors.push(err289);
                  }
                  errors++;
                }
              }
            } else {
              const err290 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/6/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err290];
              } else {
                vErrors.push(err290);
              }
              errors++;
            }
          } else if (tag0 === "number") {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.inputType === undefined) {
                const err291 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/7/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err291];
                } else {
                  vErrors.push(err291);
                }
                errors++;
              }
              if (data0.type === undefined) {
                const err292 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/7/required",
                  keyword: "required",
                  params: { missingProperty: "type" },
                  message: "must have required property '" + "type" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err292];
                } else {
                  vErrors.push(err292);
                }
                errors++;
              }
              if (data0.name === undefined) {
                const err293 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/7/required",
                  keyword: "required",
                  params: { missingProperty: "name" },
                  message: "must have required property '" + "name" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err293];
                } else {
                  vErrors.push(err293);
                }
                errors++;
              }
              if (data0.required === undefined) {
                const err294 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/7/required",
                  keyword: "required",
                  params: { missingProperty: "required" },
                  message: "must have required property '" + "required" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err294];
                } else {
                  vErrors.push(err294);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err295 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/7/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err295];
                } else {
                  vErrors.push(err295);
                }
                errors++;
              }
              for (const key10 in data0) {
                if (!func2.call(schema28.items.oneOf[7].properties, key10)) {
                  const err296 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/7/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key10 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err296];
                  } else {
                    vErrors.push(err296);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data156 = data0.inputType;
                if (typeof data156 !== "string") {
                  const err297 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/7/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err297];
                  } else {
                    vErrors.push(err297);
                  }
                  errors++;
                }
                if (!(data156 === "number")) {
                  const err298 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/7/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[7].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err298];
                  } else {
                    vErrors.push(err298);
                  }
                  errors++;
                }
              }
              if (data0.type !== undefined) {
                let data157 = data0.type;
                if (typeof data157 !== "string") {
                  const err299 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/7/properties/type/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err299];
                  } else {
                    vErrors.push(err299);
                  }
                  errors++;
                }
                if (!(data157 === "number")) {
                  const err300 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/7/properties/type/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[7].properties.type.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err300];
                  } else {
                    vErrors.push(err300);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err301 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/7/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err301];
                  } else {
                    vErrors.push(err301);
                  }
                  errors++;
                }
              }
              if (data0.placeholder !== undefined) {
                if (typeof data0.placeholder !== "string") {
                  const err302 = {
                    instancePath: instancePath + "/" + i0 + "/placeholder",
                    schemaPath: "#/items/oneOf/7/properties/placeholder/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err302];
                  } else {
                    vErrors.push(err302);
                  }
                  errors++;
                }
              }
              if (data0.tooltipText !== undefined) {
                if (typeof data0.tooltipText !== "string") {
                  const err303 = {
                    instancePath: instancePath + "/" + i0 + "/tooltipText",
                    schemaPath: "#/items/oneOf/7/properties/tooltipText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err303];
                  } else {
                    vErrors.push(err303);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err304 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/7/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err304];
                  } else {
                    vErrors.push(err304);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                let data162 = data0.title;
                if (typeof data162 === "string") {
                  if (func3(data162) < 1) {
                    const err305 = {
                      instancePath: instancePath + "/" + i0 + "/title",
                      schemaPath: "#/items/oneOf/7/properties/title/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err305];
                    } else {
                      vErrors.push(err305);
                    }
                    errors++;
                  }
                } else {
                  const err306 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/7/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err306];
                  } else {
                    vErrors.push(err306);
                  }
                  errors++;
                }
              }
              if (data0.step !== undefined) {
                let data163 = data0.step;
                if (!(typeof data163 == "number" && isFinite(data163))) {
                  const err307 = {
                    instancePath: instancePath + "/" + i0 + "/step",
                    schemaPath: "#/items/oneOf/7/properties/step/type",
                    keyword: "type",
                    params: { type: "number" },
                    message: "must be number",
                  };
                  if (vErrors === null) {
                    vErrors = [err307];
                  } else {
                    vErrors.push(err307);
                  }
                  errors++;
                }
              }
              if (data0.minimum !== undefined) {
                let data164 = data0.minimum;
                if (typeof data164 == "number" && isFinite(data164)) {
                  const vSchema27 = data0 && data0.maximum;
                  if (
                    vSchema27 !== undefined &&
                    (!(typeof vSchema27 == "number" && isFinite(vSchema27)) ||
                      data164 >= vSchema27 ||
                      isNaN(data164))
                  ) {
                    const err308 = {
                      instancePath: instancePath + "/" + i0 + "/minimum",
                      schemaPath:
                        "#/items/oneOf/7/properties/minimum/exclusiveMaximum",
                      keyword: "exclusiveMaximum",
                      params: { comparison: "<", limit: vSchema27 },
                      message: "must be < " + vSchema27,
                    };
                    if (vErrors === null) {
                      vErrors = [err308];
                    } else {
                      vErrors.push(err308);
                    }
                    errors++;
                  }
                } else {
                  const err309 = {
                    instancePath: instancePath + "/" + i0 + "/minimum",
                    schemaPath: "#/items/oneOf/7/properties/minimum/type",
                    keyword: "type",
                    params: { type: "number" },
                    message: "must be number",
                  };
                  if (vErrors === null) {
                    vErrors = [err309];
                  } else {
                    vErrors.push(err309);
                  }
                  errors++;
                }
              }
              if (data0.maximum !== undefined) {
                let data165 = data0.maximum;
                if (typeof data165 == "number" && isFinite(data165)) {
                  const vSchema28 = data0 && data0.minimum;
                  if (
                    vSchema28 !== undefined &&
                    (!(typeof vSchema28 == "number" && isFinite(vSchema28)) ||
                      data165 <= vSchema28 ||
                      isNaN(data165))
                  ) {
                    const err310 = {
                      instancePath: instancePath + "/" + i0 + "/maximum",
                      schemaPath:
                        "#/items/oneOf/7/properties/maximum/exclusiveMinimum",
                      keyword: "exclusiveMinimum",
                      params: { comparison: ">", limit: vSchema28 },
                      message: "must be > " + vSchema28,
                    };
                    if (vErrors === null) {
                      vErrors = [err310];
                    } else {
                      vErrors.push(err310);
                    }
                    errors++;
                  }
                } else {
                  const err311 = {
                    instancePath: instancePath + "/" + i0 + "/maximum",
                    schemaPath: "#/items/oneOf/7/properties/maximum/type",
                    keyword: "type",
                    params: { type: "number" },
                    message: "must be number",
                  };
                  if (vErrors === null) {
                    vErrors = [err311];
                  } else {
                    vErrors.push(err311);
                  }
                  errors++;
                }
              }
              if (data0.prefix !== undefined) {
                if (typeof data0.prefix !== "string") {
                  const err312 = {
                    instancePath: instancePath + "/" + i0 + "/prefix",
                    schemaPath: "#/items/oneOf/7/properties/prefix/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err312];
                  } else {
                    vErrors.push(err312);
                  }
                  errors++;
                }
              }
              if (data0.postfix !== undefined) {
                if (typeof data0.postfix !== "string") {
                  const err313 = {
                    instancePath: instancePath + "/" + i0 + "/postfix",
                    schemaPath: "#/items/oneOf/7/properties/postfix/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err313];
                  } else {
                    vErrors.push(err313);
                  }
                  errors++;
                }
              }
              if (data0.defaultValuePath !== undefined) {
                let data168 = data0.defaultValuePath;
                if (typeof data168 !== "string") {
                  const err314 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValuePath",
                    schemaPath:
                      "#/items/oneOf/7/properties/defaultValuePath/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err314];
                  } else {
                    vErrors.push(err314);
                  }
                  errors++;
                }
                if (
                  !(
                    data168 === "property.sisd.adjustmentRatio" ||
                    data168 === "property.sisd.defaultExclude" ||
                    data168 === "property.improvementValue" ||
                    data168 === "property.sisd.costType" ||
                    data168 === "property.latitude" ||
                    data168 === "property.longitude" ||
                    data168 === "parcel.mailingAddress1" ||
                    data168 === "parcel.mailingAddress2" ||
                    data168 === "parcel.mailingAddress" ||
                    data168 === "parcel.parcelId" ||
                    data168 === "parcel.improvementValue" ||
                    data168 === "parcel.block" ||
                    data168 === "parcel.lot" ||
                    data168 === "parcel.ownerName" ||
                    data168 === "user.firstName" ||
                    data168 === "user.lastName" ||
                    data168 === "user.fullName" ||
                    data168 === "units.feet" ||
                    data168 === "units.inches" ||
                    data168 === "units.hours" ||
                    data168 === "units.minutes" ||
                    data168 === "units.days" ||
                    data168 === "boolean.true" ||
                    data168 === "boolean.false" ||
                    data168 === "date.today"
                  )
                ) {
                  const err315 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValuePath",
                    schemaPath:
                      "#/items/oneOf/7/properties/defaultValuePath/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[7].properties.defaultValuePath
                          .enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err315];
                  } else {
                    vErrors.push(err315);
                  }
                  errors++;
                }
              }
              if (data0.defaultValue !== undefined) {
                let data169 = data0.defaultValue;
                if (typeof data169 == "number" && isFinite(data169)) {
                  const vSchema30 = data0 && data0.maximum;
                  if (
                    vSchema30 !== undefined &&
                    (!(typeof vSchema30 == "number" && isFinite(vSchema30)) ||
                      data169 > vSchema30 ||
                      isNaN(data169))
                  ) {
                    const err316 = {
                      instancePath: instancePath + "/" + i0 + "/defaultValue",
                      schemaPath:
                        "#/items/oneOf/7/properties/defaultValue/maximum",
                      keyword: "maximum",
                      params: { comparison: "<=", limit: vSchema30 },
                      message: "must be <= " + vSchema30,
                    };
                    if (vErrors === null) {
                      vErrors = [err316];
                    } else {
                      vErrors.push(err316);
                    }
                    errors++;
                  }
                  const vSchema31 = data0 && data0.minimum;
                  if (
                    vSchema31 !== undefined &&
                    (!(typeof vSchema31 == "number" && isFinite(vSchema31)) ||
                      data169 < vSchema31 ||
                      isNaN(data169))
                  ) {
                    const err317 = {
                      instancePath: instancePath + "/" + i0 + "/defaultValue",
                      schemaPath:
                        "#/items/oneOf/7/properties/defaultValue/minimum",
                      keyword: "minimum",
                      params: { comparison: ">=", limit: vSchema31 },
                      message: "must be >= " + vSchema31,
                    };
                    if (vErrors === null) {
                      vErrors = [err317];
                    } else {
                      vErrors.push(err317);
                    }
                    errors++;
                  }
                } else {
                  const err318 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValue",
                    schemaPath: "#/items/oneOf/7/properties/defaultValue/type",
                    keyword: "type",
                    params: { type: "number" },
                    message: "must be number",
                  };
                  if (vErrors === null) {
                    vErrors = [err318];
                  } else {
                    vErrors.push(err318);
                  }
                  errors++;
                }
              }
              if (data0.labelSize !== undefined) {
                let data170 = data0.labelSize;
                if (typeof data170 !== "string") {
                  const err319 = {
                    instancePath: instancePath + "/" + i0 + "/labelSize",
                    schemaPath: "#/items/oneOf/7/properties/labelSize/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err319];
                  } else {
                    vErrors.push(err319);
                  }
                  errors++;
                }
                if (!(data170 === "small" || data170 === "medium")) {
                  const err320 = {
                    instancePath: instancePath + "/" + i0 + "/labelSize",
                    schemaPath: "#/items/oneOf/7/properties/labelSize/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[7].properties.labelSize.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err320];
                  } else {
                    vErrors.push(err320);
                  }
                  errors++;
                }
              }
              if (data0.columnHeaderOverride !== undefined) {
                if (typeof data0.columnHeaderOverride !== "string") {
                  const err321 = {
                    instancePath:
                      instancePath + "/" + i0 + "/columnHeaderOverride",
                    schemaPath:
                      "#/items/oneOf/7/properties/columnHeaderOverride/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err321];
                  } else {
                    vErrors.push(err321);
                  }
                  errors++;
                }
              }
              if (data0.disabled !== undefined) {
                if (typeof data0.disabled !== "boolean") {
                  const err322 = {
                    instancePath: instancePath + "/" + i0 + "/disabled",
                    schemaPath: "#/items/oneOf/7/properties/disabled/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err322];
                  } else {
                    vErrors.push(err322);
                  }
                  errors++;
                }
              }
              if (data0.helperText !== undefined) {
                if (typeof data0.helperText !== "string") {
                  const err323 = {
                    instancePath: instancePath + "/" + i0 + "/helperText",
                    schemaPath: "#/items/oneOf/7/properties/helperText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err323];
                  } else {
                    vErrors.push(err323);
                  }
                  errors++;
                }
              }
              if (data0.viewOnCreate !== undefined) {
                let data174 = data0.viewOnCreate;
                if (Array.isArray(data174)) {
                  const len25 = data174.length;
                  for (let i25 = 0; i25 < len25; i25++) {
                    if (typeof data174[i25] !== "string") {
                      const err324 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnCreate/" + i25,
                        schemaPath:
                          "#/items/oneOf/7/properties/viewOnCreate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err324];
                      } else {
                        vErrors.push(err324);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err325 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnCreate",
                    schemaPath: "#/items/oneOf/7/properties/viewOnCreate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err325];
                  } else {
                    vErrors.push(err325);
                  }
                  errors++;
                }
              }
              if (data0.viewOnRetrieve !== undefined) {
                let data176 = data0.viewOnRetrieve;
                if (Array.isArray(data176)) {
                  if (data176.length < 1) {
                    const err326 = {
                      instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                      schemaPath:
                        "#/items/oneOf/7/properties/viewOnRetrieve/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err326];
                    } else {
                      vErrors.push(err326);
                    }
                    errors++;
                  }
                  const len26 = data176.length;
                  for (let i26 = 0; i26 < len26; i26++) {
                    let data177 = data176[i26];
                    if (typeof data177 !== "string") {
                      const err327 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i26,
                        schemaPath:
                          "#/items/oneOf/7/properties/viewOnRetrieve/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err327];
                      } else {
                        vErrors.push(err327);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data177 === "manager" ||
                        data177 === "member" ||
                        data177 === "creator" ||
                        data177 === "view_only" ||
                        data177 === "admin" ||
                        data177 === "guest" ||
                        data177 === "publicUser"
                      )
                    ) {
                      const err328 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i26,
                        schemaPath:
                          "#/items/oneOf/7/properties/viewOnRetrieve/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[7].properties.viewOnRetrieve
                              .items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err328];
                      } else {
                        vErrors.push(err328);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err329 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                    schemaPath:
                      "#/items/oneOf/7/properties/viewOnRetrieve/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err329];
                  } else {
                    vErrors.push(err329);
                  }
                  errors++;
                }
              }
              if (data0.canUpdate !== undefined) {
                let data178 = data0.canUpdate;
                if (Array.isArray(data178)) {
                  const len27 = data178.length;
                  for (let i27 = 0; i27 < len27; i27++) {
                    if (typeof data178[i27] !== "string") {
                      const err330 = {
                        instancePath:
                          instancePath + "/" + i0 + "/canUpdate/" + i27,
                        schemaPath:
                          "#/items/oneOf/7/properties/canUpdate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err330];
                      } else {
                        vErrors.push(err330);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err331 = {
                    instancePath: instancePath + "/" + i0 + "/canUpdate",
                    schemaPath: "#/items/oneOf/7/properties/canUpdate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err331];
                  } else {
                    vErrors.push(err331);
                  }
                  errors++;
                }
              }
              if (data0.formula !== undefined) {
                let data180 = data0.formula;
                if (
                  data180 &&
                  typeof data180 == "object" &&
                  !Array.isArray(data180)
                ) {
                  if (data180.name === undefined) {
                    const err332 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/7/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err332];
                    } else {
                      vErrors.push(err332);
                    }
                    errors++;
                  }
                  if (data180.applies === undefined) {
                    const err333 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/7/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "applies" },
                      message:
                        "must have required property '" + "applies" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err333];
                    } else {
                      vErrors.push(err333);
                    }
                    errors++;
                  }
                  if (data180.logic === undefined) {
                    const err334 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/7/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "logic" },
                      message: "must have required property '" + "logic" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err334];
                    } else {
                      vErrors.push(err334);
                    }
                    errors++;
                  }
                  for (const key11 in data180) {
                    if (
                      !(
                        key11 === "name" ||
                        key11 === "applies" ||
                        key11 === "logic"
                      )
                    ) {
                      const err335 = {
                        instancePath: instancePath + "/" + i0 + "/formula",
                        schemaPath:
                          "#/items/oneOf/7/properties/formula/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key11 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err335];
                      } else {
                        vErrors.push(err335);
                      }
                      errors++;
                    }
                  }
                  if (data180.name !== undefined) {
                    if (typeof data180.name !== "string") {
                      const err336 = {
                        instancePath: instancePath + "/" + i0 + "/formula/name",
                        schemaPath:
                          "#/items/oneOf/7/properties/formula/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err336];
                      } else {
                        vErrors.push(err336);
                      }
                      errors++;
                    }
                  }
                  if (data180.applies !== undefined) {
                    let data182 = data180.applies;
                    if (
                      !(
                        data182 &&
                        typeof data182 == "object" &&
                        !Array.isArray(data182)
                      ) &&
                      typeof data182 !== "boolean"
                    ) {
                      const err337 = {
                        instancePath:
                          instancePath + "/" + i0 + "/formula/applies",
                        schemaPath:
                          "#/items/oneOf/7/properties/formula/properties/applies/type",
                        keyword: "type",
                        params: {
                          type: schema28.items.oneOf[7].properties.formula
                            .properties.applies.type,
                        },
                        message: "must be object,boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err337];
                      } else {
                        vErrors.push(err337);
                      }
                      errors++;
                    }
                  }
                  if (data180.logic !== undefined) {
                    let data183 = data180.logic;
                    if (
                      data183 &&
                      typeof data183 == "object" &&
                      !Array.isArray(data183)
                    ) {
                    } else {
                      const err338 = {
                        instancePath:
                          instancePath + "/" + i0 + "/formula/logic",
                        schemaPath:
                          "#/items/oneOf/7/properties/formula/properties/logic/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err338];
                      } else {
                        vErrors.push(err338);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err339 = {
                    instancePath: instancePath + "/" + i0 + "/formula",
                    schemaPath: "#/items/oneOf/7/properties/formula/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err339];
                  } else {
                    vErrors.push(err339);
                  }
                  errors++;
                }
              }
              if (data0.prefixPostfix !== undefined) {
                let data184 = data0.prefixPostfix;
                if (
                  data184 &&
                  typeof data184 == "object" &&
                  !Array.isArray(data184)
                ) {
                  if (data184.label !== undefined) {
                    let data185 = data184.label;
                    if (typeof data185 === "string") {
                      if (func3(data185) < 1) {
                        const err340 = {
                          instancePath:
                            instancePath + "/" + i0 + "/prefixPostfix/label",
                          schemaPath:
                            "#/items/oneOf/7/properties/prefixPostfix/properties/label/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err340];
                        } else {
                          vErrors.push(err340);
                        }
                        errors++;
                      }
                    } else {
                      const err341 = {
                        instancePath:
                          instancePath + "/" + i0 + "/prefixPostfix/label",
                        schemaPath:
                          "#/items/oneOf/7/properties/prefixPostfix/properties/label/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err341];
                      } else {
                        vErrors.push(err341);
                      }
                      errors++;
                    }
                  }
                  if (data184.value !== undefined) {
                    let data186 = data184.value;
                    if (typeof data186 === "string") {
                      if (func3(data186) < 1) {
                        const err342 = {
                          instancePath:
                            instancePath + "/" + i0 + "/prefixPostfix/value",
                          schemaPath:
                            "#/items/oneOf/7/properties/prefixPostfix/properties/value/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err342];
                        } else {
                          vErrors.push(err342);
                        }
                        errors++;
                      }
                    } else {
                      const err343 = {
                        instancePath:
                          instancePath + "/" + i0 + "/prefixPostfix/value",
                        schemaPath:
                          "#/items/oneOf/7/properties/prefixPostfix/properties/value/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err343];
                      } else {
                        vErrors.push(err343);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err344 = {
                    instancePath: instancePath + "/" + i0 + "/prefixPostfix",
                    schemaPath: "#/items/oneOf/7/properties/prefixPostfix/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err344];
                  } else {
                    vErrors.push(err344);
                  }
                  errors++;
                }
              }
            } else {
              const err345 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/7/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err345];
              } else {
                vErrors.push(err345);
              }
              errors++;
            }
          } else if (tag0 === "checkbox") {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.name === undefined) {
                const err346 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/8/required",
                  keyword: "required",
                  params: { missingProperty: "name" },
                  message: "must have required property '" + "name" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err346];
                } else {
                  vErrors.push(err346);
                }
                errors++;
              }
              if (data0.required === undefined) {
                const err347 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/8/required",
                  keyword: "required",
                  params: { missingProperty: "required" },
                  message: "must have required property '" + "required" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err347];
                } else {
                  vErrors.push(err347);
                }
                errors++;
              }
              if (data0.type === undefined) {
                const err348 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/8/required",
                  keyword: "required",
                  params: { missingProperty: "type" },
                  message: "must have required property '" + "type" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err348];
                } else {
                  vErrors.push(err348);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err349 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/8/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err349];
                } else {
                  vErrors.push(err349);
                }
                errors++;
              }
              if (data0.inputType === undefined) {
                const err350 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/8/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err350];
                } else {
                  vErrors.push(err350);
                }
                errors++;
              }
              if (data0.checkboxText === undefined) {
                const err351 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/8/required",
                  keyword: "required",
                  params: { missingProperty: "checkboxText" },
                  message:
                    "must have required property '" + "checkboxText" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err351];
                } else {
                  vErrors.push(err351);
                }
                errors++;
              }
              for (const key12 in data0) {
                if (!func2.call(schema28.items.oneOf[8].properties, key12)) {
                  const err352 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/8/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key12 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err352];
                  } else {
                    vErrors.push(err352);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err353 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/8/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err353];
                  } else {
                    vErrors.push(err353);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err354 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/8/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err354];
                  } else {
                    vErrors.push(err354);
                  }
                  errors++;
                }
              }
              if (data0.type !== undefined) {
                let data189 = data0.type;
                if (typeof data189 !== "string") {
                  const err355 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/8/properties/type/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err355];
                  } else {
                    vErrors.push(err355);
                  }
                  errors++;
                }
                if (!(data189 === "boolean")) {
                  const err356 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/8/properties/type/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[8].properties.type.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err356];
                  } else {
                    vErrors.push(err356);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data190 = data0.inputType;
                if (typeof data190 !== "string") {
                  const err357 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/8/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err357];
                  } else {
                    vErrors.push(err357);
                  }
                  errors++;
                }
                if (!(data190 === "checkbox")) {
                  const err358 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/8/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[8].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err358];
                  } else {
                    vErrors.push(err358);
                  }
                  errors++;
                }
              }
              if (data0.tooltipText !== undefined) {
                if (typeof data0.tooltipText !== "string") {
                  const err359 = {
                    instancePath: instancePath + "/" + i0 + "/tooltipText",
                    schemaPath: "#/items/oneOf/8/properties/tooltipText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err359];
                  } else {
                    vErrors.push(err359);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                if (typeof data0.title !== "string") {
                  const err360 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/8/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err360];
                  } else {
                    vErrors.push(err360);
                  }
                  errors++;
                }
              }
              if (data0.checkboxText !== undefined) {
                let data193 = data0.checkboxText;
                if (typeof data193 === "string") {
                  if (func3(data193) < 1) {
                    const err361 = {
                      instancePath: instancePath + "/" + i0 + "/checkboxText",
                      schemaPath:
                        "#/items/oneOf/8/properties/checkboxText/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err361];
                    } else {
                      vErrors.push(err361);
                    }
                    errors++;
                  }
                } else {
                  const err362 = {
                    instancePath: instancePath + "/" + i0 + "/checkboxText",
                    schemaPath: "#/items/oneOf/8/properties/checkboxText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err362];
                  } else {
                    vErrors.push(err362);
                  }
                  errors++;
                }
              }
              if (data0.columnHeaderOverride !== undefined) {
                if (typeof data0.columnHeaderOverride !== "string") {
                  const err363 = {
                    instancePath:
                      instancePath + "/" + i0 + "/columnHeaderOverride",
                    schemaPath:
                      "#/items/oneOf/8/properties/columnHeaderOverride/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err363];
                  } else {
                    vErrors.push(err363);
                  }
                  errors++;
                }
              }
              if (data0.defaultValuePath !== undefined) {
                let data195 = data0.defaultValuePath;
                if (typeof data195 !== "string") {
                  const err364 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValuePath",
                    schemaPath:
                      "#/items/oneOf/8/properties/defaultValuePath/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err364];
                  } else {
                    vErrors.push(err364);
                  }
                  errors++;
                }
                if (
                  !(
                    data195 === "property.sisd.adjustmentRatio" ||
                    data195 === "property.sisd.defaultExclude" ||
                    data195 === "property.improvementValue" ||
                    data195 === "property.sisd.costType" ||
                    data195 === "property.latitude" ||
                    data195 === "property.longitude" ||
                    data195 === "parcel.mailingAddress1" ||
                    data195 === "parcel.mailingAddress2" ||
                    data195 === "parcel.mailingAddress" ||
                    data195 === "parcel.parcelId" ||
                    data195 === "parcel.improvementValue" ||
                    data195 === "parcel.block" ||
                    data195 === "parcel.lot" ||
                    data195 === "parcel.ownerName" ||
                    data195 === "user.firstName" ||
                    data195 === "user.lastName" ||
                    data195 === "user.fullName" ||
                    data195 === "units.feet" ||
                    data195 === "units.inches" ||
                    data195 === "units.hours" ||
                    data195 === "units.minutes" ||
                    data195 === "units.days" ||
                    data195 === "boolean.true" ||
                    data195 === "boolean.false" ||
                    data195 === "date.today"
                  )
                ) {
                  const err365 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValuePath",
                    schemaPath:
                      "#/items/oneOf/8/properties/defaultValuePath/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[8].properties.defaultValuePath
                          .enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err365];
                  } else {
                    vErrors.push(err365);
                  }
                  errors++;
                }
              }
              if (data0.disabled !== undefined) {
                if (typeof data0.disabled !== "boolean") {
                  const err366 = {
                    instancePath: instancePath + "/" + i0 + "/disabled",
                    schemaPath: "#/items/oneOf/8/properties/disabled/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err366];
                  } else {
                    vErrors.push(err366);
                  }
                  errors++;
                }
              }
              if (data0.viewOnCreate !== undefined) {
                let data197 = data0.viewOnCreate;
                if (Array.isArray(data197)) {
                  const len28 = data197.length;
                  for (let i28 = 0; i28 < len28; i28++) {
                    if (typeof data197[i28] !== "string") {
                      const err367 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnCreate/" + i28,
                        schemaPath:
                          "#/items/oneOf/8/properties/viewOnCreate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err367];
                      } else {
                        vErrors.push(err367);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err368 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnCreate",
                    schemaPath: "#/items/oneOf/8/properties/viewOnCreate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err368];
                  } else {
                    vErrors.push(err368);
                  }
                  errors++;
                }
              }
              if (data0.viewOnRetrieve !== undefined) {
                let data199 = data0.viewOnRetrieve;
                if (Array.isArray(data199)) {
                  if (data199.length < 1) {
                    const err369 = {
                      instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                      schemaPath:
                        "#/items/oneOf/8/properties/viewOnRetrieve/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err369];
                    } else {
                      vErrors.push(err369);
                    }
                    errors++;
                  }
                  const len29 = data199.length;
                  for (let i29 = 0; i29 < len29; i29++) {
                    let data200 = data199[i29];
                    if (typeof data200 !== "string") {
                      const err370 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i29,
                        schemaPath:
                          "#/items/oneOf/8/properties/viewOnRetrieve/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err370];
                      } else {
                        vErrors.push(err370);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data200 === "manager" ||
                        data200 === "member" ||
                        data200 === "creator" ||
                        data200 === "view_only" ||
                        data200 === "admin" ||
                        data200 === "guest" ||
                        data200 === "publicUser"
                      )
                    ) {
                      const err371 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i29,
                        schemaPath:
                          "#/items/oneOf/8/properties/viewOnRetrieve/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[8].properties.viewOnRetrieve
                              .items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err371];
                      } else {
                        vErrors.push(err371);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err372 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                    schemaPath:
                      "#/items/oneOf/8/properties/viewOnRetrieve/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err372];
                  } else {
                    vErrors.push(err372);
                  }
                  errors++;
                }
              }
              if (data0.canUpdate !== undefined) {
                let data201 = data0.canUpdate;
                if (Array.isArray(data201)) {
                  const len30 = data201.length;
                  for (let i30 = 0; i30 < len30; i30++) {
                    if (typeof data201[i30] !== "string") {
                      const err373 = {
                        instancePath:
                          instancePath + "/" + i0 + "/canUpdate/" + i30,
                        schemaPath:
                          "#/items/oneOf/8/properties/canUpdate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err373];
                      } else {
                        vErrors.push(err373);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err374 = {
                    instancePath: instancePath + "/" + i0 + "/canUpdate",
                    schemaPath: "#/items/oneOf/8/properties/canUpdate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err374];
                  } else {
                    vErrors.push(err374);
                  }
                  errors++;
                }
              }
              if (data0.formula !== undefined) {
                let data203 = data0.formula;
                if (
                  data203 &&
                  typeof data203 == "object" &&
                  !Array.isArray(data203)
                ) {
                  if (data203.name === undefined) {
                    const err375 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/8/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err375];
                    } else {
                      vErrors.push(err375);
                    }
                    errors++;
                  }
                  if (data203.applies === undefined) {
                    const err376 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/8/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "applies" },
                      message:
                        "must have required property '" + "applies" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err376];
                    } else {
                      vErrors.push(err376);
                    }
                    errors++;
                  }
                  if (data203.logic === undefined) {
                    const err377 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath: "#/items/oneOf/8/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "logic" },
                      message: "must have required property '" + "logic" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err377];
                    } else {
                      vErrors.push(err377);
                    }
                    errors++;
                  }
                  for (const key13 in data203) {
                    if (
                      !(
                        key13 === "name" ||
                        key13 === "applies" ||
                        key13 === "logic"
                      )
                    ) {
                      const err378 = {
                        instancePath: instancePath + "/" + i0 + "/formula",
                        schemaPath:
                          "#/items/oneOf/8/properties/formula/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key13 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err378];
                      } else {
                        vErrors.push(err378);
                      }
                      errors++;
                    }
                  }
                  if (data203.name !== undefined) {
                    if (typeof data203.name !== "string") {
                      const err379 = {
                        instancePath: instancePath + "/" + i0 + "/formula/name",
                        schemaPath:
                          "#/items/oneOf/8/properties/formula/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err379];
                      } else {
                        vErrors.push(err379);
                      }
                      errors++;
                    }
                  }
                  if (data203.applies !== undefined) {
                    let data205 = data203.applies;
                    if (
                      !(
                        data205 &&
                        typeof data205 == "object" &&
                        !Array.isArray(data205)
                      ) &&
                      typeof data205 !== "boolean"
                    ) {
                      const err380 = {
                        instancePath:
                          instancePath + "/" + i0 + "/formula/applies",
                        schemaPath:
                          "#/items/oneOf/8/properties/formula/properties/applies/type",
                        keyword: "type",
                        params: {
                          type: schema28.items.oneOf[8].properties.formula
                            .properties.applies.type,
                        },
                        message: "must be object,boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err380];
                      } else {
                        vErrors.push(err380);
                      }
                      errors++;
                    }
                  }
                  if (data203.logic !== undefined) {
                    let data206 = data203.logic;
                    if (
                      data206 &&
                      typeof data206 == "object" &&
                      !Array.isArray(data206)
                    ) {
                    } else {
                      const err381 = {
                        instancePath:
                          instancePath + "/" + i0 + "/formula/logic",
                        schemaPath:
                          "#/items/oneOf/8/properties/formula/properties/logic/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err381];
                      } else {
                        vErrors.push(err381);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err382 = {
                    instancePath: instancePath + "/" + i0 + "/formula",
                    schemaPath: "#/items/oneOf/8/properties/formula/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err382];
                  } else {
                    vErrors.push(err382);
                  }
                  errors++;
                }
              }
            } else {
              const err383 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/8/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err383];
              } else {
                vErrors.push(err383);
              }
              errors++;
            }
          } else if (tag0 === "NumberWithUnits") {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.inputType === undefined) {
                const err384 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/9/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err384];
                } else {
                  vErrors.push(err384);
                }
                errors++;
              }
              if (data0.name === undefined) {
                const err385 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/9/required",
                  keyword: "required",
                  params: { missingProperty: "name" },
                  message: "must have required property '" + "name" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err385];
                } else {
                  vErrors.push(err385);
                }
                errors++;
              }
              if (data0.enum === undefined) {
                const err386 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/9/required",
                  keyword: "required",
                  params: { missingProperty: "enum" },
                  message: "must have required property '" + "enum" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err386];
                } else {
                  vErrors.push(err386);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err387 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/9/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err387];
                } else {
                  vErrors.push(err387);
                }
                errors++;
              }
              if (data0.required === undefined) {
                const err388 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/9/required",
                  keyword: "required",
                  params: { missingProperty: "required" },
                  message: "must have required property '" + "required" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err388];
                } else {
                  vErrors.push(err388);
                }
                errors++;
              }
              for (const key14 in data0) {
                if (!func2.call(schema28.items.oneOf[9].properties, key14)) {
                  const err389 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/9/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key14 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err389];
                  } else {
                    vErrors.push(err389);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data207 = data0.inputType;
                if (typeof data207 !== "string") {
                  const err390 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/9/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err390];
                  } else {
                    vErrors.push(err390);
                  }
                  errors++;
                }
                if (!(data207 === "NumberWithUnits")) {
                  const err391 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/9/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[9].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err391];
                  } else {
                    vErrors.push(err391);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err392 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/9/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err392];
                  } else {
                    vErrors.push(err392);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err393 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/9/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err393];
                  } else {
                    vErrors.push(err393);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                let data210 = data0.title;
                if (typeof data210 === "string") {
                  if (func3(data210) < 1) {
                    const err394 = {
                      instancePath: instancePath + "/" + i0 + "/title",
                      schemaPath: "#/items/oneOf/9/properties/title/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err394];
                    } else {
                      vErrors.push(err394);
                    }
                    errors++;
                  }
                } else {
                  const err395 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/9/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err395];
                  } else {
                    vErrors.push(err395);
                  }
                  errors++;
                }
              }
              if (data0.minimum !== undefined) {
                let data211 = data0.minimum;
                if (typeof data211 == "number" && isFinite(data211)) {
                  const vSchema39 = data0 && data0.maximum;
                  if (
                    vSchema39 !== undefined &&
                    (!(typeof vSchema39 == "number" && isFinite(vSchema39)) ||
                      data211 >= vSchema39 ||
                      isNaN(data211))
                  ) {
                    const err396 = {
                      instancePath: instancePath + "/" + i0 + "/minimum",
                      schemaPath:
                        "#/items/oneOf/9/properties/minimum/exclusiveMaximum",
                      keyword: "exclusiveMaximum",
                      params: { comparison: "<", limit: vSchema39 },
                      message: "must be < " + vSchema39,
                    };
                    if (vErrors === null) {
                      vErrors = [err396];
                    } else {
                      vErrors.push(err396);
                    }
                    errors++;
                  }
                } else {
                  const err397 = {
                    instancePath: instancePath + "/" + i0 + "/minimum",
                    schemaPath: "#/items/oneOf/9/properties/minimum/type",
                    keyword: "type",
                    params: { type: "number" },
                    message: "must be number",
                  };
                  if (vErrors === null) {
                    vErrors = [err397];
                  } else {
                    vErrors.push(err397);
                  }
                  errors++;
                }
              }
              if (data0.maximum !== undefined) {
                let data212 = data0.maximum;
                if (typeof data212 == "number" && isFinite(data212)) {
                  const vSchema40 = data0 && data0.minimum;
                  if (
                    vSchema40 !== undefined &&
                    (!(typeof vSchema40 == "number" && isFinite(vSchema40)) ||
                      data212 <= vSchema40 ||
                      isNaN(data212))
                  ) {
                    const err398 = {
                      instancePath: instancePath + "/" + i0 + "/maximum",
                      schemaPath:
                        "#/items/oneOf/9/properties/maximum/exclusiveMinimum",
                      keyword: "exclusiveMinimum",
                      params: { comparison: ">", limit: vSchema40 },
                      message: "must be > " + vSchema40,
                    };
                    if (vErrors === null) {
                      vErrors = [err398];
                    } else {
                      vErrors.push(err398);
                    }
                    errors++;
                  }
                } else {
                  const err399 = {
                    instancePath: instancePath + "/" + i0 + "/maximum",
                    schemaPath: "#/items/oneOf/9/properties/maximum/type",
                    keyword: "type",
                    params: { type: "number" },
                    message: "must be number",
                  };
                  if (vErrors === null) {
                    vErrors = [err399];
                  } else {
                    vErrors.push(err399);
                  }
                  errors++;
                }
              }
              if (data0.tooltipText !== undefined) {
                if (typeof data0.tooltipText !== "string") {
                  const err400 = {
                    instancePath: instancePath + "/" + i0 + "/tooltipText",
                    schemaPath: "#/items/oneOf/9/properties/tooltipText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err400];
                  } else {
                    vErrors.push(err400);
                  }
                  errors++;
                }
              }
              if (data0.defaultValuePath !== undefined) {
                let data214 = data0.defaultValuePath;
                if (typeof data214 !== "string") {
                  const err401 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValuePath",
                    schemaPath:
                      "#/items/oneOf/9/properties/defaultValuePath/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err401];
                  } else {
                    vErrors.push(err401);
                  }
                  errors++;
                }
                if (
                  !(
                    data214 === "property.sisd.adjustmentRatio" ||
                    data214 === "property.sisd.defaultExclude" ||
                    data214 === "property.improvementValue" ||
                    data214 === "property.sisd.costType" ||
                    data214 === "property.latitude" ||
                    data214 === "property.longitude" ||
                    data214 === "parcel.mailingAddress1" ||
                    data214 === "parcel.mailingAddress2" ||
                    data214 === "parcel.mailingAddress" ||
                    data214 === "parcel.parcelId" ||
                    data214 === "parcel.improvementValue" ||
                    data214 === "parcel.block" ||
                    data214 === "parcel.lot" ||
                    data214 === "parcel.ownerName" ||
                    data214 === "user.firstName" ||
                    data214 === "user.lastName" ||
                    data214 === "user.fullName" ||
                    data214 === "units.feet" ||
                    data214 === "units.inches" ||
                    data214 === "units.hours" ||
                    data214 === "units.minutes" ||
                    data214 === "units.days" ||
                    data214 === "boolean.true" ||
                    data214 === "boolean.false" ||
                    data214 === "date.today"
                  )
                ) {
                  const err402 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValuePath",
                    schemaPath:
                      "#/items/oneOf/9/properties/defaultValuePath/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[9].properties.defaultValuePath
                          .enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err402];
                  } else {
                    vErrors.push(err402);
                  }
                  errors++;
                }
              }
              if (data0.defaultValue !== undefined) {
                let data215 = data0.defaultValue;
                if (typeof data215 == "number" && isFinite(data215)) {
                  const vSchema42 = data0 && data0.maximum;
                  if (
                    vSchema42 !== undefined &&
                    (!(typeof vSchema42 == "number" && isFinite(vSchema42)) ||
                      data215 > vSchema42 ||
                      isNaN(data215))
                  ) {
                    const err403 = {
                      instancePath: instancePath + "/" + i0 + "/defaultValue",
                      schemaPath:
                        "#/items/oneOf/9/properties/defaultValue/maximum",
                      keyword: "maximum",
                      params: { comparison: "<=", limit: vSchema42 },
                      message: "must be <= " + vSchema42,
                    };
                    if (vErrors === null) {
                      vErrors = [err403];
                    } else {
                      vErrors.push(err403);
                    }
                    errors++;
                  }
                  const vSchema43 = data0 && data0.minimum;
                  if (
                    vSchema43 !== undefined &&
                    (!(typeof vSchema43 == "number" && isFinite(vSchema43)) ||
                      data215 < vSchema43 ||
                      isNaN(data215))
                  ) {
                    const err404 = {
                      instancePath: instancePath + "/" + i0 + "/defaultValue",
                      schemaPath:
                        "#/items/oneOf/9/properties/defaultValue/minimum",
                      keyword: "minimum",
                      params: { comparison: ">=", limit: vSchema43 },
                      message: "must be >= " + vSchema43,
                    };
                    if (vErrors === null) {
                      vErrors = [err404];
                    } else {
                      vErrors.push(err404);
                    }
                    errors++;
                  }
                } else {
                  const err405 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValue",
                    schemaPath: "#/items/oneOf/9/properties/defaultValue/type",
                    keyword: "type",
                    params: { type: "number" },
                    message: "must be number",
                  };
                  if (vErrors === null) {
                    vErrors = [err405];
                  } else {
                    vErrors.push(err405);
                  }
                  errors++;
                }
              }
              if (data0.unitsDefaultValuePath !== undefined) {
                let data216 = data0.unitsDefaultValuePath;
                if (typeof data216 !== "string") {
                  const err406 = {
                    instancePath:
                      instancePath + "/" + i0 + "/unitsDefaultValuePath",
                    schemaPath:
                      "#/items/oneOf/9/properties/unitsDefaultValuePath/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err406];
                  } else {
                    vErrors.push(err406);
                  }
                  errors++;
                }
                if (
                  !(
                    data216 === "property.sisd.adjustmentRatio" ||
                    data216 === "property.sisd.defaultExclude" ||
                    data216 === "property.improvementValue" ||
                    data216 === "property.sisd.costType" ||
                    data216 === "property.latitude" ||
                    data216 === "property.longitude" ||
                    data216 === "parcel.mailingAddress1" ||
                    data216 === "parcel.mailingAddress2" ||
                    data216 === "parcel.mailingAddress" ||
                    data216 === "parcel.parcelId" ||
                    data216 === "parcel.improvementValue" ||
                    data216 === "parcel.block" ||
                    data216 === "parcel.lot" ||
                    data216 === "parcel.ownerName" ||
                    data216 === "user.firstName" ||
                    data216 === "user.lastName" ||
                    data216 === "user.fullName" ||
                    data216 === "units.feet" ||
                    data216 === "units.inches" ||
                    data216 === "units.hours" ||
                    data216 === "units.minutes" ||
                    data216 === "units.days" ||
                    data216 === "boolean.true" ||
                    data216 === "boolean.false" ||
                    data216 === "date.today"
                  )
                ) {
                  const err407 = {
                    instancePath:
                      instancePath + "/" + i0 + "/unitsDefaultValuePath",
                    schemaPath:
                      "#/items/oneOf/9/properties/unitsDefaultValuePath/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[9].properties.unitsDefaultValuePath
                          .enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err407];
                  } else {
                    vErrors.push(err407);
                  }
                  errors++;
                }
              }
              if (data0.unitsDefaultValue !== undefined) {
                if (typeof data0.unitsDefaultValue !== "string") {
                  const err408 = {
                    instancePath:
                      instancePath + "/" + i0 + "/unitsDefaultValue",
                    schemaPath:
                      "#/items/oneOf/9/properties/unitsDefaultValue/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err408];
                  } else {
                    vErrors.push(err408);
                  }
                  errors++;
                }
              }
              if (data0.enum !== undefined) {
                let data218 = data0.enum;
                if (Array.isArray(data218)) {
                  if (data218.length < 1) {
                    const err409 = {
                      instancePath: instancePath + "/" + i0 + "/enum",
                      schemaPath: "#/items/oneOf/9/properties/enum/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err409];
                    } else {
                      vErrors.push(err409);
                    }
                    errors++;
                  }
                  const len31 = data218.length;
                  for (let i31 = 0; i31 < len31; i31++) {
                    let data219 = data218[i31];
                    if (
                      data219 &&
                      typeof data219 == "object" &&
                      !Array.isArray(data219)
                    ) {
                      if (data219.label === undefined) {
                        const err410 = {
                          instancePath:
                            instancePath + "/" + i0 + "/enum/" + i31,
                          schemaPath:
                            "#/items/oneOf/9/properties/enum/items/required",
                          keyword: "required",
                          params: { missingProperty: "label" },
                          message:
                            "must have required property '" + "label" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err410];
                        } else {
                          vErrors.push(err410);
                        }
                        errors++;
                      }
                      if (data219.value === undefined) {
                        const err411 = {
                          instancePath:
                            instancePath + "/" + i0 + "/enum/" + i31,
                          schemaPath:
                            "#/items/oneOf/9/properties/enum/items/required",
                          keyword: "required",
                          params: { missingProperty: "value" },
                          message:
                            "must have required property '" + "value" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err411];
                        } else {
                          vErrors.push(err411);
                        }
                        errors++;
                      }
                      if (data219.label !== undefined) {
                        let data220 = data219.label;
                        if (typeof data220 === "string") {
                          if (func3(data220) < 1) {
                            const err412 = {
                              instancePath:
                                instancePath +
                                "/" +
                                i0 +
                                "/enum/" +
                                i31 +
                                "/label",
                              schemaPath:
                                "#/items/oneOf/9/properties/enum/items/properties/label/minLength",
                              keyword: "minLength",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 characters",
                            };
                            if (vErrors === null) {
                              vErrors = [err412];
                            } else {
                              vErrors.push(err412);
                            }
                            errors++;
                          }
                        } else {
                          const err413 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/enum/" +
                              i31 +
                              "/label",
                            schemaPath:
                              "#/items/oneOf/9/properties/enum/items/properties/label/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err413];
                          } else {
                            vErrors.push(err413);
                          }
                          errors++;
                        }
                      }
                      if (data219.value !== undefined) {
                        let data221 = data219.value;
                        if (typeof data221 === "string") {
                          if (func3(data221) < 1) {
                            const err414 = {
                              instancePath:
                                instancePath +
                                "/" +
                                i0 +
                                "/enum/" +
                                i31 +
                                "/value",
                              schemaPath:
                                "#/items/oneOf/9/properties/enum/items/properties/value/minLength",
                              keyword: "minLength",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 characters",
                            };
                            if (vErrors === null) {
                              vErrors = [err414];
                            } else {
                              vErrors.push(err414);
                            }
                            errors++;
                          }
                        } else {
                          const err415 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/enum/" +
                              i31 +
                              "/value",
                            schemaPath:
                              "#/items/oneOf/9/properties/enum/items/properties/value/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err415];
                          } else {
                            vErrors.push(err415);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err416 = {
                        instancePath: instancePath + "/" + i0 + "/enum/" + i31,
                        schemaPath:
                          "#/items/oneOf/9/properties/enum/items/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err416];
                      } else {
                        vErrors.push(err416);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err417 = {
                    instancePath: instancePath + "/" + i0 + "/enum",
                    schemaPath: "#/items/oneOf/9/properties/enum/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err417];
                  } else {
                    vErrors.push(err417);
                  }
                  errors++;
                }
              }
              if (data0.columnHeaderOverride !== undefined) {
                if (typeof data0.columnHeaderOverride !== "string") {
                  const err418 = {
                    instancePath:
                      instancePath + "/" + i0 + "/columnHeaderOverride",
                    schemaPath:
                      "#/items/oneOf/9/properties/columnHeaderOverride/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err418];
                  } else {
                    vErrors.push(err418);
                  }
                  errors++;
                }
              }
              if (data0.disabled !== undefined) {
                if (typeof data0.disabled !== "boolean") {
                  const err419 = {
                    instancePath: instancePath + "/" + i0 + "/disabled",
                    schemaPath: "#/items/oneOf/9/properties/disabled/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err419];
                  } else {
                    vErrors.push(err419);
                  }
                  errors++;
                }
              }
              if (data0.helperText !== undefined) {
                if (typeof data0.helperText !== "string") {
                  const err420 = {
                    instancePath: instancePath + "/" + i0 + "/helperText",
                    schemaPath: "#/items/oneOf/9/properties/helperText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err420];
                  } else {
                    vErrors.push(err420);
                  }
                  errors++;
                }
              }
              if (data0.viewOnCreate !== undefined) {
                let data225 = data0.viewOnCreate;
                if (Array.isArray(data225)) {
                  const len32 = data225.length;
                  for (let i32 = 0; i32 < len32; i32++) {
                    if (typeof data225[i32] !== "string") {
                      const err421 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnCreate/" + i32,
                        schemaPath:
                          "#/items/oneOf/9/properties/viewOnCreate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err421];
                      } else {
                        vErrors.push(err421);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err422 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnCreate",
                    schemaPath: "#/items/oneOf/9/properties/viewOnCreate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err422];
                  } else {
                    vErrors.push(err422);
                  }
                  errors++;
                }
              }
              if (data0.viewOnRetrieve !== undefined) {
                let data227 = data0.viewOnRetrieve;
                if (Array.isArray(data227)) {
                  if (data227.length < 1) {
                    const err423 = {
                      instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                      schemaPath:
                        "#/items/oneOf/9/properties/viewOnRetrieve/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err423];
                    } else {
                      vErrors.push(err423);
                    }
                    errors++;
                  }
                  const len33 = data227.length;
                  for (let i33 = 0; i33 < len33; i33++) {
                    let data228 = data227[i33];
                    if (typeof data228 !== "string") {
                      const err424 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i33,
                        schemaPath:
                          "#/items/oneOf/9/properties/viewOnRetrieve/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err424];
                      } else {
                        vErrors.push(err424);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data228 === "manager" ||
                        data228 === "member" ||
                        data228 === "creator" ||
                        data228 === "view_only" ||
                        data228 === "admin" ||
                        data228 === "guest" ||
                        data228 === "publicUser"
                      )
                    ) {
                      const err425 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i33,
                        schemaPath:
                          "#/items/oneOf/9/properties/viewOnRetrieve/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[9].properties.viewOnRetrieve
                              .items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err425];
                      } else {
                        vErrors.push(err425);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err426 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                    schemaPath:
                      "#/items/oneOf/9/properties/viewOnRetrieve/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err426];
                  } else {
                    vErrors.push(err426);
                  }
                  errors++;
                }
              }
              if (data0.canUpdate !== undefined) {
                let data229 = data0.canUpdate;
                if (Array.isArray(data229)) {
                  const len34 = data229.length;
                  for (let i34 = 0; i34 < len34; i34++) {
                    if (typeof data229[i34] !== "string") {
                      const err427 = {
                        instancePath:
                          instancePath + "/" + i0 + "/canUpdate/" + i34,
                        schemaPath:
                          "#/items/oneOf/9/properties/canUpdate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err427];
                      } else {
                        vErrors.push(err427);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err428 = {
                    instancePath: instancePath + "/" + i0 + "/canUpdate",
                    schemaPath: "#/items/oneOf/9/properties/canUpdate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err428];
                  } else {
                    vErrors.push(err428);
                  }
                  errors++;
                }
              }
            } else {
              const err429 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/9/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err429];
              } else {
                vErrors.push(err429);
              }
              errors++;
            }
          } else if (tag0 === "PropertyMarketValue") {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.inputType === undefined) {
                const err430 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/10/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err430];
                } else {
                  vErrors.push(err430);
                }
                errors++;
              }
              if (data0.name === undefined) {
                const err431 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/10/required",
                  keyword: "required",
                  params: { missingProperty: "name" },
                  message: "must have required property '" + "name" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err431];
                } else {
                  vErrors.push(err431);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err432 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/10/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err432];
                } else {
                  vErrors.push(err432);
                }
                errors++;
              }
              if (data0.required === undefined) {
                const err433 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/10/required",
                  keyword: "required",
                  params: { missingProperty: "required" },
                  message: "must have required property '" + "required" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err433];
                } else {
                  vErrors.push(err433);
                }
                errors++;
              }
              for (const key15 in data0) {
                if (!func2.call(schema28.items.oneOf[10].properties, key15)) {
                  const err434 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/10/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key15 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err434];
                  } else {
                    vErrors.push(err434);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data231 = data0.inputType;
                if (typeof data231 !== "string") {
                  const err435 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/10/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err435];
                  } else {
                    vErrors.push(err435);
                  }
                  errors++;
                }
                if (!(data231 === "PropertyMarketValue")) {
                  const err436 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/10/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[10].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err436];
                  } else {
                    vErrors.push(err436);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err437 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/10/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err437];
                  } else {
                    vErrors.push(err437);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err438 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/10/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err438];
                  } else {
                    vErrors.push(err438);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                let data234 = data0.title;
                if (typeof data234 === "string") {
                  if (func3(data234) < 1) {
                    const err439 = {
                      instancePath: instancePath + "/" + i0 + "/title",
                      schemaPath: "#/items/oneOf/10/properties/title/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err439];
                    } else {
                      vErrors.push(err439);
                    }
                    errors++;
                  }
                } else {
                  const err440 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/10/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err440];
                  } else {
                    vErrors.push(err440);
                  }
                  errors++;
                }
              }
              if (data0.columnHeaderOverride !== undefined) {
                if (typeof data0.columnHeaderOverride !== "string") {
                  const err441 = {
                    instancePath:
                      instancePath + "/" + i0 + "/columnHeaderOverride",
                    schemaPath:
                      "#/items/oneOf/10/properties/columnHeaderOverride/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err441];
                  } else {
                    vErrors.push(err441);
                  }
                  errors++;
                }
              }
              if (data0.tooltipText !== undefined) {
                if (typeof data0.tooltipText !== "string") {
                  const err442 = {
                    instancePath: instancePath + "/" + i0 + "/tooltipText",
                    schemaPath: "#/items/oneOf/10/properties/tooltipText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err442];
                  } else {
                    vErrors.push(err442);
                  }
                  errors++;
                }
              }
              if (data0.description !== undefined) {
                if (typeof data0.description !== "string") {
                  const err443 = {
                    instancePath: instancePath + "/" + i0 + "/description",
                    schemaPath: "#/items/oneOf/10/properties/description/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err443];
                  } else {
                    vErrors.push(err443);
                  }
                  errors++;
                }
              }
              if (data0.viewOnCreate !== undefined) {
                let data238 = data0.viewOnCreate;
                if (Array.isArray(data238)) {
                  const len35 = data238.length;
                  for (let i35 = 0; i35 < len35; i35++) {
                    if (typeof data238[i35] !== "string") {
                      const err444 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnCreate/" + i35,
                        schemaPath:
                          "#/items/oneOf/10/properties/viewOnCreate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err444];
                      } else {
                        vErrors.push(err444);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err445 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnCreate",
                    schemaPath: "#/items/oneOf/10/properties/viewOnCreate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err445];
                  } else {
                    vErrors.push(err445);
                  }
                  errors++;
                }
              }
              if (data0.viewOnRetrieve !== undefined) {
                let data240 = data0.viewOnRetrieve;
                if (Array.isArray(data240)) {
                  if (data240.length < 1) {
                    const err446 = {
                      instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                      schemaPath:
                        "#/items/oneOf/10/properties/viewOnRetrieve/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err446];
                    } else {
                      vErrors.push(err446);
                    }
                    errors++;
                  }
                  const len36 = data240.length;
                  for (let i36 = 0; i36 < len36; i36++) {
                    let data241 = data240[i36];
                    if (typeof data241 !== "string") {
                      const err447 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i36,
                        schemaPath:
                          "#/items/oneOf/10/properties/viewOnRetrieve/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err447];
                      } else {
                        vErrors.push(err447);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data241 === "manager" ||
                        data241 === "member" ||
                        data241 === "creator" ||
                        data241 === "view_only" ||
                        data241 === "admin" ||
                        data241 === "guest" ||
                        data241 === "publicUser"
                      )
                    ) {
                      const err448 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i36,
                        schemaPath:
                          "#/items/oneOf/10/properties/viewOnRetrieve/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[10].properties.viewOnRetrieve
                              .items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err448];
                      } else {
                        vErrors.push(err448);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err449 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                    schemaPath:
                      "#/items/oneOf/10/properties/viewOnRetrieve/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err449];
                  } else {
                    vErrors.push(err449);
                  }
                  errors++;
                }
              }
              if (data0.canUpdate !== undefined) {
                let data242 = data0.canUpdate;
                if (Array.isArray(data242)) {
                  const len37 = data242.length;
                  for (let i37 = 0; i37 < len37; i37++) {
                    if (typeof data242[i37] !== "string") {
                      const err450 = {
                        instancePath:
                          instancePath + "/" + i0 + "/canUpdate/" + i37,
                        schemaPath:
                          "#/items/oneOf/10/properties/canUpdate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err450];
                      } else {
                        vErrors.push(err450);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err451 = {
                    instancePath: instancePath + "/" + i0 + "/canUpdate",
                    schemaPath: "#/items/oneOf/10/properties/canUpdate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err451];
                  } else {
                    vErrors.push(err451);
                  }
                  errors++;
                }
              }
              if (data0.formula !== undefined) {
                let data244 = data0.formula;
                if (
                  data244 &&
                  typeof data244 == "object" &&
                  !Array.isArray(data244)
                ) {
                  if (data244.name === undefined) {
                    const err452 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath:
                        "#/items/oneOf/10/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err452];
                    } else {
                      vErrors.push(err452);
                    }
                    errors++;
                  }
                  if (data244.applies === undefined) {
                    const err453 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath:
                        "#/items/oneOf/10/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "applies" },
                      message:
                        "must have required property '" + "applies" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err453];
                    } else {
                      vErrors.push(err453);
                    }
                    errors++;
                  }
                  if (data244.logic === undefined) {
                    const err454 = {
                      instancePath: instancePath + "/" + i0 + "/formula",
                      schemaPath:
                        "#/items/oneOf/10/properties/formula/required",
                      keyword: "required",
                      params: { missingProperty: "logic" },
                      message: "must have required property '" + "logic" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err454];
                    } else {
                      vErrors.push(err454);
                    }
                    errors++;
                  }
                  for (const key16 in data244) {
                    if (
                      !(
                        key16 === "name" ||
                        key16 === "applies" ||
                        key16 === "logic"
                      )
                    ) {
                      const err455 = {
                        instancePath: instancePath + "/" + i0 + "/formula",
                        schemaPath:
                          "#/items/oneOf/10/properties/formula/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key16 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err455];
                      } else {
                        vErrors.push(err455);
                      }
                      errors++;
                    }
                  }
                  if (data244.name !== undefined) {
                    if (typeof data244.name !== "string") {
                      const err456 = {
                        instancePath: instancePath + "/" + i0 + "/formula/name",
                        schemaPath:
                          "#/items/oneOf/10/properties/formula/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err456];
                      } else {
                        vErrors.push(err456);
                      }
                      errors++;
                    }
                  }
                  if (data244.applies !== undefined) {
                    let data246 = data244.applies;
                    if (
                      !(
                        data246 &&
                        typeof data246 == "object" &&
                        !Array.isArray(data246)
                      ) &&
                      typeof data246 !== "boolean"
                    ) {
                      const err457 = {
                        instancePath:
                          instancePath + "/" + i0 + "/formula/applies",
                        schemaPath:
                          "#/items/oneOf/10/properties/formula/properties/applies/type",
                        keyword: "type",
                        params: {
                          type: schema28.items.oneOf[10].properties.formula
                            .properties.applies.type,
                        },
                        message: "must be object,boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err457];
                      } else {
                        vErrors.push(err457);
                      }
                      errors++;
                    }
                  }
                  if (data244.logic !== undefined) {
                    let data247 = data244.logic;
                    if (
                      data247 &&
                      typeof data247 == "object" &&
                      !Array.isArray(data247)
                    ) {
                    } else {
                      const err458 = {
                        instancePath:
                          instancePath + "/" + i0 + "/formula/logic",
                        schemaPath:
                          "#/items/oneOf/10/properties/formula/properties/logic/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err458];
                      } else {
                        vErrors.push(err458);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err459 = {
                    instancePath: instancePath + "/" + i0 + "/formula",
                    schemaPath: "#/items/oneOf/10/properties/formula/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err459];
                  } else {
                    vErrors.push(err459);
                  }
                  errors++;
                }
              }
              if (data0.enum !== undefined) {
                let data248 = data0.enum;
                if (Array.isArray(data248)) {
                  const len38 = data248.length;
                  for (let i38 = 0; i38 < len38; i38++) {
                    let data249 = data248[i38];
                    if (
                      !(
                        data249 === "squareFootageEstimate" ||
                        data249 === "automatedAssessedValue" ||
                        data249 === "otherValueEstimate"
                      )
                    ) {
                      const err460 = {
                        instancePath: instancePath + "/" + i0 + "/enum/" + i38,
                        schemaPath:
                          "#/items/oneOf/10/properties/enum/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[10].properties.enum.items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err460];
                      } else {
                        vErrors.push(err460);
                      }
                      errors++;
                    }
                    if (typeof data249 === "string") {
                      if (func3(data249) < 1) {
                        const err461 = {
                          instancePath:
                            instancePath + "/" + i0 + "/enum/" + i38,
                          schemaPath:
                            "#/items/oneOf/10/properties/enum/items/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err461];
                        } else {
                          vErrors.push(err461);
                        }
                        errors++;
                      }
                    } else {
                      const err462 = {
                        instancePath: instancePath + "/" + i0 + "/enum/" + i38,
                        schemaPath:
                          "#/items/oneOf/10/properties/enum/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err462];
                      } else {
                        vErrors.push(err462);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err463 = {
                    instancePath: instancePath + "/" + i0 + "/enum",
                    schemaPath: "#/items/oneOf/10/properties/enum/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err463];
                  } else {
                    vErrors.push(err463);
                  }
                  errors++;
                }
              }
              if (data0.overrides !== undefined) {
                let data250 = data0.overrides;
                if (
                  data250 &&
                  typeof data250 == "object" &&
                  !Array.isArray(data250)
                ) {
                  if (data250.overrides !== undefined) {
                    let data251 = data250.overrides;
                    if (
                      data251 &&
                      typeof data251 == "object" &&
                      !Array.isArray(data251)
                    ) {
                      if (data251.squareFootageEstimate !== undefined) {
                        let data252 = data251.squareFootageEstimate;
                        if (
                          data252 &&
                          typeof data252 == "object" &&
                          !Array.isArray(data252)
                        ) {
                          if (data252.description !== undefined) {
                            if (typeof data252.description !== "string") {
                              const err464 = {
                                instancePath:
                                  instancePath +
                                  "/" +
                                  i0 +
                                  "/overrides/overrides/squareFootageEstimate/description",
                                schemaPath:
                                  "#/items/oneOf/10/properties/overrides/properties/overrides/properties/squareFootageEstimate/properties/description/type",
                                keyword: "type",
                                params: { type: "string" },
                                message: "must be string",
                              };
                              if (vErrors === null) {
                                vErrors = [err464];
                              } else {
                                vErrors.push(err464);
                              }
                              errors++;
                            }
                          }
                          if (data252.adjustmentRatio !== undefined) {
                            let data254 = data252.adjustmentRatio;
                            if (
                              data254 &&
                              typeof data254 == "object" &&
                              !Array.isArray(data254)
                            ) {
                              if (data254.title !== undefined) {
                                if (typeof data254.title !== "string") {
                                  const err465 = {
                                    instancePath:
                                      instancePath +
                                      "/" +
                                      i0 +
                                      "/overrides/overrides/squareFootageEstimate/adjustmentRatio/title",
                                    schemaPath:
                                      "#/items/oneOf/10/properties/overrides/properties/overrides/properties/squareFootageEstimate/properties/adjustmentRatio/properties/title/type",
                                    keyword: "type",
                                    params: { type: "string" },
                                    message: "must be string",
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err465];
                                  } else {
                                    vErrors.push(err465);
                                  }
                                  errors++;
                                }
                              }
                            } else {
                              const err466 = {
                                instancePath:
                                  instancePath +
                                  "/" +
                                  i0 +
                                  "/overrides/overrides/squareFootageEstimate/adjustmentRatio",
                                schemaPath:
                                  "#/items/oneOf/10/properties/overrides/properties/overrides/properties/squareFootageEstimate/properties/adjustmentRatio/type",
                                keyword: "type",
                                params: { type: "object" },
                                message: "must be object",
                              };
                              if (vErrors === null) {
                                vErrors = [err466];
                              } else {
                                vErrors.push(err466);
                              }
                              errors++;
                            }
                          }
                        } else {
                          const err467 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/overrides/overrides/squareFootageEstimate",
                            schemaPath:
                              "#/items/oneOf/10/properties/overrides/properties/overrides/properties/squareFootageEstimate/type",
                            keyword: "type",
                            params: { type: "object" },
                            message: "must be object",
                          };
                          if (vErrors === null) {
                            vErrors = [err467];
                          } else {
                            vErrors.push(err467);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err468 = {
                        instancePath:
                          instancePath + "/" + i0 + "/overrides/overrides",
                        schemaPath:
                          "#/items/oneOf/10/properties/overrides/properties/overrides/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err468];
                      } else {
                        vErrors.push(err468);
                      }
                      errors++;
                    }
                  }
                  if (data250.viewOnCreate !== undefined) {
                    let data256 = data250.viewOnCreate;
                    if (Array.isArray(data256)) {
                      const len39 = data256.length;
                      for (let i39 = 0; i39 < len39; i39++) {
                        if (typeof data256[i39] !== "string") {
                          const err469 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/overrides/viewOnCreate/" +
                              i39,
                            schemaPath:
                              "#/items/oneOf/10/properties/overrides/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err469];
                          } else {
                            vErrors.push(err469);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err470 = {
                        instancePath:
                          instancePath + "/" + i0 + "/overrides/viewOnCreate",
                        schemaPath:
                          "#/items/oneOf/10/properties/overrides/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err470];
                      } else {
                        vErrors.push(err470);
                      }
                      errors++;
                    }
                  }
                  if (data250.viewOnRetrieve !== undefined) {
                    let data258 = data250.viewOnRetrieve;
                    if (Array.isArray(data258)) {
                      if (data258.length < 1) {
                        const err471 = {
                          instancePath:
                            instancePath +
                            "/" +
                            i0 +
                            "/overrides/viewOnRetrieve",
                          schemaPath:
                            "#/items/oneOf/10/properties/overrides/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err471];
                        } else {
                          vErrors.push(err471);
                        }
                        errors++;
                      }
                      const len40 = data258.length;
                      for (let i40 = 0; i40 < len40; i40++) {
                        let data259 = data258[i40];
                        if (typeof data259 !== "string") {
                          const err472 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/overrides/viewOnRetrieve/" +
                              i40,
                            schemaPath:
                              "#/items/oneOf/10/properties/overrides/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err472];
                          } else {
                            vErrors.push(err472);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data259 === "manager" ||
                            data259 === "member" ||
                            data259 === "creator" ||
                            data259 === "view_only" ||
                            data259 === "admin" ||
                            data259 === "guest" ||
                            data259 === "publicUser"
                          )
                        ) {
                          const err473 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/overrides/viewOnRetrieve/" +
                              i40,
                            schemaPath:
                              "#/items/oneOf/10/properties/overrides/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema28.items.oneOf[10].properties.overrides
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err473];
                          } else {
                            vErrors.push(err473);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err474 = {
                        instancePath:
                          instancePath + "/" + i0 + "/overrides/viewOnRetrieve",
                        schemaPath:
                          "#/items/oneOf/10/properties/overrides/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err474];
                      } else {
                        vErrors.push(err474);
                      }
                      errors++;
                    }
                  }
                  if (data250.canUpdate !== undefined) {
                    let data260 = data250.canUpdate;
                    if (Array.isArray(data260)) {
                      const len41 = data260.length;
                      for (let i41 = 0; i41 < len41; i41++) {
                        if (typeof data260[i41] !== "string") {
                          const err475 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/overrides/canUpdate/" +
                              i41,
                            schemaPath:
                              "#/items/oneOf/10/properties/overrides/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err475];
                          } else {
                            vErrors.push(err475);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err476 = {
                        instancePath:
                          instancePath + "/" + i0 + "/overrides/canUpdate",
                        schemaPath:
                          "#/items/oneOf/10/properties/overrides/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err476];
                      } else {
                        vErrors.push(err476);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err477 = {
                    instancePath: instancePath + "/" + i0 + "/overrides",
                    schemaPath: "#/items/oneOf/10/properties/overrides/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err477];
                  } else {
                    vErrors.push(err477);
                  }
                  errors++;
                }
              }
            } else {
              const err478 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/10/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err478];
              } else {
                vErrors.push(err478);
              }
              errors++;
            }
          } else if (tag0 === "group") {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.inputType === undefined) {
                const err479 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/11/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err479];
                } else {
                  vErrors.push(err479);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err480 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/11/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err480];
                } else {
                  vErrors.push(err480);
                }
                errors++;
              }
              if (data0.properties === undefined) {
                const err481 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/11/required",
                  keyword: "required",
                  params: { missingProperty: "properties" },
                  message: "must have required property '" + "properties" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err481];
                } else {
                  vErrors.push(err481);
                }
                errors++;
              }
              for (const key17 in data0) {
                if (
                  !(
                    key17 === "inputType" ||
                    key17 === "name" ||
                    key17 === "title" ||
                    key17 === "description" ||
                    key17 === "properties" ||
                    key17 === "required" ||
                    key17 === "columns" ||
                    key17 === "heading"
                  )
                ) {
                  const err482 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/11/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key17 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err482];
                  } else {
                    vErrors.push(err482);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data262 = data0.inputType;
                if (typeof data262 !== "string") {
                  const err483 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/11/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err483];
                  } else {
                    vErrors.push(err483);
                  }
                  errors++;
                }
                if (!(data262 === "group")) {
                  const err484 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/11/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[11].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err484];
                  } else {
                    vErrors.push(err484);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err485 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/11/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err485];
                  } else {
                    vErrors.push(err485);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                let data264 = data0.title;
                if (typeof data264 === "string") {
                  if (func3(data264) < 1) {
                    const err486 = {
                      instancePath: instancePath + "/" + i0 + "/title",
                      schemaPath: "#/items/oneOf/11/properties/title/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err486];
                    } else {
                      vErrors.push(err486);
                    }
                    errors++;
                  }
                } else {
                  const err487 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/11/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err487];
                  } else {
                    vErrors.push(err487);
                  }
                  errors++;
                }
              }
              if (data0.description !== undefined) {
                if (typeof data0.description !== "string") {
                  const err488 = {
                    instancePath: instancePath + "/" + i0 + "/description",
                    schemaPath: "#/items/oneOf/11/properties/description/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err488];
                  } else {
                    vErrors.push(err488);
                  }
                  errors++;
                }
              }
              if (data0.properties !== undefined) {
                let data266 = data0.properties;
                if (
                  !wrapper0.validate(data266, {
                    instancePath: instancePath + "/" + i0 + "/properties",
                    parentData: data0,
                    parentDataProperty: "properties",
                    rootData,
                  })
                ) {
                  vErrors =
                    vErrors === null ?
                      wrapper0.validate.errors
                    : vErrors.concat(wrapper0.validate.errors);
                  errors = vErrors.length;
                }
                if (Array.isArray(data266)) {
                  if (data266.length < 1) {
                    const err489 = {
                      instancePath: instancePath + "/" + i0 + "/properties",
                      schemaPath:
                        "#/items/oneOf/11/properties/properties/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err489];
                    } else {
                      vErrors.push(err489);
                    }
                    errors++;
                  }
                  const len42 = data266.length;
                  for (let i42 = 0; i42 < len42; i42++) {
                    let data267 = data266[i42];
                    if (
                      !(
                        data267 &&
                        typeof data267 == "object" &&
                        !Array.isArray(data267)
                      )
                    ) {
                      const err490 = {
                        instancePath:
                          instancePath + "/" + i0 + "/properties/" + i42,
                        schemaPath:
                          "#/items/oneOf/11/properties/properties/items/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err490];
                      } else {
                        vErrors.push(err490);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err491 = {
                    instancePath: instancePath + "/" + i0 + "/properties",
                    schemaPath: "#/items/oneOf/11/properties/properties/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err491];
                  } else {
                    vErrors.push(err491);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err492 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/11/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err492];
                  } else {
                    vErrors.push(err492);
                  }
                  errors++;
                }
              }
              if (data0.columns !== undefined) {
                let data269 = data0.columns;
                if (
                  !(
                    typeof data269 == "number" &&
                    !(data269 % 1) &&
                    !isNaN(data269) &&
                    isFinite(data269)
                  )
                ) {
                  const err493 = {
                    instancePath: instancePath + "/" + i0 + "/columns",
                    schemaPath: "#/items/oneOf/11/properties/columns/type",
                    keyword: "type",
                    params: { type: "integer" },
                    message: "must be integer",
                  };
                  if (vErrors === null) {
                    vErrors = [err493];
                  } else {
                    vErrors.push(err493);
                  }
                  errors++;
                }
              }
              if (data0.heading !== undefined) {
                let data270 = data0.heading;
                if (typeof data270 !== "string") {
                  const err494 = {
                    instancePath: instancePath + "/" + i0 + "/heading",
                    schemaPath: "#/items/oneOf/11/properties/heading/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err494];
                  } else {
                    vErrors.push(err494);
                  }
                  errors++;
                }
                if (!(data270 === "h1" || data270 === "h2")) {
                  const err495 = {
                    instancePath: instancePath + "/" + i0 + "/heading",
                    schemaPath: "#/items/oneOf/11/properties/heading/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[11].properties.heading.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err495];
                  } else {
                    vErrors.push(err495);
                  }
                  errors++;
                }
              }
            } else {
              const err496 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/11/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err496];
              } else {
                vErrors.push(err496);
              }
              errors++;
            }
          } else if (tag0 === "User") {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.inputType === undefined) {
                const err497 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/12/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err497];
                } else {
                  vErrors.push(err497);
                }
                errors++;
              }
              if (data0.name === undefined) {
                const err498 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/12/required",
                  keyword: "required",
                  params: { missingProperty: "name" },
                  message: "must have required property '" + "name" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err498];
                } else {
                  vErrors.push(err498);
                }
                errors++;
              }
              if (data0.required === undefined) {
                const err499 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/12/required",
                  keyword: "required",
                  params: { missingProperty: "required" },
                  message: "must have required property '" + "required" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err499];
                } else {
                  vErrors.push(err499);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err500 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/12/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err500];
                } else {
                  vErrors.push(err500);
                }
                errors++;
              }
              for (const key18 in data0) {
                if (!func2.call(schema28.items.oneOf[12].properties, key18)) {
                  const err501 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/12/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key18 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err501];
                  } else {
                    vErrors.push(err501);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data271 = data0.inputType;
                if (typeof data271 !== "string") {
                  const err502 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/12/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err502];
                  } else {
                    vErrors.push(err502);
                  }
                  errors++;
                }
                if (!(data271 === "User")) {
                  const err503 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/12/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[12].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err503];
                  } else {
                    vErrors.push(err503);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err504 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/12/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err504];
                  } else {
                    vErrors.push(err504);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                let data273 = data0.title;
                if (typeof data273 === "string") {
                  if (func3(data273) < 1) {
                    const err505 = {
                      instancePath: instancePath + "/" + i0 + "/title",
                      schemaPath: "#/items/oneOf/12/properties/title/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err505];
                    } else {
                      vErrors.push(err505);
                    }
                    errors++;
                  }
                } else {
                  const err506 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/12/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err506];
                  } else {
                    vErrors.push(err506);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err507 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/12/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err507];
                  } else {
                    vErrors.push(err507);
                  }
                  errors++;
                }
              }
              if (data0.placeholder !== undefined) {
                if (typeof data0.placeholder !== "string") {
                  const err508 = {
                    instancePath: instancePath + "/" + i0 + "/placeholder",
                    schemaPath: "#/items/oneOf/12/properties/placeholder/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err508];
                  } else {
                    vErrors.push(err508);
                  }
                  errors++;
                }
              }
              if (data0.type !== undefined) {
                if (typeof data0.type !== "string") {
                  const err509 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/12/properties/type/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err509];
                  } else {
                    vErrors.push(err509);
                  }
                  errors++;
                }
              }
              if (data0.tooltipText !== undefined) {
                if (typeof data0.tooltipText !== "string") {
                  const err510 = {
                    instancePath: instancePath + "/" + i0 + "/tooltipText",
                    schemaPath: "#/items/oneOf/12/properties/tooltipText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err510];
                  } else {
                    vErrors.push(err510);
                  }
                  errors++;
                }
              }
              if (data0.description !== undefined) {
                if (typeof data0.description !== "string") {
                  const err511 = {
                    instancePath: instancePath + "/" + i0 + "/description",
                    schemaPath: "#/items/oneOf/12/properties/description/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err511];
                  } else {
                    vErrors.push(err511);
                  }
                  errors++;
                }
              }
              if (data0.disabled !== undefined) {
                if (typeof data0.disabled !== "boolean") {
                  const err512 = {
                    instancePath: instancePath + "/" + i0 + "/disabled",
                    schemaPath: "#/items/oneOf/12/properties/disabled/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err512];
                  } else {
                    vErrors.push(err512);
                  }
                  errors++;
                }
              }
              if (data0.helperText !== undefined) {
                if (typeof data0.helperText !== "string") {
                  const err513 = {
                    instancePath: instancePath + "/" + i0 + "/helperText",
                    schemaPath: "#/items/oneOf/12/properties/helperText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err513];
                  } else {
                    vErrors.push(err513);
                  }
                  errors++;
                }
              }
              if (data0.viewOnCreate !== undefined) {
                let data281 = data0.viewOnCreate;
                if (Array.isArray(data281)) {
                  const len43 = data281.length;
                  for (let i43 = 0; i43 < len43; i43++) {
                    if (typeof data281[i43] !== "string") {
                      const err514 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnCreate/" + i43,
                        schemaPath:
                          "#/items/oneOf/12/properties/viewOnCreate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err514];
                      } else {
                        vErrors.push(err514);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err515 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnCreate",
                    schemaPath: "#/items/oneOf/12/properties/viewOnCreate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err515];
                  } else {
                    vErrors.push(err515);
                  }
                  errors++;
                }
              }
              if (data0.viewOnRetrieve !== undefined) {
                let data283 = data0.viewOnRetrieve;
                if (Array.isArray(data283)) {
                  if (data283.length < 1) {
                    const err516 = {
                      instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                      schemaPath:
                        "#/items/oneOf/12/properties/viewOnRetrieve/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err516];
                    } else {
                      vErrors.push(err516);
                    }
                    errors++;
                  }
                  const len44 = data283.length;
                  for (let i44 = 0; i44 < len44; i44++) {
                    let data284 = data283[i44];
                    if (typeof data284 !== "string") {
                      const err517 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i44,
                        schemaPath:
                          "#/items/oneOf/12/properties/viewOnRetrieve/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err517];
                      } else {
                        vErrors.push(err517);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data284 === "manager" ||
                        data284 === "member" ||
                        data284 === "creator" ||
                        data284 === "view_only" ||
                        data284 === "admin" ||
                        data284 === "guest" ||
                        data284 === "publicUser"
                      )
                    ) {
                      const err518 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i44,
                        schemaPath:
                          "#/items/oneOf/12/properties/viewOnRetrieve/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[12].properties.viewOnRetrieve
                              .items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err518];
                      } else {
                        vErrors.push(err518);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err519 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                    schemaPath:
                      "#/items/oneOf/12/properties/viewOnRetrieve/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err519];
                  } else {
                    vErrors.push(err519);
                  }
                  errors++;
                }
              }
              if (data0.canUpdate !== undefined) {
                let data285 = data0.canUpdate;
                if (Array.isArray(data285)) {
                  const len45 = data285.length;
                  for (let i45 = 0; i45 < len45; i45++) {
                    if (typeof data285[i45] !== "string") {
                      const err520 = {
                        instancePath:
                          instancePath + "/" + i0 + "/canUpdate/" + i45,
                        schemaPath:
                          "#/items/oneOf/12/properties/canUpdate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err520];
                      } else {
                        vErrors.push(err520);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err521 = {
                    instancePath: instancePath + "/" + i0 + "/canUpdate",
                    schemaPath: "#/items/oneOf/12/properties/canUpdate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err521];
                  } else {
                    vErrors.push(err521);
                  }
                  errors++;
                }
              }
              if (data0.userGroupSelection !== undefined) {
                if (!Array.isArray(data0.userGroupSelection)) {
                  const err522 = {
                    instancePath:
                      instancePath + "/" + i0 + "/userGroupSelection",
                    schemaPath:
                      "#/items/oneOf/12/properties/userGroupSelection/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err522];
                  } else {
                    vErrors.push(err522);
                  }
                  errors++;
                }
              }
              if (data0.columnHeaderOverride !== undefined) {
                if (typeof data0.columnHeaderOverride !== "string") {
                  const err523 = {
                    instancePath:
                      instancePath + "/" + i0 + "/columnHeaderOverride",
                    schemaPath:
                      "#/items/oneOf/12/properties/columnHeaderOverride/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err523];
                  } else {
                    vErrors.push(err523);
                  }
                  errors++;
                }
              }
            } else {
              const err524 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/12/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err524];
              } else {
                vErrors.push(err524);
              }
              errors++;
            }
          } else if (tag0 === "multiSelect") {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.inputType === undefined) {
                const err525 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/13/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err525];
                } else {
                  vErrors.push(err525);
                }
                errors++;
              }
              if (data0.name === undefined) {
                const err526 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/13/required",
                  keyword: "required",
                  params: { missingProperty: "name" },
                  message: "must have required property '" + "name" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err526];
                } else {
                  vErrors.push(err526);
                }
                errors++;
              }
              if (data0.type === undefined) {
                const err527 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/13/required",
                  keyword: "required",
                  params: { missingProperty: "type" },
                  message: "must have required property '" + "type" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err527];
                } else {
                  vErrors.push(err527);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err528 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/13/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err528];
                } else {
                  vErrors.push(err528);
                }
                errors++;
              }
              if (data0.required === undefined) {
                const err529 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/13/required",
                  keyword: "required",
                  params: { missingProperty: "required" },
                  message: "must have required property '" + "required" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err529];
                } else {
                  vErrors.push(err529);
                }
                errors++;
              }
              if (data0.enum === undefined) {
                const err530 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/13/required",
                  keyword: "required",
                  params: { missingProperty: "enum" },
                  message: "must have required property '" + "enum" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err530];
                } else {
                  vErrors.push(err530);
                }
                errors++;
              }
              for (const key19 in data0) {
                if (!func2.call(schema28.items.oneOf[13].properties, key19)) {
                  const err531 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/13/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key19 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err531];
                  } else {
                    vErrors.push(err531);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data289 = data0.inputType;
                if (typeof data289 !== "string") {
                  const err532 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/13/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err532];
                  } else {
                    vErrors.push(err532);
                  }
                  errors++;
                }
                if (!(data289 === "multiSelect")) {
                  const err533 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/13/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[13].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err533];
                  } else {
                    vErrors.push(err533);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err534 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/13/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err534];
                  } else {
                    vErrors.push(err534);
                  }
                  errors++;
                }
              }
              if (data0.type !== undefined) {
                let data291 = data0.type;
                if (typeof data291 !== "string") {
                  const err535 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/13/properties/type/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err535];
                  } else {
                    vErrors.push(err535);
                  }
                  errors++;
                }
                if (!(data291 === "string" || data291 === "number")) {
                  const err536 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/13/properties/type/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[13].properties.type.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err536];
                  } else {
                    vErrors.push(err536);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                let data292 = data0.title;
                if (typeof data292 === "string") {
                  if (func3(data292) < 1) {
                    const err537 = {
                      instancePath: instancePath + "/" + i0 + "/title",
                      schemaPath: "#/items/oneOf/13/properties/title/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err537];
                    } else {
                      vErrors.push(err537);
                    }
                    errors++;
                  }
                } else {
                  const err538 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/13/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err538];
                  } else {
                    vErrors.push(err538);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err539 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/13/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err539];
                  } else {
                    vErrors.push(err539);
                  }
                  errors++;
                }
              }
              if (data0.placeholder !== undefined) {
                if (typeof data0.placeholder !== "string") {
                  const err540 = {
                    instancePath: instancePath + "/" + i0 + "/placeholder",
                    schemaPath: "#/items/oneOf/13/properties/placeholder/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err540];
                  } else {
                    vErrors.push(err540);
                  }
                  errors++;
                }
              }
              if (data0.description !== undefined) {
                if (typeof data0.description !== "string") {
                  const err541 = {
                    instancePath: instancePath + "/" + i0 + "/description",
                    schemaPath: "#/items/oneOf/13/properties/description/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err541];
                  } else {
                    vErrors.push(err541);
                  }
                  errors++;
                }
              }
              if (data0.tooltipText !== undefined) {
                if (typeof data0.tooltipText !== "string") {
                  const err542 = {
                    instancePath: instancePath + "/" + i0 + "/tooltipText",
                    schemaPath: "#/items/oneOf/13/properties/tooltipText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err542];
                  } else {
                    vErrors.push(err542);
                  }
                  errors++;
                }
              }
              if (data0.columnHeaderOverride !== undefined) {
                if (typeof data0.columnHeaderOverride !== "string") {
                  const err543 = {
                    instancePath:
                      instancePath + "/" + i0 + "/columnHeaderOverride",
                    schemaPath:
                      "#/items/oneOf/13/properties/columnHeaderOverride/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err543];
                  } else {
                    vErrors.push(err543);
                  }
                  errors++;
                }
              }
              if (data0.helperText !== undefined) {
                if (typeof data0.helperText !== "string") {
                  const err544 = {
                    instancePath: instancePath + "/" + i0 + "/helperText",
                    schemaPath: "#/items/oneOf/13/properties/helperText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err544];
                  } else {
                    vErrors.push(err544);
                  }
                  errors++;
                }
              }
              if (data0.viewOnCreate !== undefined) {
                let data299 = data0.viewOnCreate;
                if (Array.isArray(data299)) {
                  const len46 = data299.length;
                  for (let i46 = 0; i46 < len46; i46++) {
                    if (typeof data299[i46] !== "string") {
                      const err545 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnCreate/" + i46,
                        schemaPath:
                          "#/items/oneOf/13/properties/viewOnCreate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err545];
                      } else {
                        vErrors.push(err545);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err546 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnCreate",
                    schemaPath: "#/items/oneOf/13/properties/viewOnCreate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err546];
                  } else {
                    vErrors.push(err546);
                  }
                  errors++;
                }
              }
              if (data0.viewOnRetrieve !== undefined) {
                let data301 = data0.viewOnRetrieve;
                if (Array.isArray(data301)) {
                  if (data301.length < 1) {
                    const err547 = {
                      instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                      schemaPath:
                        "#/items/oneOf/13/properties/viewOnRetrieve/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err547];
                    } else {
                      vErrors.push(err547);
                    }
                    errors++;
                  }
                  const len47 = data301.length;
                  for (let i47 = 0; i47 < len47; i47++) {
                    let data302 = data301[i47];
                    if (typeof data302 !== "string") {
                      const err548 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i47,
                        schemaPath:
                          "#/items/oneOf/13/properties/viewOnRetrieve/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err548];
                      } else {
                        vErrors.push(err548);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data302 === "manager" ||
                        data302 === "member" ||
                        data302 === "creator" ||
                        data302 === "view_only" ||
                        data302 === "admin" ||
                        data302 === "guest" ||
                        data302 === "publicUser"
                      )
                    ) {
                      const err549 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i47,
                        schemaPath:
                          "#/items/oneOf/13/properties/viewOnRetrieve/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[13].properties.viewOnRetrieve
                              .items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err549];
                      } else {
                        vErrors.push(err549);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err550 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                    schemaPath:
                      "#/items/oneOf/13/properties/viewOnRetrieve/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err550];
                  } else {
                    vErrors.push(err550);
                  }
                  errors++;
                }
              }
              if (data0.canUpdate !== undefined) {
                let data303 = data0.canUpdate;
                if (Array.isArray(data303)) {
                  const len48 = data303.length;
                  for (let i48 = 0; i48 < len48; i48++) {
                    if (typeof data303[i48] !== "string") {
                      const err551 = {
                        instancePath:
                          instancePath + "/" + i0 + "/canUpdate/" + i48,
                        schemaPath:
                          "#/items/oneOf/13/properties/canUpdate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err551];
                      } else {
                        vErrors.push(err551);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err552 = {
                    instancePath: instancePath + "/" + i0 + "/canUpdate",
                    schemaPath: "#/items/oneOf/13/properties/canUpdate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err552];
                  } else {
                    vErrors.push(err552);
                  }
                  errors++;
                }
              }
              if (data0.useAsTag !== undefined) {
                if (typeof data0.useAsTag !== "boolean") {
                  const err553 = {
                    instancePath: instancePath + "/" + i0 + "/useAsTag",
                    schemaPath: "#/items/oneOf/13/properties/useAsTag/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err553];
                  } else {
                    vErrors.push(err553);
                  }
                  errors++;
                }
              }
              if (data0.enum !== undefined) {
                let data306 = data0.enum;
                if (Array.isArray(data306)) {
                  if (data306.length < 1) {
                    const err554 = {
                      instancePath: instancePath + "/" + i0 + "/enum",
                      schemaPath: "#/items/oneOf/13/properties/enum/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err554];
                    } else {
                      vErrors.push(err554);
                    }
                    errors++;
                  }
                  const len49 = data306.length;
                  for (let i49 = 0; i49 < len49; i49++) {
                    let data307 = data306[i49];
                    const _errs689 = errors;
                    let valid154 = false;
                    let passing1 = null;
                    const _errs690 = errors;
                    if (typeof data307 === "string") {
                      if (func3(data307) < 1) {
                        const err555 = {
                          instancePath:
                            instancePath + "/" + i0 + "/enum/" + i49,
                          schemaPath:
                            "#/items/oneOf/13/properties/enum/items/oneOf/0/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err555];
                        } else {
                          vErrors.push(err555);
                        }
                        errors++;
                      }
                    } else {
                      const err556 = {
                        instancePath: instancePath + "/" + i0 + "/enum/" + i49,
                        schemaPath:
                          "#/items/oneOf/13/properties/enum/items/oneOf/0/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err556];
                      } else {
                        vErrors.push(err556);
                      }
                      errors++;
                    }
                    var _valid4 = _errs690 === errors;
                    if (_valid4) {
                      valid154 = true;
                      passing1 = 0;
                    }
                    const _errs692 = errors;
                    if (
                      data307 &&
                      typeof data307 == "object" &&
                      !Array.isArray(data307)
                    ) {
                      if (data307.label === undefined) {
                        const err557 = {
                          instancePath:
                            instancePath + "/" + i0 + "/enum/" + i49,
                          schemaPath:
                            "#/items/oneOf/13/properties/enum/items/oneOf/1/required",
                          keyword: "required",
                          params: { missingProperty: "label" },
                          message:
                            "must have required property '" + "label" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err557];
                        } else {
                          vErrors.push(err557);
                        }
                        errors++;
                      }
                      if (data307.value === undefined) {
                        const err558 = {
                          instancePath:
                            instancePath + "/" + i0 + "/enum/" + i49,
                          schemaPath:
                            "#/items/oneOf/13/properties/enum/items/oneOf/1/required",
                          keyword: "required",
                          params: { missingProperty: "value" },
                          message:
                            "must have required property '" + "value" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err558];
                        } else {
                          vErrors.push(err558);
                        }
                        errors++;
                      }
                      if (data307.label !== undefined) {
                        let data308 = data307.label;
                        if (typeof data308 === "string") {
                          if (func3(data308) < 1) {
                            const err559 = {
                              instancePath:
                                instancePath +
                                "/" +
                                i0 +
                                "/enum/" +
                                i49 +
                                "/label",
                              schemaPath:
                                "#/items/oneOf/13/properties/enum/items/oneOf/1/properties/label/minLength",
                              keyword: "minLength",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 characters",
                            };
                            if (vErrors === null) {
                              vErrors = [err559];
                            } else {
                              vErrors.push(err559);
                            }
                            errors++;
                          }
                        } else {
                          const err560 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/enum/" +
                              i49 +
                              "/label",
                            schemaPath:
                              "#/items/oneOf/13/properties/enum/items/oneOf/1/properties/label/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err560];
                          } else {
                            vErrors.push(err560);
                          }
                          errors++;
                        }
                      }
                      if (data307.value !== undefined) {
                        let data309 = data307.value;
                        if (typeof data309 === "string") {
                          if (func3(data309) < 1) {
                            const err561 = {
                              instancePath:
                                instancePath +
                                "/" +
                                i0 +
                                "/enum/" +
                                i49 +
                                "/value",
                              schemaPath:
                                "#/items/oneOf/13/properties/enum/items/oneOf/1/properties/value/minLength",
                              keyword: "minLength",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 characters",
                            };
                            if (vErrors === null) {
                              vErrors = [err561];
                            } else {
                              vErrors.push(err561);
                            }
                            errors++;
                          }
                        } else {
                          const err562 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/enum/" +
                              i49 +
                              "/value",
                            schemaPath:
                              "#/items/oneOf/13/properties/enum/items/oneOf/1/properties/value/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err562];
                          } else {
                            vErrors.push(err562);
                          }
                          errors++;
                        }
                      }
                      if (data307.display !== undefined) {
                        let data310 = data307.display;
                        if (typeof data310 !== "string" && data310 !== null) {
                          const err563 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/enum/" +
                              i49 +
                              "/display",
                            schemaPath:
                              "#/items/oneOf/13/properties/enum/items/oneOf/1/properties/display/type",
                            keyword: "type",
                            params: {
                              type: schema28.items.oneOf[13].properties.enum
                                .items.oneOf[1].properties.display.type,
                            },
                            message: "must be string,null",
                          };
                          if (vErrors === null) {
                            vErrors = [err563];
                          } else {
                            vErrors.push(err563);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data310 === "default" ||
                            data310 === "neutral" ||
                            data310 === "warning" ||
                            data310 === "critical" ||
                            data310 === "neutralInverted"
                          )
                        ) {
                          const err564 = {
                            instancePath:
                              instancePath +
                              "/" +
                              i0 +
                              "/enum/" +
                              i49 +
                              "/display",
                            schemaPath:
                              "#/items/oneOf/13/properties/enum/items/oneOf/1/properties/display/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema28.items.oneOf[13].properties.enum.items
                                  .oneOf[1].properties.display.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err564];
                          } else {
                            vErrors.push(err564);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err565 = {
                        instancePath: instancePath + "/" + i0 + "/enum/" + i49,
                        schemaPath:
                          "#/items/oneOf/13/properties/enum/items/oneOf/1/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err565];
                      } else {
                        vErrors.push(err565);
                      }
                      errors++;
                    }
                    var _valid4 = _errs692 === errors;
                    if (_valid4 && valid154) {
                      valid154 = false;
                      passing1 = [passing1, 1];
                    } else {
                      if (_valid4) {
                        valid154 = true;
                        passing1 = 1;
                      }
                    }
                    if (!valid154) {
                      const err566 = {
                        instancePath: instancePath + "/" + i0 + "/enum/" + i49,
                        schemaPath:
                          "#/items/oneOf/13/properties/enum/items/oneOf",
                        keyword: "oneOf",
                        params: { passingSchemas: passing1 },
                        message: "must match exactly one schema in oneOf",
                      };
                      if (vErrors === null) {
                        vErrors = [err566];
                      } else {
                        vErrors.push(err566);
                      }
                      errors++;
                    } else {
                      errors = _errs689;
                      if (vErrors !== null) {
                        if (_errs689) {
                          vErrors.length = _errs689;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                  }
                } else {
                  const err567 = {
                    instancePath: instancePath + "/" + i0 + "/enum",
                    schemaPath: "#/items/oneOf/13/properties/enum/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err567];
                  } else {
                    vErrors.push(err567);
                  }
                  errors++;
                }
              }
              if (data0.defaultValue !== undefined) {
                let data311 = data0.defaultValue;
                if (Array.isArray(data311)) {
                  const len50 = data311.length;
                  for (let i50 = 0; i50 < len50; i50++) {
                    if (typeof data311[i50] !== "string") {
                      const err568 = {
                        instancePath:
                          instancePath + "/" + i0 + "/defaultValue/" + i50,
                        schemaPath:
                          "#/items/oneOf/13/properties/defaultValue/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err568];
                      } else {
                        vErrors.push(err568);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err569 = {
                    instancePath: instancePath + "/" + i0 + "/defaultValue",
                    schemaPath: "#/items/oneOf/13/properties/defaultValue/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err569];
                  } else {
                    vErrors.push(err569);
                  }
                  errors++;
                }
              }
            } else {
              const err570 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/13/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err570];
              } else {
                vErrors.push(err570);
              }
              errors++;
            }
          } else if (tag0 === "UniqueId") {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.name === undefined) {
                const err571 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/14/required",
                  keyword: "required",
                  params: { missingProperty: "name" },
                  message: "must have required property '" + "name" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err571];
                } else {
                  vErrors.push(err571);
                }
                errors++;
              }
              if (data0.required === undefined) {
                const err572 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/14/required",
                  keyword: "required",
                  params: { missingProperty: "required" },
                  message: "must have required property '" + "required" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err572];
                } else {
                  vErrors.push(err572);
                }
                errors++;
              }
              if (data0.inputType === undefined) {
                const err573 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/14/required",
                  keyword: "required",
                  params: { missingProperty: "inputType" },
                  message: "must have required property '" + "inputType" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err573];
                } else {
                  vErrors.push(err573);
                }
                errors++;
              }
              if (data0.type === undefined) {
                const err574 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/14/required",
                  keyword: "required",
                  params: { missingProperty: "type" },
                  message: "must have required property '" + "type" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err574];
                } else {
                  vErrors.push(err574);
                }
                errors++;
              }
              if (data0.placeholder === undefined) {
                const err575 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/14/required",
                  keyword: "required",
                  params: { missingProperty: "placeholder" },
                  message:
                    "must have required property '" + "placeholder" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err575];
                } else {
                  vErrors.push(err575);
                }
                errors++;
              }
              if (data0.title === undefined) {
                const err576 = {
                  instancePath: instancePath + "/" + i0,
                  schemaPath: "#/items/oneOf/14/required",
                  keyword: "required",
                  params: { missingProperty: "title" },
                  message: "must have required property '" + "title" + "'",
                };
                if (vErrors === null) {
                  vErrors = [err576];
                } else {
                  vErrors.push(err576);
                }
                errors++;
              }
              for (const key20 in data0) {
                if (!func2.call(schema28.items.oneOf[14].properties, key20)) {
                  const err577 = {
                    instancePath: instancePath + "/" + i0,
                    schemaPath: "#/items/oneOf/14/additionalProperties",
                    keyword: "additionalProperties",
                    params: { additionalProperty: key20 },
                    message: "must NOT have additional properties",
                  };
                  if (vErrors === null) {
                    vErrors = [err577];
                  } else {
                    vErrors.push(err577);
                  }
                  errors++;
                }
              }
              if (data0.name !== undefined) {
                if (typeof data0.name !== "string") {
                  const err578 = {
                    instancePath: instancePath + "/" + i0 + "/name",
                    schemaPath: "#/items/oneOf/14/properties/name/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err578];
                  } else {
                    vErrors.push(err578);
                  }
                  errors++;
                }
              }
              if (data0.required !== undefined) {
                if (typeof data0.required !== "boolean") {
                  const err579 = {
                    instancePath: instancePath + "/" + i0 + "/required",
                    schemaPath: "#/items/oneOf/14/properties/required/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err579];
                  } else {
                    vErrors.push(err579);
                  }
                  errors++;
                }
              }
              if (data0.inputType !== undefined) {
                let data315 = data0.inputType;
                if (typeof data315 !== "string") {
                  const err580 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/14/properties/inputType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err580];
                  } else {
                    vErrors.push(err580);
                  }
                  errors++;
                }
                if (!(data315 === "UniqueId")) {
                  const err581 = {
                    instancePath: instancePath + "/" + i0 + "/inputType",
                    schemaPath: "#/items/oneOf/14/properties/inputType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[14].properties.inputType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err581];
                  } else {
                    vErrors.push(err581);
                  }
                  errors++;
                }
              }
              if (data0.type !== undefined) {
                let data316 = data0.type;
                if (typeof data316 !== "string") {
                  const err582 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/14/properties/type/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err582];
                  } else {
                    vErrors.push(err582);
                  }
                  errors++;
                }
                if (!(data316 === "string")) {
                  const err583 = {
                    instancePath: instancePath + "/" + i0 + "/type",
                    schemaPath: "#/items/oneOf/14/properties/type/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[14].properties.type.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err583];
                  } else {
                    vErrors.push(err583);
                  }
                  errors++;
                }
              }
              if (data0.placeholder !== undefined) {
                if (typeof data0.placeholder !== "string") {
                  const err584 = {
                    instancePath: instancePath + "/" + i0 + "/placeholder",
                    schemaPath: "#/items/oneOf/14/properties/placeholder/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err584];
                  } else {
                    vErrors.push(err584);
                  }
                  errors++;
                }
              }
              if (data0.tooltipText !== undefined) {
                if (typeof data0.tooltipText !== "string") {
                  const err585 = {
                    instancePath: instancePath + "/" + i0 + "/tooltipText",
                    schemaPath: "#/items/oneOf/14/properties/tooltipText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err585];
                  } else {
                    vErrors.push(err585);
                  }
                  errors++;
                }
              }
              if (data0.title !== undefined) {
                let data319 = data0.title;
                if (typeof data319 === "string") {
                  if (func3(data319) < 1) {
                    const err586 = {
                      instancePath: instancePath + "/" + i0 + "/title",
                      schemaPath: "#/items/oneOf/14/properties/title/minLength",
                      keyword: "minLength",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 characters",
                    };
                    if (vErrors === null) {
                      vErrors = [err586];
                    } else {
                      vErrors.push(err586);
                    }
                    errors++;
                  }
                } else {
                  const err587 = {
                    instancePath: instancePath + "/" + i0 + "/title",
                    schemaPath: "#/items/oneOf/14/properties/title/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err587];
                  } else {
                    vErrors.push(err587);
                  }
                  errors++;
                }
              }
              if (data0.labelSize !== undefined) {
                let data320 = data0.labelSize;
                if (typeof data320 !== "string") {
                  const err588 = {
                    instancePath: instancePath + "/" + i0 + "/labelSize",
                    schemaPath: "#/items/oneOf/14/properties/labelSize/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err588];
                  } else {
                    vErrors.push(err588);
                  }
                  errors++;
                }
                if (!(data320 === "small" || data320 === "medium")) {
                  const err589 = {
                    instancePath: instancePath + "/" + i0 + "/labelSize",
                    schemaPath: "#/items/oneOf/14/properties/labelSize/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[14].properties.labelSize.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err589];
                  } else {
                    vErrors.push(err589);
                  }
                  errors++;
                }
              }
              if (data0.columnHeaderOverride !== undefined) {
                if (typeof data0.columnHeaderOverride !== "string") {
                  const err590 = {
                    instancePath:
                      instancePath + "/" + i0 + "/columnHeaderOverride",
                    schemaPath:
                      "#/items/oneOf/14/properties/columnHeaderOverride/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err590];
                  } else {
                    vErrors.push(err590);
                  }
                  errors++;
                }
              }
              if (data0.disabled !== undefined) {
                if (typeof data0.disabled !== "boolean") {
                  const err591 = {
                    instancePath: instancePath + "/" + i0 + "/disabled",
                    schemaPath: "#/items/oneOf/14/properties/disabled/type",
                    keyword: "type",
                    params: { type: "boolean" },
                    message: "must be boolean",
                  };
                  if (vErrors === null) {
                    vErrors = [err591];
                  } else {
                    vErrors.push(err591);
                  }
                  errors++;
                }
              }
              if (data0.helperText !== undefined) {
                if (typeof data0.helperText !== "string") {
                  const err592 = {
                    instancePath: instancePath + "/" + i0 + "/helperText",
                    schemaPath: "#/items/oneOf/14/properties/helperText/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err592];
                  } else {
                    vErrors.push(err592);
                  }
                  errors++;
                }
              }
              if (data0.viewOnRetrieve !== undefined) {
                let data324 = data0.viewOnRetrieve;
                if (Array.isArray(data324)) {
                  if (data324.length < 1) {
                    const err593 = {
                      instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                      schemaPath:
                        "#/items/oneOf/14/properties/viewOnRetrieve/minItems",
                      keyword: "minItems",
                      params: { limit: 1 },
                      message: "must NOT have fewer than 1 items",
                    };
                    if (vErrors === null) {
                      vErrors = [err593];
                    } else {
                      vErrors.push(err593);
                    }
                    errors++;
                  }
                  const len51 = data324.length;
                  for (let i51 = 0; i51 < len51; i51++) {
                    let data325 = data324[i51];
                    if (typeof data325 !== "string") {
                      const err594 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i51,
                        schemaPath:
                          "#/items/oneOf/14/properties/viewOnRetrieve/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err594];
                      } else {
                        vErrors.push(err594);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data325 === "manager" ||
                        data325 === "member" ||
                        data325 === "creator" ||
                        data325 === "view_only" ||
                        data325 === "admin" ||
                        data325 === "guest" ||
                        data325 === "publicUser"
                      )
                    ) {
                      const err595 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnRetrieve/" + i51,
                        schemaPath:
                          "#/items/oneOf/14/properties/viewOnRetrieve/items/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema28.items.oneOf[14].properties.viewOnRetrieve
                              .items.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err595];
                      } else {
                        vErrors.push(err595);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err596 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnRetrieve",
                    schemaPath:
                      "#/items/oneOf/14/properties/viewOnRetrieve/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err596];
                  } else {
                    vErrors.push(err596);
                  }
                  errors++;
                }
              }
              if (data0.canUpdate !== undefined) {
                let data326 = data0.canUpdate;
                if (Array.isArray(data326)) {
                  const len52 = data326.length;
                  for (let i52 = 0; i52 < len52; i52++) {
                    if (typeof data326[i52] !== "string") {
                      const err597 = {
                        instancePath:
                          instancePath + "/" + i0 + "/canUpdate/" + i52,
                        schemaPath:
                          "#/items/oneOf/14/properties/canUpdate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err597];
                      } else {
                        vErrors.push(err597);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err598 = {
                    instancePath: instancePath + "/" + i0 + "/canUpdate",
                    schemaPath: "#/items/oneOf/14/properties/canUpdate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err598];
                  } else {
                    vErrors.push(err598);
                  }
                  errors++;
                }
              }
              if (data0.viewOnCreate !== undefined) {
                let data328 = data0.viewOnCreate;
                if (Array.isArray(data328)) {
                  const len53 = data328.length;
                  for (let i53 = 0; i53 < len53; i53++) {
                    if (typeof data328[i53] !== "string") {
                      const err599 = {
                        instancePath:
                          instancePath + "/" + i0 + "/viewOnCreate/" + i53,
                        schemaPath:
                          "#/items/oneOf/14/properties/viewOnCreate/items/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err599];
                      } else {
                        vErrors.push(err599);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err600 = {
                    instancePath: instancePath + "/" + i0 + "/viewOnCreate",
                    schemaPath: "#/items/oneOf/14/properties/viewOnCreate/type",
                    keyword: "type",
                    params: { type: "array" },
                    message: "must be array",
                  };
                  if (vErrors === null) {
                    vErrors = [err600];
                  } else {
                    vErrors.push(err600);
                  }
                  errors++;
                }
              }
              if (data0.prefix !== undefined) {
                if (typeof data0.prefix !== "string") {
                  const err601 = {
                    instancePath: instancePath + "/" + i0 + "/prefix",
                    schemaPath: "#/items/oneOf/14/properties/prefix/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err601];
                  } else {
                    vErrors.push(err601);
                  }
                  errors++;
                }
              }
              if (data0.numberType !== undefined) {
                let data331 = data0.numberType;
                if (typeof data331 !== "string") {
                  const err602 = {
                    instancePath: instancePath + "/" + i0 + "/numberType",
                    schemaPath: "#/items/oneOf/14/properties/numberType/type",
                    keyword: "type",
                    params: { type: "string" },
                    message: "must be string",
                  };
                  if (vErrors === null) {
                    vErrors = [err602];
                  } else {
                    vErrors.push(err602);
                  }
                  errors++;
                }
                if (!(data331 === "ascending" || data331 === "random")) {
                  const err603 = {
                    instancePath: instancePath + "/" + i0 + "/numberType",
                    schemaPath: "#/items/oneOf/14/properties/numberType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues:
                        schema28.items.oneOf[14].properties.numberType.enum,
                    },
                    message: "must be equal to one of the allowed values",
                  };
                  if (vErrors === null) {
                    vErrors = [err603];
                  } else {
                    vErrors.push(err603);
                  }
                  errors++;
                }
              }
            } else {
              const err604 = {
                instancePath: instancePath + "/" + i0,
                schemaPath: "#/items/oneOf/14/type",
                keyword: "type",
                params: { type: "object" },
                message: "must be object",
              };
              if (vErrors === null) {
                vErrors = [err604];
              } else {
                vErrors.push(err604);
              }
              errors++;
            }
          } else {
            const err605 = {
              instancePath: instancePath + "/" + i0,
              schemaPath: "#/items/discriminator",
              keyword: "discriminator",
              params: { error: "mapping", tag: "inputType", tagValue: tag0 },
              message: 'value of tag "inputType" must be in oneOf',
            };
            if (vErrors === null) {
              vErrors = [err605];
            } else {
              vErrors.push(err605);
            }
            errors++;
          }
        } else {
          const err606 = {
            instancePath: instancePath + "/" + i0,
            schemaPath: "#/items/discriminator",
            keyword: "discriminator",
            params: { error: "tag", tag: "inputType", tagValue: tag0 },
            message: 'tag "inputType" must be string',
          };
          if (vErrors === null) {
            vErrors = [err606];
          } else {
            vErrors.push(err606);
          }
          errors++;
        }
      } else {
        const err607 = {
          instancePath: instancePath + "/" + i0,
          schemaPath: "#/items/type",
          keyword: "type",
          params: { type: "object" },
          message: "must be object",
        };
        if (vErrors === null) {
          vErrors = [err607];
        } else {
          vErrors.push(err607);
        }
        errors++;
      }
    }
  } else {
    const err608 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: { type: "array" },
      message: "must be array",
    };
    if (vErrors === null) {
      vErrors = [err608];
    } else {
      vErrors.push(err608);
    }
    errors++;
  }
  validate11.errors = vErrors;
  return errors === 0;
}
function validate10(
  data,
  { instancePath = "", parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.name === undefined) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: { missingProperty: "name" },
        message: "must have required property '" + "name" + "'",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.category === undefined) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: { missingProperty: "category" },
        message: "must have required property '" + "category" + "'",
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.canCreateRolesAndGroupIds === undefined) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: { missingProperty: "canCreateRolesAndGroupIds" },
        message:
          "must have required property '" + "canCreateRolesAndGroupIds" + "'",
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.inputs === undefined) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: { missingProperty: "inputs" },
        message: "must have required property '" + "inputs" + "'",
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.attachments === undefined) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: { missingProperty: "attachments" },
        message: "must have required property '" + "attachments" + "'",
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!func2.call(schema27.properties, key0)) {
        const err5 = {
          instancePath,
          schemaPath: "#/additionalProperties",
          keyword: "additionalProperties",
          params: { additionalProperty: key0 },
          message: "must NOT have additional properties",
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.name !== undefined) {
      let data0 = data.name;
      if (typeof data0 === "string") {
        if (func3(data0) < 1) {
          const err6 = {
            instancePath: instancePath + "/name",
            schemaPath: "#/properties/name/minLength",
            keyword: "minLength",
            params: { limit: 1 },
            message: "must NOT have fewer than 1 characters",
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
      } else {
        const err7 = {
          instancePath: instancePath + "/name",
          schemaPath: "#/properties/name/type",
          keyword: "type",
          params: { type: "string" },
          message: "must be string",
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.description !== undefined) {
      let data1 = data.description;
      if (typeof data1 !== "string" && data1 !== null) {
        const err8 = {
          instancePath: instancePath + "/description",
          schemaPath: "#/properties/description/type",
          keyword: "type",
          params: { type: schema27.properties.description.type },
          message: "must be string,null",
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.hiddenFromPublicByDefault !== undefined) {
      if (typeof data.hiddenFromPublicByDefault !== "boolean") {
        const err9 = {
          instancePath: instancePath + "/hiddenFromPublicByDefault",
          schemaPath: "#/properties/hiddenFromPublicByDefault/type",
          keyword: "type",
          params: { type: "boolean" },
          message: "must be boolean",
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.successMessage !== undefined) {
      let data3 = data.successMessage;
      if (typeof data3 !== "string" && data3 !== null) {
        const err10 = {
          instancePath: instancePath + "/successMessage",
          schemaPath: "#/properties/successMessage/type",
          keyword: "type",
          params: { type: schema27.properties.successMessage.type },
          message: "must be string,null",
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.preamble !== undefined) {
      let data4 = data.preamble;
      if (typeof data4 !== "string" && data4 !== null) {
        const err11 = {
          instancePath: instancePath + "/preamble",
          schemaPath: "#/properties/preamble/type",
          keyword: "type",
          params: { type: schema27.properties.preamble.type },
          message: "must be string,null",
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.postamble !== undefined) {
      let data5 = data.postamble;
      if (typeof data5 !== "string" && data5 !== null) {
        const err12 = {
          instancePath: instancePath + "/postamble",
          schemaPath: "#/properties/postamble/type",
          keyword: "type",
          params: { type: schema27.properties.postamble.type },
          message: "must be string,null",
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.notificationEmails !== undefined) {
      let data6 = data.notificationEmails;
      if (typeof data6 !== "string" && data6 !== null) {
        const err13 = {
          instancePath: instancePath + "/notificationEmails",
          schemaPath: "#/properties/notificationEmails/type",
          keyword: "type",
          params: { type: schema27.properties.notificationEmails.type },
          message: "must be string,null",
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.category !== undefined) {
      let data7 = data.category;
      if (typeof data7 === "string") {
        if (func3(data7) < 1) {
          const err14 = {
            instancePath: instancePath + "/category",
            schemaPath: "#/properties/category/minLength",
            keyword: "minLength",
            params: { limit: 1 },
            message: "must NOT have fewer than 1 characters",
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
      } else {
        const err15 = {
          instancePath: instancePath + "/category",
          schemaPath: "#/properties/category/type",
          keyword: "type",
          params: { type: "string" },
          message: "must be string",
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
    if (data.canCreateRolesAndGroupIds !== undefined) {
      let data8 = data.canCreateRolesAndGroupIds;
      if (Array.isArray(data8)) {
        if (data8.length < 1) {
          const err16 = {
            instancePath: instancePath + "/canCreateRolesAndGroupIds",
            schemaPath: "#/properties/canCreateRolesAndGroupIds/minItems",
            keyword: "minItems",
            params: { limit: 1 },
            message: "must NOT have fewer than 1 items",
          };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
        const len0 = data8.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (typeof data8[i0] !== "string") {
            const err17 = {
              instancePath: instancePath + "/canCreateRolesAndGroupIds/" + i0,
              schemaPath: "#/properties/canCreateRolesAndGroupIds/items/type",
              keyword: "type",
              params: { type: "string" },
              message: "must be string",
            };
            if (vErrors === null) {
              vErrors = [err17];
            } else {
              vErrors.push(err17);
            }
            errors++;
          }
        }
      } else {
        const err18 = {
          instancePath: instancePath + "/canCreateRolesAndGroupIds",
          schemaPath: "#/properties/canCreateRolesAndGroupIds/type",
          keyword: "type",
          params: { type: "array" },
          message: "must be array",
        };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
    if (data.modules !== undefined) {
      let data10 = data.modules;
      if (Array.isArray(data10)) {
        const len1 = data10.length;
        for (let i1 = 0; i1 < len1; i1++) {
          let data11 = data10[i1];
          if (typeof data11 !== "string") {
            const err19 = {
              instancePath: instancePath + "/modules/" + i1,
              schemaPath: "#/properties/modules/items/type",
              keyword: "type",
              params: { type: "string" },
              message: "must be string",
            };
            if (vErrors === null) {
              vErrors = [err19];
            } else {
              vErrors.push(err19);
            }
            errors++;
          }
          if (
            !(
              data11 === "preliminary_damage_assessment" ||
              data11 === "substantial_damage_estimate" ||
              data11 === "substantial_improvement_substantial_damage" ||
              data11 === "ec_submission" ||
              data11 === "milestone_inspection" ||
              data11 === "mailings"
            )
          ) {
            const err20 = {
              instancePath: instancePath + "/modules/" + i1,
              schemaPath: "#/properties/modules/items/enum",
              keyword: "enum",
              params: { allowedValues: schema27.properties.modules.items.enum },
              message: "must be equal to one of the allowed values",
            };
            if (vErrors === null) {
              vErrors = [err20];
            } else {
              vErrors.push(err20);
            }
            errors++;
          }
        }
      } else {
        const err21 = {
          instancePath: instancePath + "/modules",
          schemaPath: "#/properties/modules/type",
          keyword: "type",
          params: { type: "array" },
          message: "must be array",
        };
        if (vErrors === null) {
          vErrors = [err21];
        } else {
          vErrors.push(err21);
        }
        errors++;
      }
    }
    if (data.attachments !== undefined) {
      let data12 = data.attachments;
      if (Array.isArray(data12)) {
        if (data12.length < 1) {
          const err22 = {
            instancePath: instancePath + "/attachments",
            schemaPath: "#/properties/attachments/minItems",
            keyword: "minItems",
            params: { limit: 1 },
            message: "must NOT have fewer than 1 items",
          };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
        const len2 = data12.length;
        for (let i2 = 0; i2 < len2; i2++) {
          let data13 = data12[i2];
          if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
            const tag0 = data13.type;
            if (typeof tag0 == "string") {
              if (tag0 === "customMapGeometry") {
                if (
                  data13 &&
                  typeof data13 == "object" &&
                  !Array.isArray(data13)
                ) {
                  if (data13.type === undefined) {
                    const err23 = {
                      instancePath: instancePath + "/attachments/" + i2,
                      schemaPath:
                        "#/properties/attachments/items/oneOf/0/required",
                      keyword: "required",
                      params: { missingProperty: "type" },
                      message: "must have required property '" + "type" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err23];
                    } else {
                      vErrors.push(err23);
                    }
                    errors++;
                  }
                  if (data13.customMapIds === undefined) {
                    const err24 = {
                      instancePath: instancePath + "/attachments/" + i2,
                      schemaPath:
                        "#/properties/attachments/items/oneOf/0/required",
                      keyword: "required",
                      params: { missingProperty: "customMapIds" },
                      message:
                        "must have required property '" + "customMapIds" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err24];
                    } else {
                      vErrors.push(err24);
                    }
                    errors++;
                  }
                  for (const key1 in data13) {
                    if (
                      !(
                        key1 === "type" ||
                        key1 === "tags" ||
                        key1 === "customMapIds"
                      )
                    ) {
                      const err25 = {
                        instancePath: instancePath + "/attachments/" + i2,
                        schemaPath:
                          "#/properties/attachments/items/oneOf/0/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key1 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err25];
                      } else {
                        vErrors.push(err25);
                      }
                      errors++;
                    }
                  }
                  if (data13.type !== undefined) {
                    let data14 = data13.type;
                    if (typeof data14 !== "string") {
                      const err26 = {
                        instancePath:
                          instancePath + "/attachments/" + i2 + "/type",
                        schemaPath:
                          "#/properties/attachments/items/oneOf/0/properties/type/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err26];
                      } else {
                        vErrors.push(err26);
                      }
                      errors++;
                    }
                    if (!(data14 === "customMapGeometry")) {
                      const err27 = {
                        instancePath:
                          instancePath + "/attachments/" + i2 + "/type",
                        schemaPath:
                          "#/properties/attachments/items/oneOf/0/properties/type/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.attachments.items.oneOf[0]
                              .properties.type.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err27];
                      } else {
                        vErrors.push(err27);
                      }
                      errors++;
                    }
                  }
                  if (data13.tags !== undefined) {
                    let data15 = data13.tags;
                    if (Array.isArray(data15)) {
                      const len3 = data15.length;
                      for (let i3 = 0; i3 < len3; i3++) {
                        let data16 = data15[i3];
                        if (typeof data16 === "string") {
                          if (func3(data16) < 1) {
                            const err28 = {
                              instancePath:
                                instancePath +
                                "/attachments/" +
                                i2 +
                                "/tags/" +
                                i3,
                              schemaPath:
                                "#/properties/attachments/items/oneOf/0/properties/tags/items/minLength",
                              keyword: "minLength",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 characters",
                            };
                            if (vErrors === null) {
                              vErrors = [err28];
                            } else {
                              vErrors.push(err28);
                            }
                            errors++;
                          }
                        } else {
                          const err29 = {
                            instancePath:
                              instancePath +
                              "/attachments/" +
                              i2 +
                              "/tags/" +
                              i3,
                            schemaPath:
                              "#/properties/attachments/items/oneOf/0/properties/tags/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err29];
                          } else {
                            vErrors.push(err29);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err30 = {
                        instancePath:
                          instancePath + "/attachments/" + i2 + "/tags",
                        schemaPath:
                          "#/properties/attachments/items/oneOf/0/properties/tags/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err30];
                      } else {
                        vErrors.push(err30);
                      }
                      errors++;
                    }
                  }
                  if (data13.customMapIds !== undefined) {
                    let data17 = data13.customMapIds;
                    if (Array.isArray(data17)) {
                      if (data17.length < 1) {
                        const err31 = {
                          instancePath:
                            instancePath +
                            "/attachments/" +
                            i2 +
                            "/customMapIds",
                          schemaPath:
                            "#/properties/attachments/items/oneOf/0/properties/customMapIds/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err31];
                        } else {
                          vErrors.push(err31);
                        }
                        errors++;
                      }
                      const len4 = data17.length;
                      for (let i4 = 0; i4 < len4; i4++) {
                        let data18 = data17[i4];
                        if (typeof data18 === "string") {
                          if (func3(data18) < 1) {
                            const err32 = {
                              instancePath:
                                instancePath +
                                "/attachments/" +
                                i2 +
                                "/customMapIds/" +
                                i4,
                              schemaPath:
                                "#/properties/attachments/items/oneOf/0/properties/customMapIds/items/minLength",
                              keyword: "minLength",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 characters",
                            };
                            if (vErrors === null) {
                              vErrors = [err32];
                            } else {
                              vErrors.push(err32);
                            }
                            errors++;
                          }
                        } else {
                          const err33 = {
                            instancePath:
                              instancePath +
                              "/attachments/" +
                              i2 +
                              "/customMapIds/" +
                              i4,
                            schemaPath:
                              "#/properties/attachments/items/oneOf/0/properties/customMapIds/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err33];
                          } else {
                            vErrors.push(err33);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err34 = {
                        instancePath:
                          instancePath + "/attachments/" + i2 + "/customMapIds",
                        schemaPath:
                          "#/properties/attachments/items/oneOf/0/properties/customMapIds/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err34];
                      } else {
                        vErrors.push(err34);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err35 = {
                    instancePath: instancePath + "/attachments/" + i2,
                    schemaPath: "#/properties/attachments/items/oneOf/0/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err35];
                  } else {
                    vErrors.push(err35);
                  }
                  errors++;
                }
              } else if (tag0 === "property") {
                if (
                  data13 &&
                  typeof data13 == "object" &&
                  !Array.isArray(data13)
                ) {
                  if (data13.type === undefined) {
                    const err36 = {
                      instancePath: instancePath + "/attachments/" + i2,
                      schemaPath:
                        "#/properties/attachments/items/oneOf/1/required",
                      keyword: "required",
                      params: { missingProperty: "type" },
                      message: "must have required property '" + "type" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err36];
                    } else {
                      vErrors.push(err36);
                    }
                    errors++;
                  }
                  for (const key2 in data13) {
                    if (!(key2 === "type")) {
                      const err37 = {
                        instancePath: instancePath + "/attachments/" + i2,
                        schemaPath:
                          "#/properties/attachments/items/oneOf/1/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key2 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err37];
                      } else {
                        vErrors.push(err37);
                      }
                      errors++;
                    }
                  }
                  if (data13.type !== undefined) {
                    let data19 = data13.type;
                    if (typeof data19 !== "string") {
                      const err38 = {
                        instancePath:
                          instancePath + "/attachments/" + i2 + "/type",
                        schemaPath:
                          "#/properties/attachments/items/oneOf/1/properties/type/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err38];
                      } else {
                        vErrors.push(err38);
                      }
                      errors++;
                    }
                    if (!(data19 === "property")) {
                      const err39 = {
                        instancePath:
                          instancePath + "/attachments/" + i2 + "/type",
                        schemaPath:
                          "#/properties/attachments/items/oneOf/1/properties/type/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.attachments.items.oneOf[1]
                              .properties.type.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err39];
                      } else {
                        vErrors.push(err39);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err40 = {
                    instancePath: instancePath + "/attachments/" + i2,
                    schemaPath: "#/properties/attachments/items/oneOf/1/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err40];
                  } else {
                    vErrors.push(err40);
                  }
                  errors++;
                }
              } else {
                const err41 = {
                  instancePath: instancePath + "/attachments/" + i2,
                  schemaPath: "#/properties/attachments/items/discriminator",
                  keyword: "discriminator",
                  params: { error: "mapping", tag: "type", tagValue: tag0 },
                  message: 'value of tag "type" must be in oneOf',
                };
                if (vErrors === null) {
                  vErrors = [err41];
                } else {
                  vErrors.push(err41);
                }
                errors++;
              }
            } else {
              const err42 = {
                instancePath: instancePath + "/attachments/" + i2,
                schemaPath: "#/properties/attachments/items/discriminator",
                keyword: "discriminator",
                params: { error: "tag", tag: "type", tagValue: tag0 },
                message: 'tag "type" must be string',
              };
              if (vErrors === null) {
                vErrors = [err42];
              } else {
                vErrors.push(err42);
              }
              errors++;
            }
          } else {
            const err43 = {
              instancePath: instancePath + "/attachments/" + i2,
              schemaPath: "#/properties/attachments/items/type",
              keyword: "type",
              params: { type: "object" },
              message: "must be object",
            };
            if (vErrors === null) {
              vErrors = [err43];
            } else {
              vErrors.push(err43);
            }
            errors++;
          }
        }
      } else {
        const err44 = {
          instancePath: instancePath + "/attachments",
          schemaPath: "#/properties/attachments/type",
          keyword: "type",
          params: { type: "array" },
          message: "must be array",
        };
        if (vErrors === null) {
          vErrors = [err44];
        } else {
          vErrors.push(err44);
        }
        errors++;
      }
    }
    if (data.inputs !== undefined) {
      let data20 = data.inputs;
      if (Array.isArray(data20)) {
        if (data20.length < 1) {
          const err45 = {
            instancePath: instancePath + "/inputs",
            schemaPath: "#/properties/inputs/minItems",
            keyword: "minItems",
            params: { limit: 1 },
            message: "must NOT have fewer than 1 items",
          };
          if (vErrors === null) {
            vErrors = [err45];
          } else {
            vErrors.push(err45);
          }
          errors++;
        }
        const len5 = data20.length;
        for (let i5 = 0; i5 < len5; i5++) {
          let data21 = data20[i5];
          if (data21 && typeof data21 == "object" && !Array.isArray(data21)) {
            const tag1 = data21.inputType;
            if (typeof tag1 == "string") {
              if (tag1 === "DocumentUploader") {
                const _errs57 = errors;
                let valid21 = true;
                const _errs58 = errors;
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.required !== undefined) {
                    if (true !== data21.required) {
                      const err46 = {};
                      if (vErrors === null) {
                        vErrors = [err46];
                      } else {
                        vErrors.push(err46);
                      }
                      errors++;
                    }
                  }
                }
                var _valid0 = _errs58 === errors;
                errors = _errs57;
                if (vErrors !== null) {
                  if (_errs57) {
                    vErrors.length = _errs57;
                  } else {
                    vErrors = null;
                  }
                }
                if (_valid0) {
                  const _errs60 = errors;
                  if (
                    data21 &&
                    typeof data21 == "object" &&
                    !Array.isArray(data21)
                  ) {
                    if (data21.minItems === undefined) {
                      const err47 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/allOf/0/then/required",
                        keyword: "required",
                        params: { missingProperty: "minItems" },
                        message:
                          "must have required property '" + "minItems" + "'",
                      };
                      if (vErrors === null) {
                        vErrors = [err47];
                      } else {
                        vErrors.push(err47);
                      }
                      errors++;
                    }
                    if (data21.minItems !== undefined) {
                      let data23 = data21.minItems;
                      if (typeof data23 == "number" && isFinite(data23)) {
                        if (data23 < 1 || isNaN(data23)) {
                          const err48 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/minItems",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/0/allOf/0/then/properties/minItems/minimum",
                            keyword: "minimum",
                            params: { comparison: ">=", limit: 1 },
                            message: "must be >= 1",
                          };
                          if (vErrors === null) {
                            vErrors = [err48];
                          } else {
                            vErrors.push(err48);
                          }
                          errors++;
                        }
                      } else {
                        const err49 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/minItems",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/0/allOf/0/then/properties/minItems/type",
                          keyword: "type",
                          params: { type: "number" },
                          message: "must be number",
                        };
                        if (vErrors === null) {
                          vErrors = [err49];
                        } else {
                          vErrors.push(err49);
                        }
                        errors++;
                      }
                    }
                  }
                  var _valid0 = _errs60 === errors;
                  valid21 = _valid0;
                }
                if (!valid21) {
                  const err50 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/0/allOf/0/if",
                    keyword: "if",
                    params: { failingKeyword: "then" },
                    message: 'must match "then" schema',
                  };
                  if (vErrors === null) {
                    vErrors = [err50];
                  } else {
                    vErrors.push(err50);
                  }
                  errors++;
                }
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.inputType === undefined) {
                    const err51 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/0/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err51];
                    } else {
                      vErrors.push(err51);
                    }
                    errors++;
                  }
                  if (data21.name === undefined) {
                    const err52 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/0/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err52];
                    } else {
                      vErrors.push(err52);
                    }
                    errors++;
                  }
                  if (data21.required === undefined) {
                    const err53 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/0/required",
                      keyword: "required",
                      params: { missingProperty: "required" },
                      message:
                        "must have required property '" + "required" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err53];
                    } else {
                      vErrors.push(err53);
                    }
                    errors++;
                  }
                  if (data21.maxItems === undefined) {
                    const err54 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/0/required",
                      keyword: "required",
                      params: { missingProperty: "maxItems" },
                      message:
                        "must have required property '" + "maxItems" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err54];
                    } else {
                      vErrors.push(err54);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err55 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/0/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err55];
                    } else {
                      vErrors.push(err55);
                    }
                    errors++;
                  }
                  if (data21.fileTypeDescription === undefined) {
                    const err56 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/0/required",
                      keyword: "required",
                      params: { missingProperty: "fileTypeDescription" },
                      message:
                        "must have required property '" +
                        "fileTypeDescription" +
                        "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err56];
                    } else {
                      vErrors.push(err56);
                    }
                    errors++;
                  }
                  if (data21.fileQuantityDescription === undefined) {
                    const err57 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/0/required",
                      keyword: "required",
                      params: { missingProperty: "fileQuantityDescription" },
                      message:
                        "must have required property '" +
                        "fileQuantityDescription" +
                        "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err57];
                    } else {
                      vErrors.push(err57);
                    }
                    errors++;
                  }
                  if (data21.fileSizeDescription === undefined) {
                    const err58 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/0/required",
                      keyword: "required",
                      params: { missingProperty: "fileSizeDescription" },
                      message:
                        "must have required property '" +
                        "fileSizeDescription" +
                        "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err58];
                    } else {
                      vErrors.push(err58);
                    }
                    errors++;
                  }
                  if (data21.accountDocumentType === undefined) {
                    const err59 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/0/required",
                      keyword: "required",
                      params: { missingProperty: "accountDocumentType" },
                      message:
                        "must have required property '" +
                        "accountDocumentType" +
                        "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err59];
                    } else {
                      vErrors.push(err59);
                    }
                    errors++;
                  }
                  if (data21.documentTypeName === undefined) {
                    const err60 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/0/required",
                      keyword: "required",
                      params: { missingProperty: "documentTypeName" },
                      message:
                        "must have required property '" +
                        "documentTypeName" +
                        "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err60];
                    } else {
                      vErrors.push(err60);
                    }
                    errors++;
                  }
                  if (data21.documentTypeAbbreviation === undefined) {
                    const err61 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/0/required",
                      keyword: "required",
                      params: { missingProperty: "documentTypeAbbreviation" },
                      message:
                        "must have required property '" +
                        "documentTypeAbbreviation" +
                        "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err61];
                    } else {
                      vErrors.push(err61);
                    }
                    errors++;
                  }
                  for (const key3 in data21) {
                    if (
                      !func2.call(
                        schema27.properties.inputs.items.oneOf[0].properties,
                        key3,
                      )
                    ) {
                      const err62 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key3 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err62];
                      } else {
                        vErrors.push(err62);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data24 = data21.inputType;
                    if (typeof data24 !== "string") {
                      const err63 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err63];
                      } else {
                        vErrors.push(err63);
                      }
                      errors++;
                    }
                    if (!(data24 === "DocumentUploader")) {
                      const err64 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[0].properties
                              .inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err64];
                      } else {
                        vErrors.push(err64);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err65 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err65];
                      } else {
                        vErrors.push(err65);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    let data26 = data21.title;
                    if (typeof data26 === "string") {
                      if (func3(data26) < 1) {
                        const err66 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/title",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/0/properties/title/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err66];
                        } else {
                          vErrors.push(err66);
                        }
                        errors++;
                      }
                    } else {
                      const err67 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err67];
                      } else {
                        vErrors.push(err67);
                      }
                      errors++;
                    }
                  }
                  if (data21.tooltipText !== undefined) {
                    if (typeof data21.tooltipText !== "string") {
                      const err68 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/tooltipText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/tooltipText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err68];
                      } else {
                        vErrors.push(err68);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err69 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err69];
                      } else {
                        vErrors.push(err69);
                      }
                      errors++;
                    }
                  }
                  if (data21.accountDocumentType !== undefined) {
                    let data29 = data21.accountDocumentType;
                    if (typeof data29 === "string") {
                      if (func3(data29) < 1) {
                        const err70 = {
                          instancePath:
                            instancePath +
                            "/inputs/" +
                            i5 +
                            "/accountDocumentType",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/0/properties/accountDocumentType/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err70];
                        } else {
                          vErrors.push(err70);
                        }
                        errors++;
                      }
                    } else {
                      const err71 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/accountDocumentType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/accountDocumentType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err71];
                      } else {
                        vErrors.push(err71);
                      }
                      errors++;
                    }
                  }
                  if (data21.documentTypeAbbreviation !== undefined) {
                    let data30 = data21.documentTypeAbbreviation;
                    if (typeof data30 === "string") {
                      if (func3(data30) < 1) {
                        const err72 = {
                          instancePath:
                            instancePath +
                            "/inputs/" +
                            i5 +
                            "/documentTypeAbbreviation",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/0/properties/documentTypeAbbreviation/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err72];
                        } else {
                          vErrors.push(err72);
                        }
                        errors++;
                      }
                    } else {
                      const err73 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/documentTypeAbbreviation",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/documentTypeAbbreviation/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err73];
                      } else {
                        vErrors.push(err73);
                      }
                      errors++;
                    }
                  }
                  if (data21.documentTypeName !== undefined) {
                    if (typeof data21.documentTypeName !== "string") {
                      const err74 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/documentTypeName",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/documentTypeName/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err74];
                      } else {
                        vErrors.push(err74);
                      }
                      errors++;
                    }
                  }
                  if (data21.emptyFilesMessage !== undefined) {
                    if (typeof data21.emptyFilesMessage !== "string") {
                      const err75 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/emptyFilesMessage",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/emptyFilesMessage/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err75];
                      } else {
                        vErrors.push(err75);
                      }
                      errors++;
                    }
                  }
                  if (data21.fileQuantityDescription !== undefined) {
                    let data33 = data21.fileQuantityDescription;
                    if (typeof data33 === "string") {
                      if (func3(data33) < 1) {
                        const err76 = {
                          instancePath:
                            instancePath +
                            "/inputs/" +
                            i5 +
                            "/fileQuantityDescription",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/0/properties/fileQuantityDescription/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err76];
                        } else {
                          vErrors.push(err76);
                        }
                        errors++;
                      }
                    } else {
                      const err77 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/fileQuantityDescription",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/fileQuantityDescription/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err77];
                      } else {
                        vErrors.push(err77);
                      }
                      errors++;
                    }
                  }
                  if (data21.fileSizeDescription !== undefined) {
                    let data34 = data21.fileSizeDescription;
                    if (typeof data34 === "string") {
                      if (func3(data34) < 1) {
                        const err78 = {
                          instancePath:
                            instancePath +
                            "/inputs/" +
                            i5 +
                            "/fileSizeDescription",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/0/properties/fileSizeDescription/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err78];
                        } else {
                          vErrors.push(err78);
                        }
                        errors++;
                      }
                    } else {
                      const err79 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/fileSizeDescription",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/fileSizeDescription/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err79];
                      } else {
                        vErrors.push(err79);
                      }
                      errors++;
                    }
                  }
                  if (data21.fileTypeDescription !== undefined) {
                    let data35 = data21.fileTypeDescription;
                    if (typeof data35 === "string") {
                      if (func3(data35) < 1) {
                        const err80 = {
                          instancePath:
                            instancePath +
                            "/inputs/" +
                            i5 +
                            "/fileTypeDescription",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/0/properties/fileTypeDescription/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err80];
                        } else {
                          vErrors.push(err80);
                        }
                        errors++;
                      }
                    } else {
                      const err81 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/fileTypeDescription",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/fileTypeDescription/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err81];
                      } else {
                        vErrors.push(err81);
                      }
                      errors++;
                    }
                  }
                  if (data21.columnHeaderOverride !== undefined) {
                    if (typeof data21.columnHeaderOverride !== "string") {
                      const err82 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/columnHeaderOverride",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/columnHeaderOverride/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err82];
                      } else {
                        vErrors.push(err82);
                      }
                      errors++;
                    }
                  }
                  if (data21.helperText !== undefined) {
                    if (typeof data21.helperText !== "string") {
                      const err83 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/helperText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/helperText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err83];
                      } else {
                        vErrors.push(err83);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnCreate !== undefined) {
                    let data38 = data21.viewOnCreate;
                    if (Array.isArray(data38)) {
                      const len6 = data38.length;
                      for (let i6 = 0; i6 < len6; i6++) {
                        if (typeof data38[i6] !== "string") {
                          const err84 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnCreate/" +
                              i6,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/0/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err84];
                          } else {
                            vErrors.push(err84);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err85 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnCreate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err85];
                      } else {
                        vErrors.push(err85);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnRetrieve !== undefined) {
                    let data40 = data21.viewOnRetrieve;
                    if (Array.isArray(data40)) {
                      if (data40.length < 1) {
                        const err86 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/0/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err86];
                        } else {
                          vErrors.push(err86);
                        }
                        errors++;
                      }
                      const len7 = data40.length;
                      for (let i7 = 0; i7 < len7; i7++) {
                        let data41 = data40[i7];
                        if (typeof data41 !== "string") {
                          const err87 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i7,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/0/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err87];
                          } else {
                            vErrors.push(err87);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data41 === "manager" ||
                            data41 === "member" ||
                            data41 === "creator" ||
                            data41 === "view_only" ||
                            data41 === "admin" ||
                            data41 === "guest" ||
                            data41 === "publicUser"
                          )
                        ) {
                          const err88 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i7,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/0/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[0]
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err88];
                          } else {
                            vErrors.push(err88);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err89 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err89];
                      } else {
                        vErrors.push(err89);
                      }
                      errors++;
                    }
                  }
                  if (data21.canUpdate !== undefined) {
                    let data42 = data21.canUpdate;
                    if (Array.isArray(data42)) {
                      const len8 = data42.length;
                      for (let i8 = 0; i8 < len8; i8++) {
                        if (typeof data42[i8] !== "string") {
                          const err90 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/canUpdate/" +
                              i8,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/0/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err90];
                          } else {
                            vErrors.push(err90);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err91 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/canUpdate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err91];
                      } else {
                        vErrors.push(err91);
                      }
                      errors++;
                    }
                  }
                  if (data21.maxItems !== undefined) {
                    let data44 = data21.maxItems;
                    if (
                      !(
                        typeof data44 == "number" &&
                        !(data44 % 1) &&
                        !isNaN(data44) &&
                        isFinite(data44)
                      )
                    ) {
                      const err92 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/maxItems",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/maxItems/type",
                        keyword: "type",
                        params: { type: "integer" },
                        message: "must be integer",
                      };
                      if (vErrors === null) {
                        vErrors = [err92];
                      } else {
                        vErrors.push(err92);
                      }
                      errors++;
                    }
                    if (typeof data44 == "number" && isFinite(data44)) {
                      if (data44 < 1 || isNaN(data44)) {
                        const err93 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/maxItems",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/0/properties/maxItems/minimum",
                          keyword: "minimum",
                          params: { comparison: ">=", limit: 1 },
                          message: "must be >= 1",
                        };
                        if (vErrors === null) {
                          vErrors = [err93];
                        } else {
                          vErrors.push(err93);
                        }
                        errors++;
                      }
                    }
                  }
                  if (data21.minItems !== undefined) {
                    let data45 = data21.minItems;
                    if (
                      !(
                        typeof data45 == "number" &&
                        !(data45 % 1) &&
                        !isNaN(data45) &&
                        isFinite(data45)
                      )
                    ) {
                      const err94 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/minItems",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/0/properties/minItems/type",
                        keyword: "type",
                        params: { type: "integer" },
                        message: "must be integer",
                      };
                      if (vErrors === null) {
                        vErrors = [err94];
                      } else {
                        vErrors.push(err94);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err95 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/0/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err95];
                  } else {
                    vErrors.push(err95);
                  }
                  errors++;
                }
              } else if (tag1 === "Tags") {
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.inputType === undefined) {
                    const err96 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/1/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err96];
                    } else {
                      vErrors.push(err96);
                    }
                    errors++;
                  }
                  if (data21.name === undefined) {
                    const err97 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/1/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err97];
                    } else {
                      vErrors.push(err97);
                    }
                    errors++;
                  }
                  if (data21.type === undefined) {
                    const err98 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/1/required",
                      keyword: "required",
                      params: { missingProperty: "type" },
                      message: "must have required property '" + "type" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err98];
                    } else {
                      vErrors.push(err98);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err99 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/1/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err99];
                    } else {
                      vErrors.push(err99);
                    }
                    errors++;
                  }
                  if (data21.required === undefined) {
                    const err100 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/1/required",
                      keyword: "required",
                      params: { missingProperty: "required" },
                      message:
                        "must have required property '" + "required" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err100];
                    } else {
                      vErrors.push(err100);
                    }
                    errors++;
                  }
                  if (data21.minItems === undefined) {
                    const err101 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/1/required",
                      keyword: "required",
                      params: { missingProperty: "minItems" },
                      message:
                        "must have required property '" + "minItems" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err101];
                    } else {
                      vErrors.push(err101);
                    }
                    errors++;
                  }
                  if (data21.enum === undefined) {
                    const err102 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/1/required",
                      keyword: "required",
                      params: { missingProperty: "enum" },
                      message: "must have required property '" + "enum" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err102];
                    } else {
                      vErrors.push(err102);
                    }
                    errors++;
                  }
                  for (const key4 in data21) {
                    if (
                      !func2.call(
                        schema27.properties.inputs.items.oneOf[1].properties,
                        key4,
                      )
                    ) {
                      const err103 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key4 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err103];
                      } else {
                        vErrors.push(err103);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data46 = data21.inputType;
                    if (typeof data46 !== "string") {
                      const err104 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err104];
                      } else {
                        vErrors.push(err104);
                      }
                      errors++;
                    }
                    if (!(data46 === "Tags")) {
                      const err105 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[1].properties
                              .inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err105];
                      } else {
                        vErrors.push(err105);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err106 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err106];
                      } else {
                        vErrors.push(err106);
                      }
                      errors++;
                    }
                  }
                  if (data21.type !== undefined) {
                    let data48 = data21.type;
                    if (typeof data48 !== "string") {
                      const err107 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/type/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err107];
                      } else {
                        vErrors.push(err107);
                      }
                      errors++;
                    }
                    if (!(data48 === "string" || data48 === "number")) {
                      const err108 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/type/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[1].properties
                              .type.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err108];
                      } else {
                        vErrors.push(err108);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    let data49 = data21.title;
                    if (typeof data49 === "string") {
                      if (func3(data49) < 1) {
                        const err109 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/title",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/1/properties/title/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err109];
                        } else {
                          vErrors.push(err109);
                        }
                        errors++;
                      }
                    } else {
                      const err110 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err110];
                      } else {
                        vErrors.push(err110);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err111 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err111];
                      } else {
                        vErrors.push(err111);
                      }
                      errors++;
                    }
                  }
                  if (data21.description !== undefined) {
                    if (typeof data21.description !== "string") {
                      const err112 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/description",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/description/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err112];
                      } else {
                        vErrors.push(err112);
                      }
                      errors++;
                    }
                  }
                  if (data21.tooltipText !== undefined) {
                    if (typeof data21.tooltipText !== "string") {
                      const err113 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/tooltipText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/tooltipText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err113];
                      } else {
                        vErrors.push(err113);
                      }
                      errors++;
                    }
                  }
                  if (data21.columnHeaderOverride !== undefined) {
                    if (typeof data21.columnHeaderOverride !== "string") {
                      const err114 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/columnHeaderOverride",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/columnHeaderOverride/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err114];
                      } else {
                        vErrors.push(err114);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnCreate !== undefined) {
                    let data54 = data21.viewOnCreate;
                    if (Array.isArray(data54)) {
                      const len9 = data54.length;
                      for (let i9 = 0; i9 < len9; i9++) {
                        if (typeof data54[i9] !== "string") {
                          const err115 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnCreate/" +
                              i9,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/1/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err115];
                          } else {
                            vErrors.push(err115);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err116 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnCreate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err116];
                      } else {
                        vErrors.push(err116);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnRetrieve !== undefined) {
                    let data56 = data21.viewOnRetrieve;
                    if (Array.isArray(data56)) {
                      if (data56.length < 1) {
                        const err117 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/1/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err117];
                        } else {
                          vErrors.push(err117);
                        }
                        errors++;
                      }
                      const len10 = data56.length;
                      for (let i10 = 0; i10 < len10; i10++) {
                        let data57 = data56[i10];
                        if (typeof data57 !== "string") {
                          const err118 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i10,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/1/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err118];
                          } else {
                            vErrors.push(err118);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data57 === "manager" ||
                            data57 === "member" ||
                            data57 === "creator" ||
                            data57 === "view_only" ||
                            data57 === "admin" ||
                            data57 === "guest" ||
                            data57 === "publicUser"
                          )
                        ) {
                          const err119 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i10,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/1/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[1]
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err119];
                          } else {
                            vErrors.push(err119);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err120 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err120];
                      } else {
                        vErrors.push(err120);
                      }
                      errors++;
                    }
                  }
                  if (data21.canUpdate !== undefined) {
                    let data58 = data21.canUpdate;
                    if (Array.isArray(data58)) {
                      const len11 = data58.length;
                      for (let i11 = 0; i11 < len11; i11++) {
                        if (typeof data58[i11] !== "string") {
                          const err121 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/canUpdate/" +
                              i11,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/1/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err121];
                          } else {
                            vErrors.push(err121);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err122 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/canUpdate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err122];
                      } else {
                        vErrors.push(err122);
                      }
                      errors++;
                    }
                  }
                  if (data21.minItems !== undefined) {
                    let data60 = data21.minItems;
                    if (
                      !(
                        typeof data60 == "number" &&
                        !(data60 % 1) &&
                        !isNaN(data60) &&
                        isFinite(data60)
                      )
                    ) {
                      const err123 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/minItems",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/minItems/type",
                        keyword: "type",
                        params: { type: "integer" },
                        message: "must be integer",
                      };
                      if (vErrors === null) {
                        vErrors = [err123];
                      } else {
                        vErrors.push(err123);
                      }
                      errors++;
                    }
                  }
                  if (data21.enum !== undefined) {
                    let data61 = data21.enum;
                    if (Array.isArray(data61)) {
                      if (data61.length < 1) {
                        const err124 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/enum",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/1/properties/enum/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err124];
                        } else {
                          vErrors.push(err124);
                        }
                        errors++;
                      }
                      const len12 = data61.length;
                      for (let i12 = 0; i12 < len12; i12++) {
                        let data62 = data61[i12];
                        if (typeof data62 === "string") {
                          if (func3(data62) < 1) {
                            const err125 = {
                              instancePath:
                                instancePath + "/inputs/" + i5 + "/enum/" + i12,
                              schemaPath:
                                "#/properties/inputs/items/oneOf/1/properties/enum/items/minLength",
                              keyword: "minLength",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 characters",
                            };
                            if (vErrors === null) {
                              vErrors = [err125];
                            } else {
                              vErrors.push(err125);
                            }
                            errors++;
                          }
                        } else {
                          const err126 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/enum/" + i12,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/1/properties/enum/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err126];
                          } else {
                            vErrors.push(err126);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err127 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/enum",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/enum/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err127];
                      } else {
                        vErrors.push(err127);
                      }
                      errors++;
                    }
                  }
                  if (data21.defaultValue !== undefined) {
                    let data63 = data21.defaultValue;
                    if (Array.isArray(data63)) {
                      const len13 = data63.length;
                      for (let i13 = 0; i13 < len13; i13++) {
                        if (typeof data63[i13] !== "string") {
                          const err128 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/defaultValue/" +
                              i13,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/1/properties/defaultValue/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err128];
                          } else {
                            vErrors.push(err128);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err129 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValue",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/1/properties/defaultValue/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err129];
                      } else {
                        vErrors.push(err129);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err130 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/1/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err130];
                  } else {
                    vErrors.push(err130);
                  }
                  errors++;
                }
              } else if (tag1 === "select") {
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.name === undefined) {
                    const err131 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/2/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err131];
                    } else {
                      vErrors.push(err131);
                    }
                    errors++;
                  }
                  if (data21.required === undefined) {
                    const err132 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/2/required",
                      keyword: "required",
                      params: { missingProperty: "required" },
                      message:
                        "must have required property '" + "required" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err132];
                    } else {
                      vErrors.push(err132);
                    }
                    errors++;
                  }
                  if (data21.type === undefined) {
                    const err133 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/2/required",
                      keyword: "required",
                      params: { missingProperty: "type" },
                      message: "must have required property '" + "type" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err133];
                    } else {
                      vErrors.push(err133);
                    }
                    errors++;
                  }
                  if (data21.inputType === undefined) {
                    const err134 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/2/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err134];
                    } else {
                      vErrors.push(err134);
                    }
                    errors++;
                  }
                  if (data21.placeholder === undefined) {
                    const err135 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/2/required",
                      keyword: "required",
                      params: { missingProperty: "placeholder" },
                      message:
                        "must have required property '" + "placeholder" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err135];
                    } else {
                      vErrors.push(err135);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err136 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/2/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err136];
                    } else {
                      vErrors.push(err136);
                    }
                    errors++;
                  }
                  if (data21.enum === undefined) {
                    const err137 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/2/required",
                      keyword: "required",
                      params: { missingProperty: "enum" },
                      message: "must have required property '" + "enum" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err137];
                    } else {
                      vErrors.push(err137);
                    }
                    errors++;
                  }
                  for (const key5 in data21) {
                    if (
                      !func2.call(
                        schema27.properties.inputs.items.oneOf[2].properties,
                        key5,
                      )
                    ) {
                      const err138 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key5 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err138];
                      } else {
                        vErrors.push(err138);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err139 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err139];
                      } else {
                        vErrors.push(err139);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err140 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err140];
                      } else {
                        vErrors.push(err140);
                      }
                      errors++;
                    }
                  }
                  if (data21.useAsTag !== undefined) {
                    if (typeof data21.useAsTag !== "boolean") {
                      const err141 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/useAsTag",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/useAsTag/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err141];
                      } else {
                        vErrors.push(err141);
                      }
                      errors++;
                    }
                  }
                  if (data21.type !== undefined) {
                    let data68 = data21.type;
                    if (typeof data68 !== "string") {
                      const err142 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/type/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err142];
                      } else {
                        vErrors.push(err142);
                      }
                      errors++;
                    }
                    if (!(data68 === "string")) {
                      const err143 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/type/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[2].properties
                              .type.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err143];
                      } else {
                        vErrors.push(err143);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data69 = data21.inputType;
                    if (typeof data69 !== "string") {
                      const err144 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err144];
                      } else {
                        vErrors.push(err144);
                      }
                      errors++;
                    }
                    if (!(data69 === "select")) {
                      const err145 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[2].properties
                              .inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err145];
                      } else {
                        vErrors.push(err145);
                      }
                      errors++;
                    }
                  }
                  if (data21.placeholder !== undefined) {
                    if (typeof data21.placeholder !== "string") {
                      const err146 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/placeholder",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/placeholder/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err146];
                      } else {
                        vErrors.push(err146);
                      }
                      errors++;
                    }
                  }
                  if (data21.tooltipText !== undefined) {
                    if (typeof data21.tooltipText !== "string") {
                      const err147 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/tooltipText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/tooltipText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err147];
                      } else {
                        vErrors.push(err147);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    let data72 = data21.title;
                    if (typeof data72 === "string") {
                      if (func3(data72) < 1) {
                        const err148 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/title",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/2/properties/title/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err148];
                        } else {
                          vErrors.push(err148);
                        }
                        errors++;
                      }
                    } else {
                      const err149 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err149];
                      } else {
                        vErrors.push(err149);
                      }
                      errors++;
                    }
                  }
                  if (data21.enum !== undefined) {
                    let data73 = data21.enum;
                    if (Array.isArray(data73)) {
                      if (data73.length < 1) {
                        const err150 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/enum",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/2/properties/enum/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err150];
                        } else {
                          vErrors.push(err150);
                        }
                        errors++;
                      }
                      const len14 = data73.length;
                      for (let i14 = 0; i14 < len14; i14++) {
                        let data74 = data73[i14];
                        const _errs171 = errors;
                        let valid47 = false;
                        let passing0 = null;
                        const _errs172 = errors;
                        if (typeof data74 === "string") {
                          if (func3(data74) < 1) {
                            const err151 = {
                              instancePath:
                                instancePath + "/inputs/" + i5 + "/enum/" + i14,
                              schemaPath:
                                "#/properties/inputs/items/oneOf/2/properties/enum/items/oneOf/0/minLength",
                              keyword: "minLength",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 characters",
                            };
                            if (vErrors === null) {
                              vErrors = [err151];
                            } else {
                              vErrors.push(err151);
                            }
                            errors++;
                          }
                        } else {
                          const err152 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/enum/" + i14,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/2/properties/enum/items/oneOf/0/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err152];
                          } else {
                            vErrors.push(err152);
                          }
                          errors++;
                        }
                        var _valid1 = _errs172 === errors;
                        if (_valid1) {
                          valid47 = true;
                          passing0 = 0;
                        }
                        const _errs174 = errors;
                        if (
                          data74 &&
                          typeof data74 == "object" &&
                          !Array.isArray(data74)
                        ) {
                          if (data74.label === undefined) {
                            const err153 = {
                              instancePath:
                                instancePath + "/inputs/" + i5 + "/enum/" + i14,
                              schemaPath:
                                "#/properties/inputs/items/oneOf/2/properties/enum/items/oneOf/1/required",
                              keyword: "required",
                              params: { missingProperty: "label" },
                              message:
                                "must have required property '" + "label" + "'",
                            };
                            if (vErrors === null) {
                              vErrors = [err153];
                            } else {
                              vErrors.push(err153);
                            }
                            errors++;
                          }
                          if (data74.value === undefined) {
                            const err154 = {
                              instancePath:
                                instancePath + "/inputs/" + i5 + "/enum/" + i14,
                              schemaPath:
                                "#/properties/inputs/items/oneOf/2/properties/enum/items/oneOf/1/required",
                              keyword: "required",
                              params: { missingProperty: "value" },
                              message:
                                "must have required property '" + "value" + "'",
                            };
                            if (vErrors === null) {
                              vErrors = [err154];
                            } else {
                              vErrors.push(err154);
                            }
                            errors++;
                          }
                          if (data74.label !== undefined) {
                            let data75 = data74.label;
                            if (typeof data75 === "string") {
                              if (func3(data75) < 1) {
                                const err155 = {
                                  instancePath:
                                    instancePath +
                                    "/inputs/" +
                                    i5 +
                                    "/enum/" +
                                    i14 +
                                    "/label",
                                  schemaPath:
                                    "#/properties/inputs/items/oneOf/2/properties/enum/items/oneOf/1/properties/label/minLength",
                                  keyword: "minLength",
                                  params: { limit: 1 },
                                  message:
                                    "must NOT have fewer than 1 characters",
                                };
                                if (vErrors === null) {
                                  vErrors = [err155];
                                } else {
                                  vErrors.push(err155);
                                }
                                errors++;
                              }
                            } else {
                              const err156 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/enum/" +
                                  i14 +
                                  "/label",
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/2/properties/enum/items/oneOf/1/properties/label/type",
                                keyword: "type",
                                params: { type: "string" },
                                message: "must be string",
                              };
                              if (vErrors === null) {
                                vErrors = [err156];
                              } else {
                                vErrors.push(err156);
                              }
                              errors++;
                            }
                          }
                          if (data74.value !== undefined) {
                            let data76 = data74.value;
                            if (typeof data76 === "string") {
                              if (func3(data76) < 1) {
                                const err157 = {
                                  instancePath:
                                    instancePath +
                                    "/inputs/" +
                                    i5 +
                                    "/enum/" +
                                    i14 +
                                    "/value",
                                  schemaPath:
                                    "#/properties/inputs/items/oneOf/2/properties/enum/items/oneOf/1/properties/value/minLength",
                                  keyword: "minLength",
                                  params: { limit: 1 },
                                  message:
                                    "must NOT have fewer than 1 characters",
                                };
                                if (vErrors === null) {
                                  vErrors = [err157];
                                } else {
                                  vErrors.push(err157);
                                }
                                errors++;
                              }
                            } else {
                              const err158 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/enum/" +
                                  i14 +
                                  "/value",
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/2/properties/enum/items/oneOf/1/properties/value/type",
                                keyword: "type",
                                params: { type: "string" },
                                message: "must be string",
                              };
                              if (vErrors === null) {
                                vErrors = [err158];
                              } else {
                                vErrors.push(err158);
                              }
                              errors++;
                            }
                          }
                          if (data74.display !== undefined) {
                            let data77 = data74.display;
                            if (typeof data77 !== "string" && data77 !== null) {
                              const err159 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/enum/" +
                                  i14 +
                                  "/display",
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/2/properties/enum/items/oneOf/1/properties/display/type",
                                keyword: "type",
                                params: {
                                  type: schema27.properties.inputs.items
                                    .oneOf[2].properties.enum.items.oneOf[1]
                                    .properties.display.type,
                                },
                                message: "must be string,null",
                              };
                              if (vErrors === null) {
                                vErrors = [err159];
                              } else {
                                vErrors.push(err159);
                              }
                              errors++;
                            }
                            if (
                              !(
                                data77 === "default" ||
                                data77 === "neutral" ||
                                data77 === "warning" ||
                                data77 === "critical" ||
                                data77 === "neutralInverted"
                              )
                            ) {
                              const err160 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/enum/" +
                                  i14 +
                                  "/display",
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/2/properties/enum/items/oneOf/1/properties/display/enum",
                                keyword: "enum",
                                params: {
                                  allowedValues:
                                    schema27.properties.inputs.items.oneOf[2]
                                      .properties.enum.items.oneOf[1].properties
                                      .display.enum,
                                },
                                message:
                                  "must be equal to one of the allowed values",
                              };
                              if (vErrors === null) {
                                vErrors = [err160];
                              } else {
                                vErrors.push(err160);
                              }
                              errors++;
                            }
                          }
                        } else {
                          const err161 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/enum/" + i14,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/2/properties/enum/items/oneOf/1/type",
                            keyword: "type",
                            params: { type: "object" },
                            message: "must be object",
                          };
                          if (vErrors === null) {
                            vErrors = [err161];
                          } else {
                            vErrors.push(err161);
                          }
                          errors++;
                        }
                        var _valid1 = _errs174 === errors;
                        if (_valid1 && valid47) {
                          valid47 = false;
                          passing0 = [passing0, 1];
                        } else {
                          if (_valid1) {
                            valid47 = true;
                            passing0 = 1;
                          }
                        }
                        if (!valid47) {
                          const err162 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/enum/" + i14,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/2/properties/enum/items/oneOf",
                            keyword: "oneOf",
                            params: { passingSchemas: passing0 },
                            message: "must match exactly one schema in oneOf",
                          };
                          if (vErrors === null) {
                            vErrors = [err162];
                          } else {
                            vErrors.push(err162);
                          }
                          errors++;
                        } else {
                          errors = _errs171;
                          if (vErrors !== null) {
                            if (_errs171) {
                              vErrors.length = _errs171;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                      }
                    } else {
                      const err163 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/enum",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/enum/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err163];
                      } else {
                        vErrors.push(err163);
                      }
                      errors++;
                    }
                  }
                  if (data21.defaultValuePath !== undefined) {
                    let data78 = data21.defaultValuePath;
                    if (typeof data78 !== "string") {
                      const err164 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValuePath",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/defaultValuePath/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err164];
                      } else {
                        vErrors.push(err164);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data78 === "property.sisd.adjustmentRatio" ||
                        data78 === "property.sisd.defaultExclude" ||
                        data78 === "property.improvementValue" ||
                        data78 === "property.sisd.costType" ||
                        data78 === "property.latitude" ||
                        data78 === "property.longitude" ||
                        data78 === "parcel.mailingAddress1" ||
                        data78 === "parcel.mailingAddress2" ||
                        data78 === "parcel.mailingAddress" ||
                        data78 === "parcel.parcelId" ||
                        data78 === "parcel.improvementValue" ||
                        data78 === "parcel.block" ||
                        data78 === "parcel.lot" ||
                        data78 === "parcel.ownerName" ||
                        data78 === "user.firstName" ||
                        data78 === "user.lastName" ||
                        data78 === "user.fullName" ||
                        data78 === "units.feet" ||
                        data78 === "units.inches" ||
                        data78 === "units.hours" ||
                        data78 === "units.minutes" ||
                        data78 === "units.days" ||
                        data78 === "boolean.true" ||
                        data78 === "boolean.false" ||
                        data78 === "date.today"
                      )
                    ) {
                      const err165 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValuePath",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/defaultValuePath/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[2].properties
                              .defaultValuePath.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err165];
                      } else {
                        vErrors.push(err165);
                      }
                      errors++;
                    }
                  }
                  if (data21.defaultValue !== undefined) {
                    if (typeof data21.defaultValue !== "string") {
                      const err166 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValue",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/defaultValue/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err166];
                      } else {
                        vErrors.push(err166);
                      }
                      errors++;
                    }
                  }
                  if (data21.columnHeaderOverride !== undefined) {
                    if (typeof data21.columnHeaderOverride !== "string") {
                      const err167 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/columnHeaderOverride",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/columnHeaderOverride/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err167];
                      } else {
                        vErrors.push(err167);
                      }
                      errors++;
                    }
                  }
                  if (data21.disabled !== undefined) {
                    if (typeof data21.disabled !== "boolean") {
                      const err168 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/disabled",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/disabled/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err168];
                      } else {
                        vErrors.push(err168);
                      }
                      errors++;
                    }
                  }
                  if (data21.helperText !== undefined) {
                    if (typeof data21.helperText !== "string") {
                      const err169 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/helperText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/helperText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err169];
                      } else {
                        vErrors.push(err169);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnCreate !== undefined) {
                    let data83 = data21.viewOnCreate;
                    if (Array.isArray(data83)) {
                      const len15 = data83.length;
                      for (let i15 = 0; i15 < len15; i15++) {
                        if (typeof data83[i15] !== "string") {
                          const err170 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnCreate/" +
                              i15,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/2/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err170];
                          } else {
                            vErrors.push(err170);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err171 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnCreate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err171];
                      } else {
                        vErrors.push(err171);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnRetrieve !== undefined) {
                    let data85 = data21.viewOnRetrieve;
                    if (Array.isArray(data85)) {
                      if (data85.length < 1) {
                        const err172 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/2/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err172];
                        } else {
                          vErrors.push(err172);
                        }
                        errors++;
                      }
                      const len16 = data85.length;
                      for (let i16 = 0; i16 < len16; i16++) {
                        let data86 = data85[i16];
                        if (typeof data86 !== "string") {
                          const err173 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i16,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/2/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err173];
                          } else {
                            vErrors.push(err173);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data86 === "manager" ||
                            data86 === "member" ||
                            data86 === "creator" ||
                            data86 === "view_only" ||
                            data86 === "admin" ||
                            data86 === "guest" ||
                            data86 === "publicUser"
                          )
                        ) {
                          const err174 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i16,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/2/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[2]
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err174];
                          } else {
                            vErrors.push(err174);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err175 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err175];
                      } else {
                        vErrors.push(err175);
                      }
                      errors++;
                    }
                  }
                  if (data21.canUpdate !== undefined) {
                    let data87 = data21.canUpdate;
                    if (Array.isArray(data87)) {
                      const len17 = data87.length;
                      for (let i17 = 0; i17 < len17; i17++) {
                        if (typeof data87[i17] !== "string") {
                          const err176 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/canUpdate/" +
                              i17,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/2/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err176];
                          } else {
                            vErrors.push(err176);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err177 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/canUpdate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/2/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err177];
                      } else {
                        vErrors.push(err177);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err178 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/2/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err178];
                  } else {
                    vErrors.push(err178);
                  }
                  errors++;
                }
              } else if (tag1 === "date") {
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.name === undefined) {
                    const err179 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/3/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err179];
                    } else {
                      vErrors.push(err179);
                    }
                    errors++;
                  }
                  if (data21.required === undefined) {
                    const err180 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/3/required",
                      keyword: "required",
                      params: { missingProperty: "required" },
                      message:
                        "must have required property '" + "required" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err180];
                    } else {
                      vErrors.push(err180);
                    }
                    errors++;
                  }
                  if (data21.inputType === undefined) {
                    const err181 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/3/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err181];
                    } else {
                      vErrors.push(err181);
                    }
                    errors++;
                  }
                  if (data21.type === undefined) {
                    const err182 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/3/required",
                      keyword: "required",
                      params: { missingProperty: "type" },
                      message: "must have required property '" + "type" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err182];
                    } else {
                      vErrors.push(err182);
                    }
                    errors++;
                  }
                  if (data21.defaultToToday === undefined) {
                    const err183 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/3/required",
                      keyword: "required",
                      params: { missingProperty: "defaultToToday" },
                      message:
                        "must have required property '" +
                        "defaultToToday" +
                        "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err183];
                    } else {
                      vErrors.push(err183);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err184 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/3/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err184];
                    } else {
                      vErrors.push(err184);
                    }
                    errors++;
                  }
                  for (const key6 in data21) {
                    if (
                      !func2.call(
                        schema27.properties.inputs.items.oneOf[3].properties,
                        key6,
                      )
                    ) {
                      const err185 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key6 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err185];
                      } else {
                        vErrors.push(err185);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err186 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err186];
                      } else {
                        vErrors.push(err186);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err187 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err187];
                      } else {
                        vErrors.push(err187);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data91 = data21.inputType;
                    if (typeof data91 !== "string") {
                      const err188 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err188];
                      } else {
                        vErrors.push(err188);
                      }
                      errors++;
                    }
                    if (!(data91 === "date")) {
                      const err189 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[3].properties
                              .inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err189];
                      } else {
                        vErrors.push(err189);
                      }
                      errors++;
                    }
                  }
                  if (data21.type !== undefined) {
                    let data92 = data21.type;
                    if (typeof data92 !== "string") {
                      const err190 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/type/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err190];
                      } else {
                        vErrors.push(err190);
                      }
                      errors++;
                    }
                    if (!(data92 === "string")) {
                      const err191 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/type/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[3].properties
                              .type.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err191];
                      } else {
                        vErrors.push(err191);
                      }
                      errors++;
                    }
                  }
                  if (data21.defaultToToday !== undefined) {
                    if (typeof data21.defaultToToday !== "boolean") {
                      const err192 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultToToday",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/defaultToToday/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err192];
                      } else {
                        vErrors.push(err192);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    let data94 = data21.title;
                    if (typeof data94 === "string") {
                      if (func3(data94) < 1) {
                        const err193 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/title",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/3/properties/title/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err193];
                        } else {
                          vErrors.push(err193);
                        }
                        errors++;
                      }
                    } else {
                      const err194 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err194];
                      } else {
                        vErrors.push(err194);
                      }
                      errors++;
                    }
                  }
                  if (data21.placeholder !== undefined) {
                    if (typeof data21.placeholder !== "string") {
                      const err195 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/placeholder",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/placeholder/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err195];
                      } else {
                        vErrors.push(err195);
                      }
                      errors++;
                    }
                  }
                  if (data21.tooltipText !== undefined) {
                    if (typeof data21.tooltipText !== "string") {
                      const err196 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/tooltipText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/tooltipText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err196];
                      } else {
                        vErrors.push(err196);
                      }
                      errors++;
                    }
                  }
                  if (data21.columnHeaderOverride !== undefined) {
                    if (typeof data21.columnHeaderOverride !== "string") {
                      const err197 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/columnHeaderOverride",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/columnHeaderOverride/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err197];
                      } else {
                        vErrors.push(err197);
                      }
                      errors++;
                    }
                  }
                  if (data21.disabled !== undefined) {
                    if (typeof data21.disabled !== "boolean") {
                      const err198 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/disabled",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/disabled/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err198];
                      } else {
                        vErrors.push(err198);
                      }
                      errors++;
                    }
                  }
                  if (data21.helperText !== undefined) {
                    if (typeof data21.helperText !== "string") {
                      const err199 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/helperText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/helperText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err199];
                      } else {
                        vErrors.push(err199);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnCreate !== undefined) {
                    let data100 = data21.viewOnCreate;
                    if (Array.isArray(data100)) {
                      const len18 = data100.length;
                      for (let i18 = 0; i18 < len18; i18++) {
                        if (typeof data100[i18] !== "string") {
                          const err200 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnCreate/" +
                              i18,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/3/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err200];
                          } else {
                            vErrors.push(err200);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err201 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnCreate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err201];
                      } else {
                        vErrors.push(err201);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnRetrieve !== undefined) {
                    let data102 = data21.viewOnRetrieve;
                    if (Array.isArray(data102)) {
                      if (data102.length < 1) {
                        const err202 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/3/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err202];
                        } else {
                          vErrors.push(err202);
                        }
                        errors++;
                      }
                      const len19 = data102.length;
                      for (let i19 = 0; i19 < len19; i19++) {
                        let data103 = data102[i19];
                        if (typeof data103 !== "string") {
                          const err203 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i19,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/3/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err203];
                          } else {
                            vErrors.push(err203);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data103 === "manager" ||
                            data103 === "member" ||
                            data103 === "creator" ||
                            data103 === "view_only" ||
                            data103 === "admin" ||
                            data103 === "guest" ||
                            data103 === "publicUser"
                          )
                        ) {
                          const err204 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i19,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/3/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[3]
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err204];
                          } else {
                            vErrors.push(err204);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err205 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err205];
                      } else {
                        vErrors.push(err205);
                      }
                      errors++;
                    }
                  }
                  if (data21.canUpdate !== undefined) {
                    let data104 = data21.canUpdate;
                    if (Array.isArray(data104)) {
                      const len20 = data104.length;
                      for (let i20 = 0; i20 < len20; i20++) {
                        if (typeof data104[i20] !== "string") {
                          const err206 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/canUpdate/" +
                              i20,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/3/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err206];
                          } else {
                            vErrors.push(err206);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err207 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/canUpdate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err207];
                      } else {
                        vErrors.push(err207);
                      }
                      errors++;
                    }
                  }
                  if (data21.formula !== undefined) {
                    let data106 = data21.formula;
                    if (
                      data106 &&
                      typeof data106 == "object" &&
                      !Array.isArray(data106)
                    ) {
                      if (data106.name === undefined) {
                        const err208 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/3/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "name" },
                          message:
                            "must have required property '" + "name" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err208];
                        } else {
                          vErrors.push(err208);
                        }
                        errors++;
                      }
                      if (data106.applies === undefined) {
                        const err209 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/3/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "applies" },
                          message:
                            "must have required property '" + "applies" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err209];
                        } else {
                          vErrors.push(err209);
                        }
                        errors++;
                      }
                      if (data106.logic === undefined) {
                        const err210 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/3/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "logic" },
                          message:
                            "must have required property '" + "logic" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err210];
                        } else {
                          vErrors.push(err210);
                        }
                        errors++;
                      }
                      for (const key7 in data106) {
                        if (
                          !(
                            key7 === "name" ||
                            key7 === "applies" ||
                            key7 === "logic"
                          )
                        ) {
                          const err211 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/3/properties/formula/additionalProperties",
                            keyword: "additionalProperties",
                            params: { additionalProperty: key7 },
                            message: "must NOT have additional properties",
                          };
                          if (vErrors === null) {
                            vErrors = [err211];
                          } else {
                            vErrors.push(err211);
                          }
                          errors++;
                        }
                      }
                      if (data106.name !== undefined) {
                        if (typeof data106.name !== "string") {
                          const err212 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula/name",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/3/properties/formula/properties/name/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err212];
                          } else {
                            vErrors.push(err212);
                          }
                          errors++;
                        }
                      }
                      if (data106.applies !== undefined) {
                        let data108 = data106.applies;
                        if (
                          !(
                            data108 &&
                            typeof data108 == "object" &&
                            !Array.isArray(data108)
                          ) &&
                          typeof data108 !== "boolean"
                        ) {
                          const err213 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/formula/applies",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/3/properties/formula/properties/applies/type",
                            keyword: "type",
                            params: {
                              type: schema27.properties.inputs.items.oneOf[3]
                                .properties.formula.properties.applies.type,
                            },
                            message: "must be object,boolean",
                          };
                          if (vErrors === null) {
                            vErrors = [err213];
                          } else {
                            vErrors.push(err213);
                          }
                          errors++;
                        }
                      }
                      if (data106.logic !== undefined) {
                        let data109 = data106.logic;
                        if (
                          data109 &&
                          typeof data109 == "object" &&
                          !Array.isArray(data109)
                        ) {
                        } else {
                          const err214 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula/logic",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/3/properties/formula/properties/logic/type",
                            keyword: "type",
                            params: { type: "object" },
                            message: "must be object",
                          };
                          if (vErrors === null) {
                            vErrors = [err214];
                          } else {
                            vErrors.push(err214);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err215 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/formula",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/3/properties/formula/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err215];
                      } else {
                        vErrors.push(err215);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err216 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/3/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err216];
                  } else {
                    vErrors.push(err216);
                  }
                  errors++;
                }
              } else if (tag1 === "DamageDegree") {
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.name === undefined) {
                    const err217 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/4/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err217];
                    } else {
                      vErrors.push(err217);
                    }
                    errors++;
                  }
                  if (data21.required === undefined) {
                    const err218 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/4/required",
                      keyword: "required",
                      params: { missingProperty: "required" },
                      message:
                        "must have required property '" + "required" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err218];
                    } else {
                      vErrors.push(err218);
                    }
                    errors++;
                  }
                  if (data21.inputType === undefined) {
                    const err219 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/4/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err219];
                    } else {
                      vErrors.push(err219);
                    }
                    errors++;
                  }
                  if (data21.type === undefined) {
                    const err220 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/4/required",
                      keyword: "required",
                      params: { missingProperty: "type" },
                      message: "must have required property '" + "type" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err220];
                    } else {
                      vErrors.push(err220);
                    }
                    errors++;
                  }
                  if (data21.placeholder === undefined) {
                    const err221 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/4/required",
                      keyword: "required",
                      params: { missingProperty: "placeholder" },
                      message:
                        "must have required property '" + "placeholder" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err221];
                    } else {
                      vErrors.push(err221);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err222 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/4/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err222];
                    } else {
                      vErrors.push(err222);
                    }
                    errors++;
                  }
                  for (const key8 in data21) {
                    if (
                      !func2.call(
                        schema27.properties.inputs.items.oneOf[4].properties,
                        key8,
                      )
                    ) {
                      const err223 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/4/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key8 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err223];
                      } else {
                        vErrors.push(err223);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err224 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/4/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err224];
                      } else {
                        vErrors.push(err224);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err225 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/4/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err225];
                      } else {
                        vErrors.push(err225);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data112 = data21.inputType;
                    if (typeof data112 !== "string") {
                      const err226 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/4/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err226];
                      } else {
                        vErrors.push(err226);
                      }
                      errors++;
                    }
                    if (!(data112 === "DamageDegree")) {
                      const err227 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/4/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[4].properties
                              .inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err227];
                      } else {
                        vErrors.push(err227);
                      }
                      errors++;
                    }
                  }
                  if (data21.type !== undefined) {
                    if (typeof data21.type !== "string") {
                      const err228 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/4/properties/type/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err228];
                      } else {
                        vErrors.push(err228);
                      }
                      errors++;
                    }
                  }
                  if (data21.placeholder !== undefined) {
                    if (typeof data21.placeholder !== "string") {
                      const err229 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/placeholder",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/4/properties/placeholder/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err229];
                      } else {
                        vErrors.push(err229);
                      }
                      errors++;
                    }
                  }
                  if (data21.tooltipText !== undefined) {
                    if (typeof data21.tooltipText !== "string") {
                      const err230 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/tooltipText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/4/properties/tooltipText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err230];
                      } else {
                        vErrors.push(err230);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    let data116 = data21.title;
                    if (typeof data116 === "string") {
                      if (func3(data116) < 1) {
                        const err231 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/title",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/4/properties/title/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err231];
                        } else {
                          vErrors.push(err231);
                        }
                        errors++;
                      }
                    } else {
                      const err232 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/4/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err232];
                      } else {
                        vErrors.push(err232);
                      }
                      errors++;
                    }
                  }
                  if (data21.columnHeaderOverride !== undefined) {
                    if (typeof data21.columnHeaderOverride !== "string") {
                      const err233 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/columnHeaderOverride",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/4/properties/columnHeaderOverride/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err233];
                      } else {
                        vErrors.push(err233);
                      }
                      errors++;
                    }
                  }
                  if (data21.disabled !== undefined) {
                    if (typeof data21.disabled !== "boolean") {
                      const err234 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/disabled",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/4/properties/disabled/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err234];
                      } else {
                        vErrors.push(err234);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnCreate !== undefined) {
                    let data119 = data21.viewOnCreate;
                    if (Array.isArray(data119)) {
                      const len21 = data119.length;
                      for (let i21 = 0; i21 < len21; i21++) {
                        if (typeof data119[i21] !== "string") {
                          const err235 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnCreate/" +
                              i21,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/4/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err235];
                          } else {
                            vErrors.push(err235);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err236 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnCreate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/4/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err236];
                      } else {
                        vErrors.push(err236);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnRetrieve !== undefined) {
                    let data121 = data21.viewOnRetrieve;
                    if (Array.isArray(data121)) {
                      if (data121.length < 1) {
                        const err237 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/4/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err237];
                        } else {
                          vErrors.push(err237);
                        }
                        errors++;
                      }
                      const len22 = data121.length;
                      for (let i22 = 0; i22 < len22; i22++) {
                        let data122 = data121[i22];
                        if (typeof data122 !== "string") {
                          const err238 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i22,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/4/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err238];
                          } else {
                            vErrors.push(err238);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data122 === "manager" ||
                            data122 === "member" ||
                            data122 === "creator" ||
                            data122 === "view_only" ||
                            data122 === "admin" ||
                            data122 === "guest" ||
                            data122 === "publicUser"
                          )
                        ) {
                          const err239 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i22,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/4/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[4]
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err239];
                          } else {
                            vErrors.push(err239);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err240 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/4/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err240];
                      } else {
                        vErrors.push(err240);
                      }
                      errors++;
                    }
                  }
                  if (data21.canUpdate !== undefined) {
                    let data123 = data21.canUpdate;
                    if (Array.isArray(data123)) {
                      const len23 = data123.length;
                      for (let i23 = 0; i23 < len23; i23++) {
                        if (typeof data123[i23] !== "string") {
                          const err241 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/canUpdate/" +
                              i23,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/4/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err241];
                          } else {
                            vErrors.push(err241);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err242 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/canUpdate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/4/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err242];
                      } else {
                        vErrors.push(err242);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err243 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/4/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err243];
                  } else {
                    vErrors.push(err243);
                  }
                  errors++;
                }
              } else if (tag1 === "text") {
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.name === undefined) {
                    const err244 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/5/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err244];
                    } else {
                      vErrors.push(err244);
                    }
                    errors++;
                  }
                  if (data21.required === undefined) {
                    const err245 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/5/required",
                      keyword: "required",
                      params: { missingProperty: "required" },
                      message:
                        "must have required property '" + "required" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err245];
                    } else {
                      vErrors.push(err245);
                    }
                    errors++;
                  }
                  if (data21.inputType === undefined) {
                    const err246 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/5/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err246];
                    } else {
                      vErrors.push(err246);
                    }
                    errors++;
                  }
                  if (data21.type === undefined) {
                    const err247 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/5/required",
                      keyword: "required",
                      params: { missingProperty: "type" },
                      message: "must have required property '" + "type" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err247];
                    } else {
                      vErrors.push(err247);
                    }
                    errors++;
                  }
                  if (data21.placeholder === undefined) {
                    const err248 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/5/required",
                      keyword: "required",
                      params: { missingProperty: "placeholder" },
                      message:
                        "must have required property '" + "placeholder" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err248];
                    } else {
                      vErrors.push(err248);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err249 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/5/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err249];
                    } else {
                      vErrors.push(err249);
                    }
                    errors++;
                  }
                  for (const key9 in data21) {
                    if (
                      !func2.call(
                        schema27.properties.inputs.items.oneOf[5].properties,
                        key9,
                      )
                    ) {
                      const err250 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key9 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err250];
                      } else {
                        vErrors.push(err250);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err251 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err251];
                      } else {
                        vErrors.push(err251);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err252 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err252];
                      } else {
                        vErrors.push(err252);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data127 = data21.inputType;
                    if (typeof data127 !== "string") {
                      const err253 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err253];
                      } else {
                        vErrors.push(err253);
                      }
                      errors++;
                    }
                    if (!(data127 === "text")) {
                      const err254 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[5].properties
                              .inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err254];
                      } else {
                        vErrors.push(err254);
                      }
                      errors++;
                    }
                  }
                  if (data21.type !== undefined) {
                    let data128 = data21.type;
                    if (typeof data128 !== "string") {
                      const err255 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/type/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err255];
                      } else {
                        vErrors.push(err255);
                      }
                      errors++;
                    }
                    if (!(data128 === "string")) {
                      const err256 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/type/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[5].properties
                              .type.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err256];
                      } else {
                        vErrors.push(err256);
                      }
                      errors++;
                    }
                  }
                  if (data21.placeholder !== undefined) {
                    if (typeof data21.placeholder !== "string") {
                      const err257 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/placeholder",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/placeholder/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err257];
                      } else {
                        vErrors.push(err257);
                      }
                      errors++;
                    }
                  }
                  if (data21.tooltipText !== undefined) {
                    if (typeof data21.tooltipText !== "string") {
                      const err258 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/tooltipText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/tooltipText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err258];
                      } else {
                        vErrors.push(err258);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    let data131 = data21.title;
                    if (typeof data131 === "string") {
                      if (func3(data131) < 1) {
                        const err259 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/title",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/5/properties/title/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err259];
                        } else {
                          vErrors.push(err259);
                        }
                        errors++;
                      }
                    } else {
                      const err260 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err260];
                      } else {
                        vErrors.push(err260);
                      }
                      errors++;
                    }
                  }
                  if (data21.defaultValuePath !== undefined) {
                    let data132 = data21.defaultValuePath;
                    if (typeof data132 !== "string") {
                      const err261 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValuePath",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/defaultValuePath/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err261];
                      } else {
                        vErrors.push(err261);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data132 === "property.sisd.adjustmentRatio" ||
                        data132 === "property.sisd.defaultExclude" ||
                        data132 === "property.improvementValue" ||
                        data132 === "property.sisd.costType" ||
                        data132 === "property.latitude" ||
                        data132 === "property.longitude" ||
                        data132 === "parcel.mailingAddress1" ||
                        data132 === "parcel.mailingAddress2" ||
                        data132 === "parcel.mailingAddress" ||
                        data132 === "parcel.parcelId" ||
                        data132 === "parcel.improvementValue" ||
                        data132 === "parcel.block" ||
                        data132 === "parcel.lot" ||
                        data132 === "parcel.ownerName" ||
                        data132 === "user.firstName" ||
                        data132 === "user.lastName" ||
                        data132 === "user.fullName" ||
                        data132 === "units.feet" ||
                        data132 === "units.inches" ||
                        data132 === "units.hours" ||
                        data132 === "units.minutes" ||
                        data132 === "units.days" ||
                        data132 === "boolean.true" ||
                        data132 === "boolean.false" ||
                        data132 === "date.today"
                      )
                    ) {
                      const err262 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValuePath",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/defaultValuePath/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[5].properties
                              .defaultValuePath.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err262];
                      } else {
                        vErrors.push(err262);
                      }
                      errors++;
                    }
                  }
                  if (data21.defaultValue !== undefined) {
                    if (typeof data21.defaultValue !== "string") {
                      const err263 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValue",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/defaultValue/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err263];
                      } else {
                        vErrors.push(err263);
                      }
                      errors++;
                    }
                  }
                  if (data21.labelSize !== undefined) {
                    let data134 = data21.labelSize;
                    if (typeof data134 !== "string") {
                      const err264 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/labelSize",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/labelSize/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err264];
                      } else {
                        vErrors.push(err264);
                      }
                      errors++;
                    }
                    if (!(data134 === "small" || data134 === "medium")) {
                      const err265 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/labelSize",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/labelSize/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[5].properties
                              .labelSize.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err265];
                      } else {
                        vErrors.push(err265);
                      }
                      errors++;
                    }
                  }
                  if (data21.columnHeaderOverride !== undefined) {
                    if (typeof data21.columnHeaderOverride !== "string") {
                      const err266 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/columnHeaderOverride",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/columnHeaderOverride/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err266];
                      } else {
                        vErrors.push(err266);
                      }
                      errors++;
                    }
                  }
                  if (data21.disabled !== undefined) {
                    if (typeof data21.disabled !== "boolean") {
                      const err267 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/disabled",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/disabled/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err267];
                      } else {
                        vErrors.push(err267);
                      }
                      errors++;
                    }
                  }
                  if (data21.helperText !== undefined) {
                    if (typeof data21.helperText !== "string") {
                      const err268 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/helperText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/helperText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err268];
                      } else {
                        vErrors.push(err268);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnCreate !== undefined) {
                    let data138 = data21.viewOnCreate;
                    if (Array.isArray(data138)) {
                      const len24 = data138.length;
                      for (let i24 = 0; i24 < len24; i24++) {
                        if (typeof data138[i24] !== "string") {
                          const err269 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnCreate/" +
                              i24,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/5/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err269];
                          } else {
                            vErrors.push(err269);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err270 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnCreate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err270];
                      } else {
                        vErrors.push(err270);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnRetrieve !== undefined) {
                    let data140 = data21.viewOnRetrieve;
                    if (Array.isArray(data140)) {
                      if (data140.length < 1) {
                        const err271 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/5/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err271];
                        } else {
                          vErrors.push(err271);
                        }
                        errors++;
                      }
                      const len25 = data140.length;
                      for (let i25 = 0; i25 < len25; i25++) {
                        let data141 = data140[i25];
                        if (typeof data141 !== "string") {
                          const err272 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i25,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/5/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err272];
                          } else {
                            vErrors.push(err272);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data141 === "manager" ||
                            data141 === "member" ||
                            data141 === "creator" ||
                            data141 === "view_only" ||
                            data141 === "admin" ||
                            data141 === "guest" ||
                            data141 === "publicUser"
                          )
                        ) {
                          const err273 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i25,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/5/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[5]
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err273];
                          } else {
                            vErrors.push(err273);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err274 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err274];
                      } else {
                        vErrors.push(err274);
                      }
                      errors++;
                    }
                  }
                  if (data21.canUpdate !== undefined) {
                    let data142 = data21.canUpdate;
                    if (Array.isArray(data142)) {
                      const len26 = data142.length;
                      for (let i26 = 0; i26 < len26; i26++) {
                        if (typeof data142[i26] !== "string") {
                          const err275 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/canUpdate/" +
                              i26,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/5/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err275];
                          } else {
                            vErrors.push(err275);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err276 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/canUpdate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err276];
                      } else {
                        vErrors.push(err276);
                      }
                      errors++;
                    }
                  }
                  if (data21.uniqueIdentifier !== undefined) {
                    if (typeof data21.uniqueIdentifier !== "string") {
                      const err277 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/uniqueIdentifier",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/uniqueIdentifier/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err277];
                      } else {
                        vErrors.push(err277);
                      }
                      errors++;
                    }
                  }
                  if (data21.formula !== undefined) {
                    let data145 = data21.formula;
                    if (
                      data145 &&
                      typeof data145 == "object" &&
                      !Array.isArray(data145)
                    ) {
                      if (data145.name === undefined) {
                        const err278 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/5/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "name" },
                          message:
                            "must have required property '" + "name" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err278];
                        } else {
                          vErrors.push(err278);
                        }
                        errors++;
                      }
                      if (data145.applies === undefined) {
                        const err279 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/5/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "applies" },
                          message:
                            "must have required property '" + "applies" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err279];
                        } else {
                          vErrors.push(err279);
                        }
                        errors++;
                      }
                      if (data145.logic === undefined) {
                        const err280 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/5/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "logic" },
                          message:
                            "must have required property '" + "logic" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err280];
                        } else {
                          vErrors.push(err280);
                        }
                        errors++;
                      }
                      for (const key10 in data145) {
                        if (
                          !(
                            key10 === "name" ||
                            key10 === "applies" ||
                            key10 === "logic"
                          )
                        ) {
                          const err281 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/5/properties/formula/additionalProperties",
                            keyword: "additionalProperties",
                            params: { additionalProperty: key10 },
                            message: "must NOT have additional properties",
                          };
                          if (vErrors === null) {
                            vErrors = [err281];
                          } else {
                            vErrors.push(err281);
                          }
                          errors++;
                        }
                      }
                      if (data145.name !== undefined) {
                        if (typeof data145.name !== "string") {
                          const err282 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula/name",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/5/properties/formula/properties/name/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err282];
                          } else {
                            vErrors.push(err282);
                          }
                          errors++;
                        }
                      }
                      if (data145.applies !== undefined) {
                        let data147 = data145.applies;
                        if (
                          !(
                            data147 &&
                            typeof data147 == "object" &&
                            !Array.isArray(data147)
                          ) &&
                          typeof data147 !== "boolean"
                        ) {
                          const err283 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/formula/applies",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/5/properties/formula/properties/applies/type",
                            keyword: "type",
                            params: {
                              type: schema27.properties.inputs.items.oneOf[5]
                                .properties.formula.properties.applies.type,
                            },
                            message: "must be object,boolean",
                          };
                          if (vErrors === null) {
                            vErrors = [err283];
                          } else {
                            vErrors.push(err283);
                          }
                          errors++;
                        }
                      }
                      if (data145.logic !== undefined) {
                        let data148 = data145.logic;
                        if (
                          data148 &&
                          typeof data148 == "object" &&
                          !Array.isArray(data148)
                        ) {
                        } else {
                          const err284 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula/logic",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/5/properties/formula/properties/logic/type",
                            keyword: "type",
                            params: { type: "object" },
                            message: "must be object",
                          };
                          if (vErrors === null) {
                            vErrors = [err284];
                          } else {
                            vErrors.push(err284);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err285 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/formula",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/5/properties/formula/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err285];
                      } else {
                        vErrors.push(err285);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err286 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/5/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err286];
                  } else {
                    vErrors.push(err286);
                  }
                  errors++;
                }
              } else if (tag1 === "textarea") {
                const _errs342 = errors;
                let valid83 = true;
                const _errs343 = errors;
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.required !== undefined) {
                    if (true !== data21.required) {
                      const err287 = {};
                      if (vErrors === null) {
                        vErrors = [err287];
                      } else {
                        vErrors.push(err287);
                      }
                      errors++;
                    }
                  }
                }
                var _valid2 = _errs343 === errors;
                errors = _errs342;
                if (vErrors !== null) {
                  if (_errs342) {
                    vErrors.length = _errs342;
                  } else {
                    vErrors = null;
                  }
                }
                if (_valid2) {
                  const _errs345 = errors;
                  if (
                    data21 &&
                    typeof data21 == "object" &&
                    !Array.isArray(data21)
                  ) {
                    if (data21.useGenerativeAI !== undefined) {
                      if (!(data21.useGenerativeAI === false)) {
                        const err288 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/useGenerativeAI",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/6/allOf/0/then/properties/useGenerativeAI/enum",
                          keyword: "enum",
                          params: {
                            allowedValues:
                              schema27.properties.inputs.items.oneOf[6].allOf[0]
                                .then.properties.useGenerativeAI.enum,
                          },
                          message: "must be equal to one of the allowed values",
                        };
                        if (vErrors === null) {
                          vErrors = [err288];
                        } else {
                          vErrors.push(err288);
                        }
                        errors++;
                      }
                    }
                  }
                  var _valid2 = _errs345 === errors;
                  valid83 = _valid2;
                }
                if (!valid83) {
                  const err289 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/6/allOf/0/if",
                    keyword: "if",
                    params: { failingKeyword: "then" },
                    message: 'must match "then" schema',
                  };
                  if (vErrors === null) {
                    vErrors = [err289];
                  } else {
                    vErrors.push(err289);
                  }
                  errors++;
                }
                const _errs348 = errors;
                let valid86 = true;
                const _errs349 = errors;
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.useGenerativeAI !== undefined) {
                    if (true !== data21.useGenerativeAI) {
                      const err290 = {};
                      if (vErrors === null) {
                        vErrors = [err290];
                      } else {
                        vErrors.push(err290);
                      }
                      errors++;
                    }
                  }
                }
                var _valid3 = _errs349 === errors;
                errors = _errs348;
                if (vErrors !== null) {
                  if (_errs348) {
                    vErrors.length = _errs348;
                  } else {
                    vErrors = null;
                  }
                }
                if (_valid3) {
                  const _errs351 = errors;
                  if (
                    data21 &&
                    typeof data21 == "object" &&
                    !Array.isArray(data21)
                  ) {
                    if (data21.generativeAIPrompt !== undefined) {
                      let data152 = data21.generativeAIPrompt;
                      if (typeof data152 === "string") {
                        if (func3(data152) < 1) {
                          const err291 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/generativeAIPrompt",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/6/allOf/1/then/properties/generativeAIPrompt/minLength",
                            keyword: "minLength",
                            params: { limit: 1 },
                            message: "must NOT have fewer than 1 characters",
                          };
                          if (vErrors === null) {
                            vErrors = [err291];
                          } else {
                            vErrors.push(err291);
                          }
                          errors++;
                        }
                      } else {
                        const err292 = {
                          instancePath:
                            instancePath +
                            "/inputs/" +
                            i5 +
                            "/generativeAIPrompt",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/6/allOf/1/then/properties/generativeAIPrompt/type",
                          keyword: "type",
                          params: { type: "string" },
                          message: "must be string",
                        };
                        if (vErrors === null) {
                          vErrors = [err292];
                        } else {
                          vErrors.push(err292);
                        }
                        errors++;
                      }
                    }
                  }
                  var _valid3 = _errs351 === errors;
                  valid86 = _valid3;
                }
                if (!valid86) {
                  const err293 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/6/allOf/1/if",
                    keyword: "if",
                    params: { failingKeyword: "then" },
                    message: 'must match "then" schema',
                  };
                  if (vErrors === null) {
                    vErrors = [err293];
                  } else {
                    vErrors.push(err293);
                  }
                  errors++;
                }
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.name === undefined) {
                    const err294 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/6/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err294];
                    } else {
                      vErrors.push(err294);
                    }
                    errors++;
                  }
                  if (data21.required === undefined) {
                    const err295 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/6/required",
                      keyword: "required",
                      params: { missingProperty: "required" },
                      message:
                        "must have required property '" + "required" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err295];
                    } else {
                      vErrors.push(err295);
                    }
                    errors++;
                  }
                  if (data21.inputType === undefined) {
                    const err296 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/6/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err296];
                    } else {
                      vErrors.push(err296);
                    }
                    errors++;
                  }
                  if (data21.type === undefined) {
                    const err297 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/6/required",
                      keyword: "required",
                      params: { missingProperty: "type" },
                      message: "must have required property '" + "type" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err297];
                    } else {
                      vErrors.push(err297);
                    }
                    errors++;
                  }
                  if (data21.placeholder === undefined) {
                    const err298 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/6/required",
                      keyword: "required",
                      params: { missingProperty: "placeholder" },
                      message:
                        "must have required property '" + "placeholder" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err298];
                    } else {
                      vErrors.push(err298);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err299 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/6/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err299];
                    } else {
                      vErrors.push(err299);
                    }
                    errors++;
                  }
                  for (const key11 in data21) {
                    if (
                      !func2.call(
                        schema27.properties.inputs.items.oneOf[6].properties,
                        key11,
                      )
                    ) {
                      const err300 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key11 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err300];
                      } else {
                        vErrors.push(err300);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err301 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err301];
                      } else {
                        vErrors.push(err301);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err302 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err302];
                      } else {
                        vErrors.push(err302);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data155 = data21.inputType;
                    if (typeof data155 !== "string") {
                      const err303 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err303];
                      } else {
                        vErrors.push(err303);
                      }
                      errors++;
                    }
                    if (!(data155 === "textarea")) {
                      const err304 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[6].properties
                              .inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err304];
                      } else {
                        vErrors.push(err304);
                      }
                      errors++;
                    }
                  }
                  if (data21.type !== undefined) {
                    let data156 = data21.type;
                    if (typeof data156 !== "string") {
                      const err305 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/type/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err305];
                      } else {
                        vErrors.push(err305);
                      }
                      errors++;
                    }
                    if (!(data156 === "string")) {
                      const err306 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/type/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[6].properties
                              .type.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err306];
                      } else {
                        vErrors.push(err306);
                      }
                      errors++;
                    }
                  }
                  if (data21.placeholder !== undefined) {
                    if (typeof data21.placeholder !== "string") {
                      const err307 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/placeholder",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/placeholder/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err307];
                      } else {
                        vErrors.push(err307);
                      }
                      errors++;
                    }
                  }
                  if (data21.tooltipText !== undefined) {
                    if (typeof data21.tooltipText !== "string") {
                      const err308 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/tooltipText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/tooltipText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err308];
                      } else {
                        vErrors.push(err308);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    let data159 = data21.title;
                    if (typeof data159 === "string") {
                      if (func3(data159) < 1) {
                        const err309 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/title",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/6/properties/title/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err309];
                        } else {
                          vErrors.push(err309);
                        }
                        errors++;
                      }
                    } else {
                      const err310 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err310];
                      } else {
                        vErrors.push(err310);
                      }
                      errors++;
                    }
                  }
                  if (data21.defaultValuePath !== undefined) {
                    let data160 = data21.defaultValuePath;
                    if (typeof data160 !== "string") {
                      const err311 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValuePath",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/defaultValuePath/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err311];
                      } else {
                        vErrors.push(err311);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data160 === "property.sisd.adjustmentRatio" ||
                        data160 === "property.sisd.defaultExclude" ||
                        data160 === "property.improvementValue" ||
                        data160 === "property.sisd.costType" ||
                        data160 === "property.latitude" ||
                        data160 === "property.longitude" ||
                        data160 === "parcel.mailingAddress1" ||
                        data160 === "parcel.mailingAddress2" ||
                        data160 === "parcel.mailingAddress" ||
                        data160 === "parcel.parcelId" ||
                        data160 === "parcel.improvementValue" ||
                        data160 === "parcel.block" ||
                        data160 === "parcel.lot" ||
                        data160 === "parcel.ownerName" ||
                        data160 === "user.firstName" ||
                        data160 === "user.lastName" ||
                        data160 === "user.fullName" ||
                        data160 === "units.feet" ||
                        data160 === "units.inches" ||
                        data160 === "units.hours" ||
                        data160 === "units.minutes" ||
                        data160 === "units.days" ||
                        data160 === "boolean.true" ||
                        data160 === "boolean.false" ||
                        data160 === "date.today"
                      )
                    ) {
                      const err312 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValuePath",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/defaultValuePath/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[6].properties
                              .defaultValuePath.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err312];
                      } else {
                        vErrors.push(err312);
                      }
                      errors++;
                    }
                  }
                  if (data21.defaultValue !== undefined) {
                    if (typeof data21.defaultValue !== "string") {
                      const err313 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValue",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/defaultValue/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err313];
                      } else {
                        vErrors.push(err313);
                      }
                      errors++;
                    }
                  }
                  if (data21.generativeAIPrompt !== undefined) {
                    if (typeof data21.generativeAIPrompt !== "string") {
                      const err314 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/generativeAIPrompt",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/generativeAIPrompt/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err314];
                      } else {
                        vErrors.push(err314);
                      }
                      errors++;
                    }
                  }
                  if (data21.useGenerativeAI !== undefined) {
                    if (typeof data21.useGenerativeAI !== "boolean") {
                      const err315 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/useGenerativeAI",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/useGenerativeAI/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err315];
                      } else {
                        vErrors.push(err315);
                      }
                      errors++;
                    }
                  }
                  if (data21.columnHeaderOverride !== undefined) {
                    if (typeof data21.columnHeaderOverride !== "string") {
                      const err316 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/columnHeaderOverride",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/columnHeaderOverride/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err316];
                      } else {
                        vErrors.push(err316);
                      }
                      errors++;
                    }
                  }
                  if (data21.disabled !== undefined) {
                    if (typeof data21.disabled !== "boolean") {
                      const err317 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/disabled",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/disabled/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err317];
                      } else {
                        vErrors.push(err317);
                      }
                      errors++;
                    }
                  }
                  if (data21.helperText !== undefined) {
                    if (typeof data21.helperText !== "string") {
                      const err318 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/helperText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/helperText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err318];
                      } else {
                        vErrors.push(err318);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnCreate !== undefined) {
                    let data167 = data21.viewOnCreate;
                    if (Array.isArray(data167)) {
                      const len27 = data167.length;
                      for (let i27 = 0; i27 < len27; i27++) {
                        if (typeof data167[i27] !== "string") {
                          const err319 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnCreate/" +
                              i27,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/6/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err319];
                          } else {
                            vErrors.push(err319);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err320 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnCreate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err320];
                      } else {
                        vErrors.push(err320);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnRetrieve !== undefined) {
                    let data169 = data21.viewOnRetrieve;
                    if (Array.isArray(data169)) {
                      if (data169.length < 1) {
                        const err321 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/6/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err321];
                        } else {
                          vErrors.push(err321);
                        }
                        errors++;
                      }
                      const len28 = data169.length;
                      for (let i28 = 0; i28 < len28; i28++) {
                        let data170 = data169[i28];
                        if (typeof data170 !== "string") {
                          const err322 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i28,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/6/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err322];
                          } else {
                            vErrors.push(err322);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data170 === "manager" ||
                            data170 === "member" ||
                            data170 === "creator" ||
                            data170 === "view_only" ||
                            data170 === "admin" ||
                            data170 === "guest" ||
                            data170 === "publicUser"
                          )
                        ) {
                          const err323 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i28,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/6/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[6]
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err323];
                          } else {
                            vErrors.push(err323);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err324 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err324];
                      } else {
                        vErrors.push(err324);
                      }
                      errors++;
                    }
                  }
                  if (data21.canUpdate !== undefined) {
                    let data171 = data21.canUpdate;
                    if (Array.isArray(data171)) {
                      const len29 = data171.length;
                      for (let i29 = 0; i29 < len29; i29++) {
                        if (typeof data171[i29] !== "string") {
                          const err325 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/canUpdate/" +
                              i29,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/6/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err325];
                          } else {
                            vErrors.push(err325);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err326 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/canUpdate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err326];
                      } else {
                        vErrors.push(err326);
                      }
                      errors++;
                    }
                  }
                  if (data21.formula !== undefined) {
                    let data173 = data21.formula;
                    if (
                      data173 &&
                      typeof data173 == "object" &&
                      !Array.isArray(data173)
                    ) {
                      if (data173.name === undefined) {
                        const err327 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/6/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "name" },
                          message:
                            "must have required property '" + "name" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err327];
                        } else {
                          vErrors.push(err327);
                        }
                        errors++;
                      }
                      if (data173.applies === undefined) {
                        const err328 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/6/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "applies" },
                          message:
                            "must have required property '" + "applies" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err328];
                        } else {
                          vErrors.push(err328);
                        }
                        errors++;
                      }
                      if (data173.logic === undefined) {
                        const err329 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/6/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "logic" },
                          message:
                            "must have required property '" + "logic" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err329];
                        } else {
                          vErrors.push(err329);
                        }
                        errors++;
                      }
                      for (const key12 in data173) {
                        if (
                          !(
                            key12 === "name" ||
                            key12 === "applies" ||
                            key12 === "logic"
                          )
                        ) {
                          const err330 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/6/properties/formula/additionalProperties",
                            keyword: "additionalProperties",
                            params: { additionalProperty: key12 },
                            message: "must NOT have additional properties",
                          };
                          if (vErrors === null) {
                            vErrors = [err330];
                          } else {
                            vErrors.push(err330);
                          }
                          errors++;
                        }
                      }
                      if (data173.name !== undefined) {
                        if (typeof data173.name !== "string") {
                          const err331 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula/name",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/6/properties/formula/properties/name/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err331];
                          } else {
                            vErrors.push(err331);
                          }
                          errors++;
                        }
                      }
                      if (data173.applies !== undefined) {
                        let data175 = data173.applies;
                        if (
                          !(
                            data175 &&
                            typeof data175 == "object" &&
                            !Array.isArray(data175)
                          ) &&
                          typeof data175 !== "boolean"
                        ) {
                          const err332 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/formula/applies",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/6/properties/formula/properties/applies/type",
                            keyword: "type",
                            params: {
                              type: schema27.properties.inputs.items.oneOf[6]
                                .properties.formula.properties.applies.type,
                            },
                            message: "must be object,boolean",
                          };
                          if (vErrors === null) {
                            vErrors = [err332];
                          } else {
                            vErrors.push(err332);
                          }
                          errors++;
                        }
                      }
                      if (data173.logic !== undefined) {
                        let data176 = data173.logic;
                        if (
                          data176 &&
                          typeof data176 == "object" &&
                          !Array.isArray(data176)
                        ) {
                        } else {
                          const err333 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula/logic",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/6/properties/formula/properties/logic/type",
                            keyword: "type",
                            params: { type: "object" },
                            message: "must be object",
                          };
                          if (vErrors === null) {
                            vErrors = [err333];
                          } else {
                            vErrors.push(err333);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err334 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/formula",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/6/properties/formula/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err334];
                      } else {
                        vErrors.push(err334);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err335 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/6/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err335];
                  } else {
                    vErrors.push(err335);
                  }
                  errors++;
                }
              } else if (tag1 === "number") {
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.inputType === undefined) {
                    const err336 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/7/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err336];
                    } else {
                      vErrors.push(err336);
                    }
                    errors++;
                  }
                  if (data21.type === undefined) {
                    const err337 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/7/required",
                      keyword: "required",
                      params: { missingProperty: "type" },
                      message: "must have required property '" + "type" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err337];
                    } else {
                      vErrors.push(err337);
                    }
                    errors++;
                  }
                  if (data21.name === undefined) {
                    const err338 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/7/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err338];
                    } else {
                      vErrors.push(err338);
                    }
                    errors++;
                  }
                  if (data21.required === undefined) {
                    const err339 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/7/required",
                      keyword: "required",
                      params: { missingProperty: "required" },
                      message:
                        "must have required property '" + "required" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err339];
                    } else {
                      vErrors.push(err339);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err340 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/7/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err340];
                    } else {
                      vErrors.push(err340);
                    }
                    errors++;
                  }
                  for (const key13 in data21) {
                    if (
                      !func2.call(
                        schema27.properties.inputs.items.oneOf[7].properties,
                        key13,
                      )
                    ) {
                      const err341 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key13 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err341];
                      } else {
                        vErrors.push(err341);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data177 = data21.inputType;
                    if (typeof data177 !== "string") {
                      const err342 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err342];
                      } else {
                        vErrors.push(err342);
                      }
                      errors++;
                    }
                    if (!(data177 === "number")) {
                      const err343 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[7].properties
                              .inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err343];
                      } else {
                        vErrors.push(err343);
                      }
                      errors++;
                    }
                  }
                  if (data21.type !== undefined) {
                    let data178 = data21.type;
                    if (typeof data178 !== "string") {
                      const err344 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/type/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err344];
                      } else {
                        vErrors.push(err344);
                      }
                      errors++;
                    }
                    if (!(data178 === "number")) {
                      const err345 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/type/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[7].properties
                              .type.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err345];
                      } else {
                        vErrors.push(err345);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err346 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err346];
                      } else {
                        vErrors.push(err346);
                      }
                      errors++;
                    }
                  }
                  if (data21.placeholder !== undefined) {
                    if (typeof data21.placeholder !== "string") {
                      const err347 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/placeholder",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/placeholder/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err347];
                      } else {
                        vErrors.push(err347);
                      }
                      errors++;
                    }
                  }
                  if (data21.tooltipText !== undefined) {
                    if (typeof data21.tooltipText !== "string") {
                      const err348 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/tooltipText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/tooltipText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err348];
                      } else {
                        vErrors.push(err348);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err349 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err349];
                      } else {
                        vErrors.push(err349);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    let data183 = data21.title;
                    if (typeof data183 === "string") {
                      if (func3(data183) < 1) {
                        const err350 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/title",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/7/properties/title/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err350];
                        } else {
                          vErrors.push(err350);
                        }
                        errors++;
                      }
                    } else {
                      const err351 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err351];
                      } else {
                        vErrors.push(err351);
                      }
                      errors++;
                    }
                  }
                  if (data21.step !== undefined) {
                    let data184 = data21.step;
                    if (!(typeof data184 == "number" && isFinite(data184))) {
                      const err352 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/step",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/step/type",
                        keyword: "type",
                        params: { type: "number" },
                        message: "must be number",
                      };
                      if (vErrors === null) {
                        vErrors = [err352];
                      } else {
                        vErrors.push(err352);
                      }
                      errors++;
                    }
                  }
                  if (data21.minimum !== undefined) {
                    let data185 = data21.minimum;
                    if (typeof data185 == "number" && isFinite(data185)) {
                      const vSchema30 = data21 && data21.maximum;
                      if (
                        vSchema30 !== undefined &&
                        (!(
                          typeof vSchema30 == "number" && isFinite(vSchema30)
                        ) ||
                          data185 >= vSchema30 ||
                          isNaN(data185))
                      ) {
                        const err353 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/minimum",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/7/properties/minimum/exclusiveMaximum",
                          keyword: "exclusiveMaximum",
                          params: { comparison: "<", limit: vSchema30 },
                          message: "must be < " + vSchema30,
                        };
                        if (vErrors === null) {
                          vErrors = [err353];
                        } else {
                          vErrors.push(err353);
                        }
                        errors++;
                      }
                    } else {
                      const err354 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/minimum",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/minimum/type",
                        keyword: "type",
                        params: { type: "number" },
                        message: "must be number",
                      };
                      if (vErrors === null) {
                        vErrors = [err354];
                      } else {
                        vErrors.push(err354);
                      }
                      errors++;
                    }
                  }
                  if (data21.maximum !== undefined) {
                    let data186 = data21.maximum;
                    if (typeof data186 == "number" && isFinite(data186)) {
                      const vSchema31 = data21 && data21.minimum;
                      if (
                        vSchema31 !== undefined &&
                        (!(
                          typeof vSchema31 == "number" && isFinite(vSchema31)
                        ) ||
                          data186 <= vSchema31 ||
                          isNaN(data186))
                      ) {
                        const err355 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/maximum",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/7/properties/maximum/exclusiveMinimum",
                          keyword: "exclusiveMinimum",
                          params: { comparison: ">", limit: vSchema31 },
                          message: "must be > " + vSchema31,
                        };
                        if (vErrors === null) {
                          vErrors = [err355];
                        } else {
                          vErrors.push(err355);
                        }
                        errors++;
                      }
                    } else {
                      const err356 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/maximum",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/maximum/type",
                        keyword: "type",
                        params: { type: "number" },
                        message: "must be number",
                      };
                      if (vErrors === null) {
                        vErrors = [err356];
                      } else {
                        vErrors.push(err356);
                      }
                      errors++;
                    }
                  }
                  if (data21.prefix !== undefined) {
                    if (typeof data21.prefix !== "string") {
                      const err357 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/prefix",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/prefix/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err357];
                      } else {
                        vErrors.push(err357);
                      }
                      errors++;
                    }
                  }
                  if (data21.postfix !== undefined) {
                    if (typeof data21.postfix !== "string") {
                      const err358 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/postfix",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/postfix/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err358];
                      } else {
                        vErrors.push(err358);
                      }
                      errors++;
                    }
                  }
                  if (data21.defaultValuePath !== undefined) {
                    let data189 = data21.defaultValuePath;
                    if (typeof data189 !== "string") {
                      const err359 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValuePath",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/defaultValuePath/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err359];
                      } else {
                        vErrors.push(err359);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data189 === "property.sisd.adjustmentRatio" ||
                        data189 === "property.sisd.defaultExclude" ||
                        data189 === "property.improvementValue" ||
                        data189 === "property.sisd.costType" ||
                        data189 === "property.latitude" ||
                        data189 === "property.longitude" ||
                        data189 === "parcel.mailingAddress1" ||
                        data189 === "parcel.mailingAddress2" ||
                        data189 === "parcel.mailingAddress" ||
                        data189 === "parcel.parcelId" ||
                        data189 === "parcel.improvementValue" ||
                        data189 === "parcel.block" ||
                        data189 === "parcel.lot" ||
                        data189 === "parcel.ownerName" ||
                        data189 === "user.firstName" ||
                        data189 === "user.lastName" ||
                        data189 === "user.fullName" ||
                        data189 === "units.feet" ||
                        data189 === "units.inches" ||
                        data189 === "units.hours" ||
                        data189 === "units.minutes" ||
                        data189 === "units.days" ||
                        data189 === "boolean.true" ||
                        data189 === "boolean.false" ||
                        data189 === "date.today"
                      )
                    ) {
                      const err360 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValuePath",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/defaultValuePath/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[7].properties
                              .defaultValuePath.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err360];
                      } else {
                        vErrors.push(err360);
                      }
                      errors++;
                    }
                  }
                  if (data21.defaultValue !== undefined) {
                    let data190 = data21.defaultValue;
                    if (typeof data190 == "number" && isFinite(data190)) {
                      const vSchema33 = data21 && data21.maximum;
                      if (
                        vSchema33 !== undefined &&
                        (!(
                          typeof vSchema33 == "number" && isFinite(vSchema33)
                        ) ||
                          data190 > vSchema33 ||
                          isNaN(data190))
                      ) {
                        const err361 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/defaultValue",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/7/properties/defaultValue/maximum",
                          keyword: "maximum",
                          params: { comparison: "<=", limit: vSchema33 },
                          message: "must be <= " + vSchema33,
                        };
                        if (vErrors === null) {
                          vErrors = [err361];
                        } else {
                          vErrors.push(err361);
                        }
                        errors++;
                      }
                      const vSchema34 = data21 && data21.minimum;
                      if (
                        vSchema34 !== undefined &&
                        (!(
                          typeof vSchema34 == "number" && isFinite(vSchema34)
                        ) ||
                          data190 < vSchema34 ||
                          isNaN(data190))
                      ) {
                        const err362 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/defaultValue",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/7/properties/defaultValue/minimum",
                          keyword: "minimum",
                          params: { comparison: ">=", limit: vSchema34 },
                          message: "must be >= " + vSchema34,
                        };
                        if (vErrors === null) {
                          vErrors = [err362];
                        } else {
                          vErrors.push(err362);
                        }
                        errors++;
                      }
                    } else {
                      const err363 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValue",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/defaultValue/type",
                        keyword: "type",
                        params: { type: "number" },
                        message: "must be number",
                      };
                      if (vErrors === null) {
                        vErrors = [err363];
                      } else {
                        vErrors.push(err363);
                      }
                      errors++;
                    }
                  }
                  if (data21.labelSize !== undefined) {
                    let data191 = data21.labelSize;
                    if (typeof data191 !== "string") {
                      const err364 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/labelSize",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/labelSize/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err364];
                      } else {
                        vErrors.push(err364);
                      }
                      errors++;
                    }
                    if (!(data191 === "small" || data191 === "medium")) {
                      const err365 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/labelSize",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/labelSize/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[7].properties
                              .labelSize.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err365];
                      } else {
                        vErrors.push(err365);
                      }
                      errors++;
                    }
                  }
                  if (data21.columnHeaderOverride !== undefined) {
                    if (typeof data21.columnHeaderOverride !== "string") {
                      const err366 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/columnHeaderOverride",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/columnHeaderOverride/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err366];
                      } else {
                        vErrors.push(err366);
                      }
                      errors++;
                    }
                  }
                  if (data21.disabled !== undefined) {
                    if (typeof data21.disabled !== "boolean") {
                      const err367 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/disabled",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/disabled/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err367];
                      } else {
                        vErrors.push(err367);
                      }
                      errors++;
                    }
                  }
                  if (data21.helperText !== undefined) {
                    if (typeof data21.helperText !== "string") {
                      const err368 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/helperText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/helperText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err368];
                      } else {
                        vErrors.push(err368);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnCreate !== undefined) {
                    let data195 = data21.viewOnCreate;
                    if (Array.isArray(data195)) {
                      const len30 = data195.length;
                      for (let i30 = 0; i30 < len30; i30++) {
                        if (typeof data195[i30] !== "string") {
                          const err369 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnCreate/" +
                              i30,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/7/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err369];
                          } else {
                            vErrors.push(err369);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err370 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnCreate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err370];
                      } else {
                        vErrors.push(err370);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnRetrieve !== undefined) {
                    let data197 = data21.viewOnRetrieve;
                    if (Array.isArray(data197)) {
                      if (data197.length < 1) {
                        const err371 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/7/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err371];
                        } else {
                          vErrors.push(err371);
                        }
                        errors++;
                      }
                      const len31 = data197.length;
                      for (let i31 = 0; i31 < len31; i31++) {
                        let data198 = data197[i31];
                        if (typeof data198 !== "string") {
                          const err372 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i31,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/7/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err372];
                          } else {
                            vErrors.push(err372);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data198 === "manager" ||
                            data198 === "member" ||
                            data198 === "creator" ||
                            data198 === "view_only" ||
                            data198 === "admin" ||
                            data198 === "guest" ||
                            data198 === "publicUser"
                          )
                        ) {
                          const err373 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i31,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/7/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[7]
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err373];
                          } else {
                            vErrors.push(err373);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err374 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err374];
                      } else {
                        vErrors.push(err374);
                      }
                      errors++;
                    }
                  }
                  if (data21.canUpdate !== undefined) {
                    let data199 = data21.canUpdate;
                    if (Array.isArray(data199)) {
                      const len32 = data199.length;
                      for (let i32 = 0; i32 < len32; i32++) {
                        if (typeof data199[i32] !== "string") {
                          const err375 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/canUpdate/" +
                              i32,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/7/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err375];
                          } else {
                            vErrors.push(err375);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err376 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/canUpdate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err376];
                      } else {
                        vErrors.push(err376);
                      }
                      errors++;
                    }
                  }
                  if (data21.formula !== undefined) {
                    let data201 = data21.formula;
                    if (
                      data201 &&
                      typeof data201 == "object" &&
                      !Array.isArray(data201)
                    ) {
                      if (data201.name === undefined) {
                        const err377 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/7/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "name" },
                          message:
                            "must have required property '" + "name" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err377];
                        } else {
                          vErrors.push(err377);
                        }
                        errors++;
                      }
                      if (data201.applies === undefined) {
                        const err378 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/7/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "applies" },
                          message:
                            "must have required property '" + "applies" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err378];
                        } else {
                          vErrors.push(err378);
                        }
                        errors++;
                      }
                      if (data201.logic === undefined) {
                        const err379 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/7/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "logic" },
                          message:
                            "must have required property '" + "logic" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err379];
                        } else {
                          vErrors.push(err379);
                        }
                        errors++;
                      }
                      for (const key14 in data201) {
                        if (
                          !(
                            key14 === "name" ||
                            key14 === "applies" ||
                            key14 === "logic"
                          )
                        ) {
                          const err380 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/7/properties/formula/additionalProperties",
                            keyword: "additionalProperties",
                            params: { additionalProperty: key14 },
                            message: "must NOT have additional properties",
                          };
                          if (vErrors === null) {
                            vErrors = [err380];
                          } else {
                            vErrors.push(err380);
                          }
                          errors++;
                        }
                      }
                      if (data201.name !== undefined) {
                        if (typeof data201.name !== "string") {
                          const err381 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula/name",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/7/properties/formula/properties/name/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err381];
                          } else {
                            vErrors.push(err381);
                          }
                          errors++;
                        }
                      }
                      if (data201.applies !== undefined) {
                        let data203 = data201.applies;
                        if (
                          !(
                            data203 &&
                            typeof data203 == "object" &&
                            !Array.isArray(data203)
                          ) &&
                          typeof data203 !== "boolean"
                        ) {
                          const err382 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/formula/applies",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/7/properties/formula/properties/applies/type",
                            keyword: "type",
                            params: {
                              type: schema27.properties.inputs.items.oneOf[7]
                                .properties.formula.properties.applies.type,
                            },
                            message: "must be object,boolean",
                          };
                          if (vErrors === null) {
                            vErrors = [err382];
                          } else {
                            vErrors.push(err382);
                          }
                          errors++;
                        }
                      }
                      if (data201.logic !== undefined) {
                        let data204 = data201.logic;
                        if (
                          data204 &&
                          typeof data204 == "object" &&
                          !Array.isArray(data204)
                        ) {
                        } else {
                          const err383 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula/logic",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/7/properties/formula/properties/logic/type",
                            keyword: "type",
                            params: { type: "object" },
                            message: "must be object",
                          };
                          if (vErrors === null) {
                            vErrors = [err383];
                          } else {
                            vErrors.push(err383);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err384 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/formula",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/formula/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err384];
                      } else {
                        vErrors.push(err384);
                      }
                      errors++;
                    }
                  }
                  if (data21.prefixPostfix !== undefined) {
                    let data205 = data21.prefixPostfix;
                    if (
                      data205 &&
                      typeof data205 == "object" &&
                      !Array.isArray(data205)
                    ) {
                      if (data205.label !== undefined) {
                        let data206 = data205.label;
                        if (typeof data206 === "string") {
                          if (func3(data206) < 1) {
                            const err385 = {
                              instancePath:
                                instancePath +
                                "/inputs/" +
                                i5 +
                                "/prefixPostfix/label",
                              schemaPath:
                                "#/properties/inputs/items/oneOf/7/properties/prefixPostfix/properties/label/minLength",
                              keyword: "minLength",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 characters",
                            };
                            if (vErrors === null) {
                              vErrors = [err385];
                            } else {
                              vErrors.push(err385);
                            }
                            errors++;
                          }
                        } else {
                          const err386 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/prefixPostfix/label",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/7/properties/prefixPostfix/properties/label/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err386];
                          } else {
                            vErrors.push(err386);
                          }
                          errors++;
                        }
                      }
                      if (data205.value !== undefined) {
                        let data207 = data205.value;
                        if (typeof data207 === "string") {
                          if (func3(data207) < 1) {
                            const err387 = {
                              instancePath:
                                instancePath +
                                "/inputs/" +
                                i5 +
                                "/prefixPostfix/value",
                              schemaPath:
                                "#/properties/inputs/items/oneOf/7/properties/prefixPostfix/properties/value/minLength",
                              keyword: "minLength",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 characters",
                            };
                            if (vErrors === null) {
                              vErrors = [err387];
                            } else {
                              vErrors.push(err387);
                            }
                            errors++;
                          }
                        } else {
                          const err388 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/prefixPostfix/value",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/7/properties/prefixPostfix/properties/value/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err388];
                          } else {
                            vErrors.push(err388);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err389 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/prefixPostfix",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/7/properties/prefixPostfix/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err389];
                      } else {
                        vErrors.push(err389);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err390 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/7/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err390];
                  } else {
                    vErrors.push(err390);
                  }
                  errors++;
                }
              } else if (tag1 === "checkbox") {
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.name === undefined) {
                    const err391 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/8/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err391];
                    } else {
                      vErrors.push(err391);
                    }
                    errors++;
                  }
                  if (data21.required === undefined) {
                    const err392 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/8/required",
                      keyword: "required",
                      params: { missingProperty: "required" },
                      message:
                        "must have required property '" + "required" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err392];
                    } else {
                      vErrors.push(err392);
                    }
                    errors++;
                  }
                  if (data21.type === undefined) {
                    const err393 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/8/required",
                      keyword: "required",
                      params: { missingProperty: "type" },
                      message: "must have required property '" + "type" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err393];
                    } else {
                      vErrors.push(err393);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err394 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/8/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err394];
                    } else {
                      vErrors.push(err394);
                    }
                    errors++;
                  }
                  if (data21.inputType === undefined) {
                    const err395 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/8/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err395];
                    } else {
                      vErrors.push(err395);
                    }
                    errors++;
                  }
                  if (data21.checkboxText === undefined) {
                    const err396 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/8/required",
                      keyword: "required",
                      params: { missingProperty: "checkboxText" },
                      message:
                        "must have required property '" + "checkboxText" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err396];
                    } else {
                      vErrors.push(err396);
                    }
                    errors++;
                  }
                  for (const key15 in data21) {
                    if (
                      !func2.call(
                        schema27.properties.inputs.items.oneOf[8].properties,
                        key15,
                      )
                    ) {
                      const err397 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key15 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err397];
                      } else {
                        vErrors.push(err397);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err398 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err398];
                      } else {
                        vErrors.push(err398);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err399 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err399];
                      } else {
                        vErrors.push(err399);
                      }
                      errors++;
                    }
                  }
                  if (data21.type !== undefined) {
                    let data210 = data21.type;
                    if (typeof data210 !== "string") {
                      const err400 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/type/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err400];
                      } else {
                        vErrors.push(err400);
                      }
                      errors++;
                    }
                    if (!(data210 === "boolean")) {
                      const err401 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/type/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[8].properties
                              .type.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err401];
                      } else {
                        vErrors.push(err401);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data211 = data21.inputType;
                    if (typeof data211 !== "string") {
                      const err402 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err402];
                      } else {
                        vErrors.push(err402);
                      }
                      errors++;
                    }
                    if (!(data211 === "checkbox")) {
                      const err403 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[8].properties
                              .inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err403];
                      } else {
                        vErrors.push(err403);
                      }
                      errors++;
                    }
                  }
                  if (data21.tooltipText !== undefined) {
                    if (typeof data21.tooltipText !== "string") {
                      const err404 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/tooltipText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/tooltipText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err404];
                      } else {
                        vErrors.push(err404);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    if (typeof data21.title !== "string") {
                      const err405 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err405];
                      } else {
                        vErrors.push(err405);
                      }
                      errors++;
                    }
                  }
                  if (data21.checkboxText !== undefined) {
                    let data214 = data21.checkboxText;
                    if (typeof data214 === "string") {
                      if (func3(data214) < 1) {
                        const err406 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/checkboxText",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/8/properties/checkboxText/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err406];
                        } else {
                          vErrors.push(err406);
                        }
                        errors++;
                      }
                    } else {
                      const err407 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/checkboxText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/checkboxText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err407];
                      } else {
                        vErrors.push(err407);
                      }
                      errors++;
                    }
                  }
                  if (data21.columnHeaderOverride !== undefined) {
                    if (typeof data21.columnHeaderOverride !== "string") {
                      const err408 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/columnHeaderOverride",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/columnHeaderOverride/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err408];
                      } else {
                        vErrors.push(err408);
                      }
                      errors++;
                    }
                  }
                  if (data21.defaultValuePath !== undefined) {
                    let data216 = data21.defaultValuePath;
                    if (typeof data216 !== "string") {
                      const err409 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValuePath",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/defaultValuePath/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err409];
                      } else {
                        vErrors.push(err409);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data216 === "property.sisd.adjustmentRatio" ||
                        data216 === "property.sisd.defaultExclude" ||
                        data216 === "property.improvementValue" ||
                        data216 === "property.sisd.costType" ||
                        data216 === "property.latitude" ||
                        data216 === "property.longitude" ||
                        data216 === "parcel.mailingAddress1" ||
                        data216 === "parcel.mailingAddress2" ||
                        data216 === "parcel.mailingAddress" ||
                        data216 === "parcel.parcelId" ||
                        data216 === "parcel.improvementValue" ||
                        data216 === "parcel.block" ||
                        data216 === "parcel.lot" ||
                        data216 === "parcel.ownerName" ||
                        data216 === "user.firstName" ||
                        data216 === "user.lastName" ||
                        data216 === "user.fullName" ||
                        data216 === "units.feet" ||
                        data216 === "units.inches" ||
                        data216 === "units.hours" ||
                        data216 === "units.minutes" ||
                        data216 === "units.days" ||
                        data216 === "boolean.true" ||
                        data216 === "boolean.false" ||
                        data216 === "date.today"
                      )
                    ) {
                      const err410 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValuePath",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/defaultValuePath/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[8].properties
                              .defaultValuePath.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err410];
                      } else {
                        vErrors.push(err410);
                      }
                      errors++;
                    }
                  }
                  if (data21.disabled !== undefined) {
                    if (typeof data21.disabled !== "boolean") {
                      const err411 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/disabled",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/disabled/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err411];
                      } else {
                        vErrors.push(err411);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnCreate !== undefined) {
                    let data218 = data21.viewOnCreate;
                    if (Array.isArray(data218)) {
                      const len33 = data218.length;
                      for (let i33 = 0; i33 < len33; i33++) {
                        if (typeof data218[i33] !== "string") {
                          const err412 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnCreate/" +
                              i33,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/8/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err412];
                          } else {
                            vErrors.push(err412);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err413 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnCreate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err413];
                      } else {
                        vErrors.push(err413);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnRetrieve !== undefined) {
                    let data220 = data21.viewOnRetrieve;
                    if (Array.isArray(data220)) {
                      if (data220.length < 1) {
                        const err414 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/8/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err414];
                        } else {
                          vErrors.push(err414);
                        }
                        errors++;
                      }
                      const len34 = data220.length;
                      for (let i34 = 0; i34 < len34; i34++) {
                        let data221 = data220[i34];
                        if (typeof data221 !== "string") {
                          const err415 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i34,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/8/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err415];
                          } else {
                            vErrors.push(err415);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data221 === "manager" ||
                            data221 === "member" ||
                            data221 === "creator" ||
                            data221 === "view_only" ||
                            data221 === "admin" ||
                            data221 === "guest" ||
                            data221 === "publicUser"
                          )
                        ) {
                          const err416 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i34,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/8/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[8]
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err416];
                          } else {
                            vErrors.push(err416);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err417 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err417];
                      } else {
                        vErrors.push(err417);
                      }
                      errors++;
                    }
                  }
                  if (data21.canUpdate !== undefined) {
                    let data222 = data21.canUpdate;
                    if (Array.isArray(data222)) {
                      const len35 = data222.length;
                      for (let i35 = 0; i35 < len35; i35++) {
                        if (typeof data222[i35] !== "string") {
                          const err418 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/canUpdate/" +
                              i35,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/8/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err418];
                          } else {
                            vErrors.push(err418);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err419 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/canUpdate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err419];
                      } else {
                        vErrors.push(err419);
                      }
                      errors++;
                    }
                  }
                  if (data21.formula !== undefined) {
                    let data224 = data21.formula;
                    if (
                      data224 &&
                      typeof data224 == "object" &&
                      !Array.isArray(data224)
                    ) {
                      if (data224.name === undefined) {
                        const err420 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/8/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "name" },
                          message:
                            "must have required property '" + "name" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err420];
                        } else {
                          vErrors.push(err420);
                        }
                        errors++;
                      }
                      if (data224.applies === undefined) {
                        const err421 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/8/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "applies" },
                          message:
                            "must have required property '" + "applies" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err421];
                        } else {
                          vErrors.push(err421);
                        }
                        errors++;
                      }
                      if (data224.logic === undefined) {
                        const err422 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/8/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "logic" },
                          message:
                            "must have required property '" + "logic" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err422];
                        } else {
                          vErrors.push(err422);
                        }
                        errors++;
                      }
                      for (const key16 in data224) {
                        if (
                          !(
                            key16 === "name" ||
                            key16 === "applies" ||
                            key16 === "logic"
                          )
                        ) {
                          const err423 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/8/properties/formula/additionalProperties",
                            keyword: "additionalProperties",
                            params: { additionalProperty: key16 },
                            message: "must NOT have additional properties",
                          };
                          if (vErrors === null) {
                            vErrors = [err423];
                          } else {
                            vErrors.push(err423);
                          }
                          errors++;
                        }
                      }
                      if (data224.name !== undefined) {
                        if (typeof data224.name !== "string") {
                          const err424 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula/name",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/8/properties/formula/properties/name/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err424];
                          } else {
                            vErrors.push(err424);
                          }
                          errors++;
                        }
                      }
                      if (data224.applies !== undefined) {
                        let data226 = data224.applies;
                        if (
                          !(
                            data226 &&
                            typeof data226 == "object" &&
                            !Array.isArray(data226)
                          ) &&
                          typeof data226 !== "boolean"
                        ) {
                          const err425 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/formula/applies",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/8/properties/formula/properties/applies/type",
                            keyword: "type",
                            params: {
                              type: schema27.properties.inputs.items.oneOf[8]
                                .properties.formula.properties.applies.type,
                            },
                            message: "must be object,boolean",
                          };
                          if (vErrors === null) {
                            vErrors = [err425];
                          } else {
                            vErrors.push(err425);
                          }
                          errors++;
                        }
                      }
                      if (data224.logic !== undefined) {
                        let data227 = data224.logic;
                        if (
                          data227 &&
                          typeof data227 == "object" &&
                          !Array.isArray(data227)
                        ) {
                        } else {
                          const err426 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula/logic",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/8/properties/formula/properties/logic/type",
                            keyword: "type",
                            params: { type: "object" },
                            message: "must be object",
                          };
                          if (vErrors === null) {
                            vErrors = [err426];
                          } else {
                            vErrors.push(err426);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err427 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/formula",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/8/properties/formula/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err427];
                      } else {
                        vErrors.push(err427);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err428 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/8/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err428];
                  } else {
                    vErrors.push(err428);
                  }
                  errors++;
                }
              } else if (tag1 === "NumberWithUnits") {
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.inputType === undefined) {
                    const err429 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/9/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err429];
                    } else {
                      vErrors.push(err429);
                    }
                    errors++;
                  }
                  if (data21.name === undefined) {
                    const err430 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/9/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err430];
                    } else {
                      vErrors.push(err430);
                    }
                    errors++;
                  }
                  if (data21.enum === undefined) {
                    const err431 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/9/required",
                      keyword: "required",
                      params: { missingProperty: "enum" },
                      message: "must have required property '" + "enum" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err431];
                    } else {
                      vErrors.push(err431);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err432 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/9/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err432];
                    } else {
                      vErrors.push(err432);
                    }
                    errors++;
                  }
                  if (data21.required === undefined) {
                    const err433 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/9/required",
                      keyword: "required",
                      params: { missingProperty: "required" },
                      message:
                        "must have required property '" + "required" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err433];
                    } else {
                      vErrors.push(err433);
                    }
                    errors++;
                  }
                  for (const key17 in data21) {
                    if (
                      !func2.call(
                        schema27.properties.inputs.items.oneOf[9].properties,
                        key17,
                      )
                    ) {
                      const err434 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key17 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err434];
                      } else {
                        vErrors.push(err434);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data228 = data21.inputType;
                    if (typeof data228 !== "string") {
                      const err435 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err435];
                      } else {
                        vErrors.push(err435);
                      }
                      errors++;
                    }
                    if (!(data228 === "NumberWithUnits")) {
                      const err436 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[9].properties
                              .inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err436];
                      } else {
                        vErrors.push(err436);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err437 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err437];
                      } else {
                        vErrors.push(err437);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err438 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err438];
                      } else {
                        vErrors.push(err438);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    let data231 = data21.title;
                    if (typeof data231 === "string") {
                      if (func3(data231) < 1) {
                        const err439 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/title",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/9/properties/title/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err439];
                        } else {
                          vErrors.push(err439);
                        }
                        errors++;
                      }
                    } else {
                      const err440 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err440];
                      } else {
                        vErrors.push(err440);
                      }
                      errors++;
                    }
                  }
                  if (data21.minimum !== undefined) {
                    let data232 = data21.minimum;
                    if (typeof data232 == "number" && isFinite(data232)) {
                      const vSchema42 = data21 && data21.maximum;
                      if (
                        vSchema42 !== undefined &&
                        (!(
                          typeof vSchema42 == "number" && isFinite(vSchema42)
                        ) ||
                          data232 >= vSchema42 ||
                          isNaN(data232))
                      ) {
                        const err441 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/minimum",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/9/properties/minimum/exclusiveMaximum",
                          keyword: "exclusiveMaximum",
                          params: { comparison: "<", limit: vSchema42 },
                          message: "must be < " + vSchema42,
                        };
                        if (vErrors === null) {
                          vErrors = [err441];
                        } else {
                          vErrors.push(err441);
                        }
                        errors++;
                      }
                    } else {
                      const err442 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/minimum",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/minimum/type",
                        keyword: "type",
                        params: { type: "number" },
                        message: "must be number",
                      };
                      if (vErrors === null) {
                        vErrors = [err442];
                      } else {
                        vErrors.push(err442);
                      }
                      errors++;
                    }
                  }
                  if (data21.maximum !== undefined) {
                    let data233 = data21.maximum;
                    if (typeof data233 == "number" && isFinite(data233)) {
                      const vSchema43 = data21 && data21.minimum;
                      if (
                        vSchema43 !== undefined &&
                        (!(
                          typeof vSchema43 == "number" && isFinite(vSchema43)
                        ) ||
                          data233 <= vSchema43 ||
                          isNaN(data233))
                      ) {
                        const err443 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/maximum",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/9/properties/maximum/exclusiveMinimum",
                          keyword: "exclusiveMinimum",
                          params: { comparison: ">", limit: vSchema43 },
                          message: "must be > " + vSchema43,
                        };
                        if (vErrors === null) {
                          vErrors = [err443];
                        } else {
                          vErrors.push(err443);
                        }
                        errors++;
                      }
                    } else {
                      const err444 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/maximum",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/maximum/type",
                        keyword: "type",
                        params: { type: "number" },
                        message: "must be number",
                      };
                      if (vErrors === null) {
                        vErrors = [err444];
                      } else {
                        vErrors.push(err444);
                      }
                      errors++;
                    }
                  }
                  if (data21.tooltipText !== undefined) {
                    if (typeof data21.tooltipText !== "string") {
                      const err445 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/tooltipText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/tooltipText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err445];
                      } else {
                        vErrors.push(err445);
                      }
                      errors++;
                    }
                  }
                  if (data21.defaultValuePath !== undefined) {
                    let data235 = data21.defaultValuePath;
                    if (typeof data235 !== "string") {
                      const err446 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValuePath",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/defaultValuePath/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err446];
                      } else {
                        vErrors.push(err446);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data235 === "property.sisd.adjustmentRatio" ||
                        data235 === "property.sisd.defaultExclude" ||
                        data235 === "property.improvementValue" ||
                        data235 === "property.sisd.costType" ||
                        data235 === "property.latitude" ||
                        data235 === "property.longitude" ||
                        data235 === "parcel.mailingAddress1" ||
                        data235 === "parcel.mailingAddress2" ||
                        data235 === "parcel.mailingAddress" ||
                        data235 === "parcel.parcelId" ||
                        data235 === "parcel.improvementValue" ||
                        data235 === "parcel.block" ||
                        data235 === "parcel.lot" ||
                        data235 === "parcel.ownerName" ||
                        data235 === "user.firstName" ||
                        data235 === "user.lastName" ||
                        data235 === "user.fullName" ||
                        data235 === "units.feet" ||
                        data235 === "units.inches" ||
                        data235 === "units.hours" ||
                        data235 === "units.minutes" ||
                        data235 === "units.days" ||
                        data235 === "boolean.true" ||
                        data235 === "boolean.false" ||
                        data235 === "date.today"
                      )
                    ) {
                      const err447 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValuePath",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/defaultValuePath/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[9].properties
                              .defaultValuePath.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err447];
                      } else {
                        vErrors.push(err447);
                      }
                      errors++;
                    }
                  }
                  if (data21.defaultValue !== undefined) {
                    let data236 = data21.defaultValue;
                    if (typeof data236 == "number" && isFinite(data236)) {
                      const vSchema45 = data21 && data21.maximum;
                      if (
                        vSchema45 !== undefined &&
                        (!(
                          typeof vSchema45 == "number" && isFinite(vSchema45)
                        ) ||
                          data236 > vSchema45 ||
                          isNaN(data236))
                      ) {
                        const err448 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/defaultValue",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/9/properties/defaultValue/maximum",
                          keyword: "maximum",
                          params: { comparison: "<=", limit: vSchema45 },
                          message: "must be <= " + vSchema45,
                        };
                        if (vErrors === null) {
                          vErrors = [err448];
                        } else {
                          vErrors.push(err448);
                        }
                        errors++;
                      }
                      const vSchema46 = data21 && data21.minimum;
                      if (
                        vSchema46 !== undefined &&
                        (!(
                          typeof vSchema46 == "number" && isFinite(vSchema46)
                        ) ||
                          data236 < vSchema46 ||
                          isNaN(data236))
                      ) {
                        const err449 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/defaultValue",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/9/properties/defaultValue/minimum",
                          keyword: "minimum",
                          params: { comparison: ">=", limit: vSchema46 },
                          message: "must be >= " + vSchema46,
                        };
                        if (vErrors === null) {
                          vErrors = [err449];
                        } else {
                          vErrors.push(err449);
                        }
                        errors++;
                      }
                    } else {
                      const err450 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValue",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/defaultValue/type",
                        keyword: "type",
                        params: { type: "number" },
                        message: "must be number",
                      };
                      if (vErrors === null) {
                        vErrors = [err450];
                      } else {
                        vErrors.push(err450);
                      }
                      errors++;
                    }
                  }
                  if (data21.unitsDefaultValuePath !== undefined) {
                    let data237 = data21.unitsDefaultValuePath;
                    if (typeof data237 !== "string") {
                      const err451 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/unitsDefaultValuePath",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/unitsDefaultValuePath/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err451];
                      } else {
                        vErrors.push(err451);
                      }
                      errors++;
                    }
                    if (
                      !(
                        data237 === "property.sisd.adjustmentRatio" ||
                        data237 === "property.sisd.defaultExclude" ||
                        data237 === "property.improvementValue" ||
                        data237 === "property.sisd.costType" ||
                        data237 === "property.latitude" ||
                        data237 === "property.longitude" ||
                        data237 === "parcel.mailingAddress1" ||
                        data237 === "parcel.mailingAddress2" ||
                        data237 === "parcel.mailingAddress" ||
                        data237 === "parcel.parcelId" ||
                        data237 === "parcel.improvementValue" ||
                        data237 === "parcel.block" ||
                        data237 === "parcel.lot" ||
                        data237 === "parcel.ownerName" ||
                        data237 === "user.firstName" ||
                        data237 === "user.lastName" ||
                        data237 === "user.fullName" ||
                        data237 === "units.feet" ||
                        data237 === "units.inches" ||
                        data237 === "units.hours" ||
                        data237 === "units.minutes" ||
                        data237 === "units.days" ||
                        data237 === "boolean.true" ||
                        data237 === "boolean.false" ||
                        data237 === "date.today"
                      )
                    ) {
                      const err452 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/unitsDefaultValuePath",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/unitsDefaultValuePath/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[9].properties
                              .unitsDefaultValuePath.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err452];
                      } else {
                        vErrors.push(err452);
                      }
                      errors++;
                    }
                  }
                  if (data21.unitsDefaultValue !== undefined) {
                    if (typeof data21.unitsDefaultValue !== "string") {
                      const err453 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/unitsDefaultValue",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/unitsDefaultValue/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err453];
                      } else {
                        vErrors.push(err453);
                      }
                      errors++;
                    }
                  }
                  if (data21.enum !== undefined) {
                    let data239 = data21.enum;
                    if (Array.isArray(data239)) {
                      if (data239.length < 1) {
                        const err454 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/enum",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/9/properties/enum/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err454];
                        } else {
                          vErrors.push(err454);
                        }
                        errors++;
                      }
                      const len36 = data239.length;
                      for (let i36 = 0; i36 < len36; i36++) {
                        let data240 = data239[i36];
                        if (
                          data240 &&
                          typeof data240 == "object" &&
                          !Array.isArray(data240)
                        ) {
                          if (data240.label === undefined) {
                            const err455 = {
                              instancePath:
                                instancePath + "/inputs/" + i5 + "/enum/" + i36,
                              schemaPath:
                                "#/properties/inputs/items/oneOf/9/properties/enum/items/required",
                              keyword: "required",
                              params: { missingProperty: "label" },
                              message:
                                "must have required property '" + "label" + "'",
                            };
                            if (vErrors === null) {
                              vErrors = [err455];
                            } else {
                              vErrors.push(err455);
                            }
                            errors++;
                          }
                          if (data240.value === undefined) {
                            const err456 = {
                              instancePath:
                                instancePath + "/inputs/" + i5 + "/enum/" + i36,
                              schemaPath:
                                "#/properties/inputs/items/oneOf/9/properties/enum/items/required",
                              keyword: "required",
                              params: { missingProperty: "value" },
                              message:
                                "must have required property '" + "value" + "'",
                            };
                            if (vErrors === null) {
                              vErrors = [err456];
                            } else {
                              vErrors.push(err456);
                            }
                            errors++;
                          }
                          if (data240.label !== undefined) {
                            let data241 = data240.label;
                            if (typeof data241 === "string") {
                              if (func3(data241) < 1) {
                                const err457 = {
                                  instancePath:
                                    instancePath +
                                    "/inputs/" +
                                    i5 +
                                    "/enum/" +
                                    i36 +
                                    "/label",
                                  schemaPath:
                                    "#/properties/inputs/items/oneOf/9/properties/enum/items/properties/label/minLength",
                                  keyword: "minLength",
                                  params: { limit: 1 },
                                  message:
                                    "must NOT have fewer than 1 characters",
                                };
                                if (vErrors === null) {
                                  vErrors = [err457];
                                } else {
                                  vErrors.push(err457);
                                }
                                errors++;
                              }
                            } else {
                              const err458 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/enum/" +
                                  i36 +
                                  "/label",
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/9/properties/enum/items/properties/label/type",
                                keyword: "type",
                                params: { type: "string" },
                                message: "must be string",
                              };
                              if (vErrors === null) {
                                vErrors = [err458];
                              } else {
                                vErrors.push(err458);
                              }
                              errors++;
                            }
                          }
                          if (data240.value !== undefined) {
                            let data242 = data240.value;
                            if (typeof data242 === "string") {
                              if (func3(data242) < 1) {
                                const err459 = {
                                  instancePath:
                                    instancePath +
                                    "/inputs/" +
                                    i5 +
                                    "/enum/" +
                                    i36 +
                                    "/value",
                                  schemaPath:
                                    "#/properties/inputs/items/oneOf/9/properties/enum/items/properties/value/minLength",
                                  keyword: "minLength",
                                  params: { limit: 1 },
                                  message:
                                    "must NOT have fewer than 1 characters",
                                };
                                if (vErrors === null) {
                                  vErrors = [err459];
                                } else {
                                  vErrors.push(err459);
                                }
                                errors++;
                              }
                            } else {
                              const err460 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/enum/" +
                                  i36 +
                                  "/value",
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/9/properties/enum/items/properties/value/type",
                                keyword: "type",
                                params: { type: "string" },
                                message: "must be string",
                              };
                              if (vErrors === null) {
                                vErrors = [err460];
                              } else {
                                vErrors.push(err460);
                              }
                              errors++;
                            }
                          }
                        } else {
                          const err461 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/enum/" + i36,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/9/properties/enum/items/type",
                            keyword: "type",
                            params: { type: "object" },
                            message: "must be object",
                          };
                          if (vErrors === null) {
                            vErrors = [err461];
                          } else {
                            vErrors.push(err461);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err462 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/enum",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/enum/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err462];
                      } else {
                        vErrors.push(err462);
                      }
                      errors++;
                    }
                  }
                  if (data21.columnHeaderOverride !== undefined) {
                    if (typeof data21.columnHeaderOverride !== "string") {
                      const err463 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/columnHeaderOverride",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/columnHeaderOverride/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err463];
                      } else {
                        vErrors.push(err463);
                      }
                      errors++;
                    }
                  }
                  if (data21.disabled !== undefined) {
                    if (typeof data21.disabled !== "boolean") {
                      const err464 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/disabled",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/disabled/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err464];
                      } else {
                        vErrors.push(err464);
                      }
                      errors++;
                    }
                  }
                  if (data21.helperText !== undefined) {
                    if (typeof data21.helperText !== "string") {
                      const err465 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/helperText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/helperText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err465];
                      } else {
                        vErrors.push(err465);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnCreate !== undefined) {
                    let data246 = data21.viewOnCreate;
                    if (Array.isArray(data246)) {
                      const len37 = data246.length;
                      for (let i37 = 0; i37 < len37; i37++) {
                        if (typeof data246[i37] !== "string") {
                          const err466 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnCreate/" +
                              i37,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/9/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err466];
                          } else {
                            vErrors.push(err466);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err467 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnCreate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err467];
                      } else {
                        vErrors.push(err467);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnRetrieve !== undefined) {
                    let data248 = data21.viewOnRetrieve;
                    if (Array.isArray(data248)) {
                      if (data248.length < 1) {
                        const err468 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/9/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err468];
                        } else {
                          vErrors.push(err468);
                        }
                        errors++;
                      }
                      const len38 = data248.length;
                      for (let i38 = 0; i38 < len38; i38++) {
                        let data249 = data248[i38];
                        if (typeof data249 !== "string") {
                          const err469 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i38,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/9/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err469];
                          } else {
                            vErrors.push(err469);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data249 === "manager" ||
                            data249 === "member" ||
                            data249 === "creator" ||
                            data249 === "view_only" ||
                            data249 === "admin" ||
                            data249 === "guest" ||
                            data249 === "publicUser"
                          )
                        ) {
                          const err470 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i38,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/9/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[9]
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err470];
                          } else {
                            vErrors.push(err470);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err471 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err471];
                      } else {
                        vErrors.push(err471);
                      }
                      errors++;
                    }
                  }
                  if (data21.canUpdate !== undefined) {
                    let data250 = data21.canUpdate;
                    if (Array.isArray(data250)) {
                      const len39 = data250.length;
                      for (let i39 = 0; i39 < len39; i39++) {
                        if (typeof data250[i39] !== "string") {
                          const err472 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/canUpdate/" +
                              i39,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/9/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err472];
                          } else {
                            vErrors.push(err472);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err473 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/canUpdate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/9/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err473];
                      } else {
                        vErrors.push(err473);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err474 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/9/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err474];
                  } else {
                    vErrors.push(err474);
                  }
                  errors++;
                }
              } else if (tag1 === "PropertyMarketValue") {
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.inputType === undefined) {
                    const err475 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/10/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err475];
                    } else {
                      vErrors.push(err475);
                    }
                    errors++;
                  }
                  if (data21.name === undefined) {
                    const err476 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/10/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err476];
                    } else {
                      vErrors.push(err476);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err477 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/10/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err477];
                    } else {
                      vErrors.push(err477);
                    }
                    errors++;
                  }
                  if (data21.required === undefined) {
                    const err478 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/10/required",
                      keyword: "required",
                      params: { missingProperty: "required" },
                      message:
                        "must have required property '" + "required" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err478];
                    } else {
                      vErrors.push(err478);
                    }
                    errors++;
                  }
                  for (const key18 in data21) {
                    if (
                      !func2.call(
                        schema27.properties.inputs.items.oneOf[10].properties,
                        key18,
                      )
                    ) {
                      const err479 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key18 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err479];
                      } else {
                        vErrors.push(err479);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data252 = data21.inputType;
                    if (typeof data252 !== "string") {
                      const err480 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err480];
                      } else {
                        vErrors.push(err480);
                      }
                      errors++;
                    }
                    if (!(data252 === "PropertyMarketValue")) {
                      const err481 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[10]
                              .properties.inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err481];
                      } else {
                        vErrors.push(err481);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err482 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err482];
                      } else {
                        vErrors.push(err482);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err483 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err483];
                      } else {
                        vErrors.push(err483);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    let data255 = data21.title;
                    if (typeof data255 === "string") {
                      if (func3(data255) < 1) {
                        const err484 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/title",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/10/properties/title/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err484];
                        } else {
                          vErrors.push(err484);
                        }
                        errors++;
                      }
                    } else {
                      const err485 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err485];
                      } else {
                        vErrors.push(err485);
                      }
                      errors++;
                    }
                  }
                  if (data21.columnHeaderOverride !== undefined) {
                    if (typeof data21.columnHeaderOverride !== "string") {
                      const err486 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/columnHeaderOverride",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/properties/columnHeaderOverride/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err486];
                      } else {
                        vErrors.push(err486);
                      }
                      errors++;
                    }
                  }
                  if (data21.tooltipText !== undefined) {
                    if (typeof data21.tooltipText !== "string") {
                      const err487 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/tooltipText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/properties/tooltipText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err487];
                      } else {
                        vErrors.push(err487);
                      }
                      errors++;
                    }
                  }
                  if (data21.description !== undefined) {
                    if (typeof data21.description !== "string") {
                      const err488 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/description",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/properties/description/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err488];
                      } else {
                        vErrors.push(err488);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnCreate !== undefined) {
                    let data259 = data21.viewOnCreate;
                    if (Array.isArray(data259)) {
                      const len40 = data259.length;
                      for (let i40 = 0; i40 < len40; i40++) {
                        if (typeof data259[i40] !== "string") {
                          const err489 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnCreate/" +
                              i40,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/10/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err489];
                          } else {
                            vErrors.push(err489);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err490 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnCreate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err490];
                      } else {
                        vErrors.push(err490);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnRetrieve !== undefined) {
                    let data261 = data21.viewOnRetrieve;
                    if (Array.isArray(data261)) {
                      if (data261.length < 1) {
                        const err491 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/10/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err491];
                        } else {
                          vErrors.push(err491);
                        }
                        errors++;
                      }
                      const len41 = data261.length;
                      for (let i41 = 0; i41 < len41; i41++) {
                        let data262 = data261[i41];
                        if (typeof data262 !== "string") {
                          const err492 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i41,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/10/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err492];
                          } else {
                            vErrors.push(err492);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data262 === "manager" ||
                            data262 === "member" ||
                            data262 === "creator" ||
                            data262 === "view_only" ||
                            data262 === "admin" ||
                            data262 === "guest" ||
                            data262 === "publicUser"
                          )
                        ) {
                          const err493 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i41,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/10/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[10]
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err493];
                          } else {
                            vErrors.push(err493);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err494 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err494];
                      } else {
                        vErrors.push(err494);
                      }
                      errors++;
                    }
                  }
                  if (data21.canUpdate !== undefined) {
                    let data263 = data21.canUpdate;
                    if (Array.isArray(data263)) {
                      const len42 = data263.length;
                      for (let i42 = 0; i42 < len42; i42++) {
                        if (typeof data263[i42] !== "string") {
                          const err495 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/canUpdate/" +
                              i42,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/10/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err495];
                          } else {
                            vErrors.push(err495);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err496 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/canUpdate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err496];
                      } else {
                        vErrors.push(err496);
                      }
                      errors++;
                    }
                  }
                  if (data21.formula !== undefined) {
                    let data265 = data21.formula;
                    if (
                      data265 &&
                      typeof data265 == "object" &&
                      !Array.isArray(data265)
                    ) {
                      if (data265.name === undefined) {
                        const err497 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/10/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "name" },
                          message:
                            "must have required property '" + "name" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err497];
                        } else {
                          vErrors.push(err497);
                        }
                        errors++;
                      }
                      if (data265.applies === undefined) {
                        const err498 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/10/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "applies" },
                          message:
                            "must have required property '" + "applies" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err498];
                        } else {
                          vErrors.push(err498);
                        }
                        errors++;
                      }
                      if (data265.logic === undefined) {
                        const err499 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/formula",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/10/properties/formula/required",
                          keyword: "required",
                          params: { missingProperty: "logic" },
                          message:
                            "must have required property '" + "logic" + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err499];
                        } else {
                          vErrors.push(err499);
                        }
                        errors++;
                      }
                      for (const key19 in data265) {
                        if (
                          !(
                            key19 === "name" ||
                            key19 === "applies" ||
                            key19 === "logic"
                          )
                        ) {
                          const err500 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/10/properties/formula/additionalProperties",
                            keyword: "additionalProperties",
                            params: { additionalProperty: key19 },
                            message: "must NOT have additional properties",
                          };
                          if (vErrors === null) {
                            vErrors = [err500];
                          } else {
                            vErrors.push(err500);
                          }
                          errors++;
                        }
                      }
                      if (data265.name !== undefined) {
                        if (typeof data265.name !== "string") {
                          const err501 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula/name",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/10/properties/formula/properties/name/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err501];
                          } else {
                            vErrors.push(err501);
                          }
                          errors++;
                        }
                      }
                      if (data265.applies !== undefined) {
                        let data267 = data265.applies;
                        if (
                          !(
                            data267 &&
                            typeof data267 == "object" &&
                            !Array.isArray(data267)
                          ) &&
                          typeof data267 !== "boolean"
                        ) {
                          const err502 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/formula/applies",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/10/properties/formula/properties/applies/type",
                            keyword: "type",
                            params: {
                              type: schema27.properties.inputs.items.oneOf[10]
                                .properties.formula.properties.applies.type,
                            },
                            message: "must be object,boolean",
                          };
                          if (vErrors === null) {
                            vErrors = [err502];
                          } else {
                            vErrors.push(err502);
                          }
                          errors++;
                        }
                      }
                      if (data265.logic !== undefined) {
                        let data268 = data265.logic;
                        if (
                          data268 &&
                          typeof data268 == "object" &&
                          !Array.isArray(data268)
                        ) {
                        } else {
                          const err503 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/formula/logic",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/10/properties/formula/properties/logic/type",
                            keyword: "type",
                            params: { type: "object" },
                            message: "must be object",
                          };
                          if (vErrors === null) {
                            vErrors = [err503];
                          } else {
                            vErrors.push(err503);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err504 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/formula",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/properties/formula/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err504];
                      } else {
                        vErrors.push(err504);
                      }
                      errors++;
                    }
                  }
                  if (data21.enum !== undefined) {
                    let data269 = data21.enum;
                    if (Array.isArray(data269)) {
                      const len43 = data269.length;
                      for (let i43 = 0; i43 < len43; i43++) {
                        let data270 = data269[i43];
                        if (
                          !(
                            data270 === "squareFootageEstimate" ||
                            data270 === "automatedAssessedValue" ||
                            data270 === "otherValueEstimate"
                          )
                        ) {
                          const err505 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/enum/" + i43,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/10/properties/enum/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[10]
                                  .properties.enum.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err505];
                          } else {
                            vErrors.push(err505);
                          }
                          errors++;
                        }
                        if (typeof data270 === "string") {
                          if (func3(data270) < 1) {
                            const err506 = {
                              instancePath:
                                instancePath + "/inputs/" + i5 + "/enum/" + i43,
                              schemaPath:
                                "#/properties/inputs/items/oneOf/10/properties/enum/items/minLength",
                              keyword: "minLength",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 characters",
                            };
                            if (vErrors === null) {
                              vErrors = [err506];
                            } else {
                              vErrors.push(err506);
                            }
                            errors++;
                          }
                        } else {
                          const err507 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/enum/" + i43,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/10/properties/enum/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err507];
                          } else {
                            vErrors.push(err507);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err508 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/enum",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/properties/enum/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err508];
                      } else {
                        vErrors.push(err508);
                      }
                      errors++;
                    }
                  }
                  if (data21.overrides !== undefined) {
                    let data271 = data21.overrides;
                    if (
                      data271 &&
                      typeof data271 == "object" &&
                      !Array.isArray(data271)
                    ) {
                      if (data271.overrides !== undefined) {
                        let data272 = data271.overrides;
                        if (
                          data272 &&
                          typeof data272 == "object" &&
                          !Array.isArray(data272)
                        ) {
                          if (data272.squareFootageEstimate !== undefined) {
                            let data273 = data272.squareFootageEstimate;
                            if (
                              data273 &&
                              typeof data273 == "object" &&
                              !Array.isArray(data273)
                            ) {
                              if (data273.description !== undefined) {
                                if (typeof data273.description !== "string") {
                                  const err509 = {
                                    instancePath:
                                      instancePath +
                                      "/inputs/" +
                                      i5 +
                                      "/overrides/overrides/squareFootageEstimate/description",
                                    schemaPath:
                                      "#/properties/inputs/items/oneOf/10/properties/overrides/properties/overrides/properties/squareFootageEstimate/properties/description/type",
                                    keyword: "type",
                                    params: { type: "string" },
                                    message: "must be string",
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err509];
                                  } else {
                                    vErrors.push(err509);
                                  }
                                  errors++;
                                }
                              }
                              if (data273.adjustmentRatio !== undefined) {
                                let data275 = data273.adjustmentRatio;
                                if (
                                  data275 &&
                                  typeof data275 == "object" &&
                                  !Array.isArray(data275)
                                ) {
                                  if (data275.title !== undefined) {
                                    if (typeof data275.title !== "string") {
                                      const err510 = {
                                        instancePath:
                                          instancePath +
                                          "/inputs/" +
                                          i5 +
                                          "/overrides/overrides/squareFootageEstimate/adjustmentRatio/title",
                                        schemaPath:
                                          "#/properties/inputs/items/oneOf/10/properties/overrides/properties/overrides/properties/squareFootageEstimate/properties/adjustmentRatio/properties/title/type",
                                        keyword: "type",
                                        params: { type: "string" },
                                        message: "must be string",
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err510];
                                      } else {
                                        vErrors.push(err510);
                                      }
                                      errors++;
                                    }
                                  }
                                } else {
                                  const err511 = {
                                    instancePath:
                                      instancePath +
                                      "/inputs/" +
                                      i5 +
                                      "/overrides/overrides/squareFootageEstimate/adjustmentRatio",
                                    schemaPath:
                                      "#/properties/inputs/items/oneOf/10/properties/overrides/properties/overrides/properties/squareFootageEstimate/properties/adjustmentRatio/type",
                                    keyword: "type",
                                    params: { type: "object" },
                                    message: "must be object",
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err511];
                                  } else {
                                    vErrors.push(err511);
                                  }
                                  errors++;
                                }
                              }
                            } else {
                              const err512 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/overrides/overrides/squareFootageEstimate",
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/10/properties/overrides/properties/overrides/properties/squareFootageEstimate/type",
                                keyword: "type",
                                params: { type: "object" },
                                message: "must be object",
                              };
                              if (vErrors === null) {
                                vErrors = [err512];
                              } else {
                                vErrors.push(err512);
                              }
                              errors++;
                            }
                          }
                        } else {
                          const err513 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/overrides/overrides",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/10/properties/overrides/properties/overrides/type",
                            keyword: "type",
                            params: { type: "object" },
                            message: "must be object",
                          };
                          if (vErrors === null) {
                            vErrors = [err513];
                          } else {
                            vErrors.push(err513);
                          }
                          errors++;
                        }
                      }
                      if (data271.viewOnCreate !== undefined) {
                        let data277 = data271.viewOnCreate;
                        if (Array.isArray(data277)) {
                          const len44 = data277.length;
                          for (let i44 = 0; i44 < len44; i44++) {
                            if (typeof data277[i44] !== "string") {
                              const err514 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/overrides/viewOnCreate/" +
                                  i44,
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/10/properties/overrides/properties/viewOnCreate/items/type",
                                keyword: "type",
                                params: { type: "string" },
                                message: "must be string",
                              };
                              if (vErrors === null) {
                                vErrors = [err514];
                              } else {
                                vErrors.push(err514);
                              }
                              errors++;
                            }
                          }
                        } else {
                          const err515 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/overrides/viewOnCreate",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/10/properties/overrides/properties/viewOnCreate/type",
                            keyword: "type",
                            params: { type: "array" },
                            message: "must be array",
                          };
                          if (vErrors === null) {
                            vErrors = [err515];
                          } else {
                            vErrors.push(err515);
                          }
                          errors++;
                        }
                      }
                      if (data271.viewOnRetrieve !== undefined) {
                        let data279 = data271.viewOnRetrieve;
                        if (Array.isArray(data279)) {
                          if (data279.length < 1) {
                            const err516 = {
                              instancePath:
                                instancePath +
                                "/inputs/" +
                                i5 +
                                "/overrides/viewOnRetrieve",
                              schemaPath:
                                "#/properties/inputs/items/oneOf/10/properties/overrides/properties/viewOnRetrieve/minItems",
                              keyword: "minItems",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 items",
                            };
                            if (vErrors === null) {
                              vErrors = [err516];
                            } else {
                              vErrors.push(err516);
                            }
                            errors++;
                          }
                          const len45 = data279.length;
                          for (let i45 = 0; i45 < len45; i45++) {
                            let data280 = data279[i45];
                            if (typeof data280 !== "string") {
                              const err517 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/overrides/viewOnRetrieve/" +
                                  i45,
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/10/properties/overrides/properties/viewOnRetrieve/items/type",
                                keyword: "type",
                                params: { type: "string" },
                                message: "must be string",
                              };
                              if (vErrors === null) {
                                vErrors = [err517];
                              } else {
                                vErrors.push(err517);
                              }
                              errors++;
                            }
                            if (
                              !(
                                data280 === "manager" ||
                                data280 === "member" ||
                                data280 === "creator" ||
                                data280 === "view_only" ||
                                data280 === "admin" ||
                                data280 === "guest" ||
                                data280 === "publicUser"
                              )
                            ) {
                              const err518 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/overrides/viewOnRetrieve/" +
                                  i45,
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/10/properties/overrides/properties/viewOnRetrieve/items/enum",
                                keyword: "enum",
                                params: {
                                  allowedValues:
                                    schema27.properties.inputs.items.oneOf[10]
                                      .properties.overrides.properties
                                      .viewOnRetrieve.items.enum,
                                },
                                message:
                                  "must be equal to one of the allowed values",
                              };
                              if (vErrors === null) {
                                vErrors = [err518];
                              } else {
                                vErrors.push(err518);
                              }
                              errors++;
                            }
                          }
                        } else {
                          const err519 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/overrides/viewOnRetrieve",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/10/properties/overrides/properties/viewOnRetrieve/type",
                            keyword: "type",
                            params: { type: "array" },
                            message: "must be array",
                          };
                          if (vErrors === null) {
                            vErrors = [err519];
                          } else {
                            vErrors.push(err519);
                          }
                          errors++;
                        }
                      }
                      if (data271.canUpdate !== undefined) {
                        let data281 = data271.canUpdate;
                        if (Array.isArray(data281)) {
                          const len46 = data281.length;
                          for (let i46 = 0; i46 < len46; i46++) {
                            if (typeof data281[i46] !== "string") {
                              const err520 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/overrides/canUpdate/" +
                                  i46,
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/10/properties/overrides/properties/canUpdate/items/type",
                                keyword: "type",
                                params: { type: "string" },
                                message: "must be string",
                              };
                              if (vErrors === null) {
                                vErrors = [err520];
                              } else {
                                vErrors.push(err520);
                              }
                              errors++;
                            }
                          }
                        } else {
                          const err521 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/overrides/canUpdate",
                            schemaPath:
                              "#/properties/inputs/items/oneOf/10/properties/overrides/properties/canUpdate/type",
                            keyword: "type",
                            params: { type: "array" },
                            message: "must be array",
                          };
                          if (vErrors === null) {
                            vErrors = [err521];
                          } else {
                            vErrors.push(err521);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err522 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/overrides",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/10/properties/overrides/type",
                        keyword: "type",
                        params: { type: "object" },
                        message: "must be object",
                      };
                      if (vErrors === null) {
                        vErrors = [err522];
                      } else {
                        vErrors.push(err522);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err523 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/10/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err523];
                  } else {
                    vErrors.push(err523);
                  }
                  errors++;
                }
              } else if (tag1 === "group") {
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.inputType === undefined) {
                    const err524 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/11/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err524];
                    } else {
                      vErrors.push(err524);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err525 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/11/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err525];
                    } else {
                      vErrors.push(err525);
                    }
                    errors++;
                  }
                  if (data21.properties === undefined) {
                    const err526 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/11/required",
                      keyword: "required",
                      params: { missingProperty: "properties" },
                      message:
                        "must have required property '" + "properties" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err526];
                    } else {
                      vErrors.push(err526);
                    }
                    errors++;
                  }
                  for (const key20 in data21) {
                    if (
                      !(
                        key20 === "inputType" ||
                        key20 === "name" ||
                        key20 === "title" ||
                        key20 === "description" ||
                        key20 === "properties" ||
                        key20 === "required" ||
                        key20 === "columns" ||
                        key20 === "heading"
                      )
                    ) {
                      const err527 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/11/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key20 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err527];
                      } else {
                        vErrors.push(err527);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data283 = data21.inputType;
                    if (typeof data283 !== "string") {
                      const err528 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/11/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err528];
                      } else {
                        vErrors.push(err528);
                      }
                      errors++;
                    }
                    if (!(data283 === "group")) {
                      const err529 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/11/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[11]
                              .properties.inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err529];
                      } else {
                        vErrors.push(err529);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err530 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/11/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err530];
                      } else {
                        vErrors.push(err530);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    let data285 = data21.title;
                    if (typeof data285 === "string") {
                      if (func3(data285) < 1) {
                        const err531 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/title",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/11/properties/title/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err531];
                        } else {
                          vErrors.push(err531);
                        }
                        errors++;
                      }
                    } else {
                      const err532 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/11/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err532];
                      } else {
                        vErrors.push(err532);
                      }
                      errors++;
                    }
                  }
                  if (data21.description !== undefined) {
                    if (typeof data21.description !== "string") {
                      const err533 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/description",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/11/properties/description/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err533];
                      } else {
                        vErrors.push(err533);
                      }
                      errors++;
                    }
                  }
                  if (data21.properties !== undefined) {
                    let data287 = data21.properties;
                    if (
                      !validate11(data287, {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/properties",
                        parentData: data21,
                        parentDataProperty: "properties",
                        rootData,
                      })
                    ) {
                      vErrors =
                        vErrors === null ?
                          validate11.errors
                        : vErrors.concat(validate11.errors);
                      errors = vErrors.length;
                    }
                    if (Array.isArray(data287)) {
                      if (data287.length < 1) {
                        const err534 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/properties",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/11/properties/properties/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err534];
                        } else {
                          vErrors.push(err534);
                        }
                        errors++;
                      }
                      const len47 = data287.length;
                      for (let i47 = 0; i47 < len47; i47++) {
                        let data288 = data287[i47];
                        if (
                          !(
                            data288 &&
                            typeof data288 == "object" &&
                            !Array.isArray(data288)
                          )
                        ) {
                          const err535 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/properties/" +
                              i47,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/11/properties/properties/items/type",
                            keyword: "type",
                            params: { type: "object" },
                            message: "must be object",
                          };
                          if (vErrors === null) {
                            vErrors = [err535];
                          } else {
                            vErrors.push(err535);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err536 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/properties",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/11/properties/properties/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err536];
                      } else {
                        vErrors.push(err536);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err537 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/11/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err537];
                      } else {
                        vErrors.push(err537);
                      }
                      errors++;
                    }
                  }
                  if (data21.columns !== undefined) {
                    let data290 = data21.columns;
                    if (
                      !(
                        typeof data290 == "number" &&
                        !(data290 % 1) &&
                        !isNaN(data290) &&
                        isFinite(data290)
                      )
                    ) {
                      const err538 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/columns",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/11/properties/columns/type",
                        keyword: "type",
                        params: { type: "integer" },
                        message: "must be integer",
                      };
                      if (vErrors === null) {
                        vErrors = [err538];
                      } else {
                        vErrors.push(err538);
                      }
                      errors++;
                    }
                  }
                  if (data21.heading !== undefined) {
                    let data291 = data21.heading;
                    if (typeof data291 !== "string") {
                      const err539 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/heading",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/11/properties/heading/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err539];
                      } else {
                        vErrors.push(err539);
                      }
                      errors++;
                    }
                    if (!(data291 === "h1" || data291 === "h2")) {
                      const err540 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/heading",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/11/properties/heading/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[11]
                              .properties.heading.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err540];
                      } else {
                        vErrors.push(err540);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err541 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/11/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err541];
                  } else {
                    vErrors.push(err541);
                  }
                  errors++;
                }
              } else if (tag1 === "User") {
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.inputType === undefined) {
                    const err542 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/12/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err542];
                    } else {
                      vErrors.push(err542);
                    }
                    errors++;
                  }
                  if (data21.name === undefined) {
                    const err543 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/12/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err543];
                    } else {
                      vErrors.push(err543);
                    }
                    errors++;
                  }
                  if (data21.required === undefined) {
                    const err544 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/12/required",
                      keyword: "required",
                      params: { missingProperty: "required" },
                      message:
                        "must have required property '" + "required" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err544];
                    } else {
                      vErrors.push(err544);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err545 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/12/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err545];
                    } else {
                      vErrors.push(err545);
                    }
                    errors++;
                  }
                  for (const key21 in data21) {
                    if (
                      !func2.call(
                        schema27.properties.inputs.items.oneOf[12].properties,
                        key21,
                      )
                    ) {
                      const err546 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key21 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err546];
                      } else {
                        vErrors.push(err546);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data292 = data21.inputType;
                    if (typeof data292 !== "string") {
                      const err547 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err547];
                      } else {
                        vErrors.push(err547);
                      }
                      errors++;
                    }
                    if (!(data292 === "User")) {
                      const err548 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[12]
                              .properties.inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err548];
                      } else {
                        vErrors.push(err548);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err549 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err549];
                      } else {
                        vErrors.push(err549);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    let data294 = data21.title;
                    if (typeof data294 === "string") {
                      if (func3(data294) < 1) {
                        const err550 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/title",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/12/properties/title/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err550];
                        } else {
                          vErrors.push(err550);
                        }
                        errors++;
                      }
                    } else {
                      const err551 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err551];
                      } else {
                        vErrors.push(err551);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err552 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err552];
                      } else {
                        vErrors.push(err552);
                      }
                      errors++;
                    }
                  }
                  if (data21.placeholder !== undefined) {
                    if (typeof data21.placeholder !== "string") {
                      const err553 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/placeholder",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/placeholder/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err553];
                      } else {
                        vErrors.push(err553);
                      }
                      errors++;
                    }
                  }
                  if (data21.type !== undefined) {
                    if (typeof data21.type !== "string") {
                      const err554 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/type/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err554];
                      } else {
                        vErrors.push(err554);
                      }
                      errors++;
                    }
                  }
                  if (data21.tooltipText !== undefined) {
                    if (typeof data21.tooltipText !== "string") {
                      const err555 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/tooltipText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/tooltipText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err555];
                      } else {
                        vErrors.push(err555);
                      }
                      errors++;
                    }
                  }
                  if (data21.description !== undefined) {
                    if (typeof data21.description !== "string") {
                      const err556 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/description",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/description/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err556];
                      } else {
                        vErrors.push(err556);
                      }
                      errors++;
                    }
                  }
                  if (data21.disabled !== undefined) {
                    if (typeof data21.disabled !== "boolean") {
                      const err557 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/disabled",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/disabled/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err557];
                      } else {
                        vErrors.push(err557);
                      }
                      errors++;
                    }
                  }
                  if (data21.helperText !== undefined) {
                    if (typeof data21.helperText !== "string") {
                      const err558 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/helperText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/helperText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err558];
                      } else {
                        vErrors.push(err558);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnCreate !== undefined) {
                    let data302 = data21.viewOnCreate;
                    if (Array.isArray(data302)) {
                      const len48 = data302.length;
                      for (let i48 = 0; i48 < len48; i48++) {
                        if (typeof data302[i48] !== "string") {
                          const err559 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnCreate/" +
                              i48,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/12/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err559];
                          } else {
                            vErrors.push(err559);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err560 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnCreate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err560];
                      } else {
                        vErrors.push(err560);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnRetrieve !== undefined) {
                    let data304 = data21.viewOnRetrieve;
                    if (Array.isArray(data304)) {
                      if (data304.length < 1) {
                        const err561 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/12/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err561];
                        } else {
                          vErrors.push(err561);
                        }
                        errors++;
                      }
                      const len49 = data304.length;
                      for (let i49 = 0; i49 < len49; i49++) {
                        let data305 = data304[i49];
                        if (typeof data305 !== "string") {
                          const err562 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i49,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/12/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err562];
                          } else {
                            vErrors.push(err562);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data305 === "manager" ||
                            data305 === "member" ||
                            data305 === "creator" ||
                            data305 === "view_only" ||
                            data305 === "admin" ||
                            data305 === "guest" ||
                            data305 === "publicUser"
                          )
                        ) {
                          const err563 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i49,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/12/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[12]
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err563];
                          } else {
                            vErrors.push(err563);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err564 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err564];
                      } else {
                        vErrors.push(err564);
                      }
                      errors++;
                    }
                  }
                  if (data21.canUpdate !== undefined) {
                    let data306 = data21.canUpdate;
                    if (Array.isArray(data306)) {
                      const len50 = data306.length;
                      for (let i50 = 0; i50 < len50; i50++) {
                        if (typeof data306[i50] !== "string") {
                          const err565 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/canUpdate/" +
                              i50,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/12/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err565];
                          } else {
                            vErrors.push(err565);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err566 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/canUpdate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err566];
                      } else {
                        vErrors.push(err566);
                      }
                      errors++;
                    }
                  }
                  if (data21.userGroupSelection !== undefined) {
                    if (!Array.isArray(data21.userGroupSelection)) {
                      const err567 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/userGroupSelection",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/userGroupSelection/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err567];
                      } else {
                        vErrors.push(err567);
                      }
                      errors++;
                    }
                  }
                  if (data21.columnHeaderOverride !== undefined) {
                    if (typeof data21.columnHeaderOverride !== "string") {
                      const err568 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/columnHeaderOverride",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/12/properties/columnHeaderOverride/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err568];
                      } else {
                        vErrors.push(err568);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err569 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/12/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err569];
                  } else {
                    vErrors.push(err569);
                  }
                  errors++;
                }
              } else if (tag1 === "multiSelect") {
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.inputType === undefined) {
                    const err570 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/13/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err570];
                    } else {
                      vErrors.push(err570);
                    }
                    errors++;
                  }
                  if (data21.name === undefined) {
                    const err571 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/13/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err571];
                    } else {
                      vErrors.push(err571);
                    }
                    errors++;
                  }
                  if (data21.type === undefined) {
                    const err572 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/13/required",
                      keyword: "required",
                      params: { missingProperty: "type" },
                      message: "must have required property '" + "type" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err572];
                    } else {
                      vErrors.push(err572);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err573 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/13/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err573];
                    } else {
                      vErrors.push(err573);
                    }
                    errors++;
                  }
                  if (data21.required === undefined) {
                    const err574 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/13/required",
                      keyword: "required",
                      params: { missingProperty: "required" },
                      message:
                        "must have required property '" + "required" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err574];
                    } else {
                      vErrors.push(err574);
                    }
                    errors++;
                  }
                  if (data21.enum === undefined) {
                    const err575 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/13/required",
                      keyword: "required",
                      params: { missingProperty: "enum" },
                      message: "must have required property '" + "enum" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err575];
                    } else {
                      vErrors.push(err575);
                    }
                    errors++;
                  }
                  for (const key22 in data21) {
                    if (
                      !func2.call(
                        schema27.properties.inputs.items.oneOf[13].properties,
                        key22,
                      )
                    ) {
                      const err576 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key22 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err576];
                      } else {
                        vErrors.push(err576);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data310 = data21.inputType;
                    if (typeof data310 !== "string") {
                      const err577 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err577];
                      } else {
                        vErrors.push(err577);
                      }
                      errors++;
                    }
                    if (!(data310 === "multiSelect")) {
                      const err578 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[13]
                              .properties.inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err578];
                      } else {
                        vErrors.push(err578);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err579 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err579];
                      } else {
                        vErrors.push(err579);
                      }
                      errors++;
                    }
                  }
                  if (data21.type !== undefined) {
                    let data312 = data21.type;
                    if (typeof data312 !== "string") {
                      const err580 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/type/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err580];
                      } else {
                        vErrors.push(err580);
                      }
                      errors++;
                    }
                    if (!(data312 === "string" || data312 === "number")) {
                      const err581 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/type/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[13]
                              .properties.type.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err581];
                      } else {
                        vErrors.push(err581);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    let data313 = data21.title;
                    if (typeof data313 === "string") {
                      if (func3(data313) < 1) {
                        const err582 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/title",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/13/properties/title/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err582];
                        } else {
                          vErrors.push(err582);
                        }
                        errors++;
                      }
                    } else {
                      const err583 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err583];
                      } else {
                        vErrors.push(err583);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err584 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err584];
                      } else {
                        vErrors.push(err584);
                      }
                      errors++;
                    }
                  }
                  if (data21.placeholder !== undefined) {
                    if (typeof data21.placeholder !== "string") {
                      const err585 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/placeholder",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/placeholder/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err585];
                      } else {
                        vErrors.push(err585);
                      }
                      errors++;
                    }
                  }
                  if (data21.description !== undefined) {
                    if (typeof data21.description !== "string") {
                      const err586 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/description",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/description/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err586];
                      } else {
                        vErrors.push(err586);
                      }
                      errors++;
                    }
                  }
                  if (data21.tooltipText !== undefined) {
                    if (typeof data21.tooltipText !== "string") {
                      const err587 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/tooltipText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/tooltipText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err587];
                      } else {
                        vErrors.push(err587);
                      }
                      errors++;
                    }
                  }
                  if (data21.columnHeaderOverride !== undefined) {
                    if (typeof data21.columnHeaderOverride !== "string") {
                      const err588 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/columnHeaderOverride",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/columnHeaderOverride/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err588];
                      } else {
                        vErrors.push(err588);
                      }
                      errors++;
                    }
                  }
                  if (data21.helperText !== undefined) {
                    if (typeof data21.helperText !== "string") {
                      const err589 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/helperText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/helperText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err589];
                      } else {
                        vErrors.push(err589);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnCreate !== undefined) {
                    let data320 = data21.viewOnCreate;
                    if (Array.isArray(data320)) {
                      const len51 = data320.length;
                      for (let i51 = 0; i51 < len51; i51++) {
                        if (typeof data320[i51] !== "string") {
                          const err590 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnCreate/" +
                              i51,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/13/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err590];
                          } else {
                            vErrors.push(err590);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err591 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnCreate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err591];
                      } else {
                        vErrors.push(err591);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnRetrieve !== undefined) {
                    let data322 = data21.viewOnRetrieve;
                    if (Array.isArray(data322)) {
                      if (data322.length < 1) {
                        const err592 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/13/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err592];
                        } else {
                          vErrors.push(err592);
                        }
                        errors++;
                      }
                      const len52 = data322.length;
                      for (let i52 = 0; i52 < len52; i52++) {
                        let data323 = data322[i52];
                        if (typeof data323 !== "string") {
                          const err593 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i52,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/13/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err593];
                          } else {
                            vErrors.push(err593);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data323 === "manager" ||
                            data323 === "member" ||
                            data323 === "creator" ||
                            data323 === "view_only" ||
                            data323 === "admin" ||
                            data323 === "guest" ||
                            data323 === "publicUser"
                          )
                        ) {
                          const err594 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i52,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/13/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[13]
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err594];
                          } else {
                            vErrors.push(err594);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err595 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err595];
                      } else {
                        vErrors.push(err595);
                      }
                      errors++;
                    }
                  }
                  if (data21.canUpdate !== undefined) {
                    let data324 = data21.canUpdate;
                    if (Array.isArray(data324)) {
                      const len53 = data324.length;
                      for (let i53 = 0; i53 < len53; i53++) {
                        if (typeof data324[i53] !== "string") {
                          const err596 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/canUpdate/" +
                              i53,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/13/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err596];
                          } else {
                            vErrors.push(err596);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err597 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/canUpdate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err597];
                      } else {
                        vErrors.push(err597);
                      }
                      errors++;
                    }
                  }
                  if (data21.useAsTag !== undefined) {
                    if (typeof data21.useAsTag !== "boolean") {
                      const err598 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/useAsTag",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/useAsTag/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err598];
                      } else {
                        vErrors.push(err598);
                      }
                      errors++;
                    }
                  }
                  if (data21.enum !== undefined) {
                    let data327 = data21.enum;
                    if (Array.isArray(data327)) {
                      if (data327.length < 1) {
                        const err599 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/enum",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/13/properties/enum/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err599];
                        } else {
                          vErrors.push(err599);
                        }
                        errors++;
                      }
                      const len54 = data327.length;
                      for (let i54 = 0; i54 < len54; i54++) {
                        let data328 = data327[i54];
                        const _errs739 = errors;
                        let valid170 = false;
                        let passing1 = null;
                        const _errs740 = errors;
                        if (typeof data328 === "string") {
                          if (func3(data328) < 1) {
                            const err600 = {
                              instancePath:
                                instancePath + "/inputs/" + i5 + "/enum/" + i54,
                              schemaPath:
                                "#/properties/inputs/items/oneOf/13/properties/enum/items/oneOf/0/minLength",
                              keyword: "minLength",
                              params: { limit: 1 },
                              message: "must NOT have fewer than 1 characters",
                            };
                            if (vErrors === null) {
                              vErrors = [err600];
                            } else {
                              vErrors.push(err600);
                            }
                            errors++;
                          }
                        } else {
                          const err601 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/enum/" + i54,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/13/properties/enum/items/oneOf/0/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err601];
                          } else {
                            vErrors.push(err601);
                          }
                          errors++;
                        }
                        var _valid4 = _errs740 === errors;
                        if (_valid4) {
                          valid170 = true;
                          passing1 = 0;
                        }
                        const _errs742 = errors;
                        if (
                          data328 &&
                          typeof data328 == "object" &&
                          !Array.isArray(data328)
                        ) {
                          if (data328.label === undefined) {
                            const err602 = {
                              instancePath:
                                instancePath + "/inputs/" + i5 + "/enum/" + i54,
                              schemaPath:
                                "#/properties/inputs/items/oneOf/13/properties/enum/items/oneOf/1/required",
                              keyword: "required",
                              params: { missingProperty: "label" },
                              message:
                                "must have required property '" + "label" + "'",
                            };
                            if (vErrors === null) {
                              vErrors = [err602];
                            } else {
                              vErrors.push(err602);
                            }
                            errors++;
                          }
                          if (data328.value === undefined) {
                            const err603 = {
                              instancePath:
                                instancePath + "/inputs/" + i5 + "/enum/" + i54,
                              schemaPath:
                                "#/properties/inputs/items/oneOf/13/properties/enum/items/oneOf/1/required",
                              keyword: "required",
                              params: { missingProperty: "value" },
                              message:
                                "must have required property '" + "value" + "'",
                            };
                            if (vErrors === null) {
                              vErrors = [err603];
                            } else {
                              vErrors.push(err603);
                            }
                            errors++;
                          }
                          if (data328.label !== undefined) {
                            let data329 = data328.label;
                            if (typeof data329 === "string") {
                              if (func3(data329) < 1) {
                                const err604 = {
                                  instancePath:
                                    instancePath +
                                    "/inputs/" +
                                    i5 +
                                    "/enum/" +
                                    i54 +
                                    "/label",
                                  schemaPath:
                                    "#/properties/inputs/items/oneOf/13/properties/enum/items/oneOf/1/properties/label/minLength",
                                  keyword: "minLength",
                                  params: { limit: 1 },
                                  message:
                                    "must NOT have fewer than 1 characters",
                                };
                                if (vErrors === null) {
                                  vErrors = [err604];
                                } else {
                                  vErrors.push(err604);
                                }
                                errors++;
                              }
                            } else {
                              const err605 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/enum/" +
                                  i54 +
                                  "/label",
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/13/properties/enum/items/oneOf/1/properties/label/type",
                                keyword: "type",
                                params: { type: "string" },
                                message: "must be string",
                              };
                              if (vErrors === null) {
                                vErrors = [err605];
                              } else {
                                vErrors.push(err605);
                              }
                              errors++;
                            }
                          }
                          if (data328.value !== undefined) {
                            let data330 = data328.value;
                            if (typeof data330 === "string") {
                              if (func3(data330) < 1) {
                                const err606 = {
                                  instancePath:
                                    instancePath +
                                    "/inputs/" +
                                    i5 +
                                    "/enum/" +
                                    i54 +
                                    "/value",
                                  schemaPath:
                                    "#/properties/inputs/items/oneOf/13/properties/enum/items/oneOf/1/properties/value/minLength",
                                  keyword: "minLength",
                                  params: { limit: 1 },
                                  message:
                                    "must NOT have fewer than 1 characters",
                                };
                                if (vErrors === null) {
                                  vErrors = [err606];
                                } else {
                                  vErrors.push(err606);
                                }
                                errors++;
                              }
                            } else {
                              const err607 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/enum/" +
                                  i54 +
                                  "/value",
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/13/properties/enum/items/oneOf/1/properties/value/type",
                                keyword: "type",
                                params: { type: "string" },
                                message: "must be string",
                              };
                              if (vErrors === null) {
                                vErrors = [err607];
                              } else {
                                vErrors.push(err607);
                              }
                              errors++;
                            }
                          }
                          if (data328.display !== undefined) {
                            let data331 = data328.display;
                            if (
                              typeof data331 !== "string" &&
                              data331 !== null
                            ) {
                              const err608 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/enum/" +
                                  i54 +
                                  "/display",
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/13/properties/enum/items/oneOf/1/properties/display/type",
                                keyword: "type",
                                params: {
                                  type: schema27.properties.inputs.items
                                    .oneOf[13].properties.enum.items.oneOf[1]
                                    .properties.display.type,
                                },
                                message: "must be string,null",
                              };
                              if (vErrors === null) {
                                vErrors = [err608];
                              } else {
                                vErrors.push(err608);
                              }
                              errors++;
                            }
                            if (
                              !(
                                data331 === "default" ||
                                data331 === "neutral" ||
                                data331 === "warning" ||
                                data331 === "critical" ||
                                data331 === "neutralInverted"
                              )
                            ) {
                              const err609 = {
                                instancePath:
                                  instancePath +
                                  "/inputs/" +
                                  i5 +
                                  "/enum/" +
                                  i54 +
                                  "/display",
                                schemaPath:
                                  "#/properties/inputs/items/oneOf/13/properties/enum/items/oneOf/1/properties/display/enum",
                                keyword: "enum",
                                params: {
                                  allowedValues:
                                    schema27.properties.inputs.items.oneOf[13]
                                      .properties.enum.items.oneOf[1].properties
                                      .display.enum,
                                },
                                message:
                                  "must be equal to one of the allowed values",
                              };
                              if (vErrors === null) {
                                vErrors = [err609];
                              } else {
                                vErrors.push(err609);
                              }
                              errors++;
                            }
                          }
                        } else {
                          const err610 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/enum/" + i54,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/13/properties/enum/items/oneOf/1/type",
                            keyword: "type",
                            params: { type: "object" },
                            message: "must be object",
                          };
                          if (vErrors === null) {
                            vErrors = [err610];
                          } else {
                            vErrors.push(err610);
                          }
                          errors++;
                        }
                        var _valid4 = _errs742 === errors;
                        if (_valid4 && valid170) {
                          valid170 = false;
                          passing1 = [passing1, 1];
                        } else {
                          if (_valid4) {
                            valid170 = true;
                            passing1 = 1;
                          }
                        }
                        if (!valid170) {
                          const err611 = {
                            instancePath:
                              instancePath + "/inputs/" + i5 + "/enum/" + i54,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/13/properties/enum/items/oneOf",
                            keyword: "oneOf",
                            params: { passingSchemas: passing1 },
                            message: "must match exactly one schema in oneOf",
                          };
                          if (vErrors === null) {
                            vErrors = [err611];
                          } else {
                            vErrors.push(err611);
                          }
                          errors++;
                        } else {
                          errors = _errs739;
                          if (vErrors !== null) {
                            if (_errs739) {
                              vErrors.length = _errs739;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                      }
                    } else {
                      const err612 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/enum",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/enum/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err612];
                      } else {
                        vErrors.push(err612);
                      }
                      errors++;
                    }
                  }
                  if (data21.defaultValue !== undefined) {
                    let data332 = data21.defaultValue;
                    if (Array.isArray(data332)) {
                      const len55 = data332.length;
                      for (let i55 = 0; i55 < len55; i55++) {
                        if (typeof data332[i55] !== "string") {
                          const err613 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/defaultValue/" +
                              i55,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/13/properties/defaultValue/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err613];
                          } else {
                            vErrors.push(err613);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err614 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/defaultValue",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/13/properties/defaultValue/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err614];
                      } else {
                        vErrors.push(err614);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err615 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/13/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err615];
                  } else {
                    vErrors.push(err615);
                  }
                  errors++;
                }
              } else if (tag1 === "UniqueId") {
                if (
                  data21 &&
                  typeof data21 == "object" &&
                  !Array.isArray(data21)
                ) {
                  if (data21.name === undefined) {
                    const err616 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/14/required",
                      keyword: "required",
                      params: { missingProperty: "name" },
                      message: "must have required property '" + "name" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err616];
                    } else {
                      vErrors.push(err616);
                    }
                    errors++;
                  }
                  if (data21.required === undefined) {
                    const err617 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/14/required",
                      keyword: "required",
                      params: { missingProperty: "required" },
                      message:
                        "must have required property '" + "required" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err617];
                    } else {
                      vErrors.push(err617);
                    }
                    errors++;
                  }
                  if (data21.inputType === undefined) {
                    const err618 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/14/required",
                      keyword: "required",
                      params: { missingProperty: "inputType" },
                      message:
                        "must have required property '" + "inputType" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err618];
                    } else {
                      vErrors.push(err618);
                    }
                    errors++;
                  }
                  if (data21.type === undefined) {
                    const err619 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/14/required",
                      keyword: "required",
                      params: { missingProperty: "type" },
                      message: "must have required property '" + "type" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err619];
                    } else {
                      vErrors.push(err619);
                    }
                    errors++;
                  }
                  if (data21.placeholder === undefined) {
                    const err620 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/14/required",
                      keyword: "required",
                      params: { missingProperty: "placeholder" },
                      message:
                        "must have required property '" + "placeholder" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err620];
                    } else {
                      vErrors.push(err620);
                    }
                    errors++;
                  }
                  if (data21.title === undefined) {
                    const err621 = {
                      instancePath: instancePath + "/inputs/" + i5,
                      schemaPath: "#/properties/inputs/items/oneOf/14/required",
                      keyword: "required",
                      params: { missingProperty: "title" },
                      message: "must have required property '" + "title" + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err621];
                    } else {
                      vErrors.push(err621);
                    }
                    errors++;
                  }
                  for (const key23 in data21) {
                    if (
                      !func2.call(
                        schema27.properties.inputs.items.oneOf[14].properties,
                        key23,
                      )
                    ) {
                      const err622 = {
                        instancePath: instancePath + "/inputs/" + i5,
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/additionalProperties",
                        keyword: "additionalProperties",
                        params: { additionalProperty: key23 },
                        message: "must NOT have additional properties",
                      };
                      if (vErrors === null) {
                        vErrors = [err622];
                      } else {
                        vErrors.push(err622);
                      }
                      errors++;
                    }
                  }
                  if (data21.name !== undefined) {
                    if (typeof data21.name !== "string") {
                      const err623 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/name",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/name/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err623];
                      } else {
                        vErrors.push(err623);
                      }
                      errors++;
                    }
                  }
                  if (data21.required !== undefined) {
                    if (typeof data21.required !== "boolean") {
                      const err624 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/required",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/required/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err624];
                      } else {
                        vErrors.push(err624);
                      }
                      errors++;
                    }
                  }
                  if (data21.inputType !== undefined) {
                    let data336 = data21.inputType;
                    if (typeof data336 !== "string") {
                      const err625 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/inputType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err625];
                      } else {
                        vErrors.push(err625);
                      }
                      errors++;
                    }
                    if (!(data336 === "UniqueId")) {
                      const err626 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/inputType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/inputType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[14]
                              .properties.inputType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err626];
                      } else {
                        vErrors.push(err626);
                      }
                      errors++;
                    }
                  }
                  if (data21.type !== undefined) {
                    let data337 = data21.type;
                    if (typeof data337 !== "string") {
                      const err627 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/type/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err627];
                      } else {
                        vErrors.push(err627);
                      }
                      errors++;
                    }
                    if (!(data337 === "string")) {
                      const err628 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/type",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/type/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[14]
                              .properties.type.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err628];
                      } else {
                        vErrors.push(err628);
                      }
                      errors++;
                    }
                  }
                  if (data21.placeholder !== undefined) {
                    if (typeof data21.placeholder !== "string") {
                      const err629 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/placeholder",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/placeholder/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err629];
                      } else {
                        vErrors.push(err629);
                      }
                      errors++;
                    }
                  }
                  if (data21.tooltipText !== undefined) {
                    if (typeof data21.tooltipText !== "string") {
                      const err630 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/tooltipText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/tooltipText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err630];
                      } else {
                        vErrors.push(err630);
                      }
                      errors++;
                    }
                  }
                  if (data21.title !== undefined) {
                    let data340 = data21.title;
                    if (typeof data340 === "string") {
                      if (func3(data340) < 1) {
                        const err631 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/title",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/14/properties/title/minLength",
                          keyword: "minLength",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 characters",
                        };
                        if (vErrors === null) {
                          vErrors = [err631];
                        } else {
                          vErrors.push(err631);
                        }
                        errors++;
                      }
                    } else {
                      const err632 = {
                        instancePath: instancePath + "/inputs/" + i5 + "/title",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/title/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err632];
                      } else {
                        vErrors.push(err632);
                      }
                      errors++;
                    }
                  }
                  if (data21.labelSize !== undefined) {
                    let data341 = data21.labelSize;
                    if (typeof data341 !== "string") {
                      const err633 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/labelSize",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/labelSize/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err633];
                      } else {
                        vErrors.push(err633);
                      }
                      errors++;
                    }
                    if (!(data341 === "small" || data341 === "medium")) {
                      const err634 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/labelSize",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/labelSize/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[14]
                              .properties.labelSize.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err634];
                      } else {
                        vErrors.push(err634);
                      }
                      errors++;
                    }
                  }
                  if (data21.columnHeaderOverride !== undefined) {
                    if (typeof data21.columnHeaderOverride !== "string") {
                      const err635 = {
                        instancePath:
                          instancePath +
                          "/inputs/" +
                          i5 +
                          "/columnHeaderOverride",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/columnHeaderOverride/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err635];
                      } else {
                        vErrors.push(err635);
                      }
                      errors++;
                    }
                  }
                  if (data21.disabled !== undefined) {
                    if (typeof data21.disabled !== "boolean") {
                      const err636 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/disabled",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/disabled/type",
                        keyword: "type",
                        params: { type: "boolean" },
                        message: "must be boolean",
                      };
                      if (vErrors === null) {
                        vErrors = [err636];
                      } else {
                        vErrors.push(err636);
                      }
                      errors++;
                    }
                  }
                  if (data21.helperText !== undefined) {
                    if (typeof data21.helperText !== "string") {
                      const err637 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/helperText",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/helperText/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err637];
                      } else {
                        vErrors.push(err637);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnRetrieve !== undefined) {
                    let data345 = data21.viewOnRetrieve;
                    if (Array.isArray(data345)) {
                      if (data345.length < 1) {
                        const err638 = {
                          instancePath:
                            instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                          schemaPath:
                            "#/properties/inputs/items/oneOf/14/properties/viewOnRetrieve/minItems",
                          keyword: "minItems",
                          params: { limit: 1 },
                          message: "must NOT have fewer than 1 items",
                        };
                        if (vErrors === null) {
                          vErrors = [err638];
                        } else {
                          vErrors.push(err638);
                        }
                        errors++;
                      }
                      const len56 = data345.length;
                      for (let i56 = 0; i56 < len56; i56++) {
                        let data346 = data345[i56];
                        if (typeof data346 !== "string") {
                          const err639 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i56,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/14/properties/viewOnRetrieve/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err639];
                          } else {
                            vErrors.push(err639);
                          }
                          errors++;
                        }
                        if (
                          !(
                            data346 === "manager" ||
                            data346 === "member" ||
                            data346 === "creator" ||
                            data346 === "view_only" ||
                            data346 === "admin" ||
                            data346 === "guest" ||
                            data346 === "publicUser"
                          )
                        ) {
                          const err640 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnRetrieve/" +
                              i56,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/14/properties/viewOnRetrieve/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues:
                                schema27.properties.inputs.items.oneOf[14]
                                  .properties.viewOnRetrieve.items.enum,
                            },
                            message:
                              "must be equal to one of the allowed values",
                          };
                          if (vErrors === null) {
                            vErrors = [err640];
                          } else {
                            vErrors.push(err640);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err641 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnRetrieve",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/viewOnRetrieve/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err641];
                      } else {
                        vErrors.push(err641);
                      }
                      errors++;
                    }
                  }
                  if (data21.canUpdate !== undefined) {
                    let data347 = data21.canUpdate;
                    if (Array.isArray(data347)) {
                      const len57 = data347.length;
                      for (let i57 = 0; i57 < len57; i57++) {
                        if (typeof data347[i57] !== "string") {
                          const err642 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/canUpdate/" +
                              i57,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/14/properties/canUpdate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err642];
                          } else {
                            vErrors.push(err642);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err643 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/canUpdate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/canUpdate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err643];
                      } else {
                        vErrors.push(err643);
                      }
                      errors++;
                    }
                  }
                  if (data21.viewOnCreate !== undefined) {
                    let data349 = data21.viewOnCreate;
                    if (Array.isArray(data349)) {
                      const len58 = data349.length;
                      for (let i58 = 0; i58 < len58; i58++) {
                        if (typeof data349[i58] !== "string") {
                          const err644 = {
                            instancePath:
                              instancePath +
                              "/inputs/" +
                              i5 +
                              "/viewOnCreate/" +
                              i58,
                            schemaPath:
                              "#/properties/inputs/items/oneOf/14/properties/viewOnCreate/items/type",
                            keyword: "type",
                            params: { type: "string" },
                            message: "must be string",
                          };
                          if (vErrors === null) {
                            vErrors = [err644];
                          } else {
                            vErrors.push(err644);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err645 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/viewOnCreate",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/viewOnCreate/type",
                        keyword: "type",
                        params: { type: "array" },
                        message: "must be array",
                      };
                      if (vErrors === null) {
                        vErrors = [err645];
                      } else {
                        vErrors.push(err645);
                      }
                      errors++;
                    }
                  }
                  if (data21.prefix !== undefined) {
                    if (typeof data21.prefix !== "string") {
                      const err646 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/prefix",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/prefix/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err646];
                      } else {
                        vErrors.push(err646);
                      }
                      errors++;
                    }
                  }
                  if (data21.numberType !== undefined) {
                    let data352 = data21.numberType;
                    if (typeof data352 !== "string") {
                      const err647 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/numberType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/numberType/type",
                        keyword: "type",
                        params: { type: "string" },
                        message: "must be string",
                      };
                      if (vErrors === null) {
                        vErrors = [err647];
                      } else {
                        vErrors.push(err647);
                      }
                      errors++;
                    }
                    if (!(data352 === "ascending" || data352 === "random")) {
                      const err648 = {
                        instancePath:
                          instancePath + "/inputs/" + i5 + "/numberType",
                        schemaPath:
                          "#/properties/inputs/items/oneOf/14/properties/numberType/enum",
                        keyword: "enum",
                        params: {
                          allowedValues:
                            schema27.properties.inputs.items.oneOf[14]
                              .properties.numberType.enum,
                        },
                        message: "must be equal to one of the allowed values",
                      };
                      if (vErrors === null) {
                        vErrors = [err648];
                      } else {
                        vErrors.push(err648);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err649 = {
                    instancePath: instancePath + "/inputs/" + i5,
                    schemaPath: "#/properties/inputs/items/oneOf/14/type",
                    keyword: "type",
                    params: { type: "object" },
                    message: "must be object",
                  };
                  if (vErrors === null) {
                    vErrors = [err649];
                  } else {
                    vErrors.push(err649);
                  }
                  errors++;
                }
              } else {
                const err650 = {
                  instancePath: instancePath + "/inputs/" + i5,
                  schemaPath: "#/properties/inputs/items/discriminator",
                  keyword: "discriminator",
                  params: {
                    error: "mapping",
                    tag: "inputType",
                    tagValue: tag1,
                  },
                  message: 'value of tag "inputType" must be in oneOf',
                };
                if (vErrors === null) {
                  vErrors = [err650];
                } else {
                  vErrors.push(err650);
                }
                errors++;
              }
            } else {
              const err651 = {
                instancePath: instancePath + "/inputs/" + i5,
                schemaPath: "#/properties/inputs/items/discriminator",
                keyword: "discriminator",
                params: { error: "tag", tag: "inputType", tagValue: tag1 },
                message: 'tag "inputType" must be string',
              };
              if (vErrors === null) {
                vErrors = [err651];
              } else {
                vErrors.push(err651);
              }
              errors++;
            }
          } else {
            const err652 = {
              instancePath: instancePath + "/inputs/" + i5,
              schemaPath: "#/properties/inputs/items/type",
              keyword: "type",
              params: { type: "object" },
              message: "must be object",
            };
            if (vErrors === null) {
              vErrors = [err652];
            } else {
              vErrors.push(err652);
            }
            errors++;
          }
        }
      } else {
        const err653 = {
          instancePath: instancePath + "/inputs",
          schemaPath: "#/properties/inputs/type",
          keyword: "type",
          params: { type: "array" },
          message: "must be array",
        };
        if (vErrors === null) {
          vErrors = [err653];
        } else {
          vErrors.push(err653);
        }
        errors++;
      }
    }
  } else {
    const err654 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: { type: "object" },
      message: "must be object",
    };
    if (vErrors === null) {
      vErrors = [err654];
    } else {
      vErrors.push(err654);
    }
    errors++;
  }
  validate10.errors = vErrors;
  return errors === 0;
}
